<template>
    <div class="container-fluid">
        <!-- 商品求购 / 请求变更记录 — 변경 기록은 독립 메뉴였다가 이 화면 탭으로 옮겼다(옛 주소는 ?view=changes 로 온다) -->
        <div class="mb-2">
            <b-button-group size="sm">
                <b-button :variant="pageView === 'requests' ? 'primary' : 'outline-primary'" @click="setPageView('requests')">采购请求<small>(구매요청)</small></b-button>
                <b-button :variant="pageView === 'changes' ? 'primary' : 'outline-primary'" @click="setPageView('changes')">请求变更记录<small>(요청 변경 기록)</small></b-button>
                <b-button :variant="pageView === 'tracking' ? 'primary' : 'outline-primary'" @click="setPageView('tracking')">进度管理<small>(구매내역관리)</small></b-button>
                <b-button :variant="pageView === 'purchased' ? 'primary' : 'outline-primary'" @click="setPageView('purchased')">已采购记录<small>(구매기록 表三)</small></b-button>
            </b-button-group>
        </div>
        <logis-req-changes v-if="pageView === 'changes'"></logis-req-changes>
        <!-- 进度管理 — 독립 메뉴였다가 이 화면 탭으로 옮겼다(2026-10 YZY, 옛 주소는 ?view=tracking 으로 온다). 열 때만 불러온다 -->
        <req-purchase-tracking v-if="pageView === 'tracking'" embedded></req-purchase-tracking>
        <!-- 已采购记录(表三) — 订单列表의 엑셀 버튼이었다가 이 화면 탭으로 옮겨 표로 보여 준다(2026-10-07 YZY, ?view=purchased) -->
        <purchased-record-view v-if="pageView === 'purchased'"></purchased-record-view>
        <div class="row" v-show="pageView === 'requests'">
            <div class="col-lg-12">
                <div class="d-flex flex-wrap flex-wrap align-items-center justify-content-between">
                    <div>
                        <h4 class="mb-3">{{ title }}
                            <span class="badge bg-warning ml-2" v-if="$store.state.sseNotifications.price_modified > 0">
                                价格修改 (가격수정) {{ $store.state.sseNotifications.price_modified }}件
                            </span>
                            <span class="badge bg-success ml-2" v-if="$store.state.sseNotifications.payment_completed > 0">
                                付款完成 (입금완료) {{ $store.state.sseNotifications.payment_completed }}件
                            </span>
                        </h4>
                        <p class="mb-0" style="font-size: 0.85rem; color: #666;">{{ desc1 }}<br>{{ desc2 }}</p>
                    </div>
                    <div class="d-flex align-items-start">
                        <!-- 💳 예치금 관리 버튼 -->
                        <b-button size="sm" variant="outline-primary" class="mr-3" @click="openDepositManageModal">
                            💳 预存款管理 (예치금 관리)
                        </b-button>
                        <!-- 银行到账核对 — 은행 입금내역을 올려 구매 청구와 대조 후 입금확인(YZY 10-07) -->
                        <b-button size="sm" variant="outline-success" class="mr-3" @click="showBankReconcile = true">
                            🏦 银行到账核对 (입금내역 대조)
                        </b-button>
                        <!-- 환율 정보 표시 (클릭 시 수정 가능) -->
                        <div v-if="exchangeRate" class="text-right" style="cursor: pointer;" @click="openExchangeRateModal">
                            <div style="font-size: 0.8rem; color: #888; line-height: 1.5;">
                                <div>单独清关 (단독통관) : <span style="color: #333; font-weight: 500;">{{ exchangeRate.cashBuyValue }}원/元</span></div>
                                <div>综合清关 (통합통관) : <span style="color: #333; font-weight: 500;">{{ integratedExchangeRate }}원/元</span></div>
                            </div>
                            <small style="color: #aaa; font-size: 0.7rem;">🔧 点击修改 (클릭하여 수정)</small>
                            <small class="ml-2" style="color: #007bff; font-size: 0.7rem; text-decoration: underline;" @click.stop="openExchangeRateHistory">历史汇率 (환율 이력)</small>
                        </div>
                    </div>
                </div>

                <bank-reconcile-modal v-model="showBankReconcile" @applied="onBankReconcileApplied"></bank-reconcile-modal>

                <!-- 批量搜索 / 일괄 검색 — 주문번호 여러 개를 붙여넣어 그 건만 본다(崔凡 10-07). 날짜 범위와 무관 -->
                <b-modal v-model="showBatchSearchModal" title="批量搜索 / 일괄 검색" size="md"
                    ok-title="搜索 / 검색" cancel-title="取消 / 취소"
                    :ok-disabled="!batchSearchParsed.length || batchSearchParsed.length > 100"
                    @ok="applyBatchSearch">
                    <!-- 화주명 모드(崔凡 10-07): 화주 여러 개를 넣어 선택 기간 안 그 화주들 건만 본다 → 전체 선택 → 일괄 1688주문 -->
                    <b-form-radio-group v-model="batchSearchMode" size="sm" buttons button-variant="outline-primary" class="mb-2"
                        :options="[{ text: '订单号 / 주문번호', value: 'order' }, { text: '货主 / 화주명', value: 'owner' }]"></b-form-radio-group>
                    <template v-if="batchSearchMode === 'owner'">
                        <p class="small text-muted mb-2">
                            货主ID，可用换行、空格、逗号分隔，不区分大小写，最多100个 — 按上方所选日期查询<br>
                            화주ID — 줄바꿈·공백·쉼표로 구분, 대소문자 무시, 최대 100개 — 위에서 고른 기간으로 조회
                        </p>
                        <b-form-checkbox v-model="ownerFilterOnlyBefore" size="sm" class="mb-2">
                            只看待采购 / 구매전만 보기
                        </b-form-checkbox>
                    </template>
                    <p v-else class="small text-muted mb-2">
                        1688订单号 / 货主订单号 / 商家订单号，可用换行、空格、逗号、分号分隔，最多100个<br>
                        1688주문번호 / 화주주문번호 / 판매처주문번호 — 줄바꿈·공백·쉼표·세미콜론으로 구분, 최대 100개<br>
                        <span class="text-info">不限日期 / 기간과 무관</span>
                    </p>
                    <b-form-textarea v-model="batchSearchText" rows="8" max-rows="14"
                        :placeholder="batchSearchMode === 'owner' ? 'LifeItemStorage naru Primepickup' : '5127302487770017511\n5127804685742008329'"></b-form-textarea>
                    <div class="d-flex justify-content-between mt-1 small">
                        <span :class="batchSearchParsed.length > 100 ? 'text-danger' : 'text-muted'">
                            {{ batchSearchParsed.length }}/100
                            <template v-if="batchSearchParsed.length > 100"> — 超过100个 / 100개를 넘었습니다</template>
                        </span>
                        <a href="#" class="text-muted" @click.prevent="batchSearchText = ''">清空 / 지우기</a>
                    </div>
                </b-modal>

                <!-- 批量下单 / 일괄 1688주문 진행 — 그룹(화주·요청일·유형·상태)마다 createOrderFromGroup 을 하나씩 부른다.
                     중단은 「다음 그룹부터」다(이미 나간 1688 호출은 되돌리지 않는다) -->
                <b-modal v-model="bulkOrderModal" title="批量下单 / 일괄 1688주문" size="lg" scrollable
                    no-close-on-backdrop no-close-on-esc :hide-header-close="bulkOrdering">
                    <div class="mb-2">
                        <b>{{ bulkOrderDone }} / {{ bulkOrderTotal }}</b>
                        <span v-if="bulkOrdering && bulkOrderCurrent" class="ml-2 text-muted small">{{ bulkOrderCurrent }}</span>
                        <span v-else-if="!bulkOrdering" class="ml-2 small text-success">完成 / 완료</span>
                    </div>
                    <b-progress :value="bulkOrderDone" :max="bulkOrderTotal || 1" show-progress animated class="mb-3"></b-progress>
                    <div class="small mb-2">
                        <span class="badge badge-success mr-1">成功 / 성공 {{ bulkOrderCount('ok') }}</span>
                        <span class="badge badge-warning mr-1">部分 / 일부 {{ bulkOrderCount('partial') }}</span>
                        <span class="badge badge-danger mr-1">失败 / 실패 {{ bulkOrderCount('fail') }}</span>
                        <span class="badge badge-secondary mr-1">跳过 / 건너뜀 {{ bulkOrderCount('skip') }}</span>
                    </div>
                    <table class="table table-sm table-bordered small mb-0">
                        <thead><tr><th>货主·分组 / 화주·그룹</th><th>件 / 건</th><th>结果 / 결과</th><th>原因 / 사유</th></tr></thead>
                        <tbody>
                            <tr v-for="(r, i) in bulkOrderResults" :key="i"
                                :class="{ 'table-danger': r.status === 'fail', 'table-warning': r.status === 'partial' }">
                                <td>{{ r.label }}</td>
                                <td>{{ r.ordered != null ? r.ordered + '/' : '' }}{{ r.count }}</td>
                                <td>{{ { ok: '成功 / 성공', partial: '部分 / 일부', fail: '失败 / 실패', skip: '跳过 / 건너뜀' }[r.status] }}</td>
                                <td style="white-space: pre-line;">{{ r.reason }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div v-if="bulkFailItems.length" class="mt-3">
                        <div class="small font-weight-bold text-danger mb-1">
                            没下单的商品 / 주문 안 된 상품 {{ bulkFailItems.length }}件 (客户名---货主号---原因 / 고객명---화주주문번호---사유)
                        </div>
                        <textarea ref="bulkFailTextarea" class="form-control form-control-sm" rows="6" readonly
                            :value="bulkFailText()"></textarea>
                        <div class="mt-1">
                            <b-button size="sm" variant="outline-secondary" class="mr-1" @click="copyBulkFail">复制 / 복사</b-button>
                            <b-button size="sm" variant="outline-secondary" @click="downloadBulkFail">下载失败清单 / 실패 목록 다운로드</b-button>
                        </div>
                    </div>
                    <template #modal-footer>
                        <b-button v-if="bulkOrdering" size="sm" variant="danger" :disabled="bulkOrderStopReq" @click="bulkOrderStopReq = true">
                            {{ bulkOrderStopReq ? '停止中… / 멈추는 중 (현재 그룹까지)' : '中止 / 중단' }}
                        </b-button>
                        <template v-else>
                            <b-button size="sm" variant="secondary" :disabled="!bulkOrderedItems.length" @click="downloadlist(bulkOrderedItems)">
                                下载本次订单记录 / 이번 주문내역 다운로드 ({{ bulkOrderedItems.length }})
                            </b-button>
                            <b-button size="sm" variant="primary" @click="bulkOrderModal = false">关闭 / 닫기</b-button>
                        </template>
                    </template>
                </b-modal>

                <!-- 购买后更换属性 (구매 후 옵션 변경) -->
                <PostPurchaseOptionModal v-model="showOptionChange" :item="optionChangeItem" :siblings="reqlistsinit" @applied="optionChangeApplied" />

                <!-- 💳 예치금 관리 모달 -->
                <b-modal v-model="showDepositManageModal" title="💳 预存款管理 (예치금 관리)" hide-footer size="xl">
                    <!-- 화주 선택 + 잔액 -->
                    <div class="row mb-3">
                        <div class="col-md-4">
                            <label class="font-weight-bold">选择货主 (화주 선택)</label>
                            <select class="form-control form-control-sm" v-model="depositSelectedCompany" @change="fetchDepositDetail">
                                <option value="">-- 请选择 (선택) --</option>
                                <option v-for="d in depositAllBalances" :key="d.companyid" :value="d.companyid">
                                    {{ d.companyid }} (₩{{ (d.잔액 || 0).toLocaleString() }})
                                </option>
                            </select>
                        </div>
                        <div class="col-md-3 d-flex align-items-end">
                            <div v-if="depositSelectedCompany" class="p-2 border rounded bg-light w-100 text-center">
                                余额 (잔액): <b class="text-primary" style="font-size:1.1rem;">₩{{ (depositDetailBalance || 0).toLocaleString() }}</b>
                            </div>
                        </div>
                        <div class="col-md-5 d-flex align-items-end justify-content-end">
                            <b-button size="sm" variant="success" class="mr-2" @click="depositAction='충전'; depositAmount=''; depositReason=''" :disabled="!depositSelectedCompany">充值 (충전)</b-button>
                            <b-button size="sm" variant="danger" class="mr-2" @click="depositAction='차감'; depositAmount=''; depositReason=''" :disabled="!depositSelectedCompany">扣除 (차감)</b-button>
                            <b-button size="sm" variant="warning" @click="depositAction='환불'; depositAmount=''; depositReason=''" :disabled="!depositSelectedCompany">退款 (환불)</b-button>
                        </div>
                    </div>
                    <!-- 충전/차감/환불 입력 폼 -->
                    <div v-if="depositAction && depositSelectedCompany" class="mb-3 p-3 border rounded" :class="{'bg-success-light': depositAction==='충전', 'bg-danger-light': depositAction==='차감', 'bg-warning-light': depositAction==='환불'}" style="background:#f9f9f9;">
                        <div class="row">
                            <div class="col-md-3"><label>{{ displayZh(depositAction) }} 金额 (금액, ₩)</label><input type="number" class="form-control form-control-sm" v-model.number="depositAmount" min="0" placeholder="金额 (금액)"></div>
                            <div class="col-md-6"><label>原因 (사유)</label><input type="text" class="form-control form-control-sm" v-model="depositReason" :placeholder="displayZh(depositAction) + ' 原因 (사유)'"></div>
                            <div class="col-md-3 d-flex align-items-end">
                                <b-button size="sm" :variant="depositAction==='충전'?'success':depositAction==='차감'?'danger':'warning'" @click="submitDepositAction" :disabled="!depositAmount || depositAmount <= 0" class="w-100">
                                    {{ displayZh(depositAction) }} 执行 (실행)
                                </b-button>
                            </div>
                        </div>
                    </div>
                    <!-- 내역 테이블 -->
                    <div v-if="depositSelectedCompany">
                        <h6 class="mb-2">📋 {{ depositSelectedCompany }} 记录 (내역)</h6>
                        <div v-if="depositDetailHistory.length === 0" class="text-center text-muted py-3">暂无记录 (내역이 없습니다.)</div>
                        <table v-else class="table table-sm table-bordered" style="font-size:0.8rem;">
                            <thead class="thead-light"><tr><th>日期<br><small>일시</small></th><th>类型<br><small>유형</small></th><th>金额<br><small>금액</small></th><th>原因<br><small>사유</small></th><th>处理人<br><small>처리자</small></th></tr></thead>
                            <tbody>
                                <tr v-for="(h, idx) in depositDetailHistory" :key="idx">
                                    <td>{{ h.처리일 ? new Date(h.처리일).toLocaleString('ko-KR') : '-' }}</td>
                                    <td><span :class="{'badge badge-success': h.type==='충전', 'badge badge-danger': h.type==='차감', 'badge badge-warning': h.type==='환불'}">{{ displayZh(h.type) }}</span></td>
                                    <td :class="{'text-success': h.type==='충전', 'text-danger': h.type!=='충전'}">{{ h.type==='충전' ? '+' : '-' }}₩{{ (h.금액||0).toLocaleString() }}</td>
                                    <td>{{ h.사유 || '-' }}</td>
                                    <td>{{ h.처리자 || '-' }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </b-modal>

                <!-- 환율 수정 모달 -->
                <b-modal id="exchange-rate-modal" title="환율 정보 수정 (汇率修改)" ok-title="保存 (저장)" cancel-title="取消 (취소)" @ok="saveIntegratedExchangeRate">
                    <div class="form-group">
                        <label>单独清关 (단독통관) 汇率 (환율)</label>
                        <div class="input-group">
                            <input type="text" class="form-control" :value="exchangeRate ? exchangeRate.cashBuyValue + '원/元' : ''" disabled>
                            <div class="input-group-append">
                                <b-button variant="outline-secondary" @click="openExchangeRateHistory">历史汇率 (환율 이력)</b-button>
                            </div>
                        </div>
                        <small class="text-muted">* 自动查询，不可修改 (자동 조회 · 기준일: {{ exchangeRate ? exchangeRate.date : '-' }}, 수정 불가)</small>
                    </div>
                    <div class="form-group mt-3">
                        <label>综合清关 (통합통관) 汇率 (환율)</label>
                        <input type="number" class="form-control" v-model="editIntegratedRate" step="0.01" placeholder="例/예: 300">
                        <small class="text-muted">* 可手动输入 (수동 입력 가능)</small>
                    </div>
                    <div class="form-group">
                        <label>生效日期 (적용 시작일)</label>
                        <input type="date" class="form-control" v-model="editIntegratedFrom" :min="todayKst()">
                        <small class="text-muted">* 默认今天；到该日期自动生效，已做好的报价单不受影响 (기본 오늘 · 그 날짜부터 자동 적용, 이미 만든 견적서는 그대로)</small>
                    </div>
                    <div class="mt-3">
                        <label class="mb-1">历史记录 (변경 이력)</label>
                        <table class="table table-sm table-bordered text-center mb-0" style="font-size: 0.8rem;">
                            <thead class="thead-light">
                                <tr><th>生效日期 (적용 시작일)</th><th>汇率 (환율)</th><th>保存时间 (저장 시각)</th></tr>
                            </thead>
                            <tbody>
                                <tr v-for="(h, i) in integratedRateHistory" :key="i" :class="{ 'table-info': h.현재 }">
                                    <td>{{ h.effectiveFrom || '最初 (처음부터)' }}<span v-if="h.현재" class="ml-1 text-primary">(当前 현재)</span><span v-if="h.예약" class="ml-1 text-warning">(预约 예약)</span></td>
                                    <td>{{ h.rate }}</td>
                                    <td>{{ h.savedAt ? new Date(h.savedAt).toLocaleString('ko-KR') : '-' }}</td>
                                </tr>
                                <tr v-if="!integratedRateHistory.length"><td colspan="3" class="text-muted">无记录 (기록 없음)</td></tr>
                            </tbody>
                        </table>
                    </div>
                </b-modal>

                <!-- 단독통관 환율 이력 모달 -->
                <b-modal id="exchange-rate-history-modal" title="单独清关 历史汇率 (단독통관 환율 이력)" ok-only ok-title="关闭 (닫기)" size="lg">
                    <p class="text-muted mb-2" style="font-size: 0.8rem;">每周二更新，适用到下次更新的前一天 (매주 화요일 갱신, 다음 갱신 전날까지 적용)</p>
                    <div v-if="exchangeRateHistoryLoading" class="text-center py-3"><b-spinner small></b-spinner></div>
                    <table v-else class="table table-sm table-bordered text-center mb-0" style="font-size: 0.85rem;">
                        <thead class="thead-light">
                            <tr><th>适用日期 (적용날짜)</th><th>汇率 (환율)</th><th>适用期间 (적용기간)</th></tr>
                        </thead>
                        <tbody>
                            <tr v-for="h in exchangeRateHistory" :key="h.date + h.적용시작" :class="{ 'table-info': h.현재 }">
                                <td>{{ h.date }}</td>
                                <td>{{ h.cashBuyValue }}</td>
                                <td>{{ h.적용시작 }} ~ {{ h.적용종료 }}<span v-if="h.현재" class="ml-1 text-primary">(当前 현재)</span></td>
                            </tr>
                            <tr v-if="!exchangeRateHistory.length"><td colspan="3" class="text-muted">无记录 (기록 없음)</td></tr>
                        </tbody>
                    </table>
                </b-modal>

                <!-- 견적서 모달 -->
                <b-modal id="quotation-modal" title="报价单 (견적서)" ok-only ok-title="关闭 (닫기)" dialog-class="quotation-modal-90">
                    <template v-if="quotationGroup">
                        <!-- 카카오로 보내기 청구서 그림은 이 화면을 찍지 않고 고객용 표를 따로 그린다 (kakaoSend.js·CustomerBillTable.vue) -->
                        <div>
                        <!-- 상단 정보 -->
                        <div class="mb-3 p-3 border rounded bg-light" style="font-size:0.85rem;">
                            <div class="row mb-1">
                                <div class="col-4"><strong>货主订单号 (화주주문번호):</strong> {{ quotationGroup.화주주문번호 || '-' }}</div>
                                <div class="col-4"><strong>清关方式 (통관타입):</strong> {{ quotationGroup.items[0]?.견적서_1688구매금액?.customsType === 'integrated' ? '综合清关 (통합통관)' : quotationGroup.items[0]?.견적서_1688구매금액?.customsType === 'kupass' ? 'COUPASS单独清关 (쿠패스단독통관)' : quotationGroup.items[0]?.견적서_1688구매금액?.customsType === 'client' ? '货主单独清关 (화주단독)' : quotationGroup.items[0]?.통관방법 || '-' }}</div>
                                <div class="col-4"><strong>适用汇率 (적용환율):</strong> {{ quotationGroupItemsProcessed[0]?._적용환율 || quotationGroup.적용환율 || '-' }}</div>
                            </div>
                            <div class="row">
                                <div class="col-4"><strong>营业执照号 (사업자등록번호):</strong> {{ quotationGroup.items[0]?.입금정보?.사업자등록번호 || '-' }}</div>
                                <div class="col-4"><strong>法人代表 (대표자명):</strong> {{ quotationGroup.items[0]?.입금정보?.대표자명 || '-' }}</div>
                                <div class="col-4"><strong>邮箱 (이메일):</strong> {{ quotationGroup.items[0]?.입금정보?.이메일주소 || '-' }}</div>
                            </div>
                        </div>
                        <!-- 견적서 테이블 -->
                        <div class="table-responsive">
                        <table class="table table-bordered table-sm" style="font-size:0.75rem;">
                            <thead class="thead-light">
                                <tr>
                                    <th rowspan="2" class="align-middle text-center">商品名<br><small>상품명</small></th>
                                    <th rowspan="2" class="align-middle text-center">条码<br><small>바코드</small></th>
                                    <th rowspan="2" class="align-middle text-center">数量<br><small>수량</small></th>
                                    <th colspan="3" class="text-center" style="background:#e8f4fd;">协商前 (협상전) CNY</th>
                                    <th colspan="3" class="text-center" style="background:#fff3cd;">协商后 (협상후) CNY</th>
                                    <th v-if="quotationGroupItemsProcessed.length === 1" rowspan="2" class="align-middle text-center">增值税(KRW)<br><small>부가세</small></th>
                                    <th v-if="quotationGroupItemsProcessed.length === 1" rowspan="2" class="align-middle text-center">总金额(KRW)<br><small>총금액</small></th>
                                </tr>
                                <tr>
                                    <th class="text-center" style="background:#e8f4fd;">单价<br><small>단가</small></th>
                                    <th class="text-center" style="background:#e8f4fd;">总运费<br><small>총배송비</small></th>
                                    <th class="text-center" style="background:#e8f4fd;">合计<br><small>합계</small></th>
                                    <th class="text-center" style="background:#fff3cd;">单价<br><small>단가</small></th>
                                    <th class="text-center" style="background:#fff3cd;">总运费<br><small>총배송비</small></th>
                                    <th class="text-center" style="background:#fff3cd;">合计<br><small>합계</small></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, idx) in quotationGroupItemsProcessed" :key="idx"
                                    :class="{ 'table-success': item.견적서_1688구매금액, 'table-light': !item.견적서_1688구매금액 }">
                                    <td>{{ item.상품명 }}
                                        <!-- 非1688 은 1688 금액이 없다 — 같은 양식을 빈 금액으로 열어 직원이 채운다(YZY 10-07) -->
                                        <span v-if="isNon1688(item)" class="badge badge-danger ml-1" v-b-tooltip.hover title="非1688: 单价·运费请手动填写 / 단가·배송비를 직접 입력">非1688</span>
                                    </td>
                                    <td class="text-center">{{ item.바코드 || '-' }}</td>
                                    <td class="text-center">
                                        <template v-if="!item.견적서_1688구매금액">
                                            <input type="number" class="form-control form-control-sm text-center p-0"
                                                style="width:55px; font-size:0.7rem;"
                                                :value="quotationEditOverrides[item._id]?.구매수량 != null ? quotationEditOverrides[item._id].구매수량 : (item.구매요청수량 || 1)"
                                                @change="setQuotationEdit(item._id, '구매수량', parseInt($event.target.value))" min="1">
                                        </template>
                                        <template v-else>{{ item.구매요청수량 || 1 }}</template>
                                    </td>
                                    <!-- 협상전 -->
                                    <td class="text-right">
                                        <template v-if="!item.견적서_1688구매금액">
                                            <input type="number" step="0.01" class="form-control form-control-sm text-right p-0"
                                                style="width:70px; font-size:0.7rem;"
                                                :value="quotationEditOverrides[item._id]?.협상전_단가 != null ? quotationEditOverrides[item._id].협상전_단가 : item._협상전_단가"
                                                @change="setQuotationEdit(item._id, '협상전_단가', parseFloat($event.target.value))">
                                        </template>
                                        <template v-else>¥{{ item._협상전_단가.toLocaleString() }}</template>
                                    </td>
                                    <td v-if="item._isFirstInOrder" :rowspan="item._orderRowspan" class="text-right align-middle" style="background:#f0f8ff;">
                                        <template v-if="!item.견적서_1688구매금액">
                                            <input type="number" step="0.01" class="form-control form-control-sm text-right p-0"
                                                style="width:70px; font-size:0.7rem;"
                                                :value="item._preOrderShipping"
                                                @change="setOrderShippingOverride(item._orderId, '협상전', parseFloat($event.target.value))">
                                        </template>
                                        <template v-else>¥{{ item._preOrderShipping.toLocaleString() }}</template>
                                    </td>
                                    <td v-if="item._isFirstInOrder" :rowspan="item._orderRowspan" class="text-right align-middle" style="background:#f0f8ff;">¥{{ item._orderPreTotal.toLocaleString() }}</td>
                                    <!-- 협상후 (computed에서 계산된 값 사용) -->
                                    <td class="text-right">
                                        <template v-if="!item.견적서_1688구매금액">
                                            <input type="number" step="0.01" class="form-control form-control-sm text-right p-0"
                                                style="width:70px; font-size:0.7rem;"
                                                :value="quotationEditOverrides[item._id]?.구매단가 != null ? quotationEditOverrides[item._id].구매단가 : (isNon1688(item) && !item._협상후_단가 ? '' : item._협상후_단가)"
                                                :placeholder="isNon1688(item) ? '手填' : ''"
                                                @change="setQuotationEdit(item._id, '구매단가', parseFloat($event.target.value))">
                                        </template>
                                        <template v-else>{{ item._협상후_단가 ? '¥' + item._협상후_단가.toLocaleString() : '-' }}</template>
                                        <div v-if="item._未改价" class="text-muted" style="font-size:0.6rem;" v-b-tooltip.hover title="没有改价，下单价即最终价 / 가격 수정 없음 — 주문가가 최종가">未改价</div>
                                        <!-- 협상후 > 협상전(옵션 추가·판매자 수정): 표시만, 계산 불변 -->
                                        <div v-if="priceRiseInfo(item._협상전_단가, item._협상후_단가)" class="mt-1">
                                            <b-badge variant="danger" style="font-size:0.65rem;" v-b-tooltip.hover :title="priceRiseTitle(priceRiseInfo(item._협상전_단가, item._협상후_단가))">价格上涨 (가격 상승) +{{ priceRiseInfo(item._협상전_단가, item._협상후_단가).diff }}</b-badge>
                                            <div class="text-danger" style="font-size:0.6rem;">卖家改价/附加选项<br>판매자 수정/옵션 추가</div>
                                        </div>
                                    </td>
                                    <td v-if="item._isFirstInOrder" :rowspan="item._orderRowspan" class="text-right align-middle" style="background:#fff8e1;">
                                        <template v-if="!item.견적서_1688구매금액">
                                            <input type="number" step="0.01" class="form-control form-control-sm text-right p-0"
                                                style="width:70px; font-size:0.7rem;"
                                                :value="item._postOrderShipping"
                                                @change="setOrderShippingOverride(item._orderId, '협상후', parseFloat($event.target.value))">
                                        </template>
                                        <template v-else>¥{{ item._postOrderShipping.toLocaleString() }}</template>
                                    </td>
                                    <td v-if="item._isFirstInOrder" :rowspan="item._orderRowspan" class="text-right align-middle" style="background:#fff8e1;">¥{{ item._orderPostTotal.toLocaleString() }}<div v-if="quotationGroupItemsProcessed.some(x => x._orderId === item._orderId && x._未改价)" class="text-muted" style="font-size:0.6rem;">未改价</div></td>
                                    <!-- 할인율/부가세/총금액 -->
                                    <td v-if="quotationGroupItemsProcessed.length === 1" class="text-right"><template v-if="quotationGroupItemsProcessed.length === 1">{{ item._부가세 ? '₩' + item._부가세.toLocaleString() : '-' }}</template></td>
                                    <td v-if="quotationGroupItemsProcessed.length === 1" class="text-right">
                                        <span v-if="item.견적서_1688구매금액 && item.견적서_1688구매금액.미입력">
                                            <b-badge variant="danger">未生成账单 / 견적 미입력</b-badge>
                                            <b-button v-if="item.processStatus !== '입금완료'" size="sm" variant="outline-warning" class="ml-1 py-0 px-1" style="font-size:0.65rem;" @click="resetQuotationForRegenerate(item)">重新生成 (재생성)</b-button>
                                        </span>
                                        <span v-else-if="item._최종금액_KRW">
                                            <template v-if="quotationGroupItemsProcessed.length === 1">₩{{ item._최종금액_KRW.toLocaleString() }}</template>
                                            <b-button v-if="item.견적서_1688구매금액 && item.processStatus !== '입금완료'" size="sm" variant="outline-warning" class="ml-1 py-0 px-1" style="font-size:0.65rem;" @click="resetQuotationForRegenerate(item)">重新生成 (재생성)</b-button>
                                        </span>
                                        <span v-else>-</span>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot class="table-secondary">
                                <tr>
                                    <th colspan="9" class="text-right">合计 (합계)
                                        <span v-if="quotationGroupItemsProcessed.length > 1" class="font-weight-normal ml-2">增值税 ₩{{ quotationGroupItemsProcessed.reduce((s, i) => s + (i._부가세 || 0), 0).toLocaleString() }} · 总金额 ₩{{ quotationGroupTotalKRW.toLocaleString() }} · 协商前 ¥{{ quotationGroupCny.pre.toLocaleString() }} · 协商后 ¥{{ quotationGroupCny.post.toLocaleString() }}</span>
                                    </th>
                                    <th v-if="quotationGroupItemsProcessed.length === 1" class="text-right">₩{{ quotationGroupItemsProcessed.reduce((s, i) => s + (i._부가세 || 0), 0).toLocaleString() }}</th>
                                    <th v-if="quotationGroupItemsProcessed.length === 1" class="text-right">₩{{ quotationGroupTotalKRW.toLocaleString() }}</th>
                                </tr>
                            </tfoot>
                        </table>
                        </div>

                        </div>

                        <!-- 견적서 미전송 아이템이 있을 때: 전송 폼 -->
                        <template v-if="quotationGroupUnquotedItems.length > 0">
                            <hr>
                            <div class="alert alert-warning mb-3">
                                <strong>📝 未发送报价单的商品 (견적서 미전송 상품) {{ quotationGroupUnquotedItems.length }}件</strong>
                                <span class="ml-2 text-muted">请在下方选择清关方式并发送报价单 (아래에서 통관타입을 선택하고 견적서를 전송하세요)</span>
                            </div>

                            <div class="p-3 border rounded bg-light">
                                <div class="row mb-3">
                                    <div class="col-12">
                                        <label class="font-weight-bold">清关方式 (통관 타입) <span class="text-danger">*</span></label>
                                        <div class="d-flex" style="gap: 10px;">
                                            <div class="card flex-fill" :class="{ 'border-primary': quotation1688Form.customsType === 'integrated' }" style="cursor:pointer" @click="quotation1688Form.customsType = 'integrated'">
                                                <div class="card-body text-center p-2">
                                                    <input type="radio" v-model="quotation1688Form.customsType" value="integrated">
                                                    <strong class="ml-1">综合清关 (통합통관)</strong>
                                                    <small class="d-block text-muted">CNY × 综合清关汇率 (통합통관환율) × 1.1</small>
                                                </div>
                                            </div>
                                            <div class="card flex-fill" :class="{ 'border-primary': quotation1688Form.customsType === 'kupass' }" style="cursor:pointer" @click="quotation1688Form.customsType = 'kupass'">
                                                <div class="card-body text-center p-2">
                                                    <input type="radio" v-model="quotation1688Form.customsType" value="kupass">
                                                    <strong class="ml-1">COUPASS单独清关 (쿠패스단독통관)</strong>
                                                    <small class="d-block text-muted">(CNY×1.03)×单独清关汇率 (단독통관환율)×1.1</small>
                                                </div>
                                            </div>
                                            <div class="card flex-fill" :class="{ 'border-primary': quotation1688Form.customsType === 'client' }" style="cursor:pointer" @click="quotation1688Form.customsType = 'client'">
                                                <div class="card-body text-center p-2">
                                                    <input type="radio" v-model="quotation1688Form.customsType" value="client">
                                                    <strong class="ml-1">货主单独清关 (화주단독)</strong>
                                                    <small class="d-block text-muted">CNY×单独清关汇率 (단독통관환율)×1.033</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mb-2">
                                    <div class="col-md-6">
                                        <label>汇率 (환율) KRW/CNY</label>
                                        <input type="number" class="form-control form-control-sm" v-model.number="quotation1688Form.환율" :disabled="quotation1688Form.customsType === 'integrated'" @input="quotation1688Form.환율수동 = true">
                                        <small v-if="quotation1688Form.customsType === 'integrated'" class="text-info">适用综合清关汇率 (통합통관환율 적용) {{ integratedExchangeRate }}원</small>
                                        <small v-else-if="quotation1688Form.환율수동" class="text-warning">手动汇率 (직접 입력한 환율 적용)</small>
                                        <small v-else class="text-info">按1688下单日汇率 (1688 주문일 환율 적용{{ quotationOrderFxNote }})</small>
                                    </div>
                                    <div class="col-md-6">
                                        <label>备注 (메모)</label>
                                        <input type="text" class="form-control form-control-sm" v-model="quotation1688Form.메모" placeholder="选填 (선택)">
                                    </div>
                                </div>
                                <!-- 실시간 미리보기 -->
                                <div v-if="quotationPreview" class="mb-3 p-2 border rounded" style="background:#f0f4ff; font-size:0.85rem;">
                                    <div class="d-flex justify-content-between">
                                        <span>1688 合计 (합계) CNY</span>
                                        <strong>¥{{ quotationPreview.totalCNY.toLocaleString() }}</strong>
                                    </div>
                                    <div class="d-flex justify-content-between">
                                        <span>适用汇率 (적용환율)</span>
                                        <strong>{{ quotationPreview.적용환율 }}원/CNY</strong>
                                    </div>
                                    <div class="d-flex justify-content-between">
                                        <span>付款金额 (결제금액) KRW</span>
                                        <strong>₩{{ quotationPreview.결제금액_KRW.toLocaleString() }}</strong>
                                    </div>
                                    <div class="d-flex justify-content-between">
                                        <span>增值税 (부가세)</span>
                                        <strong>₩{{ quotationPreview.부가세.toLocaleString() }}</strong>
                                    </div>
                                    <hr class="my-1">
                                    <div class="d-flex justify-content-between text-primary">
                                        <strong>最终合计 (최종 합계) KRW</strong>
                                        <strong>₩{{ quotationPreview.최종금액합계_KRW.toLocaleString() }}</strong>
                                    </div>
                                </div>
                                <b-button v-if="hasPreNegotiationOverrides" variant="outline-info" block size="sm" class="mb-2" @click="savePreNegotiationPrices">
                                    <b-icon icon="pencil-square"></b-icon> 保存协商前价格 (협상전 가격 저장)
                                </b-button>
                                <b-overlay :show="quotationCreating" rounded="sm">
                                    <b-button variant="primary" block @click="submitQuotationBatch">
                                        <b-icon icon="file-earmark-plus"></b-icon>
                                        批量发送报价单 {{ quotationGroupUnquotedItems.length }}件 (미전송 {{ quotationGroupUnquotedItems.length }}건 일괄 견적서 전송)
                                    </b-button>
                                </b-overlay>
                            </div>
                        </template>

                        <div class="mt-3 text-right">
                            <b-button variant="success" size="sm" @click="downloadQuotationExcel(quotationGroup)" class="mr-2">
                                <b-icon icon="file-earmark-excel"></b-icon> 下载Excel (엑셀 다운로드)
                            </b-button>
                            <b-button variant="danger" size="sm" @click="downloadQuotationPDF(quotationGroup)">
                                <b-icon icon="file-earmark-pdf"></b-icon> 下载PDF (PDF 다운로드)
                            </b-button>
                            <!-- 작업사진·청구서를 고객 카카오 상담창으로 — 여기서는 준비만, 전송은 CS 助手 창의 확인 버튼 (YZY 10-07) -->
                            <b-button variant="warning" size="sm" class="ml-2" :disabled="kakaoSending" @click="sendQuotationToKakao(quotationGroup)">
                                <b-spinner v-if="kakaoSending" small></b-spinner> 📤 发送照片·请款单到Kakao (카카오로 보내기)
                            </b-button>
                        </div>
                    </template>
                </b-modal>

                <!-- 合并请款单 / 합친 청구서 (崔凡 10-07) — 체크한 여러 건의 견적서를 한 장에 나열만 한다.
                     견적·입금상태는 건별 그대로(매입가는 건 단위). 새 견적 계산 없음 — 행은 quotationGroupItemsProcessed 를 건마다 그대로 떠온 것.
                     묶음 표시 = 각 요청건의 청구묶음id 하나. -->
                <b-modal id="merged-bill-modal" title="合并请款单 / 합친 청구서" ok-only ok-title="关闭 / 닫기" dialog-class="quotation-modal-90">
                    <template v-if="mergedBill">
                        <div class="mb-3 p-3 border rounded bg-light" style="font-size:0.85rem;">
                            <div class="row mb-1">
                                <div class="col-4"><strong>货主 / 화주:</strong> {{ mergedBill.companyid }} ({{ mergedBill.companyName }})</div>
                                <div class="col-4"><strong>合并编号 / 청구묶음:</strong>
                                    <b-badge v-if="mergedBill.청구묶음id" variant="primary">{{ mergedBill.청구묶음id }}</b-badge>
                                    <span v-else class="text-muted">未保存 / 저장 전</span>
                                </div>
                                <div class="col-4"><strong>件数 / 건수:</strong> {{ mergedBill.groups.length }}件 · {{ mergedBill.groups.reduce((s, g) => s + g.rows.length, 0) }}个商品</div>
                            </div>
                            <div class="row">
                                <div class="col-4"><strong>营业执照号 (사업자등록번호):</strong> {{ mergedBill.입금정보.사업자등록번호 || '-' }}</div>
                                <div class="col-4"><strong>法人代表 (대표자명):</strong> {{ mergedBill.입금정보.대표자명 || '-' }}</div>
                                <div class="col-4"><strong>邮箱 (이메일):</strong> {{ mergedBill.입금정보.이메일주소 || '-' }}</div>
                            </div>
                        </div>
                        <div v-if="mergedBill.warnings.length" class="alert alert-warning py-2" style="font-size:0.8rem;">
                            <div v-for="(w, wi) in mergedBill.warnings" :key="wi">⚠ {{ w }}</div>
                        </div>
                        <div class="table-responsive">
                        <table class="table table-bordered table-sm" style="font-size:0.75rem;">
                            <thead class="thead-light">
                                <tr>
                                    <th class="text-center">商品名 / 상품명</th>
                                    <th class="text-center">选项ID<br><small>옵션ID</small></th>
                                    <th class="text-center">条码<br><small>바코드</small></th>
                                    <th class="text-center">数量<br><small>수량</small></th>
                                    <th class="text-center" style="background:#fff3cd;">协商后合计(CNY)<br><small>협상후 합계</small></th>
                                    <th class="text-center">折扣率(%)<br><small>할인율</small></th>
                                    <th class="text-center">增值税(KRW)<br><small>부가세</small></th>
                                    <th class="text-center">总金额(KRW)<br><small>총금액</small></th>
                                    <th class="text-center" style="background:#d4edda;">中国物流费<br><small>중국물류비</small></th>
                                    <th class="text-center" style="background:#cce5ff;">公共分摊<br><small>공통배분</small></th>
                                    <th class="text-center" style="background:#d4edda;">韩国物流费<br><small>한국물류비</small></th>
                                </tr>
                            </thead>
                            <tbody v-for="g in mergedBill.groups" :key="g.groupKey">
                                <tr class="table-info">
                                    <td colspan="11">
                                        <!-- 고객용 청구서: 货主订单号(화주주문번호)·申请日期(요청일)는 숨긴다 (崔凡 10-26) -->
                                        <strong>清关 (통관) {{ displayZh(g.통관) }}</strong>
                                        <span class="ml-2">汇率 (환율) {{ g.환율 || '-' }}</span>
                                        <b-badge class="ml-2" :variant="g.입금여부 ? 'success' : 'warning'">{{ g.입금여부 ? '已入账 / 입금완료' : '未入账 / 미입금' }}</b-badge>
                                        <span class="float-right">小计 / 소계 <strong>₩{{ g.소계.toLocaleString() }}</strong></span>
                                    </td>
                                </tr>
                                <tr v-for="r in g.rows" :key="r._id">
                                    <td>{{ r.상품명 }}</td>
                                    <td class="text-center">{{ r.SKUID || '-' }}</td>
                                    <td class="text-center">{{ r.바코드 || '-' }}</td>
                                    <td class="text-center">{{ r.구매요청수량 || 1 }}</td>
                                    <td class="text-right">{{ r.주문정보?.협상후_총금액 != null ? '¥' + r.주문정보.협상후_총금액.toLocaleString() : (r._未改价 ? '¥' + r._협상전_총금액.toLocaleString() : '-') }}<div v-if="r._未改价" class="text-muted" style="font-size:0.6rem;">未改价</div></td>
                                    <td class="text-center">{{ r._할인율 ? r._할인율 + '%' : '-' }}</td>
                                    <td class="text-right">{{ r._부가세 ? '₩' + r._부가세.toLocaleString() : '-' }}</td>
                                    <td class="text-right">
                                        <b-badge v-if="r._미생성" variant="danger">未报价 / 견적 미생성</b-badge>
                                        <span v-else>₩{{ (r._최종금액_KRW || 0).toLocaleString() }}</span>
                                    </td>
                                    <td class="text-right" style="background:#f0fff0;">{{ r._중국물류비 ? '₩' + r._중국물류비.toLocaleString() : '-' }}</td>
                                    <td class="text-right" style="background:#f0f4ff;">{{ r._공통배분 ? '₩' + r._공통배분.toLocaleString() : '-' }}</td>
                                    <td class="text-right" style="background:#f0fff0;">{{ r._한국물류비 ? '₩' + r._한국물류비.toLocaleString() : '-' }}</td>
                                </tr>
                            </tbody>
                            <tfoot class="table-secondary">
                                <tr>
                                    <th colspan="6" class="text-right">合计 / 합계</th>
                                    <th class="text-right">₩{{ mergedBill.합계.부가세.toLocaleString() }}</th>
                                    <th class="text-right">₩{{ mergedBill.합계.총금액.toLocaleString() }}</th>
                                    <th class="text-right">₩{{ mergedBill.합계.중국물류비.toLocaleString() }}</th>
                                    <th class="text-right">₩{{ mergedBill.합계.공통배분.toLocaleString() }}</th>
                                    <th class="text-right">₩{{ mergedBill.합계.한국물류비.toLocaleString() }}</th>
                                </tr>
                            </tfoot>
                        </table>
                        </div>
                        <div class="p-2 border rounded text-right" style="background:#f0f4ff;">
                            <strong class="text-primary">请款合计 / 청구 합계(1688 구매금액): ₩{{ mergedBill.합계.총금액.toLocaleString() }}</strong>
                            <div v-if="mergedBill.합계.중국물류비 + mergedBill.합계.공통배분 + mergedBill.합계.한국물류비 > 0" class="small text-muted">
                                物流费另行请款 / 물류비는 기존처럼 별도 입금요청
                            </div>
                        </div>
                        <div class="mt-3 d-flex justify-content-between">
                            <div>
                                <b-button v-if="!mergedBill.청구묶음id" variant="primary" size="sm" class="mr-2" :disabled="mergedBillSaving" @click="saveMergedBillTag">
                                    <b-icon icon="link45deg"></b-icon> 保存合并 / 묶음 저장
                                </b-button>
                                <b-button v-else variant="outline-secondary" size="sm" class="mr-2" :disabled="mergedBillSaving" @click="releaseMergedBillTag">
                                    <b-icon icon="x-circle"></b-icon> 解除合并 / 묶음 해제
                                </b-button>
                                <b-button variant="warning" size="sm" :disabled="mergedBillSaving || !mergedBill.groups.some(g => !g.입금여부)" @click="confirmMergedBillPayment">
                                    <b-icon icon="check2-circle"></b-icon> 合并确认入账 / 묶음 입금확인
                                </b-button>
                            </div>
                            <div>
                                <b-button variant="success" size="sm" class="mr-2" @click="downloadMergedBillExcel">
                                    <b-icon icon="file-earmark-excel"></b-icon> 下载Excel (엑셀 다운로드)
                                </b-button>
                                <b-button variant="danger" size="sm" @click="downloadMergedBillPDF">
                                    <b-icon icon="file-earmark-pdf"></b-icon> 下载PDF (PDF 다운로드)
                                </b-button>
                            </div>
                        </div>
                    </template>
                </b-modal>
            </div>
            <div class="col-lg-12 mt-n3">
                <b-card class="search-card">
                    <form @submit.prevent="submit">
                        <div class="search-row">
                            <!-- 기간 선택 -->
                            <div class="search-group search-group--period">
                                <div class="custom-control custom-radio custom-control-inline">
                                    <input type="radio" id="customRadio7" name="customRadio-2"
                                        class="custom-control-input" v-model="selectdate" value="today"
                                        @change="changedate()">
                                    <label class="custom-control-label" for="customRadio7">今天 (오늘)</label>
                                </div>
                                <div class="custom-control custom-radio custom-control-inline">
                                    <input type="radio" id="customRadio8" name="customRadio-2"
                                        class="custom-control-input" v-model="selectdate" value="week"
                                        @change="changedate()">
                                    <label class="custom-control-label" for="customRadio8">7天 (7일)</label>
                                </div>
                                <div class="custom-control custom-radio custom-control-inline">
                                    <input type="radio" id="customRadio9" name="customRadio-2"
                                        class="custom-control-input" v-model="selectdate" value="month"
                                        @change="changedate()">
                                    <label class="custom-control-label" for="customRadio9">1个月 (1개월)</label>
                                </div>
                            </div>
                            <!-- 날짜 선택 -->
                            <div class="search-group search-group--date">
                                <select class="custom-select w-25" v-model="selectoption">
                                    <option value="요청일">请求日 (요청일)</option>
                                </select>
                                <b-form-datepicker class="w-50 h-100" id="example-datepicker1" size="sm" v-model="startdate"></b-form-datepicker>
                                <span class="date-separator">~</span>
                                <b-form-datepicker class="w-50" id="example-datepicker2" size="sm" v-model="enddate"></b-form-datepicker>
                            </div>
                            <!-- 업체ID -->
                            <div class="search-group search-group--company">
                                <b-form-input type="text" class="form-control" list="my-list-id"
                                    placeholder="货主ID (업체ID)" @keyup.enter="importtextchange($event)"
                                    v-model="업체명"></b-form-input>
                                <datalist id="my-list-id">
                                    <option v-for="companyid in companyidOptions" :key="companyid">{{ companyid }}</option>
                                </datalist>
                            </div>
                            <!-- 구매전 스위치 -->
                            <div class="search-group search-group--switch">
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" id="customSwitch1"
                                        v-model="tobepurchase">
                                    <label class="custom-control-label" for="customSwitch1">待采购(구매전)</label>
                                </div>
                            </div>
                            <!-- 검색 버튼 -->
                            <button type="button" class="btn btn-primary search-btn" @click="clearBatchSearch(false); search()">检索</button>
                        </div>
                        <!-- 주문 조회 (화주주문번호/1688주문번호/운송장번호) -->
                        <div class="search-row search-row--lookup mt-2">
                            <div class="search-group search-group--lookup-type">
                                <label class="mb-0 mr-1 text-muted" style="font-size: 0.8rem; white-space: nowrap;">🔍 订单查询 (주문조회)</label>
                                <select class="custom-select custom-select-sm" v-model="orderLookupType" style="max-width: 140px;">
                                    <option value="order">货主订单号 (화주주문번호)</option>
                                    <option value="order1688">1688订单号 (1688주문번호)</option>
                                    <option value="tracking">快递单号 (운송장번호)</option>
                                    <option value="batch">批次号 (묶음번호)</option>
                                </select>
                            </div>
                            <div class="search-group search-group--lookup-input">
                                <b-form-input type="text" size="sm"
                                    :placeholder="orderLookupPlaceholder"
                                    v-model="orderLookupKeyword"
                                    @keyup.enter="searchByOrder()"></b-form-input>
                            </div>
                            <button type="button" class="btn btn-outline-primary btn-sm" @click="searchByOrder()" :disabled="orderLookupLoading">
                                <b-spinner v-if="orderLookupLoading" small></b-spinner>
                                <span v-else>查询 (조회)</span>
                            </button>
                        </div>
                        <img v-if="showspinner" style="max-width:100%;"
                            :src="require('../../../assets/images/small/spinner.gif')">
                    </form>
                </b-card>
            </div>
            <div class="col-lg-12 mt-n5" v-if="showreqlist">
                <div class="filter-container mb-3">
                    <!-- 진행현황 필터 그룹 — 전체·1688구매·입금 은 한 줄(2026-10-07 YZY) -->
                    <div class="d-flex flex-wrap gap-2">
                    <div class="filter-group">
                        <span class="filter-group__title">📋 全部<br><small class="text-muted">전체</small></span>
                        <div class="filter-group__buttons">
                            <b-button :variant="activeFilter === 'total' ? 'secondary' : 'outline-secondary'"
                                size="sm" class="filter-btn filter-btn--bilingual" @click="showtotal(); activeFilter = 'total'">
                                <span>全部<br><small>전체</small></span> <b-badge variant="outline-secondary">{{ total }}</b-badge>
                            </b-button>
                        </div>
                    </div>
                    <div class="filter-group">
                        <span class="filter-group__title">🏪 1688采购<br><small class="text-muted">1688구매</small></span>
                        <div class="filter-group__buttons">
                            <b-button :variant="activeFilter === '구매전' ? 'secondary' : (statusCounts.구매전 ? 'outline-secondary' : 'outline-light')"
                                size="sm" class="filter-btn filter-btn--bilingual" :class="{ 'filter-btn--dim': !statusCounts.구매전 }"
                                @click="showStatus('구매전'); activeFilter = '구매전'">
                                <span>待采购<br><small>구매전</small></span> <b-badge :variant="statusCounts.구매전 ? 'secondary' : 'light'">{{ statusCounts.구매전 || 0 }}</b-badge>
                            </b-button>
                            <b-button :variant="activeFilter === '협상중' ? 'secondary' : (statusCounts.협상중 ? 'outline-secondary' : 'outline-light')"
                                size="sm" class="filter-btn filter-btn--bilingual" :class="{ 'filter-btn--dim': !statusCounts.협상중 }"
                                @click="showStatus('협상중'); activeFilter = '협상중'">
                                <span>协商中<br><small>협상중</small></span> <b-badge :variant="statusCounts.협상중 ? 'secondary' : 'light'">{{ statusCounts.협상중 || 0 }}</b-badge>
                            </b-button>
                            <b-button :variant="activeFilter === '구매완료' ? 'secondary' : (statusCounts.구매완료 ? 'outline-secondary' : 'outline-light')"
                                size="sm" class="filter-btn filter-btn--bilingual" :class="{ 'filter-btn--dim': !statusCounts.구매완료 }"
                                @click="showStatus('구매완료'); activeFilter = '구매완료'">
                                <span>已付款<br><small>구매완료</small></span> <b-badge :variant="statusCounts.구매완료 ? 'secondary' : 'light'">{{ statusCounts.구매완료 || 0 }}</b-badge>
                            </b-button>
                            <b-button :variant="activeFilter === '구매보류' ? 'secondary' : (statusCounts.구매보류 ? 'outline-secondary' : 'outline-light')"
                                size="sm" class="filter-btn filter-btn--bilingual" :class="{ 'filter-btn--dim': !statusCounts.구매보류 }"
                                @click="showStatus('구매보류'); activeFilter = '구매보류'">
                                <span>采购保留<br><small>구매보류</small></span> <b-badge :variant="statusCounts.구매보류 ? 'secondary' : 'light'">{{ statusCounts.구매보류 || 0 }}</b-badge>
                            </b-button>
                            <b-button :variant="activeFilter === '구매취소' ? 'secondary' : (statusCounts.구매취소 ? 'outline-secondary' : 'outline-light')"
                                size="sm" class="filter-btn filter-btn--bilingual" :class="{ 'filter-btn--dim': !statusCounts.구매취소 }"
                                @click="showStatus('구매취소'); activeFilter = '구매취소'">
                                <span>采购取消<br><small>구매취소</small></span> <b-badge :variant="statusCounts.구매취소 ? 'secondary' : 'light'">{{ statusCounts.구매취소 || 0 }}</b-badge>
                            </b-button>
                        </div>
                    </div>
                    <div class="filter-group">
                        <span class="filter-group__title">💰 入账<br><small class="text-muted">입금</small></span>
                        <div class="filter-group__buttons">
                            <b-button :variant="activeFilter === '입금요청' ? 'secondary' : (statusCounts.입금요청 ? 'outline-secondary' : 'outline-light')"
                                size="sm" class="filter-btn filter-btn--bilingual" :class="{ 'filter-btn--dim': !statusCounts.입금요청 }"
                                @click="showStatus('입금요청'); activeFilter = '입금요청'">
                                <span>已发账单客户未转账<br><small>입금요청</small></span> <b-badge :variant="statusCounts.입금요청 ? 'warning' : 'light'">{{ statusCounts.입금요청 || 0 }}</b-badge>
                            </b-button>
                            <b-button :variant="activeFilter === '입금완료' ? 'secondary' : (statusCounts.입금완료 ? 'outline-secondary' : 'outline-light')"
                                size="sm" class="filter-btn filter-btn--bilingual" :class="{ 'filter-btn--dim': !statusCounts.입금완료 }"
                                @click="showStatus('입금완료'); activeFilter = '입금완료'">
                                <span>已入账<br><small>입금완료</small></span> <b-badge :variant="statusCounts.입금완료 ? 'primary' : 'light'">{{ statusCounts.입금완료 || 0 }}</b-badge>
                            </b-button>
                            <!-- 결제진행 = 표의 「결제진행」 칸이 「미결제」(누르면 결제)인 건: 1688 주문 있음 · 입금확인 · 최종결제 전. 새 상태값 아님 -->
                            <b-button :variant="activeFilter === '결제진행' ? 'secondary' : (paymentPendingCount ? 'outline-secondary' : 'outline-light')"
                                size="sm" class="filter-btn filter-btn--bilingual" :class="{ 'filter-btn--dim': !paymentPendingCount }"
                                @click="showPaymentPending(); activeFilter = '결제진행'">
                                <span>已入账订单未付款<br><small>입금완료미결제</small></span> <b-badge :variant="paymentPendingCount ? 'warning' : 'light'">{{ paymentPendingCount }}</b-badge>
                            </b-button>
                        </div>
                    </div>
                    </div>
                    <!-- 1688배송·쿠패스·쿠팡입고·국내창고 카드는 订单列表 위로 옮겼다(2026-10-07 YZY). 거기서 누르면 여기로 와서 그 진행현황으로 걸러진다 -->
                    <div v-if="stageFilterLabel" class="filter-group">
                        <span class="filter-group__title">🔎 进度筛选<br><small class="text-muted">진행현황 필터</small></span>
                        <div class="filter-group__buttons">
                            <b-button variant="secondary" size="sm" class="filter-btn filter-btn--bilingual" @click="showtotal(); activeFilter = 'total'">
                                <span>{{ stageFilterLabel }}</span> <b-badge variant="light">{{ statusCounts[activeFilter] || 0 }}</b-badge> ✕
                            </b-button>
                        </div>
                    </div>
                    <!-- 배송유형 + 통관방법 필터 그룹 (같은 줄) -->
                    <div class="d-flex flex-wrap gap-2">
                        <div class="filter-group flex-grow-1">
                            <span class="filter-group__title">🚚 配送类型<br><small class="text-muted">배송유형</small></span>
                            <div class="filter-group__buttons">
                                <b-button :variant="activeFilter === '일반배송' ? 'secondary' : (일반배송 ? 'outline-secondary' : 'outline-light')"
                                    size="sm" class="filter-btn filter-btn--bilingual" :class="{ 'filter-btn--dim': !일반배송 }"
                                    @click="showi(); activeFilter = '일반배송'">
                                    <span>一般货主件<br><small>일반배송</small></span> <b-badge :variant="일반배송 ? 'secondary' : 'light'">{{ 일반배송 }}</b-badge>
                                </b-button>
                                <!-- 로켓배송은 일반배송과 따로 센다(2026-10-07 YZY). 예전엔 「제트배송이 아니면 일반」이라 둘이 합쳐 보였다 -->
                                <b-button :variant="activeFilter === '로켓배송' ? 'secondary' : (로켓배송 ? 'outline-secondary' : 'outline-light')"
                                    size="sm" class="filter-btn filter-btn--bilingual" :class="{ 'filter-btn--dim': !로켓배송 }"
                                    @click="showRocket(); activeFilter = '로켓배송'">
                                    <span>快递资料件<br><small>로켓배송</small></span> <b-badge :variant="로켓배송 ? 'secondary' : 'light'">{{ 로켓배송 }}</b-badge>
                                </b-button>
                                <b-button :variant="activeFilter === '제트배송' ? 'secondary' : (노마드클럽 ? 'outline-secondary' : 'outline-light')"
                                    size="sm" class="filter-btn filter-btn--bilingual" :class="{ 'filter-btn--dim': !노마드클럽 }"
                                    @click="showe(); activeFilter = '제트배송'">
                                    <span>入库Coupang件<br><small>제트배송</small></span> <b-badge :variant="노마드클럽 ? 'secondary' : 'light'">{{ 노마드클럽 }}</b-badge>
                                </b-button>
                                <b-button :variant="activeFilter === '샘플검증' ? 'secondary' : (샘플검증 ? 'outline-secondary' : 'outline-light')"
                                    size="sm" class="filter-btn filter-btn--bilingual" :class="{ 'filter-btn--dim': !샘플검증 }"
                                    @click="showk(); activeFilter = '샘플검증'">
                                    <span>样品检测件<br><small>샘플검증</small></span> <b-badge :variant="샘플검증 ? 'secondary' : 'light'">{{ 샘플검증 }}</b-badge>
                                </b-button>
                                <b-button :variant="요청변경 > 0 ? 'danger' : (activeFilter === '요청변경' ? 'secondary' : 'outline-light')"
                                    size="sm" class="filter-btn filter-btn--bilingual"
                                    :class="{ 'filter-btn--dim': !요청변경, 'change-review-pulse': 요청변경 > 0 }"
                                    @click="showl(); activeFilter = '요청변경'">
                                    <b-icon v-if="요청변경 > 0" icon="exclamation-triangle-fill" class="mr-1"></b-icon>
                                    <span>请求变更<br><small>요청변경</small></span> <b-badge :variant="요청변경 > 0 ? 'light' : 'secondary'">{{ 요청변경 }}</b-badge>
                                </b-button>
                            </div>
                        </div>
                        <div class="filter-group flex-grow-1">
                            <span class="filter-group__title">📋 清关方式<br><small class="text-muted">통관방법</small></span>
                            <div class="filter-group__buttons">
                                <b-button :variant="activeFilter === '통합통관' ? 'secondary' : (통합통관 ? 'outline-secondary' : 'outline-light')"
                                    size="sm" class="filter-btn filter-btn--bilingual" :class="{ 'filter-btn--dim': !통합통관 }"
                                    @click="showC1(); activeFilter = '통합통관'">
                                    <span>综合清关<br><small>통합통관</small></span> <b-badge :variant="통합통관 ? 'secondary' : 'light'">{{ 통합통관 }}</b-badge>
                                </b-button>
                                <b-button :variant="activeFilter === '단독통관' ? 'secondary' : (단독통관 ? 'outline-secondary' : 'outline-light')"
                                    size="sm" class="filter-btn filter-btn--bilingual" :class="{ 'filter-btn--dim': !단독통관 }"
                                    @click="showC2(); activeFilter = '단독통관'">
                                    <span>单独清关<br><small>단독통관</small></span> <b-badge :variant="단독통관 ? 'secondary' : 'light'">{{ 단독통관 }}</b-badge>
                                </b-button>
                                <b-button :variant="activeFilter === '쿠패스단독통관' ? 'secondary' : (쿠패스단독통관 ? 'outline-secondary' : 'outline-light')"
                                    size="sm" class="filter-btn filter-btn--bilingual" :class="{ 'filter-btn--dim': !쿠패스단독통관 }"
                                    @click="showC3(); activeFilter = '쿠패스단독통관'">
                                    <span>COUPASS单独清关<br><small>쿠패스단독통관</small></span> <b-badge :variant="쿠패스단독통관 ? 'secondary' : 'light'">{{ 쿠패스단독통관 }}</b-badge>
                                </b-button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 批量搜索 결과에서 못 찾은 번호 — 이 번호들은 목록에 없다 -->
                <b-alert v-if="batchSearchNos.length && batchSearchNotFound.length" show variant="warning" class="mb-2 py-2">
                    未找到 {{ batchSearchNotFound.length }}个 (못 찾은 번호 {{ batchSearchNotFound.length }}개):
                    <span v-for="no in batchSearchNotFound" :key="no" class="badge badge-light mr-1" style="user-select: all;">{{ no }}</span>
                </b-alert>
                <!-- 화주명 일괄 필터 — 칩을 누르면 그 화주만 뺀다. 못 찾은 화주는 이 기간에 (구매전) 건이 없거나 ID 가 다르다 -->
                <div v-if="ownerFilterNames.length" class="mb-2 small">
                    <span class="mr-1">货主筛选 / 화주 필터{{ ownerFilterOnlyBefore ? ' (待采购 / 구매전)' : '' }}:</span>
                    <b-badge v-for="n in ownerFilterNames" :key="n" pill class="mr-1 batch-search-chip"
                        :variant="ownerFilterNotFound.includes(n) ? 'secondary' : 'primary'"
                        title="点击移除 / 클릭하면 이 화주를 뺍니다" @click="removeOwnerFilterName(n)">{{ n }} ✕</b-badge>
                    <a href="#" class="ml-2" @click.prevent="clearOwnerFilter()">全部取消 / 전체 해제</a>
                </div>
                <b-alert v-if="ownerFilterNames.length && ownerFilterNotFound.length" show variant="warning" class="mb-2 py-2">
                    未找到 {{ ownerFilterNotFound.length }}个货主（该日期无数据或ID不同）/ 못 찾은 화주 {{ ownerFilterNotFound.length }}개 (이 기간에 건이 없거나 ID 가 다름):
                    <span v-for="n in ownerFilterNotFound" :key="n" class="badge badge-light mr-1" style="user-select: all;">{{ n }}</span>
                </b-alert>
                <!-- 뷰 모드 토글 버튼 -->
                <div class="d-flex justify-content-end mb-3">
                    <b-button-group size="sm">
                        <b-button :variant="viewMode === 'group' ? 'primary' : 'outline-primary'" @click="viewMode = 'group'">
                            <b-icon icon="collection"></b-icon> 分组视图 (그룹 뷰)
                        </b-button>
                        <b-button :variant="viewMode === 'individual' ? 'primary' : 'outline-primary'" @click="viewMode = 'individual'">
                            <b-icon icon="list-ul"></b-icon> 单品视图 (개별 상품 뷰)
                        </b-button>
                    </b-button-group>
                </div>

                <!-- ========== 그룹 뷰 CDataTable ========== -->
                <CDataTable class="reqlist-group"
                    storage-key="logisreqpurchaseV0.1" v-if="viewMode === 'group'" :headers="groupHeaders" :items="groupedReqlists"
                    v-model="tableSelectedItem" :show-select="true" itemKey="groupKey">
                    <template v-slot:search-append>
                        <b-button size="sm" variant="outline-primary" class="ml-2 text-nowrap align-self-center" @click="openBatchSearch">
                            <b-icon icon="list-check"></b-icon> 批量搜索 / 일괄 검색
                        </b-button>
                        <b-badge v-if="batchSearchNos.length" variant="primary" pill class="ml-2 align-self-center batch-search-chip"
                            title="点击取消批量搜索 / 클릭하면 일괄 검색 해제" @click="clearBatchSearch">
                            批量搜索 {{ batchSearchNos.length }}个 ✕
                        </b-badge>
                    </template>
                    <template v-slot:화주주문번호="{ item }">
                        <span v-if="item.화주주문번호" class="badge badge-info" :title="item.화주주문번호목록.join('\n')">{{ item.화주주문번호 }}<template v-if="item.화주주문번호목록.length > 1"> +{{ item.화주주문번호목록.length - 1 }}</template></span>
                        <span v-else class="text-muted">-</span>
                    </template>
                    <template v-slot:요청일="{ item }">
                        {{ getTimeDate(item.요청일) }}
                        <div v-if="item.묶음번호목록.length" class="small text-muted" :title="'批次号 (묶음번호)\n' + item.묶음번호목록.join('\n')">批次 (묶음) {{ item.묶음번호목록[0] }}<template v-if="item.묶음번호목록.length > 1"> +{{ item.묶음번호목록.length - 1 }}</template></div>
                    </template>
                    <template v-slot:reqtype="{ item }">
                        <!-- 샘플검증이 먼저다. 「일반 + 샘플」 두 뱃지로 나눠 보이던 것을 한 칸으로 합쳤다
                             (2026-09-16 YZY 요청 — 요청타입·유형·엑셀 세 자리를 같은 표기로 통일).
                             샘플검증은 일반LCL 에만 붙는 옵션이라 배송타입 정보가 사라지지 않는다.
                             ⚠ 여기 item 은 원본 요청건이 아니라 groupedReqlists 가 만든 **그룹 행**이다.
                             그룹 행에는 요청내역이 안 담겨서 hasSampleCheck(item) 는 영원히 false 다
                             (2026-09-17 YZY 제보 — 그룹 뷰에서만 「일반」 으로 보이던 원인).
                             ⇒ 그룹을 만들 때 담아둔 집계 플래그를 본다. -->
                        <span v-if="item.샘플검증" class="badge badge-info">样品检测件<small class="d-block">샘플검증</small></span>
                        <span v-else-if="item.reqtype === '제트배송'" class="badge badge-primary">入库Coupang件<small class="d-block">제트배송</small></span>
                        <span v-else-if="item.reqtype === '로켓배송'" class="badge badge-success">快递资料件<small class="d-block">로켓배송</small></span>
                        <span v-else-if="item.reqtype === '일반LCL' || item.reqtype === '일반'" class="badge badge-dark">一般货主件<small class="d-block">일반배송</small></span>
                        <span v-else class="badge badge-secondary">{{ zhKo(item.reqtype).zh }}<small v-if="zhKo(item.reqtype).ko" class="d-block">{{ zhKo(item.reqtype).ko }}</small></span>
                        <span v-if="item.요청내역 && item.요청내역.destination === 'customer'" class="badge badge-warning ml-1" v-b-tooltip.hover title="货主收货 (화주 도착지)">货主 (화주)</span>
                        <span v-if="item.비1688 && !item.최종결제여부" class="badge badge-danger ml-1" v-b-tooltip.hover title="非1688商品，手动转账给商家采购(不走1688下单/付款) / 1688 외 상품 — 판매자에게 직접 송금해 구매">需手动下单(수동 주문 필요)</span>
                    </template>
                    <template v-slot:업체정보="{ item }">
                        <span class="font-weight-bold" style="word-break: break-all;">{{ item.companyid }}</span>
                        <br><small class="text-muted">{{ item.companyName }}</small>
                    </template>
                    <template v-slot:진행현황="{ item }">
                        <!-- 선적이 있으면 수량 분포, 없으면 지금까지 쓰던 뱃지 그대로(정본 §4) -->
                        <div v-if="distOf(item)" style="cursor: pointer;"
                            @click="openProcessHistoryModal(item)"
                            v-b-tooltip.hover title="点击查看变更记录 (클릭하여 변경 이력 보기)">
                            <ProgressDistribution :dist="distOf(item)" />
                        </div>
                        <b-badge v-else :variant="getStatusVariant(item.processStatus || item.진행현황)"
                            style="cursor: pointer;"
                            @click="openProcessHistoryModal(item)"
                            v-b-tooltip.hover title="点击查看变更记录 (클릭하여 변경 이력 보기)">
                            {{ zhKo(item.processStatus || item.진행현황).zh }}<small v-if="zhKo(item.processStatus || item.진행현황).ko" class="d-block">{{ zhKo(item.processStatus || item.진행현황).ko }}</small>
                        </b-badge>
                    </template>
                    <template v-slot:통관방법="{ item }">
                        <b-badge :variant="item.통관방법 === '통합통관' ? 'info' : 'secondary'">{{ zhKo(item.통관방법).zh || '-' }}<small v-if="zhKo(item.통관방법).ko" class="d-block">{{ zhKo(item.통관방법).ko }}</small></b-badge>
                    </template>
                    <template v-slot:구매코드1688="{ item }">
                        <code class="text-dark" style="font-size: 11px; word-break: break-all;">{{ item.구매코드1688 }}</code>
                        <b-button size="sm" variant="link" class="p-0 ml-1"
                            @click="copyToClipboard(item.구매코드1688)" v-b-tooltip.hover title="复制 (복사)">
                            <b-icon icon="clipboard" scale="0.7"></b-icon>
                        </b-button>
                        <div v-if="sellerOrderNos(item).length" class="small" v-b-tooltip.hover title="商家订单号 / 판매처 주문번호"><span style="user-select:none">商家: </span>{{ sellerOrderNos(item).join(', ') }}</div>
                    </template>
                    <template v-slot:상품수수량="{ item }">
                        {{ item.품목수 }} <small class="text-muted">({{ item.총수량 }})</small>
                    </template>
                    <template v-slot:수정여부="{ item }">
                        <b-icon v-if="item.수정여부" icon="check-circle-fill" variant="warning"
                            v-b-tooltip.hover :title="'修改 (수정) ' + item.수정내용.length + '件'"></b-icon>
                        <span v-else class="text-muted">-</span>
                    </template>
                    <template v-slot:주문생성여부="{ item }">
                        <!-- 非1688(自行采购) 그룹은 1688 주문을 만들지 않는다 — 송금 처리로 대신한다 -->
                        <template v-if="item.비1688">
                            <b-badge v-if="item.최종결제여부" variant="success" style="cursor: pointer;"
                                @click="openNon1688Transfer(item.items)"
                                v-b-tooltip.hover title="点此修改(商家订单号等) / 클릭해서 수정(판매처 주문번호 등)">已转账</b-badge>
                            <b-badge v-else-if="canManualTransfer(item)" variant="danger" style="cursor: pointer;"
                                @click="openNon1688Transfer(item.items)"
                                v-b-tooltip.hover title="非1688: 手动转账后点此 / 송금 후 클릭">已转账?</b-badge>
                            <b-badge v-else variant="secondary" v-b-tooltip.hover title="确认入账后可登记转账 (입금 확인 후 송금 등록 가능)">需手动下单</b-badge>
                        </template>
                        <b-badge v-else-if="item.주문생성여부" variant="success">完成 (완료)</b-badge>
                        <b-badge v-else-if="['구매전','구매확인'].includes(item.processStatus || item.진행현황)"
                            variant="warning"
                            style="cursor: pointer;"
                            @click="createOrderFromTable(item)"
                            v-b-tooltip.hover title="点击创建1688订单 (클릭하여 1688 주문 생성)">未生成订单<small class="d-block">미생성</small></b-badge>
                        <b-badge v-else variant="secondary"
                            v-b-tooltip.hover title="仅待采购/采购确认状态可下单 (구매전/구매확인 상태에서만 주문 가능)">未生成订单<small class="d-block">미생성</small></b-badge>
                        <b-icon v-if="groupOrderErrors[item.groupKey]"
                            icon="exclamation-triangle-fill"
                            variant="danger"
                            class="ml-1"
                            style="cursor: pointer;"
                            @click.stop="openGroupDetailWithError(item)"
                            v-b-tooltip.hover :title="groupOrderErrors[item.groupKey]"></b-icon>
                    </template>
                    <template v-slot:주문시간="{ item }">
                        <span v-if="item.주문시간">{{ getTimeDate(item.주문시간) }}</span>
                        <span v-else class="text-muted">-</span>
                    </template>
                    <template v-slot:가격확인="{ item }">
                        <div class="text-center">
                            <b-button v-if="item.주문생성여부 && item.items && item.items[0] && item.items[0].주문정보?.['1688주문번호']"
                                size="sm" variant="outline-info" style="font-size: 0.7rem; padding: 2px 6px;"
                                @click.stop="checkPriceModification(item)" :disabled="checkingPrice">
                                {{ checkingPrice ? '确认中 (확인중)...' : '价格确认 (가격확인)' }}
                            </b-button>
                            <span v-else class="text-muted">-</span>
                        </div>
                    </template>
                    <template v-slot:협상전가격="{ item }">
                        <span v-if="item.협상전가격">¥{{ item.협상전가격.toLocaleString() }}</span>
                        <span v-else class="text-muted">-</span>
                    </template>
                    <template v-slot:협상후가격="{ item }">
                        <span v-if="item.협상후가격">¥{{ item.협상후가격.toLocaleString() }}</span>
                        <span v-else class="text-muted">-</span>
                    </template>
                    <template v-slot:견적서금액CNY="{ item }">
                        <span v-if="item.견적서금액CNY">¥{{ item.견적서금액CNY.toLocaleString() }}</span>
                        <span v-else class="text-muted">-</span>
                    </template>
                    <template v-slot:견적서금액KRW="{ item }">
                        <span v-if="item.견적서금액KRW"
                            class="text-primary" style="cursor: pointer; text-decoration: underline;"
                            @click="openQuotationModal(item)">
                            ₩{{ item.견적서금액KRW.toLocaleString() }}
                        </span>
                        <!-- 非1688 은 견적 금액을 직원이 채운다. 비어 있으면 0원으로 보이지 않게 표시(YZY 10-07) -->
                        <span v-else-if="!item.견적미입력" class="text-muted">-</span>
                        <b-badge v-if="item.견적미입력" variant="danger" class="d-block" style="cursor: pointer;" @click="openQuotationModal(item)"
                            v-b-tooltip.hover title="非1688: 点此填写见积 / 클릭해서 견적 입력">未生成账单 / 견적 미입력</b-badge>
                        <!-- 合并请款单 묶음 표시 — 클릭하면 같은 묶음 전체를 한 장으로 연다 -->
                        <b-badge v-if="mergedBillIdOf(item)" variant="primary" class="d-block mt-1" style="cursor: pointer;"
                            @click="openMergedBillById(mergedBillIdOf(item))"
                            v-b-tooltip.hover title="合并请款单 / 합친 청구서 보기">合并 {{ mergedBillIdOf(item) }}</b-badge>
                    </template>
                    <template v-slot:입금여부="{ item }">
                        <b-badge v-if="item.입금여부" variant="success"
                            style="cursor: pointer;" @click="togglePaymentStatus(item, false)"
                            v-b-tooltip.hover title="点击改为未入账 (클릭하여 미입금으로 변경)">已入账<small class="d-block">입금완료</small></b-badge>
                        <b-badge v-else-if="item.견적서금액KRW" variant="warning"
                            style="cursor: pointer;" @click="togglePaymentStatus(item, true)"
                            v-b-tooltip.hover title="点击改为已入账 (클릭하여 입금완료로 변경)">未入账<small class="d-block">미입금</small></b-badge>
                        <b-badge v-else variant="secondary" v-b-tooltip.hover title="先填报价金额(不能为0)并生成报价单后，才可处理入账 (견적 금액을 먼저 입력(0 불가)하고 견적서를 생성한 뒤 입금처리 가능)">未入账<small class="d-block">미입금</small></b-badge>
                    </template>
                    <template v-slot:총결제금액CNY="{ item }">
                        <span v-if="item.총결제금액CNY">¥{{ item.총결제금액CNY.toLocaleString() }}</span>
                        <span v-else class="text-muted">-</span>
                    </template>
                    <template v-slot:최종결제여부="{ item }">
                        <b-badge v-if="item.최종결제여부" variant="success">完成 (완료)</b-badge>
                        <b-badge v-else-if="item.주문생성여부 && item.입금여부"
                            variant="warning"
                            style="cursor: pointer;"
                            @click="proceedPaymentFromTable(item)"
                            v-b-tooltip.hover title="点击付款 (클릭하여 결제진행)">订单未付款<small class="d-block">미결제</small></b-badge>
                        <b-badge v-else variant="secondary"
                            v-b-tooltip.hover
                            :title="!item.주문생성여부 ? '创建订单后可付款 (주문 생성 후 결제 가능)' : '确认入账后可付款 (입금 확인 후 결제 가능)'">订单未付款<small class="d-block">미결제</small></b-badge>
                    </template>
                    <template v-slot:구매메모="{ item }">
                        <span v-if="item.구매메모" style="white-space:pre-wrap;font-size:0.8rem;">{{ item.구매메모 }}</span>
                        <span v-else class="text-muted">-</span>
                    </template>
                    <template v-slot:구매메모사진="{ item }">
                        <div v-if="item.구매메모사진 && item.구매메모사진.length" class="d-flex flex-wrap justify-content-center" style="gap:3px;">
                            <a v-for="(u, ui) in item.구매메모사진" :key="'gpn' + ui" :href="u" target="_blank" rel="noopener"><img :src="u" alt="" style="width:36px;height:36px;object-fit:cover;border-radius:3px;border:1px solid #ddd;"></a>
                        </div>
                        <span v-else class="text-muted">-</span>
                    </template>
                    <template v-slot:쿠패스메모="{ item }">
                        <span v-if="item.쿠패스메모" class="text-truncate" style="max-width: 140px; display: inline-block;"
                            v-b-tooltip.hover :title="item.쿠패스메모">{{ item.쿠패스메모 }}</span>
                        <span v-else class="text-muted">-</span>
                    </template>
                    <template v-slot:action="{ item }">
                        <b-button size="sm" variant="info" @click="openGroupDetail(item)" v-b-tooltip.hover title="查看详情 (상세보기)">
                            <b-icon icon="eye"></b-icon>
                        </b-button>
                    </template>
                </CDataTable>

                <!-- ========== 개별 상품 뷰 CDataTable (기존) ========== -->
                <CDataTable class="reqlist-individual"
                    storage-key="logisreqpurchaseV0.2" v-if="viewMode === 'individual'" :headers="headers" :items="reqlists" v-model="tableSelectedItem" :show-select="true"
                    itemKey="_id" :row-class="getRowHighlightClass" :search-text="reqSearchText">
                    <template v-slot:search-append>
                        <b-button size="sm" variant="outline-primary" class="ml-2 text-nowrap align-self-center" @click="openBatchSearch">
                            <b-icon icon="list-check"></b-icon> 批量搜索 / 일괄 검색
                        </b-button>
                        <b-badge v-if="batchSearchNos.length" variant="primary" pill class="ml-2 align-self-center batch-search-chip"
                            title="点击取消批量搜索 / 클릭하면 일괄 검색 해제" @click="clearBatchSearch">
                            批量搜索 {{ batchSearchNos.length }}个 ✕
                        </b-badge>
                    </template>
                    <template v-slot:요청일="{ item }">
                        {{ getTimeDate(item.요청일) }}
                        <div v-if="batchNo(item)" class="small text-muted" title="批次号：同批提交的请求号码相同 (묶음번호 — 같이 제출된 요청건은 번호가 같다)">批次 (묶음) {{ batchNo(item) }}</div>
                    </template>
                    <template v-slot:화주주문번호="{ item }">
                        <span v-if="item.화주주문번호" class="badge badge-info">{{ item.화주주문번호 }}</span>
                        <span v-else class="text-muted">-</span>
                    </template>
                    <template v-slot:1688주문번호="{ item }">
                        <small v-if="item.주문정보 && item.주문정보['1688주문번호']" style="word-break: break-all;">{{ item.주문정보['1688주문번호'] }}</small>
                        <span v-else-if="!(item.주문정보 && item.주문정보.판매처주문번호)" class="text-muted">-</span>
                        <div v-if="item.주문정보 && item.주문정보.판매처주문번호" class="small" v-b-tooltip.hover title="商家订单号 / 판매처 주문번호"><span style="user-select:none">商家: </span>{{ item.주문정보.판매처주문번호 }}</div>
                    </template>
                    <template v-slot:통관방법="{ item }">
                        <small>{{ zhKo(item.통관방법).zh || '-' }}<small v-if="zhKo(item.통관방법).ko" class="d-block">{{ zhKo(item.통관방법).ko }}</small></small>
                    </template>
                    <template v-slot:reqtype="{ item }">
                        <!-- 개별 상품 뷰의 「요청타입」. 목록은 applyReqlistResults 를 타서 '일반LCL' 로
                             정규화되고 단건 조회는 DB 원본 '샘플검증' 이라 같은 건이 다르게 보였다.
                             hasSampleCheck 로 두 모양을 다 받아 한 표기로 맞춘다. -->
                        <!-- 2줄(위 中文, 아래 작게 한국어) — 가로폭 줄이기(2026-10-07 YZY) -->
                        <template v-if="hasSampleCheck(item)">样品检测件<small class="d-block text-muted">샘플검증</small></template>
                        <template v-else-if="item.reqtype">{{ zhKo(item.reqtype).zh }}<small v-if="zhKo(item.reqtype).ko" class="d-block text-muted">{{ zhKo(item.reqtype).ko === '일반LCL' || zhKo(item.reqtype).ko === '일반' ? '일반배송' : zhKo(item.reqtype).ko }}</small></template>
                        <template v-else-if="(item.polists && item.polists.length) || item.selectpo">快递资料件<small class="d-block text-muted">로켓배송</small></template>
                        <div v-if="isNon1688(item) && !item.최종결제여부"><span class="badge badge-danger" style="white-space: normal;" v-b-tooltip.hover title="非1688商品，手动转账采购 / 1688 외 상품 — 직접 송금 구매">需手动下单(수동 주문 필요)</span></div>
                    </template>
                    <template v-slot:진행현황="{ item }">
                        <!-- 선적이 있으면 수량 분포, 없으면 지금까지 쓰던 뱃지 그대로(정본 §4) -->
                        <div v-if="distOf(item)" style="cursor: pointer;"
                            @click="openProcessHistoryModal(item)"
                            v-b-tooltip.hover title="点击查看变更记录 (클릭하여 변경 이력 보기)">
                            <ProgressDistribution :dist="distOf(item)" />
                        </div>
                        <b-badge v-else :variant="getStatusVariant(item.processStatus || item.진행현황)"
                            style="cursor: pointer; white-space: normal;"
                            @click="openProcessHistoryModal(item)"
                            v-b-tooltip.hover title="点击查看变更记录 (클릭하여 변경 이력 보기)">
                            {{ zhKo(item.processStatus || item.진행현황).zh }}<small v-if="zhKo(item.processStatus || item.진행현황).ko" class="d-block">{{ zhKo(item.processStatus || item.진행현황).ko }}</small>
                        </b-badge>
                    </template>
                    <template v-slot:요청변경="{ item }">
                        <div v-if="item.changeHistory && item.changeHistory.length > 0"
                            class="change-review-cell"
                            :class="{
                                'change-review-urgent': hasUnconfirmedChange(item) && (item.processStatus || item.진행현황) !== '구매전',
                                'change-review-pending': hasUnconfirmedChange(item) && (item.processStatus || item.진행현황) === '구매전',
                                'change-review-done': !hasUnconfirmedChange(item)
                            }"
                            @click="openChangeReviewModal(item)"
                            v-b-tooltip.hover.html="getChangeHistoryTooltip(item)"
                            style="cursor:pointer">
                            <b-icon
                                :icon="hasUnconfirmedChange(item) ? 'exclamation-triangle-fill' : 'check-circle-fill'"
                                :font-scale="hasUnconfirmedChange(item) && (item.processStatus || item.진행현황) !== '구매전' ? 1.8 : 1.2"
                                :class="hasUnconfirmedChange(item) && (item.processStatus || item.진행현황) !== '구매전' ? 'change-review-pulse' : ''"></b-icon>
                            <b-badge v-if="hasUnconfirmedChange(item)" variant="danger" class="ml-1">
                                {{ unconfirmedChangeCount(item) }}
                            </b-badge>
                        </div>
                    </template>
                    <template v-slot:history="{ item }">
                        <div v-if="item.statusHistory && item.statusHistory.length > 0">
                            <b-icon icon="clock-history" font-scale="1.2" class="text-info"
                                v-b-tooltip.hover.html="getStatusHistoryTooltip(item)"></b-icon>
                        </div>
                    </template>
                    <template v-slot:견적서상태="{ item }">
                        <div class="d-flex flex-column align-items-center">
                            <b-badge v-if="item.견적서상태"
                                :variant="getQuotationBadgeVariant(item.견적서상태)"
                                class="mb-1">
                                {{ zhKo(item.견적서상태).zh }}<small v-if="zhKo(item.견적서상태).ko" class="d-block">{{ zhKo(item.견적서상태).ko }}</small>
                            </b-badge>
                            <div class="d-flex flex-wrap justify-content-center" style="gap: 2px;">
                                <!-- 1688 구매금액 견적서 생성 -->
                                <b-button v-if="!item.견적서상태 || item.견적서상태 === '미생성'"
                                    size="sm"
                                    variant="primary"
                                    @click="createQuotation(item)"
                                    v-b-tooltip.hover title="生成1688采购金额报价单 (1688 구매금액 견적서 생성)">
                                    <b-icon icon="file-earmark-plus" scale="0.8"></b-icon>
                                    1688
                                </b-button>
                                <!-- 중국물류비 견적서 생성 (출고대기 상태에서만) -->
                                <b-button v-if="(item.processStatus || item.진행현황) === '출고대기'"
                                    size="sm"
                                    variant="warning"
                                    @click="openChinaLogisticsModal(item)"
                                    v-b-tooltip.hover title="生成中国物流费报价单 (중국물류비 견적서 생성)">
                                    <b-icon icon="truck" scale="0.8"></b-icon>
                                    物流 (물류)
                                </b-button>
                                <!-- 중국물류비 paymentStatus 뱃지 -->
                                <b-badge v-if="item.견적서_중국물류비?.paymentStatus === '입금완료'" variant="success" class="ml-1">中国(중국)💰</b-badge>
                                <b-badge v-else-if="item.견적서_중국물류비?.paymentStatus === '입금요청'" variant="warning" class="ml-1">中国(중국)📨</b-badge>
                                <b-badge v-else-if="item.견적서_중국물류비" variant="secondary" class="ml-1" style="cursor:pointer" @click="requestLogisticsPayment(item, '중국물류비')" v-b-tooltip.hover title="点击请求付款 (클릭하여 입금요청)">中国(중국)✓</b-badge>
                                <!-- 한국물류비 견적서 생성 (국내입고중 또는 쿠팡센터입고완료 상태에서) -->
                                <b-button v-if="['출고완료', '해외입고중', '국내입고중', '국내창고입고중', '국내창고입고완료', '쿠팡센터입고완료'].includes(item.processStatus || item.진행현황)"
                                    size="sm"
                                    variant="success"
                                    @click="openKoreaLogisticsModal(item)"
                                    v-b-tooltip.hover title="生成韩国物流费报价单 (한국물류비 견적서 생성)">
                                    <b-icon icon="house-door" scale="0.8"></b-icon>
                                    韩国 (한국)
                                </b-button>
                                <!-- 한국물류비 paymentStatus 뱃지 -->
                                <b-badge v-if="item.견적서_한국물류비?.paymentStatus === '입금완료'" variant="success" class="ml-1">韩国(한국)💰</b-badge>
                                <b-badge v-else-if="item.견적서_한국물류비?.paymentStatus === '입금요청'" variant="warning" class="ml-1">韩国(한국)📨</b-badge>
                                <b-badge v-else-if="item.견적서_한국물류비" variant="secondary" class="ml-1" style="cursor:pointer" @click="requestLogisticsPayment(item, '한국물류비')" v-b-tooltip.hover title="点击请求付款 (클릭하여 입금요청)">韩国(한국)✓</b-badge>
                                <!-- 화주통관비 — 화주단독 관세사 정산서에서 자동 배분(화주 자기 비용, 청구 아님). 상세는 제품상세(확인) 모달 -->
                                <b-badge v-if="item.화주통관비 && item.화주통관비.총금액" variant="light" class="ml-1 border"
                                    v-b-tooltip.hover :title="'货主清关费(화주통관비) — ' + (item.화주통관비.items || []).map(c => c.name + ' ' + Number(c.amount || 0).toLocaleString()).join(' · ')">关税 ₩{{ Number(item.화주통관비.총금액).toLocaleString() }}</b-badge>
                                <!-- 견적서 보기 -->
                                <b-button v-if="item.견적서상태 && item.견적서상태 !== '미생성'"
                                    size="sm"
                                    variant="info"
                                    @click="viewQuotation(item)">
                                    <b-icon icon="eye" scale="0.8"></b-icon>
                                </b-button>
                                <!-- 입고오류 처리 (입고작업 상태에서) -->
                                <b-button v-if="(item.processStatus || item.진행현황) === '입고작업'"
                                    size="sm"
                                    variant="danger"
                                    @click="openInboundErrorModal(item)"
                                    v-b-tooltip.hover title="入库错误处理 (입고오류 처리)">
                                    <b-icon icon="exclamation-triangle" scale="0.8"></b-icon>
                                    错误 (오류)
                                </b-button>
                            </div>
                        </div>
                    </template>
                    <template v-slot:묶음구성여부="{ item }">
                        {{ item.묶음구성여부 ? item.묶음구성수량 + '个' : "" }}<br><small style="word-break: break-all;">{{ item.묶음구성여부 ? '(' + item.바코드 + ")" :
                            "" }}</small>
                    </template>
                    <template v-slot:상품명="{ item }">
                        <div class="d-flex align-items-center p-1">
                            <img :src="cdnImg(item.등록이미지)" class="img-fluid rounded avatar-80 mr-3" alt="image">
                            <div>
                                {{ item.상품명 }}
                                <p class="mb-0" style="color: #676E8A"><small>{{ item.SKUID }}</small></p>
                                <p class="mb-0" style="color: #676E8A"><small>{{ item.바코드 }}</small></p>
                            </div>
                        </div>
                        <b-modal :id="getModalId(item)" :ref="'modalRef-' + item._id" title="编辑商品信息 (상품 정보 편집)"
                            @show="handleModalShow(item)" @ok="handleModalOk($event, item)"
                            @hidden="handleModalHidden(item)" ok-title="保存 (저장)" cancel-title="取消 (취소)" centered size="md">
                            <form ref="editForm" @submit.stop.prevent="submitViaOk(item)">
                                <b-form-group label="商品名 (상품명)" :label-for="'edit-name-' + item._id">
                                    <b-form-input :id="'edit-name-' + item._id" v-model="item.상품명"
                                        required></b-form-input>
                                </b-form-group>
                                <b-form-group label="条码 (바코드)" :label-for="'edit-barcode-' + item._id">
                                    <b-form-input :id="'edit-barcode-' + item._id" v-model="item.바코드"
                                        required></b-form-input>
                                </b-form-group>
                                <!-- 다른 필드 필요 시 추가 -->
                            </form>
                            <template #modal-footer="{ ok, cancel }">
                                <b-button size="sm" variant="secondary" @click="cancel()">
                                    取消 (취소)
                                </b-button>
                                <b-button size="sm" variant="primary" @click="ok()">
                                    保存 (저장)
                                </b-button>
                            </template>
                        </b-modal>
                    </template>
                    <template v-slot:구매요청수량="{ item }">
                        {{ item.구매요청수량 }}
                    </template>
                    <template v-slot:판매구성수량="{ item }">
                        {{ item.판매구성수량 || 1 }}
                    </template>
                    <template v-slot:옵션1_중국어="{ item }">
                        <b-form-select v-if="changeoption && item.item && item.상품매칭 && item.상품매칭.옵션1_중국어 && item.상품매칭.옵션1_중국어.length"
                            size="sm" style="font-size: 11px; min-width: 90px;" :value="item.옵션1_중국어"
                            :options="[{ value: undefined, text: '选择 / 선택', disabled: true }].concat(item.상품매칭.옵션1_중국어.map(o => o.name))"
                            @change="pickOption(1, $event, item)"></b-form-select>
                        <span v-else style="font-size: 11px;">{{ item.옵션1_중국어 }}</span>
                    </template>
                    <template v-slot:옵션2_중국어="{ item }">
                        <b-form-select v-if="changeoption && item.item && item.상품매칭 && item.상품매칭.옵션2_중국어 && item.상품매칭.옵션2_중국어.length"
                            size="sm" style="font-size: 11px; min-width: 90px;" :value="item.옵션2_중국어"
                            :options="[{ value: undefined, text: '选择 / 선택', disabled: true }].concat(item.상품매칭.옵션2_중국어.map(o => o.name))"
                            @change="pickOption(2, $event, item)"></b-form-select>
                        <span v-else style="font-size: 11px;">{{ item.옵션2_중국어 }}</span>
                    </template>
                    <template v-slot:구매링크="{ item }">
                        <a :href="item.구매링크" target="_blank"><b-icon icon="link" scale="2"
                                variant="secondary"></b-icon></a>
                    </template>
                    <template v-slot:action="{ item }">
                        <div class="d-flex align-items-center list-action">
                            <a v-if="changeoption" class="badge bg-success mr-2" data-toggle="tooltip" v-b-tooltip.top
                                title="重新匹配选项 (옵션재매칭)" href="javascript:void(0)" @click="rematching(item)"
                                style="width: 30px; height: 30px; display: flex; justify-content: center; align-items: center">
                                <i class="ri-pencil-line mr-0"></i>
                            </a>
                            <a v-if="isStaffUser && item.주문정보 && item.주문정보['1688주문번호']" class="badge badge-warning mr-2" data-toggle="tooltip" v-b-tooltip.top
                                title="购买后更换属性 (구매 후 옵션 변경)" href="javascript:void(0)" @click="openOptionChange(item)"
                                style="width: 30px; height: 30px; display: flex; justify-content: center; align-items: center">
                                <i class="ri-refresh-line mr-0"></i>
                            </a>
                            <a class="badge badge-secondary mr-2" data-toggle="tooltip" v-b-tooltip.top title="查看 (확인)"
                                href="javascript:void(0)" @click="openItemActionModal('modalDetail', item)"
                                style="width: 30px; height: 30px; display: flex; justify-content: center; align-items: center">
                                <i class="ri-eye-line mr-0"></i>
                            </a>
                            <a class="badge badge-info mr-2" data-toggle="tooltip" v-b-tooltip.top title="编辑 (편집)"
                                href="javascript:void(0)" @click="openItemActionModal('modal', item)"
                                style="width: 30px; height: 30px; display: flex; justify-content: center; align-items: center">
                                <i class="ri-eye-line mr-0"></i>
                            </a>
                            <a v-if="isNon1688(item) && canManualTransfer(item)" class="badge badge-danger mr-2" v-b-tooltip.top
                                title="已转账 / 송금완료 처리" href="javascript:void(0)" @click="openNon1688Transfer([item])"
                                style="height: 30px; display: flex; justify-content: center; align-items: center; padding: 0 6px;">
                                已转账
                            </a>
                            <a class="badge mr-2 side-payment-btn" data-toggle="tooltip" v-b-tooltip.top
                                :title="item.주문정보 && item.주문정보.별도결제 ? '修改另付链接 (별도결제 수정)' : '别单链接付款 (별도링크 결제처리)'"
                                href="javascript:void(0)" @click="openSidePaymentModal(item)"
                                :class="item.주문정보 && item.주문정보.별도결제 ? 'badge-warning' : 'badge-dark'"
                                style="width: 30px; height: 30px; display: flex; justify-content: center; align-items: center">
                                <i class="ri-link-m mr-0"></i>
                            </a>
                        </div>
                    </template>
                </CDataTable>
            </div>
            <img v-if="showspinner" style="max-width:100%;" :src="require('../../../assets/images/small/spinner.gif')">
            <div class="col-lg-12 mb-4 d-flex justify-content-between" v-if="showreqlist">
                <div class="row">
                    <button type="button" class="btn btn-success mr-2" @click="createOrder" :disabled="orderCreating || bulkOrdering">创建1688订单 (1688주문생성)</button>
                    <button type="button" class="btn btn-outline-success mr-2" @click="bulkCreateOrders"
                        :disabled="orderCreating || bulkOrdering || tableSelectedItem.length === 0"
                        title="按货主·分组依次下单，显示进度 / 화주·그룹별로 차례로 주문하고 진행을 보여줍니다">
                        批量下单 (일괄 1688주문)
                    </button>
                    <button type="button" class="btn btn-secondary mr-2" @click="downloadlist">下载订单记录 (주문내역 다운로드)</button>

                    <button
                        type="button"
                        class="btn btn-warning mr-2"
                        @click="showBatchChange = !showBatchChange"
                        :disabled="tableSelectedItem.length === 0"
                    >
                        <i class="ri-edit-2-line mr-1"></i>
                        批量变更 (일괄변경)
                        <b-badge variant="light" class="ml-2" v-if="tableSelectedItem.length > 0">
                            {{ tableSelectedItem.length }}
                        </b-badge>
                    </button>

                    <button
                        type="button"
                        class="btn btn-primary mr-2"
                        @click="batchPaySelected"
                        :disabled="tableSelectedItem.length === 0 || processingPayment"
                        title="勾选的行中1688待付款订单合并付款 / 선택한 행의 1688 미결제 주문을 한 번에 결제"
                    >
                        <b-spinner v-if="processingPayment" small class="mr-1"></b-spinner>
                        <i v-else class="ri-bank-card-line mr-1"></i>
                        批量付款 / 일괄결제
                    </button>

                    <button
                        type="button"
                        class="btn btn-info mr-2"
                        @click="openMergedBillFromSelection"
                        :disabled="tableSelectedItem.length === 0"
                        title="同一货主勾选的多件报价合并成一张请款单 / 같은 화주의 선택한 여러 건을 한 장의 청구서로"
                    >
                        <i class="ri-file-list-3-line mr-1"></i>
                        合并请款单 / 청구서 합치기
                    </button>
                </div>

                <div class="custom-control custom-switch custom-control-inline">
                    <input type="checkbox" class="custom-control-input" id="customSwitchre" v-model="changeoption"
                        @change="changeoptiondone">
                    <label class="custom-control-label" for="customSwitchre">重新匹配采购选项 (구매옵션재매칭)</label>
                </div>
            </div>

            <!-- 일괄변경 Collapse 패널 -->
            <div class="col-lg-12 mb-3" v-if="showreqlist">
                <b-collapse v-model="showBatchChange">
                    <b-card>
                        <div class="row align-items-center">
                            <div class="col-md-3">
                                <label class="form-label font-weight-bold">变更状态 (진행현황 변경)</label>
                                <b-form-select v-model="batchStatus" :options="statusOptions" size="sm">
                                </b-form-select>
                            </div>
                            <div class="col-md-2">
                                <b-button
                                    variant="primary"
                                    size="sm"
                                    @click="updateBatchStatus"
                                    :disabled="!batchStatus || batchProcessing || tableSelectedItem.length === 0"
                                >
                                    <b-spinner small v-if="batchProcessing"></b-spinner>
                                    {{ batchProcessing ? '处理中 (처리중)...' : '执行变更 (변경 실행)' }}
                                </b-button>
                            </div>
                            <div class="col-md-7">
                                <small class="text-muted">
                                    将批量变更所选 {{ tableSelectedItem.length }} 项的状态 (선택된 {{ tableSelectedItem.length }}개 항목의 진행현황을 일괄 변경합니다.)
                                    <span v-if="tableSelectedItem.length > 0" class="text-primary">
                                        ({{ tableSelectedItem.map(item => (item.상품명 || '').substring(0, 20) + '...').join(', ') }})
                                    </span>
                                </small>
                            </div>
                        </div>
                    </b-card>
                </b-collapse>
            </div>
            <div class="d-flex justify-content-end" v-if="showreqlist"></div>
        </div>

        <!-- 개별 요청건 Action 모달 (제품상세 / 구매요청사항 편집)
             개별 상품 뷰와 그룹 상세 모달 양쪽 Action 버튼이 같이 쓴다. 한 번에 한 건만 렌더된다
             — openItemActionModal() 이 actionModalItem 을 바꾼 뒤 연다. -->
        <div v-for="(item, index) in (actionModalItem ? [actionModalItem] : [])" :key="'action-modals-' + item._id">
        <b-modal :id="'modalDetail' + item._id" size="xl" scrollable title="商品详情 (제품상세)" ok-title="OK"
            cancel-title="Close" class="detail-modal">
            <div class="row">
                <div class="col-md-6">
                    <img class="w-100 d-block" :src="cdnImg(item.등록이미지)"
                        style="border:1px solid silver; border-radius: 30px">
                </div>
                <div class="col-md-6">
                    <p style="font-size:100%">下单数量 (주문수량) : {{ parseInt(item.구매요청수량) * item.판매구성수량 }}</p>
                    <p style="font-size:100%">请求数量 (구매요청수량) : {{ parseInt(item.구매요청수량) }}</p>
                    <p style="font-size:100%">销售组合 (판매구성) : {{ item.판매구성수량 }}</p>
                    <!-- <div class="mb-4">
                        <div class="row text-center ml-1" id="printMe" style="border:1px solid silver;width:300px">
                            <div class="col-12 text-center mb-0">
                                <p class="mb-0" style="font-size:90%;">Made in China&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>SKU : {{purchase.SKUID}}</span></p>
                            </div>
                            <div class="col-12 text-center mb-0">
                                <barcode :value="purchase.바코드" :tag="bctag" :options="{ lineColor: '#0275d8', text: 'Scan'}"></barcode>
                            </div>
                        </div>
                        <div class="mt-2">
                            <button class="btn btn-primary" type="button" @click="print">바코드출력</button>
                        </div>
                    </div> -->
                    <p>商品名 (상품명) : {{ item.상품명 }}</p>
                    <p v-if="item.SKUID">SKU ID : {{ item.SKUID }}</p>
                    <p>条码 (바코드) : {{ item.바코드 }}</p>
                    <!-- 화주통관비 — 화주단독 BL 관세사 정산서에서 자동 배분된 화주 자기 비용(청구 아님). 매입가 총비용에 들어간다 -->
                    <div v-if="item.화주통관비 && item.화주통관비.총금액" class="border rounded p-2 mb-3 small">
                        <b>货主清关费(화주통관비) ₩{{ Number(item.화주통관비.총금액).toLocaleString() }}</b>
                        <span class="text-muted"> — 货主自付·不是请款(화주 자기 비용 · 청구 아님) · 计入采购单价(매입가에 반영)</span>
                        <div>
                            <span v-for="(c, ci) in item.화주통관비.items" :key="'sc' + ci" class="mr-3">{{ c.name }} ₩{{ Number(c.amount || 0).toLocaleString() }}</span>
                        </div>
                        <div v-for="(e, ei) in item.화주통관비.배분내역 || []" :key="'se' + ei" class="text-muted">
                            BL {{ e.bl }} · {{ e.신고번호 }} · 出库(출고) {{ e.출고수량 }} · ₩{{ Number(e.금액 || 0).toLocaleString() }}
                            <span v-if="(e.매칭 || []).length"> · 匹配(매칭) {{ e.매칭.map(m => '栏' + m.란번호 + ' ' + m.규격 + '(' + m.근거 + ')').join(', ') }}</span>
                            <span v-else> · 按出库价值分摊(출고 가액 비율)</span>
                        </div>
                    </div>
                    <p>采购链接 (구매링크) : <a :href="item.구매링크">{{ item.구매링크.slice(0,
                        item.구매링크.search('.html') + 5) }}</a></p>
                    <p>选项1中文 (옵션1_중국어) : {{ item.옵션1_중국어 }}</p>
                    <p>选项2中文 (옵션2_중국어) : {{ item.옵션2_중국어 }}</p>
                    <p>[配送要求 (배송 요청사항)]</p>
                    <card style="color:blue;">
                        <div class="ml-1 mt-1 mb-1 mr-1 row">
                            <div class="col-5">
                                <span><b>[出库作业 (출고작업)]</b></span><br>
                                <span v-if="item.selectpo">批次 (배치) : {{ item.selectpo ? '订单批次 (발주배치)' :
                                    '无 (해당없음)' }}</span><br v-if="item.selectpo">
                                <span v-if="item.selectpo">批次订单号 (배치발주번호) : {{ item.selectpo }}</span><br
                                    v-if="item.selectpo">
                                <span>出库类型 (출고유형) : {{ item.요청내역.exportType.toUpperCase() }}</span><br>
                                <br>
                                <span><b>[验货及包装 (검수 및 포장 작업)]</b></span><br>
                                <span>基本验货 (기본검수) : {{ item.요청내역.default ? 'Y' : 'N' }}</span><br>
                                <span>OPP袋 (OPP봉투) : {{ item.요청내역.opp ? 'Y' : 'N' }}</span><br>
                                <span>快递袋LDPE (택배봉투) : {{ item.요청내역.LDPE ? 'Y' : 'N' }}</span><br>
                                <span>气泡膜 (에어캡) : {{ item.요청내역.airpacking ? 'Y' : 'N' }}</span><br>
                                <br>
                            </div>
                            <div class="col-7">
                                <span><b>[标签及原产地作业 (라벨 및 원산지 작업)]</b></span><br>
                                <span>条码 (바코드) : {{ item.요청내역.barcode ? 'Y' : 'N' }}</span><br>
                                <span>韩文标识 (한글표시사항) : {{ item.요청내역.barcode ? 'Y' : 'N' }}</span><br>
                                <span>原产地贴纸 (원산지스티커) : {{ item.요청내역.sticker ? 'Y' : 'N' }}</span><br>
                                <span>印章 (도장) : {{ item.요청내역.stamp ? 'Y' : 'N' }}</span><br>
                                <span>吊牌 (택총) : {{ item.요청내역.tag ? 'Y' : 'N' }}</span><br>
                                <br>
                                <span><b>[清关信息 (통관 정보)]</b></span><br>
                                <span>申报英文名 (신고영문명) : {{ item.신고영문명 ? item.신고영문명 : '' }}</span><br>
                                <span>申报单价USD (신고단가) : {{ item.주문정보 ?
                                    Math.ceil((item.주문정보.협상전_총금액 || 0) / item.구매요청수량 / 7.4 * 100) / 100 :
                                    '' }}</span><br>
                                <span>HS-CODE : {{ item.HSCODE ? item.HSCODE : '' }}</span><br>
                                <br>
                                <span><b>[其他要求 - 物流 (기타 요청사항 - 물류)]</b></span><br>
                                <span>{{ item.요청내역.reqcontent }}</span><br>
                                <span><b>[其他要求 - 采购 (기타 요청사항 - 구매)]</b></span><br>
                                <span>{{ item.요청내역?.reqcontentPurchase }}</span><br>
                            </div>
                        </div>
                    </card>
                    <!-- <p :style="item.입고오류유형 == '' ? 'font-size:120%;font-weight:bold;color:black' : 'font-size:120%;font-weight:bold;color:red'">입고오류유형 : {{item.입고오류유형 ? item.입고오류유형 : ''}}</p>
                    <p style="font-size:120%;font-weight:bold;color:red" v-if="item.입고오류유형 == '수량불일치'">입고수량 : {{item.입고수량}}</p>
                    <p style="font-size:120%;font-weight:bold;color:red" v-if="item.입고오류유형 != '' && item.입고오류유형 != '수량불일치'">입고오류내용 : {{item.입고오류내용}}</p>
                    <div class="row">
                        <div class="col-md-4">
                            <button :class="importerrorbutton == '입고처리' ? 'btn btn-secondary' : 'btn btn-danger'" type="button" @click="importerror(item)">{{importerrorbutton}}</button>
                        </div>
                        <div class="col-md-8" v-if="showimporterror">
                            <div class="custom-control custom-radio custom-control-inline">
                                <input type="radio" id="customRadio15" name="customRadio-4" class="custom-control-input" @change="changeimporterror(item)" v-model="item.처리방법" value="입고완료처리">
                                <label class="custom-control-label" for="customRadio15">입고완료처리</label>
                            </div>
                            <div class="custom-control custom-radio custom-control-inline">
                                <input type="radio" id="customRadio16" name="customRadio-4" class="custom-control-input" @change="changeimporterror(item)" v-model="item.처리방법" value="반품">
                                <label class="custom-control-label" for="customRadio16">반품</label>
                            </div>
                            <div class="custom-control custom-radio custom-control-inline">
                                <input type="radio" id="customRadio17" name="customRadio-4" class="custom-control-input" @change="changeimporterror(item)" v-model="item.처리방법" value="폐기">
                                <label class="custom-control-label" for="customRadio17">폐기</label>
                            </div>
                            <div class="custom-control custom-radio custom-control-inline">
                                <input type="radio" id="customRadio18" name="customRadio-4" class="custom-control-input" @change="changeimporterror(item)" v-model="item.처리방법" value="입고대기">
                                <label class="custom-control-label" for="customRadio18">입고대기</label>
                            </div>
                        </div>
                        <div class="col-md-12 mt-2" v-if="showimporterror && showimporterror1">
                            <div class="form-group">
                                <label for="exampleFormControlTextarea1">반품정보</label>
                                <input type="text" class="form-control" placeholder="반품수취인" v-model="item.반품수취인">
                                <input type="text" class="form-control" placeholder="반품연락처" v-model="item.반품연락처">
                                <textarea class="form-control" placeholder="반품주소" id="exampleFormControlTextarea1" rows="3" v-model="item.반품주소"></textarea>
                                <input type="text" class="form-control" placeholder="반품운송장번호" v-model="item.반품운송장번호">
                            </div>
                        </div>
                        <div class="col-md-12 mt-2" v-if="showimporterror && showimporterror2">
                            <div class="form-group">
                                <label for="exampleFormControlTextarea1">입고대기 사유</label>
                                <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" v-model="item.입고대기사유"></textarea>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
        </b-modal>

        <b-modal :id="'modal' + item._id" @shown="showModal(item)" size="xl" title="采购请求事项 (구매요청사항)"
            ok-title="Save Changes" cancel-title="Close" @ok="saverequest(item)">
            <div class="row" v-if="item.reqtype == '제트배송'">
                <div class="reqpo-purchase-request-form">
                    <div class="row">
                        <!-- Row 1: Items 1-2 -->
                        <div class="col-md-6">
                            <div class="reqpo-form-section">
                                <div class="reqpo-section-title">1. 请求数量 (구매요청수량)</div>
                                <div class="reqpo-input-wrapper">
                                    <div class="d-flex align-items-center">
                                        <input type="number" :min="0"
                                            class="form-control text-center" style="width: 120px;"
                                            v-model="item.구매요청수량"
                                            @keyup.enter="validateQuantity(item)">
                                        <div class="reqpo-stock-info ml-3">
                                            <span class="reqpo-info-label">起批量 (최소주문):</span>
                                            <span class="reqpo-info-value">{{
                                                getMinOrderQuantity(item) }}个</span>
                                            <span class="reqpo-separator">/</span>
                                            <span class="reqpo-info-label">库存 (재고):</span>
                                            <span class="reqpo-info-value">{{
                                                getAvailableStock(item) }}个</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="reqpo-form-section">
                                <div class="reqpo-section-title">2. 销售组合数量 (판매구성수량)</div>
                                <div class="reqpo-input-wrapper">
                                    <input type="number" :min="0" class="form-control"
                                        style="width: 120px;" v-model="item.판매구성수량"
                                        v-b-tooltip.hover="'该SKU为2件装时填2 (해당 SKU가 2p 구성일 경우에는 2라고 작성해 주세요)'">
                                </div>
                            </div>

                        </div>

                        <!-- Row 2: Items 3-4 -->
                        <div class="col-md-6">
                            <div class="reqpo-form-section">
                                <div class="reqpo-section-title">3. A-B组合装 (A-B번들 묶음구성여부)</div>
                                <div class="bundle-options">
                                    <div class="custom-control custom-switch d-inline-block">
                                        <input type="checkbox" class="custom-control-input"
                                            :id="'bundleSwitch' + index" v-model="item.묶음구성여부"
                                            @change="confirmBarcode(item)">
                                        <label class="custom-control-label"
                                            :for="'bundleSwitch' + index">合包 (묶음구성)</label>
                                    </div>
                                    <div v-if="item.묶음구성여부" class="bundle-count mt-2">
                                        <input type="number" :min="0" class="form-control"
                                            style="width: 120px;" placeholder="种类数 (종류갯수)"
                                            v-model="item.묶음구성수량"
                                            v-b-tooltip.hover="'3种商品合包时填3 (3종의 제품을 묶음 구성하는 경우 3으로 작성)'">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="reqpo-form-section">
                                <div class="reqpo-section-title">4. 目的地 (도착지)</div>
                                <div class="destination-options">
                                    <div class="btn-group w-100">
                                        <button type="button" class="btn"
                                            :class="{ 'btn-primary': item.요청내역.destination === 'coupang', 'btn-outline-primary': item.요청내역.destination !== 'coupang' }"
                                            @click="item.요청내역.destination = 'coupang'">
                                            酷澎中心 (쿠팡센터)
                                        </button>
                                        <button type="button" class="btn"
                                            :class="{ 'btn-primary': item.요청내역.destination === 'customer', 'btn-outline-primary': item.요청내역.destination !== 'customer' }"
                                            @click="item.요청내역.destination = 'customer'">
                                            货主 (화주)
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Row 3: Items 5-7 -->
                        <div class="col-md-6">
                            <div class="reqpo-form-section">
                                <div class="reqpo-section-title">5. 出库形式 (출고형태)</div>
                                <div class="export-options">
                                    <div class="custom-control custom-radio mb-2">
                                        <input type="radio" :id="'exportBox' + index"
                                            name="exportType" class="custom-control-input"
                                            v-model="item.요청내역.exportType" value="box">
                                        <label class="custom-control-label"
                                            :for="'exportBox' + index">
                                            <span
                                                v-if="!item.요청내역.destination || item.요청내역.destination === 'coupang'">
                                                蓝胶带快递 (밀크런 택배)
                                            </span>
                                            <span v-else>快递 (택배)</span>
                                        </label>
                                    </div>
                                    <div class="custom-control custom-radio">
                                        <input type="radio" :id="'exportPallet' + index"
                                            name="exportType" class="custom-control-input"
                                            v-model="item.요청내역.exportType" value="pallet">
                                        <label class="custom-control-label"
                                            :for="'exportPallet' + index">
                                            <span
                                                v-if="!item.요청내역.destination || item.요청내역.destination === 'coupang'">
                                                黑胶带托盘 (밀크런 파렛트) <small
                                                    class="reqpo-text-muted">(￦35,000/pallet)</small>
                                            </span>
                                            <span v-else>
                                                托盘 (파렛트) <small
                                                    class="reqpo-text-muted">(￦20,000/pallet)</small>
                                            </span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <!-- </div>

                            <div class="col-md-6"> -->
                            <div class="reqpo-form-section">
                                <div class="reqpo-section-title">6. 清关信息 (통관정보)</div>
                                <div class="row">
                                    <div class="col-12 mb-3">
                                        <div class="form-group">
                                            <label>申报英文名 (신고영문명)</label>
                                            <input type="text" class="form-control"
                                                placeholder="例/예) shoes" v-model="item.신고영문명">
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label>HS-CODE</label>
                                            <div class="d-flex">
                                                <input type="text" class="form-control"
                                                    placeholder="例/예) 6401.10-1000"
                                                    v-model="item.HSCODE">
                                                <div class="w-25 d-flex align-items-center"><a
                                                        href="https://www.bandtrass.or.kr/hsnavi.do"
                                                        target="_blank"
                                                        class="btn btn-outline-secondary ml-2">
                                                        搜索 (검색)
                                                    </a></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="reqpo-form-section">
                                <div class="reqpo-section-title">7. 清关方式 (통관형태)</div>
                                <div class="customs-options">
                                    <div class="reqpo-custom-radio-card mb-2"
                                        :class="{ 'active': item.요청내역.customsType === 'integrated' }"
                                        @click="item.요청내역.customsType = 'integrated'">
                                        <div class="reqpo-card-title">COUPASS综合清关 (쿠패스통합통관)</div>
                                        <div class="reqpo-card-desc">人民币x280，含除验货/包装外的全部费用 (위안화x280, 검수/포장비용 제외 모든비용 포함)
                                        </div>
                                    </div>
                                    <div class="reqpo-custom-radio-card mb-2"
                                        :class="{ 'active': item.요청내역.customsType === 'client' }"
                                        @click="item.요청내역.customsType = 'client'">
                                        <div class="reqpo-card-title">货主单独清关 (화주단독통관)</div>
                                        <div class="reqpo-card-desc">代购手续费3%，材料、关税增值税、海运费、清关费、清关文件费等另计 (구매대행수수료3%, 자재, 관부가세, 해운비, 통관비,
                                            통관서류 비용 등 별도)</div>
                                    </div>
                                    <div class="reqpo-custom-radio-card"
                                        :class="{ 'active': item.요청내역.customsType === 'kupass' }"
                                        @click="item.요청내역.customsType = 'kupass'">
                                        <div class="reqpo-card-title">COUPASS单独清关 (쿠패스단독통관)</div>
                                        <div class="reqpo-card-desc">仅限食检商品，代购手续费3%，材料、关税增值税、海运费、清关费、清关文件费等另计 (식검제품만 신청가능, 구매대행수수료3%, 자재,
                                            관부가세, 해운비, 통관비, 통관서류 비용 등 별도)</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Full width sections -->
                        <div class="col-md-6">
                            <!-- 검수 및 포장 섹션 -->
                            <div class="reqpo-form-section">
                                <div class="reqpo-section-title">8. 验货及包装 (검수 및 포장)</div>
                                <div class="inspection-options">

                                    <!-- 패키징 옵션 -->
                                    <div v-if="item.요청내역.default" class="packaging-options mb-3">
                                        <div class="reqpo-option-title mb-2">选择包装方式 (포장 방법 선택):</div>
                                        <div class="custom-control custom-radio mb-2">
                                            <input type="radio" :id="'packageAuto' + index"
                                                name="packageMethod" class="custom-control-input"
                                                value="auto" v-model="packageMethod"
                                                @change="changePackage(item)">
                                            <label class="custom-control-label"
                                                :for="'packageAuto' + index">
                                                委托选择包装方式 (포장 방법 위임)
                                            </label>
                                        </div>
                                        <div class="custom-control custom-radio mb-2">
                                            <input type="radio" :id="'packageNo' + index"
                                                name="packageMethod" class="custom-control-input"
                                                value="noPackage" v-model="packageMethod"
                                                @change="changePackage(item)">
                                            <label class="custom-control-label"
                                                :for="'packageNo' + index">
                                                省略重新包装 (재포장 생략)
                                            </label>
                                        </div>
                                        <div class="custom-control custom-radio mb-2">
                                            <input type="radio" :id="'packageOPP' + index"
                                                name="packageMethod" class="custom-control-input"
                                                value="opp" v-model="packageMethod"
                                                @change="changePackage(item)">
                                            <label class="custom-control-label"
                                                :for="'packageOPP' + index">
                                                透明OPP袋包装 免费 (투명 OPP 봉투 포장, 무료)
                                            </label>
                                        </div>
                                        <div class="custom-control custom-radio">
                                            <input type="radio" :id="'packageLDPE' + index"
                                                name="packageMethod" class="custom-control-input"
                                                value="LDPE" v-model="packageMethod"
                                                @change="changePackage(item)">
                                            <label class="custom-control-label"
                                                :for="'packageLDPE' + index">
                                                不透明LDPE袋包装 免费 (불투명 LDPE 봉투 포장, 무료)
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="reqpo-option-group mb-3">
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input"
                                            :id="'defaultCheck' + index"
                                            v-model="item.요청내역.default">
                                        <label class="custom-control-label"
                                            :for="'defaultCheck' + index">
                                            基本验货/分类/包装/包材 (기본검수/분류/포장/포장자재) ￦200
                                        </label>
                                    </div>
                                </div>
                                <!-- 라벨링 옵션 -->
                                <div class="labeling-options mb-3">
                                    <div class="custom-control custom-switch mb-2">
                                        <input type="checkbox" class="custom-control-input"
                                            :id="'barcodeCheck' + index" v-model="item.요청내역.barcode"
                                            @change="changeBarcode(item)">
                                        <label class="custom-control-label"
                                            :for="'barcodeCheck' + index">
                                            条码标签 含Made in China·韩文标识 (바코드라벨, 한글표시사항 기본포함) ￦100
                                        </label>
                                    </div>

                                    <div v-if="!item.요청내역.barcode"
                                        class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input"
                                            :id="'stickerCheck' + index"
                                            v-model="item.요청내역.sticker">
                                        <label class="custom-control-label"
                                            :for="'stickerCheck' + index">
                                            原产地贴纸 (원산지스티커) ￦100
                                        </label>
                                    </div>
                                </div>

                                <!-- 추가 작업 옵션 -->
                                <div class="additional-options">
                                    <div class="custom-control custom-switch mb-2">
                                        <input type="checkbox" class="custom-control-input"
                                            :id="'maskingCheck' + index"
                                            v-model="item.요청내역.masking">
                                        <label class="custom-control-label"
                                            :for="'maskingCheck' + index">
                                            遮盖中文 免费 (중국어 마스킹, 무료)
                                        </label>
                                    </div>

                                    <div class="custom-control custom-switch mb-2">
                                        <input type="checkbox" class="custom-control-input"
                                            :id="'airpackingCheck' + index"
                                            v-model="item.요청내역.airpacking">
                                        <label class="custom-control-label"
                                            :for="'airpackingCheck' + index">
                                            气泡膜包装 按实际费用 (에어캡 포장, 실비)
                                        </label>
                                    </div>
                                    <div class="custom-control custom-switch mb-2">
                                        <input type="checkbox" class="custom-control-input"
                                            :id="'sewingCheck' + index" v-model="item.요청내역.sewing">
                                        <label class="custom-control-label"
                                            :for="'sewingCheck' + index">
                                            缝制原产地标签 (원산지라벨 봉제) 6000원/小时
                                        </label>
                                        <div class="reqpo-warning-text">* 进口服装必须缝制原产地标签 (의류 수입 시 원산지 라벨봉제는 필수
                                            사항입니다.)</div>
                                    </div>

                                    <div class="custom-control custom-switch mb-2">
                                        <input type="checkbox" class="custom-control-input"
                                            :id="'stampCheck' + index" v-model="item.요청내역.stamp">
                                        <label class="custom-control-label"
                                            :for="'stampCheck' + index">
                                            原产地印章 (원산지 도장) 6000원/小时
                                        </label>
                                        <div class="reqpo-warning-text">* 进口鞋类必须缝制原产地标签或盖原产地印章 (신발류 수입 시 제품에 원산지 라벨봉제 또는
                                            원산지 도장은 필수 사항입니다.)</div>
                                    </div>

                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input"
                                            :id="'tagCheck' + index" v-model="item.요청내역.tag">
                                        <label class="custom-control-label"
                                            :for="'tagCheck' + index">
                                            原产地吊牌 (원산지 택) 6000원/小时
                                        </label>
                                        <div class="reqpo-warning-text">* 进口箱包必须缝制原产地标签或挂原产地吊牌 (가방류 수입 시 원산지 라벨봉제 또는 원산지 택
                                            표기가 필수 사항입니다.)</div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="col-md-6">

                            <!-- 한글표시사항 섹션 -->
                            <div class="reqpo-form-section">
                                <div class="reqpo-section-title">9. 韩文标识 (한글표시사항)</div>

                                <!-- 바코드라벨 미부착 시 경고 -->
                                <div v-if="!item.요청내역.barcode" class="reqpo-warning-box mb-3">
                                    <div class="warning-content">
                                        <div class="warning-title">※ 不贴条码标签时 (바코드라벨을 부착하지 않는 경우),</div>
                                        <div class="reqpo-warning-text"
                                            v-if="item.요청내역.destination === 'coupang'">
                                            直送酷澎中心时，商品外包装上必须事先贴有或印有条码 (쿠팡센터 직납 시 사전에 제품패키지 겉에 반드시 바코드가 부착되거나 새겨져 있어야 합니다.)
                                        </div>
                                        <div class="reqpo-warning-text"
                                            v-if="item.요청내역.destination === 'customer'">
                                            必须有原产地标识 (반드시 원산지표시가 되어 있어야 합니다.)
                                        </div>
                                    </div>
                                </div>

                                <!-- 한글표시사항 입력 폼 -->
                                <div v-if="item.요청내역.barcode" class="korean-label-form">
                                    <!-- 바코드 -->
                                    <div class="form-group">
                                        <label class="col-form-label">条码号 (바코드번호)</label>
                                        <input type="text" class="form-control"
                                            placeholder="例/예) S00012341234" v-model="item.바코드">
                                    </div>

                                    <!-- 제품명 (별도 상단 배치) -->
                                    <div class="form-group">
                                        <label>商品名 (제품명)</label>
                                        <input type="text" class="form-control"
                                            placeholder="例/예) 쿠플러스 예쁜접시, 10인치" v-model="item.상품명">
                                        <small class="reqpo-warning-text">* 请一起填写在酷澎登记的商品名+选项名 (쿠팡에 등록한 상품명 + 옵션명을 같이
                                            입력해주세요)</small>
                                    </div>

                                    <!-- 기타 한글표시사항 -->
                                    <div class="form-group row">
                                        <label class="col-sm-3 col-form-label">进口商/销售商 (수입원/판매원)</label>
                                        <div class="col-sm-9">
                                            <input type="text" class="form-control"
                                                placeholder="例/예) 쿠플러스"
                                                v-model="item.한글표시사항['수입원/판매원']">
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label class="col-sm-3 col-form-label">制造商 (제조원)</label>
                                        <div class="col-sm-9">
                                            <input type="text" class="form-control"
                                                placeholder="例/예) 중국OEM" v-model="item.한글표시사항.제조원">
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label class="col-sm-3 col-form-label">制造国 (제조국)</label>
                                        <div class="col-sm-9">
                                            <input type="text" class="form-control"
                                                placeholder="例/예) 중국" v-model="item.한글표시사항.제조국">
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label class="col-sm-3 col-form-label">容量 (내용량)</label>
                                        <div class="col-sm-9">
                                            <input type="text" class="form-control"
                                                placeholder="例/예) 300ml" v-model="item.한글표시사항.내용량">
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label class="col-sm-3 col-form-label">原料及成分/材质 (원료명및성분명(재질))</label>
                                        <div class="col-sm-9">
                                            <input type="text" class="form-control"
                                                placeholder="例/예) 도자기제"
                                                v-model="item.한글표시사항['원료명및성분명(재질)']">
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label class="col-sm-3 col-form-label">商品类型 (상품유형)</label>
                                        <div class="col-sm-9">
                                            <input type="text" class="form-control"
                                                placeholder="例/예) 주방용품" v-model="item.한글표시사항.상품유형">
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label class="col-sm-3 col-form-label">使用注意事项 (사용시주의사항)</label>
                                        <div class="col-sm-9">
                                            <input type="text" class="form-control"
                                                placeholder="例/예) 용도 이외에 사용금지"
                                                v-model="item.한글표시사항.사용시주의사항">
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label class="col-sm-3 col-form-label">使用标准 (사용기준)</label>
                                        <div class="col-sm-9">
                                            <input type="text" class="form-control"
                                                placeholder="例/예) 14세 이상" v-model="item.한글표시사항.사용기준">
                                        </div>
                                    </div>

                                    <!-- KC인증 / 식품용 옵션 -->
                                    <div class="form-group row">
                                        <label class="col-sm-3 col-form-label">条码选项 (바코드 옵션)</label>
                                        <div class="col-sm-9">
                                            <div class="custom-control custom-switch mb-2">
                                                <input type="checkbox" class="custom-control-input" :id="'kcCheck-r-' + index" v-model="item.한글표시사항.kc인증">
                                                <label class="custom-control-label" :for="'kcCheck-r-' + index">显示KC认证标志 (KC인증마크 표시)</label>
                                            </div>
                                            <div class="custom-control custom-switch">
                                                <input type="checkbox" class="custom-control-input" :id="'foodCheck-r-' + index" v-model="item.한글표시사항.식품용">
                                                <label class="custom-control-label" :for="'foodCheck-r-' + index">食品用 (식품용 · 식품위생법에 의한 한글표시사항)</label>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- 기타 표시사항 -->
                                    <div class="form-group row">
                                        <label class="col-sm-3 col-form-label">其他 (기타)</label>
                                        <div class="col-sm-9">
                                            <textarea class="form-control" rows="2" placeholder="其他标识 (기타 표시사항)" v-model="item.한글표시사항.custom"></textarea>
                                        </div>
                                    </div>

                                    <!-- 바코드 출력 버튼 -->
                                    <div class="mt-2">
                                        <b-button variant="outline-success" size="sm" @click="printBarcodeFromPurchase(item)">
                                            <i class="ri-printer-line mr-1"></i>打印条码 (바코드 출력)
                                        </b-button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6">

                            <!-- 기존 판매자 협의 금액 섹션 -->
                            <div class="reqpo-form-section">
                                <div class="reqpo-section-title">10. 与商家协议金额 选填 (기존 판매자 협의 금액, 선택)</div>
                                <div class="price-info-form">
                                    <div class="form-group row">
                                        <label class="col-sm-4 col-form-label">协议单价 (협의단가) CNY</label>
                                        <div class="col-sm-8">
                                            <input type="number" :min="0" class="form-control"
                                                v-model="item.협의단가">
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label class="col-sm-4 col-form-label">
                                            总金额 (총금액) CNY<br>
                                            <small>(含中国国内运费的全部付款金额 / 중국 내륙배송비 포함 전체 결제금액)</small>
                                        </label>
                                        <div class="col-sm-8">
                                            <input type="number" :min="0" class="form-control"
                                                v-model="item.협의총금액">
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label class="col-sm-4 col-form-label">协议1688 ID (협의1688 ID)</label>
                                        <div class="col-sm-8">
                                            <input type="text" class="form-control"
                                                v-model="item.협의ID">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <!-- 기타요청사항 섹션 -->
                            <div class="reqpo-form-section">
                                <div class="reqpo-section-title">
                                    <div>其他要求 - 物流要求 (기타요청사항 - 물류요청사항)</div>
                                    <small class="reqpo-text-muted ml-3">
                                        (例：1688商品外箱中文处理、实拍、尺寸、重量、入库要求、鞋印章、服装缝制、OPP/LDPE/气泡膜、普通/精细验货等，耗时的额外作业按6000/小时收费 / 예: 1688제품 겉박스 중국어 있는부분 작업 요청 내용, 실사,
                                        사이즈, 무게, 센터 입고요청, 신발도장, 의류봉제 등,
                                        OPP/LDPE/뽁뽁이 일반검수/정밀검수, 시간이 걸리는 별도의 작업은
                                        6000/시간의 작업비 발생)
                                    </small>
                                </div>
                                <textarea class="form-control mt-3" rows="3"
                                    v-model="item.요청내역.reqcontent">
                                </textarea>
                            </div>
                            <div class="reqpo-form-section">
                                <div class="reqpo-section-title">
                                    <div>其他要求 - 采购要求 (기타요청사항 - 구매요청사항)</div>
                                </div>
                                <textarea class="form-control mt-3" rows="3"
                                    v-model="item.요청내역.reqcontentPurchase">
                                </textarea>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <!-- 로켓배송 / 일반LCL 요약 뷰 (창고팀 read-mostly) -->
            <div class="row" v-else-if="item.reqtype === '로켓배송' || item.reqtype === '일반LCL' || item.reqtype === '일반'">
                <div class="col-md-12">
                    <div class="alert alert-secondary mb-3 py-2">
                        <strong>
                            <span v-if="item.reqtype === '제트배송'">入库Coupang件 (제트배송)</span>
                            <span v-else-if="item.reqtype === '일반LCL' || item.reqtype === '일반'">一般货主件 (일반배송)</span>
                            <span v-else>{{ displayZh(item.reqtype) }}</span>
                        </strong>
                        <span class="ml-3">清关 (통관): <b-badge variant="info">{{ displayZh(item.통관방법) || '-' }}</b-badge></span>
                        <span class="ml-2">物流 (물류): <span class="badge badge-primary" :style="outboundTypeStyle(item.물류방법)">{{ outboundTypeText(item.물류방법) || '-' }}</span></span>
                        <span class="ml-2">目的地 (도착지): {{ item.요청내역 && item.요청내역.destination === 'coupang' ? '酷澎中心 (쿠팡센터)' : '货主指定 (화주지정)' }}</span>
                        <span class="ml-2">出库 (출고): {{ (item.요청내역 && item.요청내역.exportType) || 'box' }}</span>
                    </div>
                </div>
                <div class="col-md-6" v-if="item.요청내역 && item.요청내역.destination === 'customer' && item.요청내역.화주주소 && !(item.요청내역.sampleCheck && item.요청내역.sampleCheck.enabled && item.요청내역.sampleCheck.disposition === 'destroy')">
                    <div class="form-section">
                        <div class="section-title">货主地址 (화주주소)</div>
                        <div><strong>公司名 (업체명):</strong> {{ item.요청내역.화주주소.업체명 || '-' }}</div>
                        <div><strong>地址 (주소):</strong> {{ item.요청내역.화주주소.주소 || '-' }}</div>
                        <div><strong>电话 (연락처):</strong> {{ item.요청내역.화주주소.연락처 || '-' }}</div>
                        <!-- 샘플검증 화면엔 예전에 주소칸이 없어 화주가 기타요청사항에 적었다(2026-10-04 YZY) -->
                        <div v-if="!(item.요청내역.화주주소.주소 || '').trim()" class="small text-warning mt-1">
                            地址见其他要求(주소는 기타요청사항 참조)
                            <div v-if="reqcontentSnippet(item)" class="text-muted">「{{ reqcontentSnippet(item) }}」</div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6" v-if="item.reqtype === '로켓배송' && item.polists && item.polists.length > 0">
                    <div class="form-section">
                        <div class="section-title">订单信息 (발주 정보)</div>
                        <div v-if="selectedPo(item)" class="small">
                            <strong>{{ selectedPo(item).발주번호 }}</strong> · 中心 (센터): {{ selectedPo(item).발주센터 }} · 预计入库 (입고예정): {{ selectedPo(item).입고예정일 }} · {{ selectedPo(item).sku수량 }}个
                        </div>
                        <div v-else class="small text-muted">미선택(未选择)</div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-section">
                        <div class="section-title">清关信息 (통관 정보)</div>
                        <div><strong>申报英文名 (신고영문명):</strong> {{ item.신고영문명 || '-' }}</div>
                        <div><strong>HS-CODE:</strong> {{ item.HSCODE || '-' }}</div>
                        <div v-if="!item.신고영문명 && !item.HSCODE && reqcontentSnippet(item)" class="small text-warning mt-1">
                            未填写，见其他要求(미입력 — 기타요청사항 참조)
                        </div>
                    </div>
                </div>
                <div class="col-md-12" v-if="item.요청내역 && item.요청내역.sampleCheck && item.요청내역.sampleCheck.enabled">
                    <div class="form-section">
                        <div class="section-title">
                            样品检测件 (샘플검증) <small class="text-info">({{ item.요청내역.sampleCheck.quantity || 0 }}个 · 后续处理 (후처리): {{ item.요청내역.sampleCheck.disposition === 'destroy' ? '废弃 (폐기)' : '寄给货主 (화주 송달)' }})</small>
                        </div>
                        <ul class="mb-0 small"
                            v-if="item.요청내역.checklist && item.요청내역.checklist.groups && item.요청내역.checklist.groups.length">
                            <template v-for="(g, gIdx) in item.요청내역.checklist.groups">
                                <li v-for="(it, iIdx) in (g.items || [])" :key="gIdx + '-' + iIdx">
                                    {{ it.content || it.label || it.name || it }}
                                </li>
                            </template>
                        </ul>
                    </div>
                </div>
                <div class="col-md-12" v-if="item.요청내역 && item.요청내역.reqcontent">
                    <div class="form-section">
                        <div class="section-title">其他要求 (기타 요청사항)</div>
                        <div class="small" style="white-space: pre-wrap;">{{ item.요청내역.reqcontent }}</div>
                    </div>
                </div>
            </div>
            <div class="row" v-else-if="item.reqtype == '샘플검증'">
                <div class="col-md-6">
                    <div class="form-section">
                        <div class="section-title">1. 请求数量 (구매요청수량)</div>
                        <div class="input-wrapper">
                            <div class="d-flex justify-content-start flex-column">
                                <input type="number" :min="0" class="form-control text-center"
                                    style="width: 120px;" v-model="item.구매요청수량"
                                    @keyup.enter="validateQuantity(item)">
                                <div class="stock-info ml-3">
                                    <span class="info-label">起批量 (최소주문):</span>
                                    <span class="info-value">{{
                                        getMinOrderQuantity(item)
                                    }}个</span>
                                    <span class="separator">/</span>
                                    <span class="info-label">库存 (재고):</span>
                                    <span class="info-value">{{
                                        getAvailableStock(item)
                                    }}个</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-section">
                        <div class="section-title">2. 验证后处理 (검증 후 처리)</div>
                        <div class="destination-options">
                            <div class="btn-group w-100">
                                <button type="button" class="btn"
                                    :class="{ 'btn-primary': item.요청내역.destination === 'distroy', 'btn-outline-primary': item.요청내역.destination !== 'distroy' }"
                                    @click="item.요청내역.destination = 'distroy'">
                                    废弃 (폐기)
                                </button>
                                <button type="button" class="btn"
                                    :class="{ 'btn-primary': item.요청내역.destination === 'customer', 'btn-outline-primary': item.요청내역.destination !== 'customer' }"
                                    @click="item.요청내역.destination = 'customer'">
                                    货主 (화주)
                                </button>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="col-md-6" v-if="item.요청내역.destination == 'customer'">
                    <div class="form-section">
                        <div class="section-title">3. 清关信息 (통관정보)</div>
                        <div class="row">
                            <div class="col-12 mb-3">
                                <div class="form-group">
                                    <label>申报英文名 (신고영문명)</label>
                                    <input type="text" class="form-control" placeholder="例/예) shoes"
                                        v-model="item.신고영문명">
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label>HS-CODE</label>
                                    <div class="d-flex">
                                        <input type="text" class="form-control"
                                            placeholder="例/예) 6401.10-1000" v-model="item.HSCODE">
                                        <div class="w-25 d-flex align-items-center">
                                            <a href="https://www.bandtrass.or.kr/hsnavi.do"
                                                target="_blank"
                                                class="btn btn-outline-secondary ml-2">
                                                搜索 (검색)
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-6" v-if="item.요청내역.destination == 'customer'">
                    <div class="form-section">
                        <div class="section-title">4. 清关方式 (통관형태)</div>
                        <div class="customs-options">
                            <div class="custom-radio-card mb-2"
                                :class="{ 'active': item.요청내역.customsType === 'integrated' }"
                                @click="item.요청내역.customsType = 'integrated'">
                                <div class="card-title">COUPASS综合清关 (쿠패스통합통관)</div>
                                <div class="card-desc">人民币x280，含除验货/包装外的全部费用 (위안화x280, 검수/포장비용
                                    제외 모든비용 포함)</div>
                            </div>
                            <div class="custom-radio-card mb-2"
                                :class="{ 'active': item.요청내역.customsType === 'client' }"
                                @click="item.요청내역.customsType = 'client'">
                                <div class="card-title">货主单独清关 (화주단독통관)</div>
                                <div class="card-desc">代购手续费3%，材料、关税增值税、海运费、清关费、清关文件费等另计 (구매대행수수료3%, 자재,
                                    관부가세, 해운비, 통관비, 통관서류 비용 등 별도)</div>
                            </div>
                            <div class="custom-radio-card"
                                :class="{ 'active': item.요청내역.customsType === 'kupass' }"
                                @click="item.요청내역.customsType = 'kupass'">
                                <div class="card-title">COUPASS单独清关 (쿠패스단독통관)</div>
                                <div class="card-desc">仅限食检商品，代购手续费3%，材料、关税增值税、海运费、清关费、清关文件费等另计 (식검제품만 신청가능,
                                    구매대행수수료3%, 자재, 관부가세, 해운비, 통관비, 통관서류
                                    비용 등 별도)</div>
                            </div>
                        </div>
                    </div>
                </div>


                <!-- 기존 요청내역 섹션 내에 추가 -->
                <div class="col-md-12">
                    <div class="form-section">
                        <!-- 체크리스트 헤더 섹션 수정 -->
                        <div
                            class="section-title text-primary d-flex justify-content-between align-items-center">
                            <span>样品检查清单 (샘플 검사 체크리스트)</span>
                        </div>
                        <div class="inspection-checklist">
                            <div v-for="(group, groupIndex) in item.요청내역.checklist?.groups || checklistGroups"
                                :key="groupIndex" class="checklist-group">
                                <div class="d-flex justify-content-between align-items-center"
                                    v-if="group.items.find(e => e.checked)">
                                    <h6 class="group-title">{{ group.title }}</h6>
                                </div>

                                <div class="checklist-items">
                                    <div v-for="(list, itemIndex) in group.items" :key="itemIndex"
                                        class="d-flex align-items-center mb-2">
                                        <div class="custom-control custom-checkbox d-flex align-items-center w-75"
                                            v-if="list.checked">
                                            <input type="checkbox" class="custom-control-input"
                                                :id="'check-' + groupIndex + '-' + itemIndex"
                                                v-model="list.checked"
                                                @change="updateInspectionResults(group, list, item)">
                                            <label class="custom-control-label w-100"
                                                :for="'check-' + groupIndex + '-' + itemIndex"
                                                style="margin-bottom: 0; padding-top: 0;">
                                                <input type="text"
                                                    class="form-control d-inline-block ml-2"
                                                    style="width: calc(100% - 20px); margin-top: -2px;"
                                                    v-model="list.content"
                                                    @input="updateInspectionResults(group, list, item)">
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-section">
                                    <div class="section-title">
                                        <div>其他检查要求 (기타 검사요청사항)</div>
                                    </div>
                                    <textarea class="form-control mt-3" rows="5"
                                        v-model="item.요청내역.reqcontent">
                                    </textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" v-else>
                <div class="col-md-12">
                    <h6 class="mt-2 mb-1">[ 出库类型 (출고유형) ]</h6>
                </div>
                <div class="col-md-12 mt-2">
                    <div class="custom-control custom-switch custom-control-inline">
                        <input type="checkbox" class="custom-control-input" id="customSwitch1"
                            v-model="item.요청내역.poarrange">
                        <label class="custom-control-label" for="customSwitch1">按订单中心/预计入库日分箱 (발주센터/입고예정일에 따라 박스
                            분류)</label>
                    </div>
                    <span v-if="!item.요청내역.poarrange">※不区分商品/订单混装出库 (제품/발주 구분없이 적재되어 출고됩니다.)</span>
                    <div class="custom-control custom-switch custom-control-inline">
                        <div class="input-group" v-if="item.요청내역.poarrange">
                            <input type="text" class="form-control" placeholder="选择订单 (발주서선택)"
                                aria-label="" v-model="item.selectpo" style="text-align:center;">
                            <div class="input-group-append">
                                <b-dropdown class="my-class" variant="primary" type="button"
                                    text="">
                                    <b-dropdown-item @click="polistchange(b, item)"
                                        v-for="b, j in item.polists" :key="j">订单号 (발주번호) : {{ b.발주번호 }}
                                        ({{ b.발주센터 }}/{{ b.입고예정일 }}) - {{ b.sku수량
                                        }}个</b-dropdown-item>
                                </b-dropdown>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="custom-control custom-radio custom-control-inline">
                        <input type="radio" id="customRadio1" name="customRadio-3"
                            class="custom-control-input" v-model="item.요청내역.exportType"
                            value="pallet">
                        <label class="custom-control-label" for="customRadio1">托盘出库 (파렛트출고)</label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                        <input type="radio" id="customRadio2" name="customRadio-3"
                            class="custom-control-input" v-model="item.요청내역.exportType" value="box">
                        <label class="custom-control-label" for="customRadio2">箱子出库 (박스출고)</label>
                    </div>
                    <span>※最大箱子尺寸60×40×50cm，视情况可能变更 (최대 박스 사이즈는 60cm(가로) x 40cm(세로) x 50cm(높이)이며, 상황에 따라 변경될 수 있습니다.)</span>
                </div>

                <div class="col-md-12 mt-4 mb-1">
                    <h6>[ 请求数量 (구매요청수량) ]</h6>
                    <div class="custom-control-inline">
                        <input type="number" :min="0" class="form-control" placeholder="请求数量 (구매요청수량)"
                            aria-label="" v-model="item.구매요청수량" style="text-align:center;">
                    </div>
                </div>
                <div class="col-md-12"
                    v-if="item.구매요청수량 > item.발주수량 && item.발주수량 > 0 && item.요청내역.poarrange">
                    <div class="custom-control custom-radio custom-control-inline">
                        <input type="radio" id="customRadio3" name="customRadio-13"
                            class="custom-control-input" v-model="item.재고동봉" value=true>
                        <label class="custom-control-label" for="customRadio3">剩余数量出库 (나머지 수량 출고)</label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                        <input type="radio" id="customRadio4" name="customRadio-13"
                            class="custom-control-input" v-model="item.재고동봉" value=false>
                        <label class="custom-control-label" for="customRadio4">剩余数量库存保管 (나머지 수량 재고보관)</label>
                    </div>
                    <span>※剩余数量出库时另装箱一起出库 (나머지 수량 출고 시 별도의 박스로 함께 출고됩니다.)</span>
                </div>
                <div class="col-md-12 mt-4 mb-1">
                    <h6 v-b-tooltip.left="'该SKU为2件装时填2 (해당 SKU가 2p 구성일 경우에는 2라고 작성해 주세요)'">[ 销售组合数量 (판매구성수량) ]</h6>
                    <div class="custom-control-inline">
                        <input type="number" :min="0" class="form-control" placeholder="销售组合数量 (판매구성수량)"
                            aria-label="" v-model="item.판매구성수량" style="text-align:center;">
                    </div>
                </div>
                <div class="col-md-12 mt-4 mb-1">
                    <h6
                        v-b-tooltip.left="'请填写清关所需信息 (통관 시 필요한 정보를 기입해주세요) ex. 신고영문명 : shoes, 신고가격(USD) : 3.5, HS-CODE : 6401.10-0000'">
                        [ 清关信息 (통관정보) ]</h6>
                    <div class="custom-control-inline">
                        <input type="text" class="form-control" placeholder="申报英文名 (신고영문명)" aria-label=""
                            v-model="item.신고영문명" style="text-align:center;"
                            v-b-tooltip.left="'请简单填写商品申报英文名 (제품의 신고영문명을 간단히 작성해주세요.)'">
                    </div>
                    <div class="custom-control-inline">
                        <input type="number" :min="0" class="form-control" placeholder="申报价格USD (신고가격)"
                            aria-label="" v-model="item.신고가격" style="text-align:center;"
                            v-b-tooltip.left="'请填写申报价格(USD)，韩元/人民币请换算成美元 (제품의 신고가격(USD)를 작성해주세요. 원/위안화는 달러로 환산해서 작성해주세요.)'">
                    </div>
                    <div class="custom-control-inline">
                        <input type="text" class="form-control" placeholder="HS-CODE" aria-label=""
                            v-model="item.HSCODE" style="text-align:center;"
                            v-b-tooltip.left="'请填写清关商品的HS-CODE (통관할 제품의 HS-CODE를 작성해주세요) ex : 6401.10-1000'">
                    </div>
                </div>
                <div class="col-md-12">
                    <h6 class="mt-4 mb-1">[ 原产地作业 (원산지작업) ]</h6>
                </div>
                <div class="col-md-12 mt-2">
                    <div class="custom-control custom-switch custom-control-inline">
                        <input type="checkbox" class="custom-control-input" id="customSwitch2"
                            v-model="item.요청내역.barcode" @change="labelling(item.요청내역)">
                        <label class="custom-control-label" for="customSwitch2">条码标签 含原产地·韩文标识 (바코드라벨(원산지,한글표시사항
                            포함))</label>
                    </div>
                    <div class="custom-control custom-switch custom-control-inline"
                        v-if="item.요청내역.barcode">
                        <input type="text" class="form-control" placeholder="输入条码 (바코드입력)" aria-label=""
                            v-model="item.바코드" style="text-align:center;">
                    </div>
                </div>
                <div class="col-md-12 mt-2">
                    <div class="custom-control custom-switch custom-control-inline">
                        <input type="checkbox" class="custom-control-input" id="customSwitch3"
                            v-model="item.요청내역.sticker">
                        <label class="custom-control-label" for="customSwitch3">原产地贴纸 (원산지스티커)</label>
                    </div>
                </div>
                <div class="col-md-12 mt-2">
                    <div class="custom-control custom-switch custom-control-inline">
                        <input type="checkbox" class="custom-control-input" id="customSwitch4"
                            v-model="item.요청내역.stamp">
                        <label class="custom-control-label" for="customSwitch4">原产地印章 (원산지도장)</label>
                    </div>
                </div>
                <div class="col-md-12 mt-2">
                    <div class="custom-control custom-switch custom-control-inline">
                        <input type="checkbox" class="custom-control-input" id="customSwitch5"
                            v-model="item.요청내역.tag">
                        <label class="custom-control-label" for="customSwitch5">原产地吊牌 (원산지택총)</label>
                    </div>
                </div>
                <div class="col-md-12">
                    <h6 class="mt-4 mb-1">[ 验货及包装 (검수 및 포장작업) ]</h6>
                </div>
                <div class="col-md-12 mt-2">
                    <div class="custom-control custom-switch custom-control-inline">
                        <input type="checkbox" class="custom-control-input" id="customSwitch6"
                            v-model="item.요청내역.default" @change="qadefault(item.요청내역)">
                        <label class="custom-control-label" for="customSwitch6">基本验货 (기본검수)</label>
                    </div>
                </div>
                <div class="col-md-12 mt-2">
                    <div class="custom-control custom-switch custom-control-inline">
                        <input type="checkbox" class="custom-control-input" id="customSwitch7"
                            v-model="item.요청내역.opp">
                        <label class="custom-control-label" for="customSwitch7">透明OPP袋 见报价单 (투명 OPP 봉투 (견적서
                            참조))</label>
                    </div>
                </div>
                <div class="col-md-12 mt-2">
                    <div class="custom-control custom-switch custom-control-inline">
                        <input type="checkbox" class="custom-control-input" id="customSwitch8"
                            v-model="item.요청내역.LDPE">
                        <label class="custom-control-label" for="customSwitch8">不透明LDPE袋 见报价单 (불투명 LDPE 봉투 (견적서
                            참조))</label>
                    </div>
                </div>
                <div class="col-md-12 mt-2">
                    <div class="custom-control custom-switch custom-control-inline">
                        <input type="checkbox" class="custom-control-input" id="customSwitch9"
                            v-model="item.요청내역.airpacking">
                        <label class="custom-control-label" for="customSwitch9">气泡膜包装 见报价单 (에어캡 포장 (견적서
                            참조))</label>
                    </div>
                    <p>※大体积商品(最大箱子尺寸1/5以上)另行协商 (큰 부피의 제품(최대박스 사이즈의 1/5이상 사이즈)인 경우 별도 협의)</p>
                </div>
                <div class="col-md-12">
                    <h6 class="mt-4 mb-1">[ 其他要求 - 物流 (기타요청사항 - 물류) ]</h6>
                </div>
                <div class="col-md-12">
                    <textarea class="form-control" id="exampleFormControlTextarea1" rows="3"
                        v-model="item.요청내역.reqcontent"></textarea>
                </div>
                <div class="col-md-12">
                    <h6 class="mt-4 mb-1">[ 其他要求 - 采购 (기타요청사항 - 구매) ]</h6>
                </div>
                <div class="col-md-12">
                    <textarea class="form-control" id="exampleFormControlTextarea1" rows="3"
                        v-model="item.요청내역.reqcontentPurchase"></textarea>
                </div>
                <div class="col-md-12 mt-2">
                    <div class="custom-control custom-switch custom-control-inline">
                        <input type="checkbox" class="custom-control-input" id="customSwitch222"
                            v-model="item.구매취소" @change="cancelpo(item)">
                        <label class="custom-control-label" for="customSwitch222">采购取消 (구매취소)</label>
                    </div>
                    <div class="custom-control">
                        <textarea v-if="item.구매취소" class="form-control"
                            id="exampleFormControlTextarea122" v-model="item.구매취소내용"></textarea>
                    </div>
                </div>
            </div>
        </b-modal>
        </div>

        <!-- 그룹 상세 모달 -->
        <b-modal id="group-detail-modal" size="xl" scrollable title="采购请求详情 (구매요청 상세)"
            @hidden="showDetailModal = false" hide-footer>
            <b-overlay :show="orderCreatingOverlay" rounded="sm" variant="white" opacity="0.85">
                <template #overlay>
                    <div class="text-center">
                        <b-spinner variant="primary" class="mb-2"></b-spinner>
                        <p class="mb-0 font-weight-bold">{{ orderCreatingText }}</p>
                    </div>
                </template>
            <template v-if="selectedGroup">
                <!-- 주문생성 에러 메시지 고정 표시 -->
                <div v-if="orderErrorMessage" class="alert alert-danger d-flex align-items-start mb-2 py-2" style="font-size:0.85rem;">
                    <b-icon icon="exclamation-triangle-fill" class="mr-2 mt-1 flex-shrink-0"></b-icon>
                    <div class="flex-grow-1">
                        <strong>订单创建失败 (주문생성 실패)</strong>
                        <div class="mt-1" style="word-break:break-all;">{{ orderErrorMessage }}</div>
                    </div>
                    <b-button size="sm" variant="outline-danger" class="ml-2 flex-shrink-0" @click="orderErrorMessage = ''">✕</b-button>
                </div>

                <!-- 상단: 공통 정보 + 액션 버튼 (한 줄에 배치) -->
                <div class="detail-summary-bar mb-3">
                    <!-- 좌측: 요약 정보 뱃지들 -->
                    <div class="summary-badges-left">
                        <div class="summary-badge">
                            <span class="badge-label">
                                <span class="label-cn">订单号</span>
                                <span class="label-kr">(주문번호)</span>
                            </span>
                            <span v-if="selectedGroup.화주주문번호" class="badge-value text-info">{{ selectedGroup.화주주문번호 }}</span>
                            <span v-else class="badge-value text-muted">未发放 (미발급)</span>
                        </div>
                        <div class="summary-badge">
                            <span class="badge-label">
                                <span class="label-cn">请求日</span>
                                <span class="label-kr">(요청일)</span>
                            </span>
                            <span class="badge-value">{{ getTimeDate(selectedGroup.요청일) }}</span>
                        </div>
                        <div class="summary-badge">
                            <span class="badge-label">
                                <span class="label-cn">类型</span>
                                <span class="label-kr">(타입)</span>
                            </span>
                            <span class="badge-value">
                                <span v-if="selectedGroup.reqtype === '제트배송'">
                                    <b-badge :variant="selectedGroup.destination === 'customer' ? 'warning' : 'primary'">
                                        {{ selectedGroup.destination === 'customer' ? '货主 (화주)' : '入库Coupang件' }}
                                    </b-badge>
                                </span>
                                <b-badge v-else-if="selectedGroup.reqtype === '로켓배송'" variant="success">快递资料件</b-badge>
                                <b-badge v-else variant="secondary">{{ displayZh(selectedGroup.reqtype) }}</b-badge>
                            </span>
                        </div>
                        <div class="summary-badge">
                            <span class="badge-label">
                                <span class="label-cn">公司</span>
                                <span class="label-kr">(업체)</span>
                            </span>
                            <span class="badge-value font-weight-bold">{{ selectedGroup.companyid }}</span>
                        </div>
                        <div class="summary-badge">
                            <span class="badge-label">
                                <span class="label-cn">状态</span>
                                <span class="label-kr">(현황)</span>
                            </span>
                            <span class="badge-value">
                                <b-badge :variant="getStatusVariant(selectedGroup.processStatus || selectedGroup.진행현황)">{{ displayZh(selectedGroup.processStatus || selectedGroup.진행현황) }}</b-badge>
                            </span>
                        </div>
                        <div class="summary-badge">
                            <span class="badge-label">
                                <span class="label-cn">清关</span>
                                <span class="label-kr">(통관)</span>
                            </span>
                            <span class="badge-value">
                                <b-badge variant="light">{{ displayZh(selectedGroup.통관방법) }}</b-badge>
                            </span>
                        </div>
                        <div class="summary-badge">
                            <span class="badge-label">
                                <span class="label-cn">品目/数量</span>
                                <span class="label-kr">(품목/수량)</span>
                            </span>
                            <span class="badge-value">{{ selectedGroup.품목수 }} / {{ selectedGroup.총수량 }}个</span>
                        </div>
                        <div class="summary-badge summary-badge-wide">
                            <span class="badge-label">
                                <span class="label-cn">采购代码</span>
                                <span class="label-kr">(구매코드)</span>
                            </span>
                            <span class="badge-value">
                                <code>{{ selectedGroup.구매코드1688 }}</code>
                                <b-button size="sm" variant="link" class="p-0 ml-1" @click="copyToClipboard(selectedGroup.구매코드1688)">
                                    <b-icon icon="clipboard" scale="0.7"></b-icon>
                                </b-button>
                            </span>
                        </div>
                    </div>
                    <!-- 우측: 액션 버튼들 -->
                    <div class="summary-actions-right">
                        <b-button v-if="selectedGroup.비1688" size="sm" variant="danger" class="action-btn-bilingual"
                            @click="openNon1688Transfer(selectedGroup.items)" :disabled="!canManualTransfer(selectedGroup)">
                            <b-icon icon="cash-coin" class="btn-icon"></b-icon>
                            <span class="btn-text">
                                <span class="text-cn">已转账</span>
                                <span class="text-kr">송금완료</span>
                            </span>
                        </b-button>
                        <b-button v-else size="sm" variant="primary" class="action-btn-bilingual" @click="createOrderFromGroup"
                            :disabled="orderCreating || (selectedGroup.processStatus || selectedGroup.진행현황) !== '구매전' && (selectedGroup.processStatus || selectedGroup.진행현황) !== '구매확인'">
                            <b-icon icon="cart-plus" class="btn-icon"></b-icon>
                            <span class="btn-text">
                                <span class="text-cn">创建订单</span>
                                <span class="text-kr">주문생성</span>
                            </span>
                        </b-button>
                        <b-button size="sm" variant="outline-secondary" class="action-btn-bilingual" @click="openBatchQuantityEdit">
                            <b-icon icon="pencil" class="btn-icon"></b-icon>
                            <span class="btn-text">
                                <span class="text-cn">修改请求数量</span>
                                <span class="text-kr">요청수량수정</span>
                            </span>
                        </b-button>
                        <b-button size="sm" variant="outline-secondary" class="action-btn-bilingual" @click="openBatchCustomsEdit">
                            <b-icon icon="truck" class="btn-icon"></b-icon>
                            <span class="btn-text">
                                <span class="text-cn">修改清关</span>
                                <span class="text-kr">통관수정</span>
                            </span>
                        </b-button>
                        <b-button size="sm" variant="outline-secondary" class="action-btn-bilingual" @click="openBatchStatusEdit">
                            <b-icon icon="arrow-repeat" class="btn-icon"></b-icon>
                            <span class="btn-text">
                                <span class="text-cn">修改状态</span>
                                <span class="text-kr">현황수정</span>
                            </span>
                        </b-button>
                        <b-button size="sm" variant="outline-dark" class="action-btn-bilingual"
                            @click="openSidePaymentModalBatch"
                            v-b-tooltip.hover title="체크한 상품을 1688에서 직접 주문한 주문번호 하나에 연결 / 将勾选的商品关联到在1688手动下单的订单号">
                            <b-icon icon="link45deg" class="btn-icon"></b-icon>
                            <span class="btn-text">
                                <span class="text-cn">别单链接付款{{ detailSelectedItems.length ? ` (${detailSelectedItems.length})` : '' }}</span>
                                <span class="text-kr">별도링크 결제처리</span>
                            </span>
                        </b-button>
                        <b-button size="sm" variant="outline-success" class="action-btn-bilingual"
                            @click="translateGroupRequests" :disabled="isTranslating">
                            <b-spinner v-if="isTranslating" small class="btn-icon"></b-spinner>
                            <b-icon v-else icon="translate" class="btn-icon"></b-icon>
                            <span class="btn-text">
                                <span class="text-cn">翻译请求</span>
                                <span class="text-kr">요청번역</span>
                            </span>
                        </b-button>
                        <b-button size="sm" variant="warning" class="action-btn-bilingual"
                            @click="createQuotationFromGroup"
                            :disabled="!selectedGroup.주문생성여부 || !hasUnquotedItems"
                            v-b-tooltip.hover :title="!selectedGroup.주문생성여부 ? '创建订单后可生成报价单 (주문 생성 후 견적서 생성 가능)' : !hasUnquotedItems ? '所有商品已生成报价单 (모든 상품의 견적서가 생성됨)' : '为未生成的商品生成1688采购金额报价单 (미생성 상품의 1688 구매금액 견적서 생성)'">
                            <b-icon icon="file-earmark-plus" class="btn-icon"></b-icon>
                            <span class="btn-text">
                                <span class="text-cn">生成报价</span>
                                <span class="text-kr">견적서생성</span>
                            </span>
                        </b-button>
                        <b-button size="sm" variant="success" class="action-btn-bilingual"
                            @click="proceedPayment"
                            :disabled="!selectedGroup.주문생성여부 || !selectedGroup.입금여부 || processingPayment"
                            v-b-tooltip.hover :title="!selectedGroup.주문생성여부 ? '创建订单后可付款 (주문 생성 후 결제 가능)' : !selectedGroup.입금여부 ? '确认入账后可付款 (입금 확인 후 결제 가능)' : '打开1688付款页面 (1688 결제 페이지 열기)'">
                            <b-spinner v-if="processingPayment" small class="btn-icon"></b-spinner>
                            <b-icon v-else icon="credit-card" class="btn-icon"></b-icon>
                            <span class="btn-text">
                                <span class="text-cn">付款</span>
                                <span class="text-kr">결제진행</span>
                            </span>
                        </b-button>
                        <b-button size="sm" :variant="selectedGroup.items[0]?.견적서_공통물류비 ? 'outline-info' : 'info'" class="action-btn-bilingual"
                            @click="openCommonLogisticsModal(selectedGroup)">
                            <b-icon icon="box-seam" class="btn-icon"></b-icon>
                            <span class="btn-text">
                                <span class="text-cn">公共费用</span>
                                <span class="text-kr">공통물류비{{ selectedGroup.items[0]?.견적서_공통물류비 ? ' ✓' : '' }}</span>
                            </span>
                        </b-button>
                        <b-button size="sm" variant="danger" class="action-btn-bilingual"
                            @click="cancelOrder1688"
                            :disabled="cancelOrder1688Disabled || cancellingOrder"
                            v-b-tooltip.hover :title="cancelOrder1688Tooltip">
                            <b-spinner v-if="cancellingOrder" small class="btn-icon"></b-spinner>
                            <b-icon v-else icon="x-circle" class="btn-icon"></b-icon>
                            <span class="btn-text">
                                <span class="text-cn">取消订单</span>
                                <span class="text-kr">주문취소</span>
                            </span>
                        </b-button>
                    </div>
                </div>

                <!-- 중단: 개별 상품 목록 -->
                <div class="card mb-3">
                    <div class="card-header">
                        <h5 class="mb-0">商品列表 (상품 목록)</h5>
                    </div>
                    <div class="card-body p-0">
                        <CDataTable
                            storage-key="logisreqpurchaseV0.3" :headers="detailHeaders" :items="selectedGroup.items"
                            v-model="detailSelectedItems" :show-select="true" itemKey="_id"
                            :row-class="getRowHighlightClass">
                            <!-- 여기 item 은 selectedGroup.items 원소 = reqlists 원본 요청건이다(그룹 행 아님) -->
                            <template v-slot:action="{ item }">
                                <div class="d-flex align-items-center list-action">
                                    <a v-if="changeoption" class="badge bg-success mr-2" data-toggle="tooltip" v-b-tooltip.top
                                        title="重新匹配选项 (옵션재매칭)" href="javascript:void(0)" @click="rematching(item)"
                                        style="width: 30px; height: 30px; display: flex; justify-content: center; align-items: center">
                                        <i class="ri-pencil-line mr-0"></i>
                                    </a>
                                    <a v-if="isStaffUser && item.주문정보 && item.주문정보['1688주문번호']" class="badge badge-warning mr-2" data-toggle="tooltip" v-b-tooltip.top
                                title="购买后更换属性 (구매 후 옵션 변경)" href="javascript:void(0)" @click="openOptionChange(item)"
                                style="width: 30px; height: 30px; display: flex; justify-content: center; align-items: center">
                                <i class="ri-refresh-line mr-0"></i>
                            </a>
                            <a class="badge badge-secondary mr-2" data-toggle="tooltip" v-b-tooltip.top title="查看 (확인)"
                                        href="javascript:void(0)" @click="openItemActionModal('modalDetail', item)"
                                        style="width: 30px; height: 30px; display: flex; justify-content: center; align-items: center">
                                        <i class="ri-eye-line mr-0"></i>
                                    </a>
                                    <a class="badge badge-info mr-2" data-toggle="tooltip" v-b-tooltip.top title="编辑 (편집)"
                                        href="javascript:void(0)" @click="openItemActionModal('modal', item)"
                                        style="width: 30px; height: 30px; display: flex; justify-content: center; align-items: center">
                                        <i class="ri-eye-line mr-0"></i>
                                    </a>
                                    <a class="badge mr-2 side-payment-btn" data-toggle="tooltip" v-b-tooltip.top
                                        :title="item.주문정보 && item.주문정보.별도결제 ? '修改另付链接 (별도결제 수정)' : '别单链接付款 (별도링크 결제처리)'"
                                        href="javascript:void(0)" @click="openSidePaymentModal(item)"
                                        :class="item.주문정보 && item.주문정보.별도결제 ? 'badge-warning' : 'badge-dark'"
                                        style="width: 30px; height: 30px; display: flex; justify-content: center; align-items: center">
                                        <i class="ri-link-m mr-0"></i>
                                    </a>
                                </div>
                            </template>
                            <template v-slot:상품주문번호="{ item }">
                                <small v-if="item.상품주문번호">{{ item.상품주문번호 }}</small>
                                <span v-else class="text-muted">-</span>
                            </template>
                            <template v-slot:1688주문번호="{ item }">
                                <small v-if="item.주문정보 && item.주문정보['1688주문번호']">{{ item.주문정보['1688주문번호'] }}</small>
                                <span v-else-if="!(item.주문정보 && item.주문정보.판매처주문번호)" class="text-muted">-</span>
                                <div v-if="item.주문정보 && item.주문정보.판매처주문번호" class="small" v-b-tooltip.hover title="商家订单号 / 판매처 주문번호"><span style="user-select:none">商家: </span>{{ item.주문정보.판매처주문번호 }}</div>
                            </template>
                            <template v-slot:묶음구성여부="{ item }">
                                <span v-if="item.묶음구성여부">{{ item.묶음구성수량 }}个</span>
                                <span v-else class="text-muted">-</span>
                            </template>
                            <template v-slot:요청변경="{ item }">
                                <div v-if="item.changeHistory && item.changeHistory.length > 0"
                                    class="change-review-cell"
                                    :class="{
                                        'change-review-urgent': hasUnconfirmedChange(item) && (item.processStatus || item.진행현황) !== '구매전',
                                        'change-review-pending': hasUnconfirmedChange(item) && (item.processStatus || item.진행현황) === '구매전',
                                        'change-review-done': !hasUnconfirmedChange(item)
                                    }"
                                    @click="openChangeReviewModal(item)"
                                    v-b-tooltip.hover.html="getChangeHistoryTooltip(item)"
                                    style="cursor:pointer">
                                    <b-icon
                                        :icon="hasUnconfirmedChange(item) ? 'exclamation-triangle-fill' : 'check-circle-fill'"
                                        :font-scale="hasUnconfirmedChange(item) && (item.processStatus || item.진행현황) !== '구매전' ? 1.6 : 1.0"
                                        :class="hasUnconfirmedChange(item) && (item.processStatus || item.진행현황) !== '구매전' ? 'change-review-pulse' : ''"></b-icon>
                                    <b-badge v-if="hasUnconfirmedChange(item)" variant="danger" class="ml-1">
                                        {{ unconfirmedChangeCount(item) }}
                                    </b-badge>
                                </div>
                                <span v-else class="text-muted">-</span>
                            </template>
                            <template v-slot:상품명="{ item }">
                                <div class="d-flex align-items-center p-1">
                                    <img :src="cdnImg(item.등록이미지)" class="img-fluid rounded avatar-40 mr-2" alt="image"
                                        style="cursor: zoom-in;" title="双击放大 (더블클릭하면 확대)" @dblclick="zoomImageSrc = cdnImg(item.등록이미지)">
                                    <div style="max-width: 150px; user-select: text; cursor: text;">
                                        <span class="d-block" style="font-size: 12px; white-space: normal; overflow-wrap: anywhere;">{{ item.상품명 }}</span>
                                        <small v-if="item.요청내역 && item.요청내역.상품명_cn" class="text-success d-block" style="font-size: 10px; white-space: normal; overflow-wrap: anywhere;">(CN) {{ item.요청내역.상품명_cn }}</small>
                                        <small class="text-muted">{{ item.바코드 }}</small>
                                    </div>
                                </div>
                            </template>
                            <template v-slot:중국어상품명="{ item }">
                                <span v-if="item.item && item.item.subject" style="font-size: 11px;">{{ item.item.subject }}</span>
                                <span v-else class="text-muted">-</span>
                            </template>
                            <template v-slot:중국어옵션1="{ item }">
                                <b-form-select v-if="changeoption && item.item && item.상품매칭 && item.상품매칭.옵션1_중국어 && item.상품매칭.옵션1_중국어.length"
                                    size="sm" style="font-size: 11px; min-width: 90px;" :value="item.옵션1_중국어"
                                    :options="[{ value: undefined, text: '选择 / 선택', disabled: true }].concat(item.상품매칭.옵션1_중국어.map(o => o.name))"
                                    @change="pickOption(1, $event, item)"></b-form-select>
                                <span v-else-if="item.옵션1_중국어" style="font-size: 11px;">{{ item.옵션1_중국어 }}</span>
                                <span v-else class="text-muted">-</span>
                            </template>
                            <template v-slot:중국어옵션2="{ item }">
                                <b-form-select v-if="changeoption && item.item && item.상품매칭 && item.상품매칭.옵션2_중국어 && item.상품매칭.옵션2_중국어.length"
                                    size="sm" style="font-size: 11px; min-width: 90px;" :value="item.옵션2_중국어"
                                    :options="[{ value: undefined, text: '选择 / 선택', disabled: true }].concat(item.상품매칭.옵션2_중국어.map(o => o.name))"
                                    @change="pickOption(2, $event, item)"></b-form-select>
                                <span v-else-if="item.옵션2_중국어" style="font-size: 11px;">{{ item.옵션2_중국어 }}</span>
                                <span v-else class="text-muted">-</span>
                            </template>
                            <template v-slot:판매자명="{ item }">
                                <a v-if="item.item && item.item.companyName"
                                    href="javascript:void(0)"
                                    @click="openWangwangChat(item)"
                                    class="text-primary" style="font-size: 11px; cursor: pointer;">
                                    {{ item.item.companyName }}
                                    <b-icon icon="chat-dots" class="ml-1"></b-icon>
                                </a>
                                <span v-else class="text-muted">-</span>
                            </template>
                            <template v-slot:구매수량="{ item }">
                                {{ (parseInt(item.구매요청수량) || 0) * (parseInt(item.판매구성수량) || 1) }}({{ item.구매요청수량 || 0 }}x{{ item.판매구성수량 || 1 }})
                            </template>
                            <template v-slot:주문수량="{ item }">
                                <div v-if="canEditOrderQty(item)">
                                    <input type="number" class="form-control form-control-sm text-center p-0"
                                        style="width:70px; font-size:11px;"
                                        :value="item._주문수량_override != null ? item._주문수량_override : (parseInt(item.구매요청수량) || 0) * (parseInt(item.판매구성수량) || 1)"
                                        @change="$set(item, '_주문수량_override', parseInt($event.target.value))"
                                        min="1">
                                    <small v-if="item._주문수량_override != null && item._주문수량_override !== (parseInt(item.구매요청수량) || 0) * (parseInt(item.판매구성수량) || 1)"
                                        class="text-warning d-block" style="font-size:9px;">
                                        原 (원래): {{ (parseInt(item.구매요청수량) || 0) * (parseInt(item.판매구성수량) || 1) }}
                                    </small>
                                </div>
                                <span v-else>{{ item.주문정보?.주문수량 || (parseInt(item.구매요청수량) || 0) * (parseInt(item.판매구성수량) || 1) }}</span>
                            </template>
                            <template v-slot:판매자메시지="{ item }">
                                <div class="text-center">
                                    <template v-if="canEditOrderQty(item)">
                                        <b-button size="sm" variant="outline-secondary" class="p-0" style="width:26px;height:26px;"
                                            @click="openSellerMessageEdit(item)"
                                            v-b-tooltip.hover :title="item._판매자메시지 || '点击填写卖家留言 (클릭하여 판매자 메시지 입력)'">
                                            <b-icon :icon="item._판매자메시지 ? 'chat-dots-fill' : 'chat-dots'"
                                                :variant="item._판매자메시지 ? 'primary' : 'secondary'" scale="0.8"></b-icon>
                                        </b-button>
                                    </template>
                                    <template v-else-if="item.주문정보 && item.주문정보.판매자메시지">
                                        <b-icon icon="chat-dots-fill" variant="info" scale="0.9"
                                            v-b-tooltip.hover :title="item.주문정보.판매자메시지"></b-icon>
                                    </template>
                                    <span v-else class="text-muted">-</span>
                                </div>
                            </template>
                            <template v-slot:구매링크="{ item }">
                                <a :href="item.구매링크" target="_blank">
                                    <b-icon icon="link" scale="1" variant="secondary"></b-icon>
                                </a>
                            </template>
                            <template v-slot:구매요청사항="{ item }">
                                <div v-if="item.요청내역 && item.요청내역.reqcontentPurchase"
                                    v-b-tooltip.hover.html
                                    :title="getReqContentTooltip(item.요청내역.reqcontentPurchase, item.요청내역.reqcontentPurchase_cn)">
                                    <span class="text-truncate d-block" style="max-width: 100px; font-size: 11px;">
                                        {{ item.요청내역.reqcontentPurchase }}
                                    </span>
                                    <small v-if="item.요청내역.reqcontentPurchase_cn" class="text-success d-block text-truncate" style="font-size: 10px; max-width: 100px;">
                                        (CN) {{ item.요청내역.reqcontentPurchase_cn }}
                                    </small>
                                </div>
                                <span v-else class="text-muted">-</span>
                            </template>
                            <template v-slot:물류요청사항="{ item }">
                                <div v-if="item.요청내역 && item.요청내역.reqcontent"
                                    v-b-tooltip.hover.html
                                    :title="getReqContentTooltip(item.요청내역.reqcontent, item.요청내역.reqcontent_cn)">
                                    <span class="text-truncate d-block" style="max-width: 100px; font-size: 11px;">
                                        {{ item.요청내역.reqcontent }}
                                    </span>
                                    <small v-if="item.요청내역.reqcontent_cn" class="text-success d-block text-truncate" style="font-size: 10px; max-width: 100px;">
                                        (CN) {{ item.요청내역.reqcontent_cn }}
                                    </small>
                                </div>
                                <span v-else class="text-muted">-</span>
                            </template>
                            <template v-slot:협의금액="{ item }">
                                <span v-if="item.협의단가">¥{{ item.협의단가 }}</span>
                                <span v-else class="text-muted">-</span>
                            </template>
                            <template v-slot:협의ID="{ item }">
                                <span v-if="item.협의ID" style="font-size: 11px;">{{ item.협의ID }}</span>
                                <span v-else class="text-muted">-</span>
                            </template>
                            <template v-slot:이전주문가격="{ item }">
                                <span v-if="item.이전주문가격">¥{{ item.이전주문가격 }}</span>
                                <span v-else class="text-muted">-</span>
                            </template>
                            <template v-slot:협상전가격="{ item }">
                                <span v-if="item.주문정보 && item.주문정보.협상전_총금액">¥{{ item.주문정보.협상전_총금액 }}</span>
                                <span v-else class="text-muted">-</span>
                            </template>
                            <template v-slot:협상후가격="{ item }">
                                <span v-if="item.주문정보 && item.주문정보.협상후_총금액">¥{{ item.주문정보.협상후_총금액 }}</span>
                                <span v-else-if="item.주문정보 && item.주문정보.협상전_총금액">¥{{ item.주문정보.협상전_총금액 }} <small class="text-muted">未改价</small></span>
                                <span v-else class="text-muted">-</span>
                            </template>
                            <!-- 采购备注(직원이 구매를 마칠 때 적는 메모) + 实物图 — 연필을 누르면 메모·사진을 적는 창이 열린다(2026-10-25 崔凡 #146) -->
                            <template v-slot:구매메모="{ item }">
                                <div class="d-flex align-items-start" style="gap:4px;">
                                    <span v-if="item.구매메모" style="white-space:pre-wrap;font-size:0.8rem;">{{ item.구매메모 }}</span>
                                    <span v-else class="text-muted">-</span>
                                    <b-button size="sm" variant="outline-secondary" class="py-0 px-1 ml-auto" title="编辑采购备注 (메모·사진 입력)" @click="openPurchaseNote(item)"><b-icon icon="pencil" scale="0.8"></b-icon></b-button>
                                </div>
                            </template>
                            <template v-slot:구매메모사진="{ item }">
                                <div v-if="item.구매메모사진 && item.구매메모사진.length" class="d-flex flex-wrap justify-content-center" style="gap:3px;">
                                    <a v-for="(u, ui) in item.구매메모사진" :key="'pn' + ui" :href="u" target="_blank" rel="noopener"><img :src="u" alt="" style="width:40px;height:40px;object-fit:cover;border-radius:3px;border:1px solid #ddd;"></a>
                                </div>
                                <span v-else class="text-muted">-</span>
                            </template>
                            <template v-slot:부피="{ item }">
                                <div v-if="volumeEditingId === item._id" class="d-flex align-items-center" style="gap:2px;">
                                    <b-form-input v-model.number="volumeEditForm.sizeX" size="sm" type="number" style="width:50px;font-size:11px;" placeholder="X"></b-form-input>
                                    <span>×</span>
                                    <b-form-input v-model.number="volumeEditForm.sizeY" size="sm" type="number" style="width:50px;font-size:11px;" placeholder="Y"></b-form-input>
                                    <span>×</span>
                                    <b-form-input v-model.number="volumeEditForm.sizeZ" size="sm" type="number" style="width:50px;font-size:11px;" placeholder="Z"></b-form-input>
                                    <b-button size="sm" variant="success" class="py-0 px-1" @click="saveVolume(item)"><b-icon icon="check" scale="0.8"></b-icon></b-button>
                                    <b-button size="sm" variant="outline-secondary" class="py-0 px-1" @click="volumeEditingId = null"><b-icon icon="x" scale="0.8"></b-icon></b-button>
                                </div>
                                <div v-else style="cursor:pointer;" @click="startVolumeEdit(item)">
                                    <template v-if="(item.sizeX || 0) * (item.sizeY || 0) * (item.sizeZ || 0) > 0">
                                        <small>{{ item.sizeX }}×{{ item.sizeY }}×{{ item.sizeZ }}</small>
                                        <br><small class="text-muted">{{ ((item.sizeX || 0) * (item.sizeY || 0) * (item.sizeZ || 0)).toLocaleString() }}cm³</small>
                                    </template>
                                    <small v-else class="text-muted">-</small>
                                </div>
                            </template>

                        </CDataTable>
                    </div>
                </div>


            </template>
            </b-overlay>
        </b-modal>

        <!-- 개별 견적서 보기 모달 -->
        <QuotationModal
            modal-id="quotation-item-modal"
            :quotation-data="currentQuotation"
        />



        <!-- 중국물류비 견적서 생성 모달 (동적 items) -->
        <b-modal
            id="china-logistics-modal"
            v-model="showChinaLogisticsModal"
            :title="chinaLogisticsItem?.견적서_중국물류비 ? '修改中国物流费报价单 (중국물류비 견적서 수정)' : '生成中国物流费报价单 (중국물류비 견적서 생성)'"
            size="lg"
            @ok="submitChinaLogistics"
            :ok-title="chinaLogisticsItem?.견적서_중국물류비 ? '修改报价单 (견적서 수정)' : '生成报价单 (견적서 생성)'"
            cancel-title="取消 (취소)">
            <template v-if="chinaLogisticsItem">
                <div class="mb-3 p-3 bg-light rounded">
                    <div class="row">
                        <div class="col-4"><strong>商品名 (상품명):</strong> {{ chinaLogisticsItem.상품명 }}</div>
                        <div class="col-4"><strong>条码 (바코드):</strong> {{ chinaLogisticsItem.바코드 }}</div>
                        <div class="col-4"><strong>货主 (업체):</strong> {{ chinaLogisticsItem.companyid }}</div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-4"><strong>请求数量 (구매요청수량):</strong> {{ chinaLogisticsItem.구매요청수량 }}</div>
                        <div class="col-4"><strong>入库数量 (입고수량):</strong> {{ chinaLogisticsItem.입고수량 || chinaLogisticsItem.구매요청수량 || '-' }}</div>
                        <div class="col-4">
                            <strong>清关 (통관):</strong>
                            <b-badge :variant="chinaLogisticsForm.customsType === 'integrated' ? 'info' : 'warning'">
                                {{ chinaLogisticsForm.customsType === 'integrated' ? '综合清关 (통합통관)' : chinaLogisticsForm.customsType === 'client' ? '货主单独清关 (화주단독)' : 'COUPASS单独清关 (쿠패스단독통관)' }}
                            </b-badge>
                        </div>
                    </div>
                </div>

                <!-- 동적 비용 항목 테이블 -->
                <table class="table table-sm table-bordered">
                    <thead class="thead-light">
                        <tr>
                            <th style="width:30%">项目名<br><small>항목명</small></th>
                            <th style="width:20%">单价 (원)<br><small>단가</small></th>
                            <th style="width:15%">数量<br><small>수량</small></th>
                            <th style="width:25%">金额 (원)<br><small>금액</small></th>
                            <th style="width:10%"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, idx) in chinaLogisticsItems" :key="idx">
                            <td><input type="text" class="form-control form-control-sm" v-model="row.name" placeholder="项目名 (항목명)"></td>
                            <td><input type="number" class="form-control form-control-sm" v-model.number="row.unitPrice" @input="calcChinaItemAmount(idx)"></td>
                            <td><input type="number" class="form-control form-control-sm" v-model.number="row.quantity" @input="calcChinaItemAmount(idx)"></td>
                            <td class="text-right align-middle">₩{{ (row.amount || 0).toLocaleString() }}</td>
                            <td class="text-center align-middle">
                                <b-button size="sm" variant="outline-danger" @click="chinaLogisticsItems.splice(idx, 1)">✕</b-button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <b-button size="sm" variant="outline-primary" @click="chinaLogisticsItems.push({name:'', unitPrice:0, quantity:0, amount:0})">
                    + 添加项目 (항목 추가)
                </b-button>

                <div class="form-group mt-3">
                    <label>备注 (메모)</label>
                    <textarea class="form-control" v-model="chinaLogisticsForm.메모" rows="2" placeholder="备注 选填 (메모, 선택)"></textarea>
                </div>

                <!-- 합계 -->
                <div class="alert alert-success mt-3">
                    <strong>合计 零税率发票 (합계, 영세율 세금계산서)</strong>
                    <div class="font-weight-bold text-primary mt-2" style="font-size: 1.5rem;">
                        ₩{{ calculateChinaLogisticsPreview.toLocaleString() }}
                    </div>
                </div>
            </template>
        </b-modal>

        <!-- 한국물류비 견적서 생성 모달 (동적 items) -->
        <b-modal
            id="korea-logistics-modal"
            v-model="showKoreaLogisticsModal"
            :title="koreaLogisticsItem?.견적서_한국물류비 ? '修改韩国物流费报价单 (한국물류비 견적서 수정)' : '生成韩国物流费报价单 (한국물류비 견적서 생성)'"
            size="lg"
            @ok="submitKoreaLogistics"
            :ok-title="koreaLogisticsItem?.견적서_한국물류비 ? '修改报价单 (견적서 수정)' : '生成报价单 (견적서 생성)'"
            cancel-title="取消 (취소)">
            <template v-if="koreaLogisticsItem">
                <div class="mb-3 p-3 bg-light rounded">
                    <div class="row">
                        <div class="col-4"><strong>商品名 (상품명):</strong> {{ koreaLogisticsItem.상품명 }}</div>
                        <div class="col-4"><strong>条码 (바코드):</strong> {{ koreaLogisticsItem.바코드 }}</div>
                        <div class="col-4"><strong>货主 (업체):</strong> {{ koreaLogisticsItem.companyid }}</div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-4"><strong>请求数量 (구매요청수량):</strong> {{ koreaLogisticsItem.구매요청수량 }}</div>
                        <div class="col-4"><strong>入库数量 (입고수량):</strong> {{ koreaLogisticsItem.입고수량 || koreaLogisticsItem.구매요청수량 || '-' }}</div>
                        <div class="col-4">
                            <strong>清关 (통관):</strong>
                            <b-badge :variant="koreaLogisticsForm.customsType === 'integrated' ? 'info' : 'warning'">
                                {{ koreaLogisticsForm.customsType === 'integrated' ? '综合清关 (통합통관)' : koreaLogisticsForm.customsType === 'client' ? '货主单独清关 (화주단독)' : 'COUPASS单独清关 (쿠패스단독통관)' }}
                            </b-badge>
                        </div>
                    </div>
                </div>

                <!-- 동적 비용 항목 테이블 -->
                <table class="table table-sm table-bordered">
                    <thead class="thead-light">
                        <tr>
                            <th style="width:30%">项目名<br><small>항목명</small></th>
                            <th style="width:20%">单价 (원)<br><small>단가</small></th>
                            <th style="width:15%">数量<br><small>수량</small></th>
                            <th style="width:25%">金额 (원)<br><small>금액</small></th>
                            <th style="width:10%"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, idx) in koreaLogisticsItems" :key="idx">
                            <td><input type="text" class="form-control form-control-sm" v-model="row.name" placeholder="项目名 (항목명)"></td>
                            <td><input type="number" class="form-control form-control-sm" v-model.number="row.unitPrice" @input="calcKoreaItemAmount(idx)"></td>
                            <td><input type="number" class="form-control form-control-sm" v-model.number="row.quantity" @input="calcKoreaItemAmount(idx)"></td>
                            <td class="text-right align-middle">₩{{ (row.amount || 0).toLocaleString() }}</td>
                            <td class="text-center align-middle">
                                <b-button size="sm" variant="outline-danger" @click="koreaLogisticsItems.splice(idx, 1)">✕</b-button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <b-button size="sm" variant="outline-primary" @click="koreaLogisticsItems.push({name:'', unitPrice:0, quantity:1, amount:0})">
                    + 添加项目 (항목 추가)
                </b-button>

                <div class="form-group mt-3">
                    <label>备注 (메모)</label>
                    <textarea class="form-control" v-model="koreaLogisticsForm.메모" rows="2" placeholder="备注 选填 (메모, 선택)"></textarea>
                </div>

                <!-- 합계 -->
                <div class="alert alert-success mt-3">
                    <strong>合计 (합계) · {{ koreaLogisticsForm.customsType === 'client' ? '货主单独清关 (화주 단독통관)' : '普通发票 (일반 세금계산서)' }}</strong>
                    <div class="font-weight-bold text-primary mt-2" style="font-size: 1.5rem;">
                        ₩{{ calculateKoreaLogisticsPreview.toLocaleString() }}
                    </div>
                </div>
            </template>
        </b-modal>

        <!-- 공통물류비 입력 모달 -->
        <b-modal v-model="showCommonLogisticsModal"
            :title="commonLogisticsExisting ? '修改公共物流费 (공통물류비 수정)' : '填写公共物流费 (공통물류비 입력)'"
            size="lg"
            @ok="submitCommonLogistics"
            :ok-title="commonLogisticsExisting ? '修改 (수정)' : '保存 (저장)'"
            cancel-title="取消 (취소)">
            <template v-if="commonLogisticsTarget">
                <div class="mb-3 p-3 bg-light rounded">
                    <div class="row">
                        <div class="col-4"><strong>货主订单号 (화주주문번호):</strong> {{ commonLogisticsTarget.화주주문번호 }}</div>
                        <div class="col-4"><strong>货主 (업체):</strong> {{ commonLogisticsTarget.companyid }}</div>
                        <div class="col-4"><strong>商品数 (상품수):</strong> {{ commonLogisticsTarget.items?.length || 0 }}件</div>
                    </div>
                </div>

                <table class="table table-sm table-bordered">
                    <thead class="thead-light">
                        <tr>
                            <th style="width:40%">项目名<br><small>항목명</small></th>
                            <th style="width:40%">金额 (원)<br><small>금액</small></th>
                            <th style="width:20%">删除 (삭제)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, idx) in commonLogisticsItems" :key="idx">
                            <td><b-form-input v-model="row.name" size="sm" placeholder="项目名 (항목명)"></b-form-input></td>
                            <td><b-form-input v-model.number="row.amount" size="sm" type="number" placeholder="金额 (금액)"></b-form-input></td>
                            <td class="text-center">
                                <b-button v-if="commonLogisticsItems.length > 1" size="sm" variant="outline-danger" @click="commonLogisticsItems.splice(idx, 1)">✕</b-button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <b-button size="sm" variant="outline-primary" @click="commonLogisticsItems.push({name:'', amount:0})">+ 添加项目 (항목 추가)</b-button>

                <div class="form-group mt-3">
                    <label>备注 (메모)</label>
                    <textarea class="form-control" v-model="commonLogisticsMemo" rows="2" placeholder="备注 选填 (메모, 선택)"></textarea>
                </div>

                <div class="alert alert-info mt-3">
                    <strong>公共物流费合计 (공통물류비 합계)</strong>
                    <div class="font-weight-bold text-primary mt-2" style="font-size: 1.5rem;">
                        ₩{{ commonLogisticsTotal.toLocaleString() }}
                    </div>
                    <small class="text-muted">此金额按数量×体积分摊到组内商品 (이 금액은 그룹 내 상품들에 수량×부피 기준으로 배분됩니다.)</small>
                </div>
            </template>
        </b-modal>

        <!-- 변경 이력 조회 모달 -->
        <b-modal v-model="showProcessHistoryModal" size="md" title="状态变更记录 (진행현황 변경 이력)" hide-footer scrollable>
            <div v-if="processHistoryLoading" class="text-center py-3">
                <b-spinner small></b-spinner> 加载中 (로딩 중)...
            </div>
            <div v-else-if="processHistoryList.length === 0" class="text-center text-muted py-3">
                暂无变更记录 (변경 이력이 없습니다.)
            </div>
            <div v-else>
                <div class="mb-2 text-right">
                    <small class="text-muted">当前状态 (현재 상태): </small>
                    <b-badge variant="primary">{{ displayZh(processHistoryCurrentStatus) }}</b-badge>
                </div>
                <div v-for="(h, idx) in processHistoryList" :key="idx"
                    class="d-flex align-items-start mb-2 p-2 border rounded" style="font-size: 0.85rem;">
                    <div class="mr-2 text-muted" style="min-width: 20px;">{{ processHistoryList.length - idx }}</div>
                    <div class="flex-grow-1">
                        <div>
                            <b-badge variant="secondary" class="mr-1">{{ displayZh(h.fromStatus) }}</b-badge>
                            →
                            <b-badge variant="success" class="ml-1">{{ displayZh(h.toStatus) }}</b-badge>
                        </div>
                        <div class="text-muted mt-1">
                            <small>{{ new Date(h.changedAt).toLocaleString('ko-KR') }} · {{ h.changedByName || '-' }}</small>
                        </div>
                        <div v-if="h.memo" class="text-info mt-1"><small>📝 {{ h.memo }}</small></div>
                    </div>
                </div>
            </div>
            <!-- 진행현황 기록: 지금 상태가 언제부터였는지 + 펼치면 바뀐 기록 전체 -->
            <div v-if="!processHistoryLoading" class="border-top pt-2 mt-2" style="font-size: 0.8rem;">
                <div v-if="statusLogNow && statusLogNow.결과 === '이력'" class="text-muted">
                    当前状态自 {{ fmtStatusLogTime(statusLogNow.시작) }} 起，已持续 {{ statusLogDays(statusLogNow.경과ms) }}
                    (현재 상태는 {{ fmtStatusLogTime(statusLogNow.시작) }}부터, {{ statusLogDays(statusLogNow.경과ms, true) }}째)
                </div>
                <div v-else class="text-muted">暂无状态记录（此功能上线前的订单） (상태 기록 없음 — 이 기능 이전 건)</div>
                <a v-if="statusLogRows.length" href="#" class="small" @click.prevent="statusLogOpen = !statusLogOpen">
                    {{ statusLogOpen ? '▾' : '▸' }} 状态记录 {{ statusLogRows.length }}条 (상태 기록 {{ statusLogRows.length }}건)
                </a>
                <b-collapse v-model="statusLogOpen">
                    <div v-for="(r, i) in statusLogRows" :key="'sl' + i" class="d-flex align-items-center py-1 border-bottom">
                        <span class="text-muted mr-2" style="min-width: 110px;">{{ fmtStatusLogTime(r.시각) }}</span>
                        <span class="flex-grow-1">
                            <template v-if="r.이전값">{{ displayZh(r.이전값) }} → </template><b>{{ displayZh(r.값) }}</b>
                            <small v-if="r.구분" class="text-muted"> · {{ r.구분 }}</small>
                        </span>
                        <small class="text-muted ml-2">{{ r.출처 }}{{ r.누가 ? ' · ' + r.누가 : '' }}</small>
                    </div>
                </b-collapse>
            </div>
        </b-modal>

        <!-- 진행현황 선택 모달 -->
        <b-modal v-model="showStatusModal" size="md" title="变更状态 (진행현황 변경)"
            @ok="confirmBatchStatusEdit" ok-title="变更 (변경)" cancel-title="取消 (취소)"
            :ok-disabled="!selectedStatusForBatch">
            <div class="mb-3">
                <label class="form-label font-weight-bold">请选择新状态 (새로운 진행현황을 선택하세요)</label>
                <b-form-select v-model="selectedStatusForBatch" :options="statusOptions" size="sm">
                </b-form-select>
            </div>
        </b-modal>

        <!-- 입고오류 처리 모달 -->
        <b-modal v-model="showErrorModal" size="md" title="⚠️ 入库错误处理 (입고오류 처리)" @ok="submitInboundError" ok-title="登记错误 (오류 등록)" cancel-title="取消 (취소)"
            :ok-disabled="!errorForm.오류유형">
            <template v-if="errorTargetItem">
                <div class="mb-3 p-2 bg-light rounded">
                    <small><strong>商品 (상품):</strong> {{ errorTargetItem.상품명 }}</small><br>
                    <small><strong>条码 (바코드):</strong> {{ errorTargetItem.바코드 }}</small>
                </div>
            </template>
            <b-form-group label="错误类型 (오류유형)" label-class="font-weight-bold">
                <b-form-select v-model="errorForm.오류유형" :options="errorTypeOptions" size="sm"></b-form-select>
            </b-form-group>
            <b-form-group v-if="errorForm.오류유형 === '기타'" label="其他详情 (기타 상세)" label-class="font-weight-bold">
                <b-form-input v-model="errorForm.기타상세" placeholder="请输入错误类型 (오류유형을 입력하세요)" size="sm"></b-form-input>
            </b-form-group>
            <b-form-group label="错误内容·详细说明 (오류내용, 상세 설명)" label-class="font-weight-bold">
                <b-form-textarea v-model="errorForm.오류내용" rows="3" placeholder="请输入错误详细内容 (오류 상세 내용을 입력하세요)"></b-form-textarea>
            </b-form-group>
        </b-modal>

        <!-- 바코드 출력용 숨겨진 템플릿 -->
        <div class="mb-4 ml-1 d-none" id="printBarcodeArea">
            <div v-for="index in parseInt(출력수량)" :key="index">
                <div class="row d-flex justify-content-center ml-1" :style="barcodegap(index, parseInt(출력수량))">
                    <div class="col-12 d-flex flex-left mb-0" style="margin-top:0px;margin-bottom:0px;margin-left:10px;margin-right:10px;">
                        <div class="mb-0" style="font-size:90%;color:black;">{{ 원산지 }}</div>
                    </div>
                    <div class="col-12 text-center d-flex justify-content-center mt-0 mb-0" style="margin-top:0px;margin-bottom:0px">
                        <barcode :value="출력바코드" :tag="bctag" height="50" :options="{ lineColor: '#0275d8', text: 'Scan', margin: 0 }"></barcode>
                    </div>
                    <div v-if="printfoodenable" style="width:100%;margin-top:0px;margin-bottom:0px;margin-left:10px;font-size:80%;">
                        <span style="font-size:80%;color:black;display:block">{{ 출력상품명 }}</span>
                        <div style="font-size:90%;font-weight:bold">식품위생법에 의한 한글표시사항</div>
                    </div>
                    <div class="col-12 mt-0 mb-0" style="margin-top:0px;margin-bottom:0px;margin-left:10px;margin-right:10px;text-align:left;line-height:5px;">
                        <span v-if="!printfoodenable" :style="disablekr">{{ 출력상품명 }}</span><br>
                        <span :style="enablekr">1. 상품명 : {{ 출력상품명 }}</span><br>
                        <span :style="enablekr">2. 수입원/판매원 : {{ 한글표시사항print['수입원/판매원'] }}</span><br>
                        <span :style="enablekr">3. 제조원 : {{ 한글표시사항print.제조원 }}</span><br>
                        <span :style="enablekr">4. 제조국 : {{ 한글표시사항print.제조국 }}</span><br>
                        <span :style="enablekr">5. 내용량 : {{ 한글표시사항print.내용량 }}</span><br>
                        <span :style="enablekr">6. 원료명및성분명(재질) : {{ 한글표시사항print['원료명및성분명(재질)'] }}</span><br>
                        <div style="display: flex;justify-content: space-between;">
                            <div>
                                <span :style="enablekr">7. 상품유형 : {{ 한글표시사항print.상품유형 }}</span><br>
                                <span :style="enablekr">8. 사용시주의사항 : {{ 한글표시사항print.사용시주의사항 }}</span><br>
                                <span :style="enablekr">9. 사용기준 : {{ 한글표시사항print.사용기준 }}</span><br>
                                <span v-if="한글표시사항print.custom" :style="enablekr">10. {{ 한글표시사항print.custom }}</span><br v-if="한글표시사항print.custom">
                            </div>
                            <div style="height:60px;margin-right:10px;margin-top:10px;margin-left:10px;">
                                <img v-if="printfoodenable" style="height:100%" :src="require('../../../assets/images/small/ForFood.png')">
                                <img v-if="printkcenable" style="height:100%" :src="require('../../../assets/images/small/KcMark.jpg')">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 변경이력 처리 모달 -->
        <b-modal v-model="showChangeReviewModal" size="lg" hide-footer scrollable
            :title="changeReviewItem ? `处理变更记录 (변경이력 처리) - ${changeReviewItem.상품명 || ''}` : '处理变更记录 (변경이력 처리)'">
            <div v-if="changeReviewItem">
                <div v-if="(changeReviewItem.processStatus || changeReviewItem.진행현황) !== '구매전' && hasUnconfirmedChange(changeReviewItem)"
                    class="change-review-warning mb-3">
                    <b-icon icon="exclamation-triangle-fill" font-scale="1.3"></b-icon>
                    <strong class="ml-2">⚠️ 下单后变更的未确认请求 (주문 진행 후 변경된 미확인 요청) {{ unconfirmedChangeCount(changeReviewItem) }}件</strong>
                    <div class="small mt-1">
                        当前状态 (현재 상태): <b-badge variant="warning">{{ displayZh(changeReviewItem.processStatus || changeReviewItem.진행현황) }}</b-badge>
                        — 请先处理1688原订单(取消/重新下单)后再标记处理完成 (1688 기존 주문 처리(취소/재주문) 후 처리완료 처리하세요.)
                    </div>
                </div>

                <div class="change-review-list">
                    <div v-for="change in changeReviewItem.changeHistory" :key="change.changeId"
                        class="change-review-item"
                        :class="{
                            'change-item-unconfirmed': change.confirmed === false,
                            'change-item-confirmed': change.confirmed === true
                        }">
                        <div class="d-flex align-items-start">
                            <div v-if="change.confirmed === false" class="mr-2 pt-1">
                                <b-form-checkbox v-model="changeReviewSelected" :value="change.changeId"></b-form-checkbox>
                            </div>
                            <div v-else class="mr-2 pt-1">
                                <b-icon icon="check-circle-fill" variant="success"></b-icon>
                            </div>
                            <div class="flex-grow-1">
                                <div class="d-flex justify-content-between align-items-center mb-1">
                                    <small class="text-muted">
                                        <strong>{{ new Date(change.changeDate).toLocaleString('ko-KR') }}</strong>
                                        ({{ change.changedBy }})
                                    </small>
                                    <b-badge :variant="change.confirmed ? 'success' : 'danger'">
                                        {{ change.confirmed ? '处理完成 (처리완료)' : '未确认 (미확인)' }}
                                    </b-badge>
                                </div>
                                <div class="change-fields">
                                    <div v-for="(val, key) in change.changes" :key="key" class="change-field-row">
                                        <strong>{{ key }}</strong>:
                                        <span class="text-muted">{{ val.변경전 }}</span>
                                        →
                                        <span class="text-primary"><strong>{{ val.변경후 }}</strong></span>
                                    </div>
                                </div>
                                <div v-if="change.confirmed" class="mt-1 small text-muted">
                                    处理 (처리): {{ change.confirmedBy }} / {{ change.confirmedDate ? new Date(change.confirmedDate).toLocaleString('ko-KR') : '-' }}
                                    <span v-if="change.confirmNote"> / 备注 (메모): {{ change.confirmNote }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="hasUnconfirmedChange(changeReviewItem)" class="mt-3 p-3 border rounded bg-light">
                    <label class="font-weight-bold">处理备注 选填 (처리 메모, 선택)</label>
                    <b-form-input v-model="changeReviewNote" placeholder="例：1688订单取消后已重新下单 (예: 1688 주문 취소 후 재발주 완료)" size="sm"></b-form-input>
                    <div class="d-flex justify-content-end mt-2">
                        <b-button variant="outline-secondary" size="sm" class="mr-2" @click="showChangeReviewModal = false" :disabled="changeReviewProcessing">
                            取消 (취소)
                        </b-button>
                        <b-button variant="warning" size="sm" class="mr-2"
                            @click="confirmChangeHistory('selected')"
                            :disabled="changeReviewProcessing || changeReviewSelected.length === 0">
                            <b-spinner v-if="changeReviewProcessing" small></b-spinner>
                            处理所选 (선택 처리) ({{ changeReviewSelected.length }})
                        </b-button>
                        <b-button variant="danger" size="sm"
                            @click="confirmChangeHistory('all')"
                            :disabled="changeReviewProcessing">
                            <b-spinner v-if="changeReviewProcessing" small></b-spinner>
                            全部处理 (전체 처리) ({{ unconfirmedChangeCount(changeReviewItem) }})
                        </b-button>
                    </div>
                </div>
                <div v-else class="mt-3 text-center text-success">
                    <b-icon icon="check-circle-fill"></b-icon> 所有变更已处理完成 (모든 변경이 처리완료되었습니다.)
                </div>
            </div>
        </b-modal>

        <!-- 별도링크 결제처리 모달 -->
        <!-- 采购备注 + 实物图 입력 창(#146) -->
        <b-modal v-model="showPurchaseNote" title="采购备注·实物图 (구매메모·실물사진)" size="lg" no-close-on-backdrop @hidden="purchaseNoteTarget = null">
            <div v-if="purchaseNoteTarget">
                <div class="small text-muted mb-2">{{ purchaseNoteTarget.상품명 }} | {{ purchaseNoteTarget.바코드 }}</div>
                <div class="form-group">
                    <label>采购备注 (구매메모)</label>
                    <textarea class="form-control" v-model="purchaseNoteForm.메모" rows="3" maxlength="500" placeholder="例: 商家贴条码发货，实物如图"></textarea>
                </div>
                <div class="form-group">
                    <label>实物图 (실물사진) — 最多10张</label>
                    <div class="d-flex align-items-center mb-2">
                        <input type="file" multiple accept="image/*" class="form-control-file" @change="onPurchaseNoteFiles">
                        <b-spinner v-if="purchaseNoteUploading" small class="ml-2"></b-spinner>
                    </div>
                    <div v-if="purchaseNoteForm.사진.length" class="d-flex flex-wrap" style="gap:6px">
                        <div v-for="(u, i) in purchaseNoteForm.사진" :key="u + i" class="position-relative border rounded" style="width:110px;height:90px;overflow:hidden;background:#f1f3f5">
                            <a :href="u" target="_blank" rel="noopener"><img :src="u" alt="" style="width:100%;height:100%;object-fit:cover"></a>
                            <b-button size="sm" variant="danger" class="position-absolute py-0 px-1" style="top:2px;right:2px;line-height:1.2" title="删除(삭제)" @click="removePurchaseNotePhoto(u)">×</b-button>
                        </div>
                    </div>
                </div>
            </div>
            <template #modal-footer>
                <b-button variant="secondary" @click="showPurchaseNote = false">取消 (취소)</b-button>
                <b-button variant="primary" :disabled="purchaseNoteSaving || purchaseNoteUploading" @click="savePurchaseNote">保存 (저장)</b-button>
            </template>
        </b-modal>

        <b-modal :visible="!!zoomImageSrc" @hidden="zoomImageSrc = ''" size="lg" hide-footer centered title="商品图片 (상품 이미지)">
            <img :src="zoomImageSrc" class="d-block mx-auto" style="width: 100%; max-width: 560px;" alt="image">
        </b-modal>

        <b-modal v-model="showSidePaymentModal" size="lg" hide-footer scrollable
            :title="sidePaymentNon1688
                ? `非1688 已转账 / 송금완료 - ${sidePaymentItems.length}件`
                : sidePaymentItems.length > 1
                ? `别单链接付款 / 별도링크 결제처리 - ${sidePaymentItems.length}件`
                : (sidePaymentItem ? `别单链接付款 / 별도링크 결제처리 - ${sidePaymentItem.상품명 || ''}` : '别单链接付款 / 별도링크 결제처리')">
            <div v-if="sidePaymentItem">
                <!-- 非1688(自行采购): 같은 별도결제 경로로 송금완료를 기록한다. 1688 주문번호 대신 상점·메모 -->
                <div v-if="sidePaymentNon1688" class="side-payment-notice mb-3">
                    <b-icon icon="info-circle-fill"></b-icon>
                    <strong class="ml-2">非1688商品：已手动转账给商家后登记 → 采购完成(구매완료)</strong>
                    <div class="small">非1688商品直接转账给商家后登记，转账金额(CNY)计入报价单金额 / 1688 외 상품을 판매자에게 직접 송금한 뒤 등록합니다. 송금액(CNY)은 견적서 금액에 반영됩니다.</div>
                    <div class="small text-muted">货主单价×数量合计 / 화주 입력 단가×수량 합계: ¥{{ non1688TransferEstimate }}</div>
                </div>
                <div v-else class="side-payment-notice mb-3">
                    <b-icon icon="info-circle-fill"></b-icon>
                    <strong class="ml-2">1688에서 직접 주문했거나 판매자가 보내준 다른 링크로 주문한 경우 사용</strong>
                    <div class="small">在1688手动下单，或按卖家发来的其他链接下单时使用</div>
                    <ul class="mb-0 mt-1 small">
                        <li>상품 정보(상품명/옵션/이미지/바코드)는 기존 요청 그대로 유지됩니다. / 商品信息保持原请求不变。</li>
                        <li>결제·배송 상태와 금액은 입력한 1688 주문번호를 따라갑니다. / 付款、物流状态和金额以填写的1688订单号为准。</li>
                        <li>1688 기존 시스템 주문이 살아있으면 1688에서 별도로 취소해주세요. / 如原系统订单仍有效，请在1688另行取消。</li>
                    </ul>
                </div>

                <div v-if="sidePaymentItems.length > 1" class="mb-3">
                    <strong class="small">연결할 상품 / 关联商品 ({{ sidePaymentItems.length }})</strong>
                    <ul class="mb-0 mt-1 small">
                        <li v-for="it in sidePaymentItems" :key="it._id">
                            {{ it.상품명 || '-' }} · {{ it.바코드 || '-' }} · {{ it.주문정보?.주문수량 || defaultOrderQty(it) }}个
                        </li>
                    </ul>
                </div>

                <div v-if="sidePaymentItems.some(it => it.주문정보 && it.주문정보.별도결제)" class="side-payment-existing mb-3">
                    <b-icon icon="exclamation-triangle-fill"></b-icon>
                    <strong class="ml-2">이미 별도결제가 처리된 건이 있습니다. / 已有处理过的订单</strong>
                    <div v-if="sidePaymentItems.length === 1" class="small mt-1">
                        이전 주문번호(原订单号): {{ sidePaymentItem.주문정보.이전주문번호 || '-' }} /
                        처리자(处理人): {{ sidePaymentItem.별도결제?.처리자 || '-' }} /
                        처리일(处理时间): {{ sidePaymentItem.별도결제?.처리일 ? new Date(sidePaymentItem.별도결제.처리일).toLocaleString('ko-KR') : '-' }}
                    </div>
                </div>

                <div class="row">
                    <div v-if="!sidePaymentNon1688" class="col-md-6">
                        <b-form-group label="1688 주문번호 / 1688订单号 (필수/必填)" label-class="font-weight-bold">
                            <b-form-input v-model="sidePaymentForm.주문번호" placeholder="1688에서 직접 주문한 주문번호 / 手动下单的订单号" size="sm"></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group :label="sidePaymentNon1688 ? '转账金额(元) / 송금액(CNY) (必填/필수)' : '총금액 (CNY) / 总金额(人民币)'" label-class="font-weight-bold">
                            <b-form-input v-model.number="sidePaymentForm.총금액_CNY" type="number" min="0" step="0.01" size="sm"></b-form-input>
                            <small v-if="sidePaymentPreview && sidePaymentPreview.error" class="d-block text-danger font-weight-bold">
                                {{ sidePaymentPreview.error }}
                            </small>
                            <small v-else-if="sidePaymentPreview" class="d-block text-info">
                                ≈ ₩{{ sidePaymentPreview.krw.toLocaleString() }} (환율/汇率 {{ sidePaymentPreview.rates }})
                            </small>
                            <small v-else-if="!sidePaymentForm.총금액_CNY && sidePaymentForm.총금액" class="d-block text-muted">
                                기존 원화 입력 / 原韩元金额: ₩{{ Number(sidePaymentForm.총금액).toLocaleString() }}
                            </small>
                            <small v-if="sidePaymentNon1688" class="text-muted">
                                실제 송금액. 견적서 금액에 반영됩니다{{ sidePaymentItems.length > 1 ? ' (견적 금액 비율, 없으면 수량 비율로 나눔)' : '' }}. / 实际转账金额
                            </small>
                            <small v-else class="text-muted">
                                선택 입력. 견적서 금액에 반영됩니다{{ sidePaymentItems.length > 1 ? ' (수량 비율로 나눔)' : '' }}. / 选填{{ sidePaymentItems.length > 1 ? '，按数量比例分摊' : '' }}
                            </small>
                        </b-form-group>
                    </div>
                </div>

                <b-form-group :label="sidePaymentNon1688 ? '商家/链接 / 구매처(상점명·링크)' : '별도결제 링크 / 付款链接 (선택/选填)'" label-class="font-weight-bold">
                    <b-form-input v-model="sidePaymentForm.링크" placeholder="https://..." size="sm"></b-form-input>
                </b-form-group>

                <!-- 非1688: 판매처(타오바오 등)에서 받은 주문번호 — 기록용. 1688주문번호 와는 따로 저장된다(崔凡 10-07) -->
                <b-form-group v-if="sidePaymentNon1688" label="商家订单号 / 판매처 주문번호 (选填/선택)" label-class="font-weight-bold">
                    <b-form-input v-model="sidePaymentForm.판매처주문번호" placeholder="例：淘宝订单号 / 예: 타오바오 주문번호" size="sm"></b-form-input>
                </b-form-group>

                <b-form-group v-if="sidePaymentItems.length <= 1" label="주문수량 (下单数量)" label-class="font-weight-bold">
                    <b-form-input v-model.number="sidePaymentForm.주문수량" type="number" min="1" size="sm"></b-form-input>
                    <small class="text-muted">
                        实际下单的数量，直接反映到列表的下单数量 / 실제로 주문한 수량입니다. 목록의 下单数量 에 그대로 반영됩니다.
                        已按请求数量({{ defaultOrderQty(sidePaymentItem) }})预填，不同请修改 / 요청수량 기준({{ defaultOrderQty(sidePaymentItem) }}개)으로 채워두었으니 다르면 고쳐주세요.
                    </small>
                </b-form-group>

                <b-form-group label="운송장번호 / 运单号" label-class="font-weight-bold">
                    <b-form-input v-model="sidePaymentForm.운송장번호" placeholder="(있으면 입력 / 选填)" size="sm"></b-form-input>
                </b-form-group>

                <b-form-group label="메모 / 备注" label-class="font-weight-bold">
                    <b-form-textarea v-model="sidePaymentForm.메모" rows="2"
                        placeholder="예: 맞춤제작이라 1688에서 직접 주문 / 例：定制商品，在1688手动下单" size="sm"></b-form-textarea>
                </b-form-group>

                <div class="d-flex justify-content-end mt-3">
                    <b-button variant="outline-secondary" size="sm" class="mr-2"
                        @click="showSidePaymentModal = false" :disabled="sidePaymentProcessing">
                        취소 / 取消
                    </b-button>
                    <b-button variant="warning" size="sm"
                        @click="saveSidePayment" :disabled="sidePaymentProcessing">
                        <b-spinner v-if="sidePaymentProcessing" small></b-spinner>
                        저장 / 保存
                    </b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import * as XLSX from 'xlsx';
import axios from 'axios';
import AWS from 'aws-sdk';
import { validationMixin } from 'vuelidate'
import { required, integer } from 'vuelidate/lib/validators'
import CDataTable from "@/components/common/CDataTable";
import QuotationModal from "@/components/common/QuotationModal";
import VueBarcode from 'vue-barcode';
import shipmentDistributionMixin from '@/mixins/shipmentDistributionMixin'
import LogisReqChanges from './logisReqChanges'
import ReqPurchaseTracking from '../Purchases/ReqPurchaseTracking'
import BankReconcileModal from './BankReconcileModal'
import PostPurchaseOptionModal from './PostPurchaseOptionModal'
import PurchasedRecordView from './PurchasedRecordView'
import { coupassMenuTitle } from './coupassMenu'
import { prepareKakaoSend } from './kakaoSend'
import { outboundTypeText, outboundTypeStyle, PROCESS_STATUS_TEXT } from '@/utils/coupassStatusText'
import { judgeLiveStock } from '@/utils/liveStockJudge'
import { priceRiseInfo, priceRiseTitle } from '@/utils/priceRise'
import { negoUnitCny, preUnitCny, isUnchangedPrice } from '@/utils/negotiatedFallback'
import { splitPaidGroups, itemsNeedingQuotation, isPaidItem } from '@/utils/mergedBillPlan'
import { pickUnbuyableRows, describeRows } from '@/utils/rematchCancel'
// 화면 표시용 중국어 — 저장값(한국어)은 그대로, 보이는 글자만 「中文 (한국어)」(2026-10 YZY, 직원이 중국인).
// 상태값은 coupassStatusText 를 따르고, 이 화면에만 나오는 값(통관·유형·견적서상태·예치금)만 여기 둔다
// 订单列表 위 진행 단계 카드(CoupassStageCards.vue)가 넘겨주는 진행현황 — 이 화면에서는 카드를 뺐고 주소(?stage=)로만 들어온다
const STAGE_FILTERS = ['배송중', '배송완료', '입고작업', '출고확인대기', '재고대기', '출고대기', '출고완료', '중국재고', '출고요청', '입고오류',
    '해외입고중', '국내입고중', '쿠팡센터입고완료', '국내창고입고중', '국내창고입고완료'];
const DISPLAY_ZH = {
    ...PROCESS_STATUS_TEXT,
    통합통관: '综合清关', 단독통관: '单独清关', 화주단독통관: '货主单独清关', 쿠패스단독통관: 'COUPASS单独清关',
    목록통관: '目录清关', 일반통관: '一般清关',
    제트배송: '入库Coupang件', 로켓배송: '快递资料件', 일반LCL: '一般货主件', 일반: '一般货主件', 샘플검증: '样品检测件',
    미생성: '未生成', 생성완료: '已生成', 발송완료: '已发送', 입금확인: '确认入账', 결제완료: '付款完成',
    충전: '充值', 차감: '扣除', 환불: '退款'
};
// import { arrayMax } from 'highcharts';
// import { VueEditor } from 'vue2-editor'
export default {
    name: 'LogisReqPurchase',
    mixins: [validationMixin, shipmentDistributionMixin],
    validations: {
        purchaseno: { required },
        payment: { required, integer },
    },
    components: {
        //    VueEditor,
        CDataTable,
        QuotationModal,
        'barcode': VueBarcode,
        LogisReqChanges,
        ReqPurchaseTracking,
        BankReconcileModal,
        PostPurchaseOptionModal,
        PurchasedRecordView,
    },
    data() {
        return {
            // 화면 탭 — requests(구매요청) / changes(请求变更记录)
            pageView: ['changes', 'tracking', 'purchased'].includes(this.$route.query.view) ? this.$route.query.view : 'requests',
            showBankReconcile: false,
            // 개별 상품 뷰용 headers — 1920 화면에서 가로 스크롤 없이(2026-10-07 YZY): 상품주문번호·구매재고 열 뺌,
            // 구매요청수량/판매구성수량 은 한 칸(위 요청수량 / 아래 구성수량 — 슬롯 구매요청수량)
            headers: [
                { text: 'Action', value: 'action', align: 'center', width: 120, isSlot: true },
                { text: '货主\n(업체명)', value: 'companyid', align: 'center', width: 80, isSlot: false },
                { text: '请求日\n(요청일)', value: '요청일', align: 'center', width: 80, isSlot: true },
                { text: '货主订单号\n(화주주문번호)', value: '화주주문번호', align: 'center', width: 90, isSlot: true },
                { text: '1688订单号\n(1688주문번호)', value: '1688주문번호', align: 'center', width: 90, isSlot: true },
                { text: '清关方式\n(통관방법)', value: '통관방법', align: 'center', width: 70, isSlot: true },
                { text: '类型\n(요청타입)', value: 'reqtype', align: 'center', width: 80, isSlot: true },
                { text: '合包\n(묶음배송)', value: '묶음구성여부', align: 'center', width: 60, isSlot: true },
                { text: '状态\n(진행현황)', value: '진행현황', align: 'center', width: 90, isSlot: true },
                { text: '报价单\n(견적서)', value: '견적서상태', align: 'center', width: 80, isSlot: true },
                { text: '请求变更\n(요청변경)', value: '요청변경', align: 'center', width: 60, isSlot: true },
                { text: '商品信息\n(제품정보)', value: '상품명', align: 'left', width: 170, isSlot: true },
                { text: '购买请求数量\n(구매요청수량)', value: '구매요청수량', align: 'center', width: 80, isSlot: true },
                { text: '销售组合数量\n(판매구성수량)', value: '판매구성수량', align: 'center', width: 80, isSlot: true },
                { text: '链接\n(링크)', value: '구매링크', align: 'center', width: 50, isSlot: true },
                { text: '选项1中文\n(옵션1_중국어)', value: '옵션1_중국어', align: 'center', width: 70, isSlot: true },
                { text: '选项2中文\n(옵션2_중국어)', value: '옵션2_중국어', align: 'center', width: 70, isSlot: true },
                { text: 'History', value: 'history', align: 'center', width: 50, isSlot: true },
            ],

            // 그룹 뷰용 headers (메인 테이블)
            groupHeaders: [
                { text: '详情\n(상세)', value: 'action', align: 'center', width: 45, isSlot: true },
                { text: '货主订单号\n(화주주문번호)', value: '화주주문번호', align: 'center', width: 80, isSlot: true },
                { text: '请求时间\n(요청일시)', value: '요청일', align: 'center', width: 80, isSlot: true },
                { text: '货主\n(업체)', value: '업체정보', align: 'center', width: 85, isSlot: true },
                { text: '状态\n(진행현황)', value: '진행현황', align: 'center', width: 70, isSlot: true },
                { text: '清关方式\n(통관방법)', value: '통관방법', align: 'center', width: 70, isSlot: true },
                { text: '类型\n(유형)', value: 'reqtype', align: 'center', width: 95, isSlot: true },
                { text: '汇率\n(환율)', value: '적용환율', align: 'center', width: 50, isSlot: false },
                { text: '1688采购代码\n(1688구매코드)', value: '구매코드1688', align: 'center', width: 85, isSlot: true },
                { text: '品目数(数量)\n(상품수(수량))', value: '상품수수량', align: 'center', width: 60, isSlot: true },
                { text: '是否修改\n(수정여부)', value: '수정여부', align: 'center', width: 55, isSlot: true },
                { text: '创建订单\n(주문생성)', value: '주문생성여부', align: 'center', width: 75, isSlot: true },
                { text: '下单时间\n(주문시간)', value: '주문시간', align: 'center', width: 65, isSlot: true },
                { text: '价格确认\n(가격확인)', value: '가격확인', align: 'center', width: 65, isSlot: true },
                // 그룹뷰 금액 열(2026-10-16 崔凡 #55-표시): 协商前 → 报价单(KRW) → 协商后 순, 报价单(CNY)는 协商后와 같아 숨김. 금액 계산은 그대로
                { text: '协商前价格\n(협상전가격)', value: '협상전가격', align: 'right', width: 60, isSlot: true },
                { text: '报价单(KRW)\n(견적서)', value: '견적서금액KRW', align: 'right', width: 80, isSlot: true },
                { text: '协商后价格\n(협상후가격)', value: '협상후가격', align: 'right', width: 60, isSlot: true },
                { text: '确认入账\n(입금확인)', value: '입금여부', align: 'center', width: 70, isSlot: true },
                { text: '总付款(CNY)\n(총결제)', value: '총결제금액CNY', align: 'right', width: 65, isSlot: true },
                { text: '付款\n(결제진행)', value: '최종결제여부', align: 'center', width: 65, isSlot: true },
                { text: 'COUPASS备注\n(쿠패스메모)', value: '쿠패스메모', align: 'left', width: 70, isSlot: true },
                { text: '采购购买备注\n(구매메모)', value: '구매메모', align: 'left', width: 120, isSlot: true },
                { text: '采购购买照片备注\n(구매사진)', value: '구매메모사진', align: 'center', width: 100, isSlot: true },
            ],

            // 상세 모달 내 상품 목록 headers
            detailHeaders: [
                { text: 'Action', value: 'action', align: 'center', width: 100, isSlot: true },
                { text: '商品订单号\n(상품주문번호)', value: '상품주문번호', align: 'center', width: 130, isSlot: true },
                { text: '1688订单号\n(1688주문번호)', value: '1688주문번호', align: 'center', width: 120, isSlot: true },
                { text: '合包\n(묶음배송)', value: '묶음구성여부', align: 'center', width: 80, isSlot: true },
                { text: '请求变更\n(요청변경)', value: '요청변경', align: 'center', width: 70, isSlot: true },
                { text: '商品信息\n(제품정보)', value: '상품명', align: 'left', width: 200, isSlot: true },
                { text: '中文商品名\n(중국어상품명)', value: '중국어상품명', align: 'left', width: 150, isSlot: true },
                { text: '中文选项1\n(중국어옵션1)', value: '중국어옵션1', align: 'center', width: 120, isSlot: true },
                { text: '中文选项2\n(중국어옵션2)', value: '중국어옵션2', align: 'center', width: 120, isSlot: true },
                { text: '1688商家\n(1688판매자)', value: '판매자명', align: 'center', width: 100, isSlot: true },
                { text: '采购数量\n(구매수량=요청×구성)', value: '구매수량', align: 'center', width: 120, isSlot: true },
                { text: '下单数量\n(주문수량)', value: '주문수량', align: 'center', width: 100, isSlot: true },
                { text: '卖家留言\n(판매자메시지)', value: '판매자메시지', align: 'center', width: 60, isSlot: true },
                { text: '采购链接\n(구매링크)', value: '구매링크', align: 'center', width: 60, isSlot: true },
                { text: '采购要求\n(구매요청사항)', value: '구매요청사항', align: 'left', width: 120, isSlot: true },
                { text: '物流要求\n(물류요청사항)', value: '물류요청사항', align: 'left', width: 120, isSlot: true },
                { text: '协议金额\n(협의금액)', value: '협의금액', align: 'right', width: 80, isSlot: true },
                { text: '协议ID\n(협의ID)', value: '협의ID', align: 'center', width: 80, isSlot: true },
                { text: '上次价格\n(이전가격)', value: '이전주문가격', align: 'right', width: 80, isSlot: true },
                { text: '协商前价格\n(협상전가격)', value: '협상전가격', align: 'right', width: 90, isSlot: true },
                { text: '协商后价格\n(협상후가격)', value: '협상후가격', align: 'right', width: 90, isSlot: true },
                { text: '采购购买备注\n(구매메모)', value: '구매메모', align: 'left', width: 150, isSlot: true },
                { text: '采购购买照片备注\n(구매사진)', value: '구매메모사진', align: 'center', width: 110, isSlot: true },
            ],

            // 뷰 모드: 'group' (그룹 뷰) 또는 'individual' (개별 상품 뷰)
            viewMode: 'group',

            // 상세 모달 관련
            showDetailModal: false,
            selectedGroup: null, // 선택된 그룹 데이터
            orderCreatingOverlay: false, // 주문 생성 중 overlay
            orderCreatingText: '创建订单中… / 주문 생성 중...', // overlay 문구 (재고확인 중엔 库存确认中…)
            orderCreating: false, // 1688 주문 생성 진행중 — 재클릭으로 중복 주문이 나가지 않게 막는다(2026-10-07 61건 중복)
            detailSelectedItems: [], // 상세 모달에서 선택된 아이템들
            isTranslating: false, // 요청사항 번역 중 상태
            zoomImageSrc: '', // 상품 이미지 더블클릭 확대

            // 주문생성 관련
            orderErrorMessage: '', // 주문생성 에러 메시지 (모달 상단 고정 표시용)
            groupOrderErrors: {}, // 메인 테이블 그룹별 주문생성 에러 메시지 (groupKey → message)

            // 부피값 편집 관련
            volumeEditingId: null,
            // 采购备注 + 实物图(#146)
            showPurchaseNote: false,
            purchaseNoteTarget: null,
            purchaseNoteForm: { 메모: '', 사진: [] },
            purchaseNoteUploading: false,
            purchaseNoteSaving: false,
            purchaseNoteBucket: 'elasticbeanstalk-ap-northeast-2-160290560268',
            purchaseNoteRegion: 'ap-northeast-2',
            purchaseNotePool: 'ap-northeast-2:19db1347-4000-4e66-973a-e2077f8cad1d',
            volumeEditForm: { sizeX: 0, sizeY: 0, sizeZ: 0 },

            // 💳 예치금 관리 관련
            showDepositManageModal: false,
            depositAllBalances: [],
            depositSelectedCompany: '',
            depositDetailBalance: 0,
            depositDetailHistory: [],
            depositAction: '',
            depositAmount: '',
            depositReason: '',

            // 공통물류비 입력 관련
            showCommonLogisticsModal: false,
            commonLogisticsTarget: null,
            commonLogisticsItems: [],
            commonLogisticsMemo: '',
            commonLogisticsExisting: false,

            tableSelectedItem: [],
            changeindexlist: [],
            changeoption: false,
            showOptionChange: false,   // 구매 후 옵션 변경 모달
            optionChangeItem: null,
            actionModalItem: null, // Action 모달(제품상세/구매요청사항)이 지금 보여주는 요청건
            exchangeRate: null, // 환율 정보
            exchangeRateHistory: [], // 단독통관 환율 이력 (최근순)
            exchangeRateHistoryLoading: false,
            change: false,
            일괄변경: '구매취소',
            wholechanges: [{ value: '구매전', text: '待采购 (구매전)' }, { value: '구매취소', text: '采购取消 (구매취소)' }, { value: '구매확인', text: '采购确认 (구매확인)' }],
            일괄구매취소내용: '',

            // 일괄처리 관련 변수들
            showBatchChange: false,
            batchStatus: '',
            batchProcessing: false,
            showStatusModal: false,
            selectedStatusForBatch: '',
            statusOptions: [
                { value: '', text: '请选择状态 (진행현황을 선택하세요)', disabled: true },
                { value: '구매전', text: '待采购 (구매전)' },
                { value: '협상중', text: '协商中 (협상중)' },
                { value: '구매확인', text: '采购确认 (구매확인)' },
                { value: '구매보류', text: '采购保留 (구매보류)' },
                { value: '구매취소', text: '采购取消 (구매취소)' },
                { value: '입금요청', text: '已发账单客户未转账 (입금요청)' },
                { value: '입금완료', text: '已入账 (입금완료)' },
                { value: '구매완료', text: '已付款 (구매완료)' },
                { value: '배송중', text: '运输中 (배송중)' },
                { value: '배송완료', text: '已签收 (배송완료)' },
                { value: '입고작업', text: '入库作业中 (입고작업)' },
                { value: '출고확인대기', text: '待确认出库 (출고확인대기)' },
                { value: '재고대기', text: '待上架库存 (재고대기)' },
                { value: '출고요청', text: '📦 出库申请 (출고요청)' },
                { value: '출고대기', text: '待出库 (출고대기)' },
                { value: '출고완료', text: '已出库 (출고완료)' },
                { value: '중국재고', text: '中国库存 (중국재고)' },
                { value: '입고오류', text: '⚠️ 入库错误 (입고오류)' },
                { value: '해외입고중', text: '海外入库中 (해외입고중)' },
                { value: '국내입고중', text: '韩国入库中 (국내입고중)' },
                { value: '국내창고입고중', text: '韩国仓库入库中 (국내창고입고중)' },
                { value: '국내창고입고완료', text: '韩国仓库入库完成 (국내창고입고완료)' },
                { value: '쿠팡센터입고완료', text: '酷澎中心入库完成 (쿠팡센터입고완료)' }
            ],

            // 활성 필터 상태
            activeFilter: 'total',

            // 상태별 카운트
            statusCounts: {
                구매전: 0,
                협상중: 0,
                구매확인: 0,
                구매보류: 0,
                구매취소: 0,
                입금요청: 0,
                입금완료: 0,
                구매완료: 0,
                배송중: 0,
                배송완료: 0,
                입고작업: 0,
                출고확인대기: 0,
                재고대기: 0,
                출고요청: 0,
                출고대기: 0,
                출고완료: 0,
                중국재고: 0,
                입고오류: 0,
                해외입고중: 0,
                국내입고중: 0,
                국내창고입고중: 0,
                국내창고입고완료: 0,
                쿠팡센터입고완료: 0
            },
            selectdate: 'today',
            startdate: this.getTodaywith(),
            enddate: this.getTodaywith(),
            selectoption: '요청일',
            SKUID: '',
            상품명: '',
            바코드: '',

            tobepurchase: true,

            formData: {
                상품매칭: [],
                옵션1_중국어: '',
                옵션2_중국어: '',
                구매재고: '구매불가',
                등록이미지: '',
                옵션이미지: '',
                매칭상태: '매칭필요',
                요청내역: {}
            },


            업체명: '',
            companyids: [],
            companyInfos: [],
            importtext: 'Connect',

            // 주문 조회 (화주주문번호/1688주문번호/운송장번호)
            // 결과는 reqlists에 주입되어 기존 그룹뷰/주문상세 모달에서 표시됨
            orderLookupType: 'order1688',
            orderLookupKeyword: '',
            orderLookupLoading: false,

            // 批量搜索 / 일괄 검색 — batchSearchNos 가 차 있으면 search() 가 그 번호들만 받는다(날짜 무관)
            showBatchSearchModal: false,
            batchSearchText: '',
            batchSearchNos: [],
            batchSearchNotFound: [],
            // 화주명 모드 — ownerFilterNames 가 차 있으면 search() 결과를 그 화주들 건만 남긴다(선택 기간 안)
            batchSearchMode: 'order',
            ownerFilterNames: [],
            ownerFilterNotFound: [],
            ownerFilterOnlyBefore: true,
            // 批量下单 / 일괄 1688주문 진행 상태
            bulkOrderModal: false,
            bulkOrdering: false,
            bulkOrderStopReq: false,
            bulkOrderTotal: 0,
            bulkOrderDone: 0,
            bulkOrderCurrent: '',
            bulkOrderResults: [],
            bulkOrderedItems: [],
            bulkFailItems: [], // 일괄 주문에서 못 올린 상품 {_id, customer, owner, product, reason}
            bulkOrderNotes: [],

            total: 0,
            구매전: 0,
            발송전: 0,
            발송완료: 0,
            입고완료: 0,
            노마드클럽: 0,
            일반배송: 0,
            로켓배송: 0,
            구매취소: 0,
            발송지연: 0,
            배송지연: 0,
            요청변경: 0,
            // 변경이력 처리 모달 상태
            showChangeReviewModal: false,
            changeReviewItem: null,
            changeReviewSelected: [],
            changeReviewNote: '',
            changeReviewProcessing: false,
            // 별도링크 결제 모달 상태
            showSidePaymentModal: false,
            sidePaymentItem: null,
            sidePaymentItems: [], // 한 1688 주문에 함께 연결할 요청들 (단건이면 1개)
            sidePaymentForm: {
                링크: '',
                총금액: 0,
                총금액_CNY: '',
                주문번호: '',
                주문수량: 0,
                운송장번호: '',
                메모: '',
                판매처주문번호: '' // 非1688 판매처(타오바오 등) 주문번호 — 기록용, 선택
            },
            sidePaymentProcessing: false,
            통합통관: 0,
            단독통관: 0,
            쿠패스단독통관: 0,
            샘플검증: 0,

            showspinner: false,

            allcheckreqlists: false,
            reqlists: [],
            allreqlists: [], // 전체 데이터 저장용
            reqlistsinit: [],

            title: coupassMenuTitle('logis.logisreqpurchaseV0'),
            desc1: "주문생성 → 알리왕왕 협상 → 변경/취소 관리 → 견적서 생성 → 1688 API 주문 → 배송현황 확인",
            desc2: "订单创建 → 阿里旺旺协商 → 变更/取消管理 → 报价单生成 → 1688 API下单 → 物流跟踪",
            integratedExchangeRate: 300, // 통합통관 환율 (기본값)
            editIntegratedRate: 300, // 모달 입력용
            editIntegratedFrom: '', // 모달 입력용 — 적용 시작일(YYYY-MM-DD, 기본 오늘)
            integratedRateHistory: [], // 통합통관 환율 변경 이력(최근순)
            desc3: "",

            showreqlist: false,
            showlist: false,

            checkbarcode: true,
            checktag: false,
            checkstamp: false,
            checksticker: false,

            // reqtype: "로켓배송",
            showreqrocket: false,
            showreqjet: false,
            showreqgeneral: false,
            purchaseno: '',
            payment: '',
            reqcontent: '',

            allchecked: false,
            packageMethod: 'auto',
            lists: [],
            downloadlists: [],
            currentindex: '',

            uploadstatus: 'excel file upload',

            // 견적서 관련
            currentQuotation: null,
            quotationGroup: null, // 견적서 모달용 그룹 데이터
            quotationCommonLogistics: null, // 그룹 공통물류비 데이터
            quotationCreating: false, // 견적서 일괄 생성 중 상태

            // 1688 구매금액 견적서 생성 폼 (quotation-modal 내부에서 사용)
            quotation1688Form: {
                customsType: 'integrated',
                환율: 190,
                메모: ''
            },

            // 견적서 편집 오버라이드 { [item._id]: { 구매단가, 구매수량 } }
            quotationEditOverrides: {},
            // 주문별 총배송비 오버라이드 { [orderId]: { 협상전: value, 협상후: value } }
            quotationOrderShippingOverrides: {},

            // 중국물류비 견적서 생성 모달
            showChinaLogisticsModal: false,
            chinaLogisticsItem: null,
            chinaLogisticsForm: {
                customsType: 'integrated',
                메모: ''
            },
            chinaLogisticsItems: [],

            // 한국물류비 견적서 생성 모달
            showKoreaLogisticsModal: false,
            koreaLogisticsItem: null,
            koreaLogisticsForm: { customsType: 'integrated', 메모: '' },
            koreaLogisticsItems: [],

            // 입고오류 처리 모달
            showErrorModal: false,
            errorTargetItem: null,
            errorForm: {
                오류유형: '',
                오류내용: '',
                기타상세: ''
            },
            errorTypeOptions: [
                { value: '', text: '请选择错误类型 (오류유형을 선택하세요)', disabled: true },
                { value: '수량불일치', text: '数量不一致 (수량불일치)' },
                { value: '옵션다름', text: '选项不同 (옵션다름)' },
                { value: '파손', text: '破损 (파손)' },
                { value: '누락', text: '缺少 (누락)' },
                { value: '기타', text: '其他 (기타)' }
            ],

            // 변경 이력 조회 모달
            showProcessHistoryModal: false,
            processHistoryList: [],
            processHistoryCurrentStatus: '',
            processHistoryLoading: false,
            // 진행현황 기록(언제부터 이 상태였나) — /api/reqpurchase/getStatusLog
            statusLogRows: [],
            statusLogNow: null,
            statusLogOpen: false,

            // 가격 수정 확인 관련
            checkingPrice: false,
            processingPayment: false, // 결제 진행 중 상태
            mergedBill: null, // 合并请款单 / 합친 청구서 모달 데이터
            kakaoSending: false, // 카카오로 보내기 준비 중
            mergedBillSaving: false,
            cancellingOrder: false, // 1688 주문 취소 중 상태

            // 결제 자동확인 폴링 상태
            paymentPollerId: null,        // setInterval id
            paymentPollerStart: 0,        // 폴링 시작 시각(ms)
            paymentPollerOrders: null,    // { [orderId]: item[] } — 아직 확정 안 된 주문만 남김
            paymentPollerMemo: '',        // markItemsPurchased memo 접두사
            paymentPollerLastSSE: 0,      // 마지막으로 감지한 SSE payment_completed 카운트

            CreatePo_수취인: this.$store.state.settings[0].CreatePo_수취인,
            CreatePo_연락처: this.$store.state.settings[0].CreatePo_연락처,
            CreatePo_주소_성: this.$store.state.settings[0].CreatePo_주소_성,
            CreatePo_주소_시: this.$store.state.settings[0].CreatePo_주소_시,
            CreatePo_주소_구: this.$store.state.settings[0].CreatePo_주소_구,
            CreatePo_상세주소: this.$store.state.settings[0].CreatePo_상세주소,
            CreatePo_주문번호: this.$store.state.settings[0].CreatePo_주문번호,
            CreatePo_발주기준일: this.$store.state.settings[0].CreatePo_발주기준일,

            // 바코드 출력용
            enabledetail: true,
            printkcenable: false,
            printfoodenable: false,
            원산지: 'Made in China',
            출력바코드: '',
            출력상품명: '',
            출력수량: 1,
            바코드간격: 0,
            bctag: 'svg',
            한글표시사항print: {
                '수입원/판매원': '',
                제조원: '',
                제조국: '',
                내용량: '',
                '원료명및성분명(재질)': '',
                상품유형: '',
                사용시주의사항: '',
                사용기준: '',
                custom: '',
                kc인증: false,
                식품용: false,
            },
        }
    },
    created() {
        document.addEventListener.call(window, "message", event => {
            if (event.data.res && event.data.res === 'yes') {
                console.log(event.data.res);
                console.log(event.data.result[0].result);
                if (event.data.result[0].result.option1array.length == 0) {
                    this.lists[this.currentindex].상품매칭.옵션1_중국어 = [];
                    this.lists[this.currentindex].옵션1_중국어 = '';
                } else {
                    this.lists[this.currentindex].상품매칭.옵션1_중국어 = event.data.result[0].result.option1array;
                }
                if (event.data.result[0].result.option2array.length == 0) {
                    this.lists[this.currentindex].상품매칭.옵션2_중국어 = [];
                    this.lists[this.currentindex].옵션2_중국어 = '';
                } else {
                    this.lists[this.currentindex].상품매칭.옵션2_중국어 = event.data.result[0].result.option2array;
                }
                this.lists[this.currentindex].showspinner = false;
                this.currentindex = '';
            }
        });
    },
    computed: {
        // 쿠패스 직원(서버 isImportPhotoAdmin 과 같은 판정 — 서버가 다시 확인한다)
        isStaffUser() {
            const u = this.$store.state.user;
            return !!(u && u.auth && u.auth.showadmin);
        },
        // 订单列表 카드에서 온 진행현황 필터 — 카드를 뺀 자리에 무엇으로 걸렀는지 보여준다
        stageFilterLabel() {
            return STAGE_FILTERS.includes(this.activeFilter) ? this.displayZh(this.activeFilter) : '';
        },
        // 「결제진행」 필터 건수 — 기준은 isPaymentPending 하나
        paymentPendingCount() {
            return this.reqlistsinit.filter(item => this.isPaymentPending(item)).length;
        },
        // 업체ID 자동완성 — 업체가 4천 개가 넘어 「AN」 처럼 짧게 치면 수백 개가 걸리고
        // 정확히 같은 업체가 뒤로 묻힌다. 같음 → 앞글자 같음 → 포함 순으로 50개만 보여준다
        companyidOptions() {
            const q = String(this.업체명 || '').trim().toLowerCase();
            const ids = this.companyids || [];
            if (!q) return ids.slice(0, 50);
            const exact = [], starts = [], includes = [];
            ids.forEach(id => {
                const s = String(id).toLowerCase();
                if (s === q) exact.push(id);
                else if (s.startsWith(q)) starts.push(id);
                else if (s.includes(q)) includes.push(id);
            });
            return exact.concat(starts, includes).slice(0, 50);
        },
        // 붙여넣은 글 → 번호 목록(줄바꿈·공백·쉼표·전각쉼표·세미콜론 구분, 앞뒤 공백 제거, 중복 제거, 입력 순서 유지)
        batchSearchParsed() {
            return [...new Set(String(this.batchSearchText || '').split(/[\s,，;；、]+/).map(v => v.trim()).filter(Boolean))];
        },
        orderLookupPlaceholder() {
            const msgs = {
                order: '请输入货主订单号，完全一致 (화주주문번호를 입력하세요, 정확히 일치)',
                order1688: '请输入1688订单号，完全一致 (1688주문번호를 입력하세요, 정확히 일치)',
                tracking: '请输入快递单号，完全一致 (운송장번호를 입력하세요, 정확히 일치)',
                batch: '批次号 (묶음번호) 例: 260917-143025'
            };
            return msgs[this.orderLookupType] || msgs.order;
        },
        /**
         * 구매요청 데이터를 그룹화하여 반환
         * 그룹화 키: 요청일(timestamp) + reqtype + companyid + 진행현황 + 통관방법
         */
        groupedReqlists() {
            const groups = {};

            this.reqlists.forEach(item => {
                // 그룹화 키 생성: 요청일을 날짜(YYYY-MM-DD) 기준으로 그룹화
                const reqDate = new Date(item.요청일).toISOString().slice(0, 10);
                // 非1688(自行采购) 건은 1688 주문과 섞이지 않게 따로 묶는다(송금 처리 대상)
                // 이미 주문한 건은 «주문한 날»도 기준에 넣는다 — 요청일만 같다고 다른 날 주문한 건끼리 한 줄로 묶이고 下单时间 이 가장 늦은 날로 찍혔다(2026-10-25 崔凡 #147)
                const orderDay = item.주문시간 ? '_o' + String(item.주문시간).slice(0, 10) : '';
                const groupKey = `${reqDate}_${item.reqtype}_${item.companyid}_${item.processStatus || item.진행현황}_${item.통관방법}`
                    + orderDay
                    + (this.isNon1688(item) ? '_non1688' : '');

                if (!groups[groupKey]) {
                    // 1688구매코드 생성
                    const purchaseCode = this.generate1688PurchaseCode(item);

                    // companyInfos에서 회사명 찾기
                    const companyInfo = this.companyInfos.find(c => c.companyid === item.companyid);
                    const companyName = companyInfo?.name || item.companyid;

                    // 환율 결정 (통합통관: 통합통관환율, 나머지: 단독통관환율)
                    let 적용환율 = 0;
                    if (this.exchangeRate) {
                        적용환율 = item.통관방법 === '통합통관'
                            ? (this.exchangeRate.integratedRate || this.exchangeRate.rate)
                            : (parseFloat(this.exchangeRate.cashBuyValue) || 0);
                    }

                    groups[groupKey] = {
                        groupKey: groupKey,
                        요청일: item.요청일,
                        reqtype: item.reqtype,
                        companyid: item.companyid,
                        companyName: companyName,
                        진행현황: item.processStatus || item.진행현황,
                        processStatus: item.processStatus || item.진행현황,
                        통관방법: item.통관방법,
                        적용환율: 적용환율,
                        destination: item.요청내역?.destination || 'coupang',
                        // 그룹 행은 요청내역을 안 담는다. 「유형」 칸이 볼 수 있게 여기서 판정해 둔다.
                        샘플검증: this.hasSampleCheck(item),
                        비1688: this.isNon1688(item),
                        화주주문번호: item.화주주문번호 || '',
                        화주주문번호목록: [],
                        묶음번호목록: [],
                        구매코드1688: purchaseCode,
                        items: [],
                        품목수: 0,
                        총수량: 0,
                        // 집계 필드 초기화
                        수정여부: false,
                        수정내용: [],
                        주문생성여부: false,
                        주문시간: null,
                        협상전가격: 0,
                        협상후가격: 0,
                        견적서금액CNY: 0,
                        견적서금액KRW: 0,
                        입금여부: false,
                        총결제금액CNY: 0,
                        최종결제여부: false,
                        쿠패스메모: '',
                        구매메모: '',
                        구매메모사진: []
                    };
                }

                const group = groups[groupKey];
                group.items.push(item);
                group.품목수 = group.items.length;
                group.총수량 += parseInt(item.구매요청수량) || 0;
                // 한 건이라도 샘플검증이면 그룹도 샘플검증이다. 실측(2026-09-17, 최근 요청 20,000건
                // / 그룹 5,290개)상 샘플과 일반이 한 그룹에 섞인 경우는 0건이라 과대표시가 안 난다
                // — 그룹키가 날짜·업체·상태·통관으로 이미 갈리기 때문이다.
                if (this.hasSampleCheck(item)) group.샘플검증 = true;

                // 화주주문번호가 있는 아이템이 있으면 그룹에도 설정
                if (item.화주주문번호 && !group.화주주문번호) {
                    group.화주주문번호 = item.화주주문번호;
                }
                // 표시용 목록 — 그룹키가 날짜 단위라 한 그룹에 1688주문(화주주문번호)·묶음이 여럿 섞일 수 있다
                if (item.화주주문번호 && !group.화주주문번호목록.includes(item.화주주문번호)) {
                    group.화주주문번호목록.push(item.화주주문번호);
                }
                const __batch = this.batchNo(item);
                if (__batch && !group.묶음번호목록.includes(__batch)) {
                    group.묶음번호목록.push(__batch);
                }

                // 수정여부 체크 (미확인 changeHistory가 있으면 수정됨)
                if (item.changeHistory && item.changeHistory.length > 0) {
                    group.수정내용.push(...item.changeHistory);
                    if (this.hasUnconfirmedChange(item)) {
                        group.수정여부 = true;
                    }
                }

                // 주문생성여부 체크
                if (item.주문생성여부 || item.주문정보) {
                    group.주문생성여부 = true;
                    if (item.주문시간 && (!group.주문시간 || item.주문시간 > group.주문시간)) {
                        group.주문시간 = item.주문시간;
                    }
                }

                // 가격 관련 집계
                group.협상전가격 += parseFloat(item.주문정보?.협상전_총금액) || 0;
                // 협상후가 비면(가격 수정 없음) 협상전 — 견적서금액CNY 와 같은 규칙
                group.협상후가격 += parseFloat(item.주문정보?.협상후_총금액) || parseFloat(item.주문정보?.협상전_총금액) || 0;
                // 견적서금액: 주문정보에서 직접 읽음
                group.견적서금액CNY += parseFloat(item.주문정보?.협상후_총금액) || parseFloat(item.주문정보?.협상전_총금액) || 0;

                // 입금/결제 상태
                if (item.입금여부) group.입금여부 = true;
                group.총결제금액CNY += parseFloat(item.결제금액)
                    // 非1688 已转账 은 별도결제 경로가 요청별 몫을 견적서에 남긴다(별도결제.총금액_CNY 는 묶음 전체라 더하면 겹친다)
                    || (this.isNon1688(item) ? parseFloat(item.견적서_1688구매금액?.별도결제_CNY) || 0 : 0);
                if (item.최종결제여부) group.최종결제여부 = true;

                // 쿠패스메모 (첫 번째 메모 사용)
                if (item.쿠패스메모 && !group.쿠패스메모) {
                    group.쿠패스메모 = item.쿠패스메모;
                }
                // 采购购买备注·照片(#146) — 그룹에는 첫 메모와 사진 모음을 보인다
                if (item.구매메모 && !group.구매메모) group.구매메모 = item.구매메모;
                if (Array.isArray(item.구매메모사진)) item.구매메모사진.forEach(u => { if (group.구매메모사진.length < 6 && !group.구매메모사진.includes(u)) group.구매메모사진.push(u); });
            });

            // 후처리: 견적서금액 KRW 계산 (견적서_1688구매금액이 있으면 최종금액합계_KRW 합산)
            Object.values(groups).forEach(group => {
                // 단독통관 「환율」 칸 = 1688 주문일 환율(재주문이면 재주문일, 그룹에 여럿이면 최근 주문, YZY 10-07). 주문 전이면 현재 환율 그대로.
                if (group.통관방법 !== '통합통관') {
                    const fx = group.items.map(it => this.cnyRateForOrder(it)).filter(Boolean)
                        .sort((a, b) => b.기준일.localeCompare(a.기준일))[0];
                    if (fx) group.적용환율 = fx.rate;
                }
                const krwFromQuotation = group.items.reduce((sum, item) => {
                    return sum + (parseFloat(item.견적서_1688구매금액?.최종금액합계_KRW) || 0);
                }, 0);
                group.견적서금액KRW = krwFromQuotation > 0 ? krwFromQuotation : Math.round(group.견적서금액CNY * group.적용환율);
                // 非1688 은 금액을 직원이 채운다 — 한 건이라도 비어 있으면 「견적 미입력」 (0원으로 조용히 넘어가지 않게)
                group.견적미입력 = group.items.some(it => this.isNon1688(it) &&
                    (!it.견적서_1688구매금액 || it.견적서_1688구매금액.미입력 || !(parseFloat(it.견적서_1688구매금액.최종금액합계_KRW) > 0)));
            });

            // 객체를 배열로 변환하고 요청일 기준 내림차순 정렬
            return Object.values(groups).sort((a, b) => b.요청일 - a.요청일);
        },

        /**
         * 선택된 그룹에 견적서 미생성 아이템이 있는지 확인
         */
        hasUnquotedItems() {
            if (!this.selectedGroup || !this.selectedGroup.items) return false;
            return this.selectedGroup.items.some(item => !item.견적서상태 || item.견적서상태 === '미생성');
        },
        cancelOrder1688Items() {
            // 선택된 아이템이 있으면 선택된 것만, 없으면 빈 배열
            return this.detailSelectedItems.filter(item => item.주문정보?.['1688주문번호']);
        },
        cancelOrder1688Disabled() {
            return this.cancelOrder1688Items.length === 0;
        },
        cancelOrder1688Tooltip() {
            if (this.detailSelectedItems.length === 0) return '请选择要取消的商品 / 취소할 상품을 선택하세요';
            if (this.cancelOrder1688Items.length === 0) return '所选商品没有1688订单号 / 선택한 상품에 1688 주문번호가 없습니다';
            const tradeIDs = [...new Set(this.cancelOrder1688Items.map(i => i.주문정보['1688주문번호']))];
            return `取消1688订单 ${tradeIDs.join(', ')}，仅限未付款 / 1688 주문 ${tradeIDs.join(', ')} 취소 (미결제만 가능)`;
        },

        /**
         * 견적서 모달 내 미생성 아이템 목록
         */
        quotationGroupUnquotedItems() {
            if (!this.quotationGroup || !this.quotationGroup.items) return [];
            return this.quotationGroup.items.filter(item => !item.견적서_1688구매금액);
        },
        hasPreNegotiationOverrides() {
            return Object.values(this.quotationEditOverrides).some(o => o.협상전_단가 != null)
                || Object.values(this.quotationOrderShippingOverrides).some(o => o.협상전 != null);
        },

        /**
         * 견적서 미전송 아이템의 통관타입별 KRW 미리보기
         */
        /**
         * 별도링크 결제 CNY 입력 → 견적서 금액 미리보기 (서버 /api/logis/savesidepayment 와 같은 계산)
         * 요청별 견적서의 통관타입·적용환율을 쓰고, 수량 비율로 나눈다. 견적서가 없는 요청은 반영되지 않는다.
         */
        /** 별도결제 모달 대상이 전부 非1688 인가 — 非1688 已转账 모드(1688 주문번호 대신 상점·메모) */
        sidePaymentNon1688() {
            const list = this.sidePaymentItems.length ? this.sidePaymentItems : (this.sidePaymentItem ? [this.sidePaymentItem] : []);
            return list.length > 0 && list.every(it => this.isNon1688(it));
        },
        /** 非1688 已转账 참고값 — 화주가 넣은 단가(구매가격, 위안) × 구매요청수량 합계 */
        non1688TransferEstimate() {
            const sum = (this.sidePaymentItems || []).reduce((a, it) =>
                a + (parseFloat(it.구매가격) || 0) * (parseInt(it.구매요청수량) || 0), 0);
            return Math.round(sum * 100) / 100;
        },
        sidePaymentPreview() {
            const cny = parseFloat(this.sidePaymentForm.총금액_CNY) || 0;
            if (cny <= 0) return null;
            const targets = this.sidePaymentItems.length ? this.sidePaymentItems : (this.sidePaymentItem ? [this.sidePaymentItem] : []);
            if (!targets.length) return null;
            const multi = targets.length > 1;
            const qtyOf = (r) => {
                const compose = (r.판매구성수량 === '단품' || !r.판매구성수량) ? 1 : (parseInt(r.판매구성수량) || 1);
                return parseInt(r.주문정보?.주문수량) || ((parseInt(r.구매요청수량) || 0) * compose);
            };
            const 총수량 = targets.reduce((s, r) => s + qtyOf(r), 0);
            let 누적 = 0;
            let krw = 0;
            const rates = new Set();
            let fxMissing = false;
            targets.forEach((r, i) => {
                let 몫 = cny;
                if (multi) {
                    const ratio = 총수량 > 0 ? qtyOf(r) / 총수량 : 1 / targets.length;
                    몫 = i === targets.length - 1 ? Math.round((cny - 누적) * 100) / 100 : Math.round(cny * ratio * 100) / 100;
                    누적 += 몫;
                }
                const q = r.견적서_1688구매금액;
                if (!q) return;
                const customsType = q.customsType;
                // 견적에 박힌 적용환율만 쓴다. 비었으면 현재 환율로 대신 보여 주지 않고 크게 실패시킨다(숫자 대체 금지)
                const rate = parseFloat(q.적용환율);
                if (!(rate > 0)) {
                    console.error('[환율 값 비어 있음] 견적서에 적용환율이 없음 — 원인 확인 필요', { _id: r._id, 통관방법: customsType, 적용환율: q.적용환율 });
                    fxMissing = true;
                    return;
                }
                rates.add(rate);
                let 결제금액 = 0;
                if (customsType === 'client') {
                    결제금액 = Math.round(몫 * rate);
                    krw += Math.round(결제금액 * 1.033);
                } else if (customsType === 'kupass') {
                    결제금액 = Math.round(몫 * 1.03 * rate);
                    krw += 결제금액 + Math.round(결제금액 * 0.1);
                } else {
                    결제금액 = Math.round(몫 * rate);
                    krw += 결제금액 + Math.round(결제금액 * 0.1);
                }
            });
            if (fxMissing) return { krw: 0, rates: '', error: '汇率值为空：请查明原因 (환율 값이 비어 있음: 원인 확인)' };
            if (!rates.size) return null;
            return { krw, rates: Array.from(rates).join(', ') };
        },
        /** 견적서 모달 — 미생성 요청들의 1688 주문일·환율 요약 (예: ": 2026-10-06 210.56") */
        quotationOrderFxNote() {
            const parts = new Set();
            let noOrder = false;
            this.quotationGroupUnquotedItems.forEach(it => {
                const r = this.cnyRateForOrder(it);
                if (r) parts.add(`${r.기준일} ${r.rate}`);
                else noOrder = true;
            });
            const list = Array.from(parts);
            if (noOrder) list.push('未下单=当前汇率 (주문 전=현재 환율)');
            return list.length ? ': ' + list.join(' / ') : '';
        },
        quotationPreview() {
            const items = this.quotationGroupUnquotedItems;
            if (!items.length) return null;
            const form = this.quotation1688Form;
            const customsType = form.customsType;

            // 단독통관은 요청마다 1688 주문일 환율이 다를 수 있어 요청별로 환산해 더한다(서버도 요청별로 저장한다)
            let totalCNY = 0;
            let 결제금액_KRW = 0;
            let 부가세 = 0;
            let 최종금액합계_KRW = 0;
            let 원값합 = 0;
            const rates = new Set();
            items.forEach(item => {
                const qty = parseInt(item.구매요청수량) || 1;
                const 구매단가 = negoUnitCny(item.주문정보, qty);
                const post배송비 = item.주문정보?.협상후_배송비;
                const 배송비 = (post배송비 != null && post배송비 !== '') ? (parseFloat(post배송비) || 0) : (parseFloat(item.주문정보?.협상전_배송비) || 0);
                const proc = this.quotationGroupItemsProcessed.find(p => p._id === item._id);
                const itemCNY = (proc && proc._협상후_총금액_raw != null) ? proc._협상후_총금액_raw : (구매단가 * qty) + 배송비;
                totalCNY += itemCNY;
                const 환율 = this.quoteRateForItem(item);
                rates.add(환율);
                // 묶음 합계를 낸 뒤 한 번만 반올림 — 서버 create1688(inventory-services/quote-round.js)과 같은 식
                const 누계 = 원값합 + itemCNY * (customsType === 'kupass' ? 1.03 : 1) * 환율;
                const R = (v) => Math.round(Math.round(v * 1e6) / 1e6);
                const krw = R(누계) - R(원값합);
                const 배율 = customsType === 'client' ? 1.033 : 1.1;
                const 행최종 = R(누계 * 배율) - R(원값합 * 배율);
                결제금액_KRW += krw; 부가세 += 행최종 - krw; 최종금액합계_KRW += 행최종;
                원값합 = 누계;
            });
            return { totalCNY, 적용환율: Array.from(rates).join(', '), 결제금액_KRW, 부가세, 최종금액합계_KRW };
        },

        /**
         * 견적서 모달 내 KRW 합계
         */
        // 묶음 CNY 합계(협상전·협상후) — 줄마다 합계를 따로 찍는 대신 맨 아래 한 번 보인다
        quotationGroupCny() {
            const r2 = v => Math.round(v * 100) / 100;
            return this.quotationGroupItemsProcessed.reduce((a, i) => {
                const pre = i._협상전_총금액 || 0;
                const post = i._협상후_총금액_override != null ? i._협상후_총금액_override : (i.주문정보?.협상후_총금액 != null ? Number(i.주문정보.협상후_총금액) || 0 : (i._未改价 ? pre : 0));
                return { pre: r2(a.pre + pre), post: r2(a.post + post) };
            }, { pre: 0, post: 0 });
        },
        quotationGroupTotalKRW() {
            return this.quotationGroupItemsProcessed.reduce((sum, item) => {
                return sum + (item._최종금액_KRW || 0);
            }, 0);
        },

        /**
         * 견적서 모달 아이템 (rowspan 정보 포함)
         */
        // 같은 1688 주문의 행을 이어서 보이게 한다(2026-10-16 崔凡 «账单 错行»). 총배송비 칸은 «주문의 첫 행 + 행 수»로 rowspan 을 걸기 때문에
        // 다른 주문 행이 사이에 끼어 있으면 아래 행의 칸이 한 칸씩 밀렸다. 계산은 원래 순서 그대로(누계 반올림 순서 보존) 하고 보이는 순서만 모은다
        quotationGroupItemsProcessed() {
            const raw = this.quotationGroupItemsProcessedRaw;
            if (!raw.length) return raw;
            const order = [];
            const by = {};
            raw.forEach(it => {
                const k = it._orderId;
                if (!by[k]) { by[k] = []; order.push(k); }
                by[k].push(it);
            });
            const r2 = v => Math.round(v * 100) / 100;
            return [].concat(...order.map(k => {
                const g = by[k];
                const pre = r2(g.reduce((a, i) => a + (i._협상전_총금액 || 0), 0));
                const post = r2(g.reduce((a, i) => a + (i._협상후_총금액_override != null ? i._협상후_총금액_override : (i.주문정보?.협상후_총금액 != null ? Number(i.주문정보.협상후_총금액) || 0 : (i._未改价 ? (i._협상전_총금액 || 0) : 0))), 0));
                return g.map(i => Object.assign({}, i, { _orderPreTotal: pre, _orderPostTotal: post }));
            }));
        },
        quotationGroupItemsProcessedRaw() {
            if (!this.quotationGroup?.items) return [];
            const items = this.quotationGroup.items;
            const orderGroups = {};
            items.forEach((item, idx) => {
                const orderId = item.주문정보?.['1688주문번호'] || 'unknown';
                if (!orderGroups[orderId]) orderGroups[orderId] = [];
                orderGroups[orderId].push(idx);
            });

            // 공통물류비 배분 계산
            const commonTotal = this.quotationCommonLogistics?.총금액 || 0;
            let distributionMap = {};
            if (commonTotal > 0) {
                const allHaveVolume = items.every(i => ((i.sizeX || 0) * (i.sizeY || 0) * (i.sizeZ || 0)) > 0);
                const weights = items.map(i => {
                    const qty = i.구매요청수량 || 1;
                    const vol = (i.sizeX || 0) * (i.sizeY || 0) * (i.sizeZ || 0);
                    return allHaveVolume ? qty * vol : qty;
                });
                const totalWeight = weights.reduce((s, w) => s + w, 0);
                items.forEach((item, idx) => {
                    distributionMap[item._id] = totalWeight > 0 ? Math.round(commonTotal * weights[idx] / totalWeight) : 0;
                });
            }

            // 통관타입별 미리보기 계산용 (환율은 요청별 — quoteRateForItem)
            const form = this.quotation1688Form || {};
            const customsType = form.customsType || 'integrated';

            // 주문별 총수량 계산 (총배송비 → 개별배송비 분배용)
            const orderTotalQtys = {};
            for (const [oid, indices] of Object.entries(orderGroups)) {
                orderTotalQtys[oid] = indices.reduce((sum, i) => sum + (parseInt(items[i].구매요청수량) || 1), 0);
            }

            let 미리보기원값합 = 0;
            return items.map((item, idx) => {
                const orderId = item.주문정보?.['1688주문번호'] || 'unknown';
                const group = orderGroups[orderId];
                const isFirst = group[0] === idx;
                const qty = parseInt(item.구매요청수량) || 1;
                const orderTotalQty = orderTotalQtys[orderId] || qty;

                const override = this.quotationEditOverrides[item._id] || {};
                const orderShipOverride = this.quotationOrderShippingOverrides[orderId];

                // 협상전: 총배송비 override 시 개별배송비 자동 재계산
                const _협상전_총금액 = item.주문정보?.협상전_총금액 || 0;
                const origPre배송비 = item.주문정보?.협상전_배송비 || 0;
                const pre상품금액 = _협상전_총금액 - origPre배송비;
                const default_협상전_단가 = qty > 0 ? Math.round(pre상품금액 / qty * 100) / 100 : 0;

                let _협상전_배송비;
                if (orderShipOverride?.협상전 != null) {
                    _협상전_배송비 = orderTotalQty > 0 ? Math.round(parseFloat(orderShipOverride.협상전) / orderTotalQty * 100) / 100 : 0;
                } else {
                    _협상전_배송비 = qty > 0 ? Math.round(origPre배송비 / qty * 100) / 100 : 0;
                }

                let _협상전_단가;
                if (override.협상전_단가 != null) {
                    _협상전_단가 = parseFloat(override.협상전_단가);
                } else {
                    _협상전_단가 = default_협상전_단가;
                }

                // 협상후가 비어 있으면(가격 수정 없음) 협상전을 그대로 쓴다 — 화면에는 值 옆에 «未改价» 표시
                const _未改价 = isUnchangedPrice(item.주문정보);
                // 협상후: 총배송비 override 시 개별배송비 자동 재계산
                const _협상후_단가 = item.주문정보?.협상후_실결제금액
                    ? Math.round(parseFloat(item.주문정보.협상후_실결제금액) / qty * 100) / 100
                    : (parseFloat(item.주문정보?.협상후_상품금액) || (_未改价 ? Math.round(preUnitCny(item.주문정보, qty) * 100) / 100 : 0));
                let _협상후_배송비;
                if (orderShipOverride?.협상후 != null) {
                    _협상후_배송비 = orderTotalQty > 0 ? Math.round(parseFloat(orderShipOverride.협상후) / orderTotalQty * 100) / 100 : 0;
                } else {
                    const post총배송비 = parseFloat(item.주문정보?.협상후_배송비) || (_未改价 ? (parseFloat(item.주문정보?.협상전_배송비) || 0) : 0);
                    _협상후_배송비 = qty > 0 ? Math.round(post총배송비 / qty * 100) / 100 : 0;
                }

                const preTotal = _협상전_총금액;
                let postTotal = item.주문정보?.협상후_총금액 || 0;
                // 직원이 입력한 단가·수량·총배송비(override)를 합계·미리보기에 즉시 반영 — 제출(create1688)과 같은 식
                const ovUnit = override.구매단가 != null ? parseFloat(override.구매단가) : NaN;
                const ovQty = override.구매수량 != null ? parseInt(override.구매수량) : NaN;
                const ovShip = orderShipOverride?.협상후 != null ? parseFloat(orderShipOverride.협상후) : NaN;
                let _협상후_총금액_override = null;
                let _협상후_총금액_raw = null;
                if (!item.견적서_1688구매금액 && (Number.isFinite(ovUnit) || Number.isFinite(ovQty) || Number.isFinite(ovShip))) {
                    const effQty = Number.isFinite(ovQty) && ovQty > 0 ? ovQty : qty;
                    const effUnit = Number.isFinite(ovUnit) ? ovUnit : negoUnitCny(item.주문정보, qty);
                    let effShip;
                    if (Number.isFinite(ovShip)) {
                        effShip = Math.round(ovShip / orderTotalQty * effQty * 100) / 100;
                    } else {
                        const p배 = item.주문정보?.협상후_배송비;
                        effShip = (p배 != null && p배 !== '') ? (parseFloat(p배) || 0) : (parseFloat(item.주문정보?.협상전_배송비) || 0);
                    }
                    // 서버 create1688 은 CNY 합계를 반올림하지 않고 원화만 한 번 반올림한다 → 계산용은 원값, 표시용만 2자리
                    _협상후_총금액_raw = effUnit * effQty + effShip;
                    _협상후_총금액_override = Math.round(_협상후_총금액_raw * 100) / 100;
                    postTotal = _협상후_총금액_raw;
                }
                const 할인율 = preTotal > 0 && postTotal > 0 ? Math.round((1 - postTotal / preTotal) * 1000) / 10 : 0;

                // KRW 미리보기: 견적서 생성 전이면 선택한 통관타입 기반으로 계산
                const q = item.견적서_1688구매금액;
                let _부가세 = 0;
                let _최종금액_KRW = 0;
                let _적용환율 = 0;
                if (q) {
                    _부가세 = q.부가세 || 0;
                    _최종금액_KRW = q.최종금액합계_KRW || 0;
                    _적용환율 = q.적용환율 || 0;
                } else if (postTotal > 0 || preTotal > 0) {
                    const itemCNY = postTotal || preTotal;
                    // 단독통관은 요청마다 1688 주문일 환율이 다를 수 있다(서버 create1688 과 같은 규칙)
                    const 환율 = this.quoteRateForItem(item);
                    _적용환율 = 환율;
                    // 묶음 합계 후 1회 반올림 — 서버 create1688·quotationPreview 와 같은 누계 차분(견적서 없는 행끼리 누계)
                    const R = (v) => Math.round(Math.round(v * 1e6) / 1e6);
                    const 누계 = 미리보기원값합 + itemCNY * (customsType === 'kupass' ? 1.03 : 1) * 환율;
                    const 배율 = customsType === 'client' ? 1.033 : 1.1;
                    const krwBase = R(누계) - R(미리보기원값합);
                    _최종금액_KRW = R(누계 * 배율) - R(미리보기원값합 * 배율);
                    _부가세 = _최종금액_KRW - krwBase;
                    미리보기원값합 = 누계;
                }

                return {
                    ...item,
                    _orderId: orderId,
                    _isFirstInOrder: isFirst,
                    _orderRowspan: isFirst ? group.length : 0,
                    _preOrderShipping: orderShipOverride?.협상전 != null ? parseFloat(orderShipOverride.협상전) : (item.주문정보?.협상전_주문배송비 || 0),
                    _postOrderShipping: orderShipOverride?.협상후 != null ? parseFloat(orderShipOverride.협상후) : (item.주문정보?.협상후_주문배송비 || (_未改价 ? (item.주문정보?.협상전_주문배송비 || 0) : 0)),
                    _未改价,
                    _협상전_단가,
                    _협상전_배송비,
                    _협상전_총금액,
                    _협상후_단가: Number.isFinite(ovUnit) ? ovUnit : _협상후_단가,
                    _협상후_배송비,
                    _협상후_총금액: postTotal,
                    _협상후_총금액_override,
                    _협상후_총금액_raw,
                    _할인율: 할인율,
                    _부가세,
                    _최종금액_KRW,
                    _적용환율,
                    _중국물류비: item.견적서_중국물류비?.총금액 || 0,
                    _한국물류비: item.견적서_한국물류비?.총금액 || 0,
                    _공통배분: distributionMap[item._id] || 0
                };
            });
        },

        /**
         * 중국물류비 견적서 미리보기 계산
         */
        calculateChinaLogisticsPreview() {
            return this.chinaLogisticsItems.reduce((sum, item) => sum + (item.amount || 0), 0);
        },

        /**
         * 한국물류비 견적서 미리보기 계산 (동적 items 합산)
         */
        calculateKoreaLogisticsPreview() {
            return this.koreaLogisticsItems.reduce((sum, item) => sum + (item.amount || 0), 0);
        },
        /**
         * 공통물류비 합계 계산
         */
        commonLogisticsTotal() {
            return this.commonLogisticsItems.reduce((sum, i) => sum + (Number(i.amount) || 0), 0);
        },
        enablekr() {
            if (this.enabledetail) {
                return 'font-size:80%;color:black;line-height:110%;display:block;margin-bottom:0px;'
            } else {
                return 'font-size:80%;color:black;line-height:110%;display:none'
            }
        },
        disablekr() {
            if (this.enabledetail) {
                return 'font-size:80%;color:black;line-height:110%;display:none'
            } else {
                return 'font-size:80%;color:black;line-height:110%;display:block'
            }
        },
        barcodePrintkc() {
            if (this.printkcenable) {
                return 'font-size:90%;color:black;margin-left:20px;margin-top:10px'
            } else {
                return 'display:none;font-size:90%;color:black;'
            }
        },
    },
    watch: {
        // 상단 탭(keep-alive)으로 이미 열려 있을 때 订单列表 카드를 누르면 mounted 가 다시 안 돈다
        '$route.query.stage'(v) {
            if (v && this.$route.name === 'logis.logisreqpurchaseV0') this.applyStageQuery();
        },
        // 옛 변경내역 메뉴 북마크(→ ?view=changes)·뒤로가기로 탭이 바뀌어도 따라간다
        '$route.query.view'(v) {
            // 상단 탭(keep-alive)으로 숨은 동안 다른 메뉴로 가면 view 가 비어 「구매요청」 탭으로 돌아가 버린다
            if (this.$route.name !== 'logis.logisreqpurchaseV0') return;
            this.pageView = ['changes', 'tracking', 'purchased'].includes(v) ? v : 'requests';
        },
        // tableSelectedItem이 변경될 때 감시
        tableSelectedItem: {
            handler(newVal) {
                // 선택된 항목이 0개가 되면 collapse를 자동으로 닫음
                if (newVal.length === 0 && this.showBatchChange) {
                    this.showBatchChange = false;
                    // 상태 선택도 초기화
                    this.batchStatus = '';
                }
            },
            deep: true // 배열의 내용 변화도 감지
        },
        // SSE payment_completed 카운터 증가 감지 → 폴링 즉시 1회 체크 (웹훅 반영 속도 단축)
        '$store.state.sseNotifications.payment_completed'(newVal, oldVal) {
            if (typeof newVal === 'number' && typeof oldVal === 'number' && newVal > oldVal) {
                this.handlePaymentSSEHint();
            }
        }
    },
    methods: {
        // 판매자 묶음 키 — 같은 offer 가 서로 다른 sellerOpenId 로 저장된 건(조회한 계정마다 값이 달라 같은 판매자인데 갈렸다, 2026-10-18 崔凡 #67)도
        // offerId 를 공유하면 같은 판매자로 합친다. sellerOpenId 가 없는 건은 같은 offer 를 가진 건의 판매자를 따라간다.
        makeSellerKeyOf(items) {
            const parent = {};
            const find = x => { while (parent[x] !== x) x = parent[x]; return x; };
            const add = x => { if (parent[x] === undefined) parent[x] = x; };
            const union = (a, b) => { add(a); add(b); const ra = find(a); const rb = find(b); if (ra !== rb) parent[rb] = ra; };
            const offerOf = it => ((it.구매링크 || '').match(/offer\/(\d+)/) || [])[1] || '';
            (items || []).forEach(it => {
                const o = offerOf(it);
                if (!o) return;
                add('o' + o);
                if (it.item && it.item.sellerOpenId) union('s' + it.item.sellerOpenId, 'o' + o);
            });
            return (item, offerId) => { add('o' + offerId); return find('o' + offerId); };
        },
        priceRiseInfo, priceRiseTitle,
        // 구매 후 옵션 변경(쿠패스 직원 전용 — 서버도 같은 권한을 다시 본다)
        openOptionChange(item) {
            this.optionChangeItem = item;
            this.showOptionChange = true;
        },
        optionChangeApplied() {
            this.search();   // 목록을 다시 불러온다
        },
        // 저장값 → 「中文 (한국어)」 표시. 모르는 값은 원래 글자 그대로(빈 칸으로 숨기지 않는다)
        displayZh(v) {
            const zh = DISPLAY_ZH[v];
            return zh ? zh + ' (' + v + ')' : (v || '');
        },
        // 표 칸·배지용 2줄 표시 — 위 中文, 아래 작게 한국어(가로폭 줄이기, 2026-10-07 YZY). 모르는 값은 원래 글자만
        zhKo(v) {
            const zh = DISPLAY_ZH[v];
            return zh ? { zh, ko: v } : { zh: v || '', ko: '' };
        },
        // 出库形式(물류방법) 표시 라벨·색 — utils/coupassStatusText 한 곳. 저장·필터 값은 그대로
        outboundTypeText,
        outboundTypeStyle,
        // 구매요청 / 请求变更记录 탭 — 주소(?view=)에도 남겨 새로고침·북마크가 그 탭으로 열린다
        setPageView(v) {
            if (this.pageView === v) return;
            this.pageView = v;
            const query = { ...this.$route.query };
            if (v !== 'requests') query.view = v; else delete query.view;
            this.$router.replace({ query }).catch(e => { if (e && e.name !== 'NavigationDuplicated') console.error('[商品求购] 탭 주소 갱신 실패', e); });
        },
        // 쿠팡 supplierHub 이미지 주소의 "coupangcdn.com/image//" 이중 슬래시는 https 로 403 이 난다
        cdnImg(url) {
            if (typeof url !== 'string' || !url.includes('coupangcdn.com')) return url;
            return url
                .replace(/^http:\/\/([^/]*coupangcdn\.com)/, 'https://$1')
                .replace(/(coupangcdn\.com\/image)\/{2,}/, '$1/');
        },
        printBarcodeFromPurchase(item) {
            this.출력바코드 = item.바코드;
            this.출력상품명 = item.상품명;
            this.한글표시사항print = {
                '수입원/판매원': item.한글표시사항?.['수입원/판매원'] || '',
                제조원: item.한글표시사항?.제조원 || '',
                제조국: item.한글표시사항?.제조국 || '',
                내용량: item.한글표시사항?.내용량 || '',
                '원료명및성분명(재질)': item.한글표시사항?.['원료명및성분명(재질)'] || '',
                상품유형: item.한글표시사항?.상품유형 || '',
                사용시주의사항: item.한글표시사항?.사용시주의사항 || '',
                사용기준: item.한글표시사항?.사용기준 || '',
                custom: item.한글표시사항?.custom || '',
                kc인증: item.한글표시사항?.kc인증 || false,
                식품용: item.한글표시사항?.식품용 || false,
            };
            this.printkcenable = item.한글표시사항?.kc인증 || false;
            this.printfoodenable = item.한글표시사항?.식품용 || false;
            this.출력수량 = 1;
            setTimeout(() => {
                this.printBarcode('printBarcodeArea');
            }, 10);
        },
        async printBarcode(id) {
            var options = {
                name: '_blank',
                autoClose: true,
            }
            await this.$htmlToPaper(id, options);
        },
        barcodegap(index, total) {
            if (index < total) {
                return 'margin-top:' + this.바코드간격 + 'px;margin-bottom:0px;'
            } else {
                return 'margin-top:0px;margin-bottom:0px;'
            }
        },
        /**
         * 상품주문번호 생성 (화주주문번호-0001 형식)
         */
        getItemOrderNumber(item) {
            if (!this.selectedGroup) return '-';
            const group = this.selectedGroup;
            const itemIndex = group.items.findIndex(i => i._id === item._id);
            const seqNum = String(itemIndex + 1).padStart(4, '0');

            if (group.화주주문번호) {
                return `${group.화주주문번호}-${seqNum}`;
            } else {
                // 화주주문번호가 없으면 요청일 기반으로 생성
                const date = new Date(group.요청일);
                const yymmdd = date.getFullYear().toString().slice(-2) +
                    String(date.getMonth() + 1).padStart(2, '0') +
                    String(date.getDate()).padStart(2, '0');
                return `${yymmdd}-${seqNum}`;
            }
        },



        /**
         * 그룹의 1688 주문에서 가격 수정 정보 확인
         */
        async checkPriceModification(group) {
            if (!group.items || group.items.length === 0) {
                this.$bvToast.toast('没有商品信息 / 상품 정보가 없습니다.', { title: '错误 / 오류', variant: 'warning', solid: true });
                return;
            }

            // 1688주문번호별로 아이템 그룹핑 (여러 공급업체 = 여러 주문번호)
            const orderIdGroups = {};
            group.items.forEach(item => {
                const oid = item.주문정보?.['1688주문번호'];
                if (oid) {
                    if (!orderIdGroups[oid]) orderIdGroups[oid] = [];
                    orderIdGroups[oid].push(item);
                }
            });

            const orderIds = Object.keys(orderIdGroups);
            if (orderIds.length === 0) {
                this.$bvToast.toast('没有1688订单号 / 1688 주문번호가 없습니다.', { title: '错误 / 오류', variant: 'warning', solid: true });
                return;
            }

            this.checkingPrice = true;
            let totalUpdated = 0;
            const errors = [];

            try {
                for (const orderId of orderIds) {
                    const orderItems = orderIdGroups[orderId];
                    try {
                        const response = await axios.post('/api/reqpurchase/checkPriceModification', {
                            orderId: orderId,
                            reqItems: orderItems.map(item => ({
                                _id: item._id,
                                상품ID: item.상품ID || item.productId,
                                SKU: item.SKU || item.specId
                            }))
                        });

                        if (response.data.요청결과 === '성공') {
                            // 서버가 요청건별로 나눠 저장한 값을 그대로 쓴다(품목을 여기서 다시 맞추면 같은 상품 다른 옵션이 섞인다)
                            const perDoc = response.data.perDoc || {};
                            const 주문배송비 = response.data.orderSummary?.주문배송비 || 0;

                            orderItems.forEach(item => {
                                if (!item.주문정보) item.주문정보 = {};
                                const saved = perDoc[item._id];
                                if (saved) {
                                    Object.assign(item.주문정보, saved);
                                    totalUpdated++;
                                }
                                item.주문정보.협상후_주문배송비 = 주문배송비;
                            });
                        } else {
                            errors.push(`주문 ${orderId}: ${response.data.error?.errorMessage || '실패'}`);
                        }
                    } catch (err) {
                        console.error(`가격확인 오류 (주문 ${orderId}):`, err);
                        errors.push(`주문 ${orderId}: ${err.message}`);
                    }
                }

                if (totalUpdated > 0) {
                    this.$bvToast.toast(`协商后价格已更新 (${totalUpdated}个商品, ${orderIds.length}个订单) / 협상후 가격이 업데이트되었습니다.`, {
                        title: '价格确认完成 / 가격 확인 완료',
                        variant: 'success',
                        solid: true
                    });
                }
                if (errors.length > 0) {
                    this.$bvToast.toast(errors.join('\n'), {
                        title: '部分价格确认失败 / 일부 가격 확인 실패',
                        variant: 'warning',
                        solid: true
                    });
                }

                // 데이터 새로고침
                this.search();
            } catch (error) {
                console.error('가격 수정 확인 오류:', error);
                this.$bvToast.toast('价格修改确认出错 / 가격 수정 확인 중 오류가 발생했습니다.', {
                    title: '错误 / 오류',
                    variant: 'danger',
                    solid: true
                });
            } finally {
                this.checkingPrice = false;
            }
        },

        /**
         * 견적서 모달 열기
         */
        // 견적서 생성 폼 초기값 (모달 열기·합친 청구서 자동 보충 공용)
        initQuotationFormFor(group) {
            const firstItem = group.items?.[0];
            const customsType = firstItem?.요청내역?.customsType || firstItem?.통관방법 || 'integrated';
            // 단독통관 기본값 = 1688 주문일 환율(첫 주문건 기준, 요청별 실제 값은 quoteRateForItem). 주문 전이면 기존처럼 현재 환율.
            const orderFx = (group.items || []).map(i => this.cnyRateForOrder(i)).find(Boolean);
            this.quotation1688Form = {
                customsType: customsType === '통합통관' ? 'integrated' : customsType === '쿠패스단독통관' ? 'kupass' : customsType === '화주단독통관' ? 'client' : customsType,
                환율: (customsType === 'integrated' || customsType === '통합통관') ? (this.integratedExchangeRate || 300) : ((orderFx && orderFx.rate) || group.적용환율 || this.exchangeRate?.cashBuyValue || 190),
                환율수동: false,
                메모: ''
            };
        },
        async openQuotationModal(group) {
            this.quotationGroup = group;
            this.quotationEditOverrides = {};
            this.quotationOrderShippingOverrides = {};

            // 견적서 생성 폼 초기화
            this.initQuotationFormFor(group);

            // 공통물류비 데이터 조회
            this.quotationCommonLogistics = null;
            const 화주주문번호 = group.화주주문번호;
            const companyid = group.companyid;
            if (화주주문번호 && companyid) {
                try {
                    const res = await axios.get(`/api/quotation/getCommonLogistics/${encodeURIComponent(화주주문번호)}/${encodeURIComponent(companyid)}`);
                    if (res.data.요청결과 === '성공' && res.data.data) {
                        this.quotationCommonLogistics = res.data.data;
                    }
                } catch (e) { console.error('공통물류비 조회 오류:', e); }
            }

            this.$bvModal.show('quotation-modal');
        },

        /**
         * 견적서 엑셀 다운로드
         */
        downloadQuotationExcel(group) {
            if (!group || !group.items) return;

            const processed = this.quotationGroupItemsProcessed || [];
            const 통관타입텍스트 = group.items[0]?.견적서_1688구매금액?.customsType === 'integrated' ? '통합통관'
                : group.items[0]?.견적서_1688구매금액?.customsType === 'kupass' ? '쿠패스단독'
                : group.items[0]?.견적서_1688구매금액?.customsType === 'client' ? '화주단독'
                : group.items[0]?.통관방법 || '';
            const 적용환율 = processed[0]?._적용환율 || group.적용환율 || '';
            const firstItem = group.items[0];

            const data = processed.map(item => {
                return {
                    '화주주문번호': group.화주주문번호 || '',
                    '상호': group.companyid || '',
                    '화주명': group.companyName || '',
                    '통관방식': 통관타입텍스트,
                    '적용환율': 적용환율,
                    '사업자등록번호': firstItem?.입금정보?.사업자등록번호 || '',
                    '대표자명': firstItem?.입금정보?.대표자명 || '',
                    '이메일': firstItem?.입금정보?.이메일주소 || '',
                    '상품명': item.상품명,
                    '옵션ID': item.SKUID || '',
                    '바코드': item.바코드 || '',
                    '수량': item.구매요청수량 || 1,
                    '협상전_단가(CNY)': item._협상전_단가 || 0,
                    '협상전_개별배송비(CNY)': item._협상전_배송비 || 0,
                    '협상전_총배송비(CNY)': item._preOrderShipping || 0,
                    '협상전_합계(CNY)': item._협상전_총금액 || 0,
                    '협상후_단가(CNY)': item._협상후_단가 || '',
                    '협상후_개별배송비(CNY)': item._협상후_배송비 || '',
                    '협상후_총배송비(CNY)': item._postOrderShipping || '',
                    '협상후_합계(CNY)': item.주문정보?.협상후_총금액 || '',
                    '할인율(%)': item._할인율 || '',
                    '부가세(KRW)': item._부가세 || '',
                    '총금액(KRW)': item._최종금액_KRW || '',
                    '중국물류비(KRW)': item._중국물류비 || '',
                    '공통배분(KRW)': item._공통배분 || '',
                    '한국물류비(KRW)': item._한국물류비 || ''
                };
            });

            // 합계 행
            const totalKRW = processed.reduce((s, i) => s + (i._최종금액_KRW || 0), 0);
            const total부가세 = processed.reduce((s, i) => s + (i._부가세 || 0), 0);
            const total중국물류비 = processed.reduce((s, i) => s + (i._중국물류비 || 0), 0);
            const total공통배분 = processed.reduce((s, i) => s + (i._공통배분 || 0), 0);
            const total한국물류비 = processed.reduce((s, i) => s + (i._한국물류비 || 0), 0);
            data.push({
                '상품명': '합계',
                '부가세(KRW)': total부가세,
                '총금액(KRW)': totalKRW,
                '중국물류비(KRW)': total중국물류비,
                '공통배분(KRW)': total공통배분,
                '한국물류비(KRW)': total한국물류비
            });

            // XLSX 다운로드
            const ws = XLSX.utils.json_to_sheet(data);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, '견적서');
            XLSX.writeFile(wb, `견적서_${group.companyid}_${group.요청일}.xlsx`);

            this.$bvToast.toast('Excel已下载 / 엑셀 파일이 다운로드되었습니다.', { title: '下载完成 / 다운로드 완료', variant: 'success', solid: true });
        },

        /**
         * 견적서 PDF 다운로드 (간단 버전 - 새 탭에서 인쇄)
         */
        downloadQuotationPDF(group) {
            const processed = this.quotationGroupItemsProcessed || [];
            const firstItem = group.items[0];
            const 통관타입 = firstItem?.견적서_1688구매금액?.customsType === 'integrated' ? '통합통관'
                : firstItem?.견적서_1688구매금액?.customsType === 'kupass' ? '쿠패스단독'
                : firstItem?.견적서_1688구매금액?.customsType === 'client' ? '화주단독'
                : firstItem?.통관방법 || '-';
            const 적용환율 = processed[0]?._적용환율 || group.적용환율 || '-';

            let html = `
                <html><head><title>견적서</title>
                <style>
                    @page { size: A4 landscape; margin: 8mm; }
                    body { font-family: 'Malgun Gothic', sans-serif; padding: 8px; font-size: 9px; }
                    table { width: 100%; border-collapse: collapse; margin-top: 8px; }
                    th, td { border: 1px solid #333; padding: 2px 3px; text-align: center; }
                    thead { display: table-header-group; }
                    tfoot { display: table-row-group; }
                    tr { break-inside: avoid; page-break-inside: avoid; }
                    tbody td:first-child { min-width: 160px; text-align: left; }
                    th { background: #f0f0f0; }
                    .right { text-align: right; }
                    .header { margin-bottom: 15px; }
                    .info-table { border: none; margin-bottom: 10px; }
                    .info-table td { border: none; padding: 2px 10px 2px 0; text-align: left; }
                </style>
                </head><body>
                <div class="header">
                    <h2>견적서 (报价单)</h2>
                    <table class="info-table">
                        <tr><td><strong>화주주문번호:</strong> ${group.화주주문번호 || '-'}</td><td><strong>상호:</strong> ${group.companyid}</td><td><strong>화주명:</strong> ${group.companyName}</td></tr>
                        <tr><td><strong>통관방식:</strong> ${통관타입}</td><td><strong>적용환율:</strong> ${적용환율}원/元</td><td><strong>요청일:</strong> ${group.요청일}</td></tr>
                        <tr><td><strong>사업자등록번호:</strong> ${firstItem?.입금정보?.사업자등록번호 || '-'}</td><td><strong>대표자명:</strong> ${firstItem?.입금정보?.대표자명 || '-'}</td><td><strong>이메일:</strong> ${firstItem?.입금정보?.이메일주소 || '-'}</td></tr>
                    </table>
                </div>
                <table>
                    <thead>
                        <tr>
                            <th rowspan="2">상품명</th><th rowspan="2">바코드</th><th rowspan="2">수량</th>
                            <th colspan="3" style="background:#e8f4fd;">협상전 (CNY)</th>
                            <th colspan="3" style="background:#fff3cd;">협상후 (CNY)</th>
                            ${processed.length > 1 ? '' : '<th rowspan="2">부가세(KRW)</th><th rowspan="2">총금액(KRW)</th>'}
                        </tr>
                        <tr>
                            <th style="background:#e8f4fd;">단가</th><th style="background:#e8f4fd;">총배송비</th><th style="background:#e8f4fd;">합계</th>
                            <th style="background:#fff3cd;">단가</th><th style="background:#fff3cd;">총배송비</th><th style="background:#fff3cd;">합계</th>
                        </tr>
                    </thead>
                    <tbody>`;

            processed.forEach(item => {
                const showOrderShip = item._isFirstInOrder;
                const rowspan = item._orderRowspan;

                html += `<tr>
                    <td>${item.상품명}</td>
                    <td>${item.바코드 || '-'}</td>
                    <td>${item.구매요청수량 || 1}</td>
                    <td class="right">¥${(item._협상전_단가 || 0).toLocaleString()}</td>
                    ${showOrderShip ? `<td class="right" rowspan="${rowspan}" style="background:#f0f8ff;">¥${(item._preOrderShipping || 0).toLocaleString()}</td>` : ''}
                    ${showOrderShip ? `<td class="right" rowspan="${rowspan}" style="background:#f0f8ff;">¥${(item._orderPreTotal || 0).toLocaleString()}</td>` : ''}
                    <td class="right">${item._협상후_단가 ? '¥' + item._협상후_단가.toLocaleString() : '-'}</td>
                    ${showOrderShip ? `<td class="right" rowspan="${rowspan}" style="background:#fff8e1;">¥${(item._postOrderShipping || 0).toLocaleString()}</td>` : ''}
                    ${showOrderShip ? `<td class="right" rowspan="${rowspan}" style="background:#fff8e1;">¥${(item._orderPostTotal || 0).toLocaleString()}</td>` : ''}
                    ${processed.length > 1 ? '' : '<td class="right">' + (item._부가세 ? '₩' + item._부가세.toLocaleString() : '-') + '</td>'}
                    ${processed.length > 1 ? '' : '<td class="right">' + (item._최종금액_KRW ? '₩' + item._최종금액_KRW.toLocaleString() : '-') + '</td>'}
                </tr>`;
            });

            const total부가세 = processed.reduce((s, i) => s + (i._부가세 || 0), 0);
            const totalKRW = processed.reduce((s, i) => s + (i._최종금액_KRW || 0), 0);

            html += `</tbody>
                <tfoot><tr style="background:#ddd; font-weight:bold;">
                    <td colspan="9" class="right">합계${processed.length > 1 ? ' · 부가세 ₩' + total부가세.toLocaleString() + ' · 총금액 ₩' + totalKRW.toLocaleString() : ''}</td>
                    ${processed.length > 1 ? '' : '<td class="right">₩' + total부가세.toLocaleString() + '</td><td class="right">₩' + totalKRW.toLocaleString() + '</td>'}
                </tr></tfoot></table>
                <scr` + `ipt>window.print();</scr` + `ipt>
                </bo` + `dy></ht` + `ml>`;

            const printWindow = window.open('', '_blank');
            printWindow.document.write(html);
            printWindow.document.close();
        },

        /**
         * 发送到客户Kakao / 카카오로 보내기 (YZY 10-07, ①안 #45)
         * 작업사진·청구서 그림·청구 금액을 자동으로 묶어 두고, 이 화주의 카카오 상담창을 연다.
         * ★ 여기서 보내지 않는다 — 상담창 옆 CS 助手 창에서 직원이 미리보기를 보고 「확인」을 눌러야 나간다.
         * 청구 금액 = PDF 의 총금액 합계와 같은 값(_최종금액_KRW 합).
         */
        async sendQuotationToKakao(group) {
            const title = 'Kakao (카카오로 보내기)';
            if (!group || !group.items || !group.items.length) return;
            if (this.quotationGroupUnquotedItems.length) {
                this.$bvToast.toast(`有未发送报价单的商品 ${this.quotationGroupUnquotedItems.length}件，请先发送报价单 / 견적서 미전송 상품이 있습니다 — 먼저 견적서를 보내세요`, { title, variant: 'warning', solid: true });
                return;
            }
            this.kakaoSending = true;
            try {
                const rows = this.quotationGroupItemsProcessed || [];
                const amountKRW = rows.reduce((s, r) => s + (r._최종금액_KRW || 0), 0);
                const customsType = group.items[0]?.견적서_1688구매금액?.customsType || group.items[0]?.통관방법 || '';
                // 헤더 9항목 = 견적서 PDF 헤더와 같은 값(새 계산·새 필드 없음). 요청일만 사람이 읽는 날짜로
                const first = group.items[0];
                const header = {
                    '화주주문번호': group.화주주문번호,
                    '상호': group.companyid,
                    '화주명': group.companyName,
                    '통관방식': customsType === 'integrated' ? '통합통관' : customsType === 'kupass' ? '쿠패스단독' : customsType === 'client' ? '화주단독' : customsType,
                    '적용환율': (rows[0]?._적용환율 || group.적용환율) ? (rows[0]?._적용환율 || group.적용환율) + '원/元' : '',
                    '요청일': this.getTimeDate(group.요청일),
                    '사업자등록번호': first?.입금정보?.사업자등록번호,
                    '대표자명': first?.입금정보?.대표자명,
                    '이메일': first?.입금정보?.이메일주소
                };
                const r = await prepareKakaoSend({ group, amountKRW, rows, customsType, header });
                if (r.chatUrl) {
                    window.open(r.chatUrl, '_blank');
                    this.$bvToast.toast(`已打开客户的Kakao聊天。请在「CS 助手」窗口确认后发送(照片 ${r.photoCount}张) / 고객 카카오 상담창을 열었습니다. CS 助手 창에서 확인하고 보내세요 (사진 ${r.photoCount}장)`, { title, variant: 'success', solid: true, autoHideDelay: 8000 });
                } else {
                    this.$bvToast.toast('没有找到与该货主关联的Kakao聊天。请手动打开该客户的聊天，「CS 助手」窗口会显示要发送的内容 / 이 화주와 연결된 카카오 상담창을 찾지 못했습니다. 상담창을 직접 열면 CS 助手 창에 보낼 내용이 뜹니다', { title, variant: 'warning', solid: true, autoHideDelay: 10000 });
                }
            } catch (e) {
                console.error('카카오로 보내기 준비 오류:', e);
                this.$bvToast.toast('准备失败，请稍后再试 / 준비하지 못했습니다. 잠시 후 다시 시도해 주세요', { title, variant: 'danger', solid: true });
            } finally {
                this.kakaoSending = false;
            }
        },

        /**
         * 合并请款单 / 합친 청구서 (崔凡 10-07)
         * 같은 화주가 함께 산 여러 건을 한 장의 청구서로 보낸다. 견적·입금상태는 건별 그대로 두고
         * (매입가는 건 단위 — docs/coupass-logistics-chain.md §2·§4), 여기서는 건별 견적서를 묶어 보여주기만 한다.
         * 묶음 표시는 각 요청건의 청구묶음id 하나뿐이다.
         */
        mergedBillIdOf(group) {
            return (group?.items || []).map(i => i.청구묶음id).find(Boolean) || '';
        },
        openMergedBillFromSelection() {
            let groups;
            if (this.viewMode === 'group') {
                groups = this.tableSelectedItem;
            } else {
                const ids = new Set(this.tableSelectedItem.map(i => String(i._id)));
                groups = this.groupedReqlists.filter(g => g.items.some(i => ids.has(String(i._id))));
            }
            if (!groups.length) {
                this.$bvToast.toast('请先勾选要合并的行 / 합칠 행을 선택하세요', { title: '合并请款单 / 청구서 합치기', variant: 'warning', solid: true });
                return;
            }
            return this.buildMergedBill(groups);
        },
        openMergedBillById(id) {
            if (!id) return;
            const groups = this.groupedReqlists.filter(g => g.items.some(i => i.청구묶음id === id));
            const shown = groups.reduce((s, g) => s + g.items.filter(i => i.청구묶음id === id).length, 0);
            const all = (this.reqlistsinit || []).filter(i => i.청구묶음id === id).length;
            const extra = all > shown ? [`部分件不在当前列表 / 묶음 ${id} 의 ${all - shown}개 상품이 현재 목록(필터) 밖에 있습니다`] : [];
            return this.buildMergedBill(groups, extra);
        },
        /**
         * 건(그룹) 하나의 견적서 행 — 견적서 모달과 똑같은 계산(quotationGroupItemsProcessed)을 그대로 떠온다.
         * 견적서가 없는 상품은 buildMergedBill 이 먼저 자동 보충한다. 그래도 못 만든 상품만 금액을 비워 둔다.
         */
        async snapshotQuotationRows(group) {
            let common = null;
            if (group.화주주문번호 && group.companyid) {
                try {
                    const res = await axios.get(`/api/quotation/getCommonLogistics/${encodeURIComponent(group.화주주문번호)}/${encodeURIComponent(group.companyid)}`);
                    if (res.data.요청결과 === '성공' && res.data.data) common = res.data.data;
                } catch (e) { console.error('공통물류비 조회 오류(합친 청구서):', e); }
            }
            const prev = [this.quotationGroup, this.quotationCommonLogistics, this.quotationEditOverrides, this.quotationOrderShippingOverrides];
            this.quotationGroup = group;
            this.quotationCommonLogistics = common;
            this.quotationEditOverrides = {};
            this.quotationOrderShippingOverrides = {};
            const rows = this.quotationGroupItemsProcessed.map(r => {
                const q = r.견적서_1688구매금액;
                const 미생성 = !q || !!q.미입력;
                return 미생성 ? { ...r, _미생성: true, _최종금액_KRW: 0, _부가세: 0 } : { ...r, _미생성: false };
            });
            [this.quotationGroup, this.quotationCommonLogistics, this.quotationEditOverrides, this.quotationOrderShippingOverrides] = prev;
            return rows;
        },
        customsTextOf(group) {
            const ct = group.items?.[0]?.견적서_1688구매금액?.customsType;
            return ct === 'integrated' ? '통합통관' : ct === 'kupass' ? '쿠패스단독' : ct === 'client' ? '화주단독' : (group.통관방법 || '-');
        },
        /**
         * 합친 청구서용 견적서 자동 보충 — 견적서가 없는 «미결제» 건만, 견적서 모달의 «일괄 생성»(submitQuotationBatch)과 같은 길로 만든다.
         * 가격 규칙(협상후 비면 협상전, 협상후가 있으면 협상후)은 그 길(negoUnitCny)이 이미 따른다. 입금 끝난 건은 건드리지 않는다.
         */
        async autoCreateMissingQuotations(groups) {
            const prev = [this.quotationGroup, this.quotationEditOverrides, this.quotationOrderShippingOverrides, this.quotation1688Form];
            try {
                for (const g of groups) {
                    if (!itemsNeedingQuotation(g).length) continue;
                    const unpaidItems = (g.items || []).filter(i => !isPaidItem(i));
                    this.quotationGroup = { ...g, items: unpaidItems };
                    this.quotationEditOverrides = {};
                    this.quotationOrderShippingOverrides = {};
                    this.initQuotationFormFor(this.quotationGroup);
                    await this.submitQuotationBatch();
                }
            } catch (e) {
                console.error('합친 청구서 견적서 자동 보충 오류:', e);
            } finally {
                [this.quotationGroup, this.quotationEditOverrides, this.quotationOrderShippingOverrides, this.quotation1688Form] = prev;
            }
        },
        async buildMergedBill(groups, extraWarnings = []) {
            const companies = [...new Set(groups.map(g => g.companyid))];
            if (companies.length > 1) {
                this.$bvToast.toast(`只能合并同一货主 / 같은 화주만 합칠 수 있습니다 (${companies.join(', ')})`, { title: '合并请款单 / 청구서 합치기', variant: 'danger', solid: true });
                return;
            }
            // 이미 입금 끝난 건은 합병 대상이 아니다 — 목록에서 빼고 견적 보충도 하지 않는다 (崔凡 10-26)
            const { kept, paidOut } = splitPaidGroups(groups);
            groups = kept;
            if (!groups.length) {
                this.$bvToast.toast('已入账的件不能合并 / 이미 입금된 건은 합칠 수 없습니다', { title: '合并请款单 / 청구서 합치기', variant: 'warning', solid: true });
                return;
            }
            extraWarnings = [...extraWarnings];
            if (paidOut.length) extraWarnings.push(`已入账 ${paidOut.length}件 已除外 / 이미 입금된 ${paidOut.length}건은 합병에서 제외했습니다`);
            // 견적서가 없는 미결제 건은 서버 견적 생성(create1688)으로 자동 보충한다 — 직원이 건마다 누르던 것을 대신한다
            await this.autoCreateMissingQuotations(groups);
            const sorted = [...groups].sort((a, b) => (a.요청일 || 0) - (b.요청일 || 0));
            const billGroups = [];
            for (const g of sorted) {
                const rows = await this.snapshotQuotationRows(g);
                billGroups.push({
                    src: g,
                    groupKey: g.groupKey,
                    요청일: g.요청일,
                    화주주문번호목록: g.화주주문번호목록?.length ? g.화주주문번호목록 : (g.화주주문번호 ? [g.화주주문번호] : []),
                    통관: this.customsTextOf(g),
                    환율: rows[0]?._적용환율 || g.적용환율 || '',
                    입금여부: !!g.입금여부,
                    rows,
                    소계: rows.reduce((s, r) => s + (r._최종금액_KRW || 0), 0)
                });
            }
            const allRows = billGroups.flatMap(g => g.rows);
            const sum = k => allRows.reduce((s, r) => s + (r[k] || 0), 0);
            const label = g => g.화주주문번호목록.join(',') || this.getTimeDate(g.요청일);

            const warnings = [...extraWarnings];
            const customs = [...new Set(billGroups.map(g => g.통관))];
            if (customs.length > 1) warnings.push(`清关方式不同 / 통관방식이 다른 건이 섞여 있습니다: ${customs.join(' · ')}`);
            const rates = [...new Set(billGroups.map(g => String(g.환율)))];
            if (rates.length > 1) warnings.push(`汇率不同 / 환율이 다른 건이 섞여 있습니다: ${rates.join(' · ')}`);
            const paid = billGroups.filter(g => g.입금여부);
            if (paid.length) warnings.push(`已入账 / 이미 입금된 건이 있습니다: ${paid.map(label).join(' · ')}`);
            const unquoted = allRows.filter(r => r._미생성).length;
            if (unquoted) warnings.push(`未报价 / 견적서가 없는 상품 ${unquoted}개는 합계에서 빠졌습니다 — 각 건 견적서를 먼저 보내세요`);

            // 묶음번호: 모든 상품이 같은 청구묶음id 를 갖고 있을 때만 「저장된 묶음」 으로 본다
            const tagIds = [...new Set(allRows.map(r => r.청구묶음id || ''))];
            const 청구묶음id = tagIds.length === 1 && tagIds[0] ? tagIds[0] : '';
            const others = tagIds.filter(Boolean).filter(id => id !== 청구묶음id);
            if (others.length) warnings.push(`已在其他合并中 / 다른 묶음에 들어 있는 건이 있습니다: ${others.join(', ')} — 저장하면 이 묶음으로 바뀝니다`);

            const first = groups[0];
            this.mergedBill = {
                companyid: first.companyid,
                companyName: first.companyName,
                입금정보: allRows.map(r => r.입금정보).find(Boolean) || {},
                청구묶음id,
                groups: billGroups,
                warnings,
                합계: { 부가세: sum('_부가세'), 총금액: sum('_최종금액_KRW'), 중국물류비: sum('_중국물류비'), 공통배분: sum('_공통배분'), 한국물류비: sum('_한국물류비') }
            };
            this.$bvModal.show('merged-bill-modal');
        },
        mergedBillItems() {
            return (this.mergedBill?.groups || []).flatMap(g => g.src.items || []);
        },
        async saveMergedBillTag() {
            if (!this.mergedBill || this.mergedBillSaving) return;
            const d = new Date();
            const p = n => String(n).padStart(2, '0');
            const id = `MB${String(d.getFullYear()).slice(2)}${p(d.getMonth() + 1)}${p(d.getDate())}-${Math.random().toString(36).slice(2, 6).toUpperCase()}`;
            await this.writeMergedBillTag(id);
        },
        async releaseMergedBillTag() {
            if (!this.mergedBill || this.mergedBillSaving) return;
            if (!confirm(`解除合并 ${this.mergedBill.청구묶음id}? / 묶음을 해제할까요? (각 건 견적·입금상태는 그대로)`)) return;
            await this.writeMergedBillTag('');
        },
        async writeMergedBillTag(id) {
            const items = this.mergedBillItems();
            this.mergedBillSaving = true;
            try {
                // 청구묶음id 한 필드만 보낸다(구매id 를 안 실어 Purchase 쪽은 건드리지 않는다)
                await this.updatereqlist(items.map(i => ({ _id: i._id, 청구묶음id: id })));
                items.forEach(i => this.$set(i, '청구묶음id', id));
                this.mergedBill.groups.forEach(g => g.rows.forEach(r => { r.청구묶음id = id; }));
                this.mergedBill.청구묶음id = id;
                this.mergedBill.warnings = this.mergedBill.warnings.filter(w => !w.startsWith('已在其他合并中'));
                this.$bvToast.toast(id ? `合并已保存 / 묶음 저장: ${id}` : '合并已解除 / 묶음 해제됨', { title: '合并请款单 / 합친 청구서', variant: 'success', solid: true });
            } catch (e) {
                console.error('청구묶음 저장 오류:', e);
                this.$bvToast.toast('保存失败 / 묶음 저장 중 오류가 발생했습니다', { title: '错误 / 오류', variant: 'danger', solid: true });
            } finally {
                this.mergedBillSaving = false;
            }
        },
        /**
         * 묶음 입금확인 — 포함된 각 건을 단건 입금확인(togglePaymentStatus)과 같은 필드·같은 저장 경로로 처리한다.
         * 견적서가 없는 상품이 있는 건은 빼고 알린다.
         */
        async confirmMergedBillPayment() {
            if (!this.mergedBill || this.mergedBillSaving) return;
            const targets = this.mergedBill.groups.filter(g => !g.입금여부 && !g.rows.some(r => r._미생성));
            const skipped = this.mergedBill.groups.filter(g => !g.입금여부 && g.rows.some(r => r._미생성));
            if (!targets.length) {
                this.$bvToast.toast('没有可确认的件 / 입금확인할 건이 없습니다 (견적서 미생성 건 제외)', { title: '合并确认入账 / 묶음 입금확인', variant: 'warning', solid: true });
                return;
            }
            const total = targets.reduce((s, g) => s + g.소계, 0);
            const msg = `${this.mergedBill.companyid} ${targets.length}件 ₩${total.toLocaleString()} 入账确认? / 입금완료로 변경할까요?`
                + (skipped.length ? `\n(未报价 ${skipped.length}件 제외 / 견적서 없는 건 제외)` : '');
            if (!confirm(msg)) return;
            this.mergedBillSaving = true;
            try {
                const now = new Date().toISOString();
                const items = targets.flatMap(g => g.src.items || []);
                for (const item of items) {
                    item.입금여부 = true;
                    item.입금일시 = now;
                }
                await this.updatereqlist(items);
                targets.forEach(g => { g.입금여부 = true; g.src.입금여부 = true; });
                this.$bvToast.toast(`入账确认 ${targets.length}件 / 입금완료 ${targets.length}건`, { title: '合并确认入账 / 묶음 입금확인', variant: 'success', solid: true });
            } catch (e) {
                console.error('묶음 입금확인 오류:', e);
                this.$bvToast.toast('入账确认失败 / 묶음 입금확인 중 오류가 발생했습니다', { title: '错误 / 오류', variant: 'danger', solid: true });
            } finally {
                this.mergedBillSaving = false;
            }
        },
        downloadMergedBillExcel() {
            const b = this.mergedBill;
            if (!b) return;
            const data = [];
            b.groups.forEach(g => g.rows.forEach(r => data.push({
                '청구묶음': b.청구묶음id || '',
                '상호': b.companyid || '',
                '화주명': b.companyName || '',
                '통관방식': g.통관,
                '적용환율': g.환율,
                '입금여부': g.입금여부 ? '입금완료' : '미입금',
                '상품명': r.상품명,
                '옵션ID': r.SKUID || '',
                '바코드': r.바코드 || '',
                '수량': r.구매요청수량 || 1,
                '협상후_합계(CNY)': r.주문정보?.협상후_총금액 || '',
                '할인율(%)': r._할인율 || '',
                '부가세(KRW)': r._미생성 ? '' : (r._부가세 || ''),
                '총금액(KRW)': r._미생성 ? '견적 미생성' : (r._최종금액_KRW || ''),
                '중국물류비(KRW)': r._중국물류비 || '',
                '공통배분(KRW)': r._공통배분 || '',
                '한국물류비(KRW)': r._한국물류비 || ''
            })));
            data.push({
                '상품명': '합계',
                '부가세(KRW)': b.합계.부가세,
                '총금액(KRW)': b.합계.총금액,
                '중국물류비(KRW)': b.합계.중국물류비,
                '공통배분(KRW)': b.합계.공통배분,
                '한국물류비(KRW)': b.합계.한국물류비
            });
            const ws = XLSX.utils.json_to_sheet(data);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, '청구서');
            XLSX.writeFile(wb, `청구서_${b.companyid}_${b.청구묶음id || b.groups.length + '건'}.xlsx`);
        },
        downloadMergedBillPDF() {
            const b = this.mergedBill;
            if (!b) return;
            const esc = v => String(v == null ? '' : v).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
            const won = v => (v ? '₩' + v.toLocaleString() : '-');
            let html = `
                <html><head><title>청구서</title>
                <style>
                    body { font-family: 'Malgun Gothic', sans-serif; padding: 20px; font-size: 12px; }
                    table { width: 100%; border-collapse: collapse; margin-top: 15px; }
                    th, td { border: 1px solid #333; padding: 5px 6px; text-align: center; }
                    th { background: #f0f0f0; }
                    .right { text-align: right; }
                    .grp td { background: #e8f4fd; text-align: left; font-weight: bold; }
                    .info-table { border: none; margin-bottom: 10px; }
                    .info-table td { border: none; padding: 2px 10px 2px 0; text-align: left; }
                </style>
                </head><body>
                <h2>청구서 (请款单)</h2>
                <table class="info-table">
                    <tr><td><strong>상호:</strong> ${esc(b.companyid)}</td><td><strong>화주명:</strong> ${esc(b.companyName)}</td><td><strong>청구묶음:</strong> ${esc(b.청구묶음id || '-')}</td></tr>
                    <tr><td><strong>사업자등록번호:</strong> ${esc(b.입금정보.사업자등록번호 || '-')}</td><td><strong>대표자명:</strong> ${esc(b.입금정보.대표자명 || '-')}</td><td><strong>이메일:</strong> ${esc(b.입금정보.이메일주소 || '-')}</td></tr>
                </table>
                <table>
                    <thead><tr>
                        <th>상품명</th><th>옵션ID</th><th>바코드</th><th>수량</th><th>협상후 합계(CNY)</th><th>할인율(%)</th>
                        <th>부가세(KRW)</th><th>총금액(KRW)</th><th>중국물류비</th><th>공통배분</th><th>한국물류비</th>
                    </tr></thead>`;
            b.groups.forEach(g => {
                html += `<tbody><tr class="grp"><td colspan="11">${esc(g.통관)} · 환율 ${esc(g.환율 || '-')} · 소계 ₩${g.소계.toLocaleString()}</td></tr>`;
                g.rows.forEach(r => {
                    html += `<tr>
                        <td>${esc(r.상품명)}</td><td>${esc(r.SKUID || '-')}</td><td>${esc(r.바코드 || '-')}</td><td>${r.구매요청수량 || 1}</td>
                        <td class="right">${r.주문정보?.협상후_총금액 != null ? '¥' + r.주문정보.협상후_총금액.toLocaleString() : (r._未改价 ? '¥' + r._협상전_총금액.toLocaleString() + ' 未改价' : '-')}</td>
                        <td>${r._할인율 ? r._할인율 + '%' : '-'}</td>
                        <td class="right">${won(r._부가세)}</td>
                        <td class="right">${r._미생성 ? '견적 미생성' : won(r._최종금액_KRW)}</td>
                        <td class="right">${won(r._중국물류비)}</td><td class="right">${won(r._공통배분)}</td><td class="right">${won(r._한국물류비)}</td>
                    </tr>`;
                });
                html += `</tbody>`;
            });
            html += `<tfoot><tr style="background:#ddd; font-weight:bold;">
                    <td colspan="6" class="right">합계</td>
                    <td class="right">₩${b.합계.부가세.toLocaleString()}</td>
                    <td class="right">₩${b.합계.총금액.toLocaleString()}</td>
                    <td class="right">₩${b.합계.중국물류비.toLocaleString()}</td>
                    <td class="right">₩${b.합계.공통배분.toLocaleString()}</td>
                    <td class="right">₩${b.합계.한국물류비.toLocaleString()}</td>
                </tr></tfoot></table>
                <h3 style="text-align:right;">청구 합계: ₩${b.합계.총금액.toLocaleString()}</h3>
                <scr` + `ipt>window.print();</scr` + `ipt>
                </bo` + `dy></ht` + `ml>`;
            const w = window.open('', '_blank');
            if (!w) { console.error('합친 청구서 PDF: 팝업이 차단됐습니다'); return; }
            w.document.write(html);
            w.document.close();
        },

        /**
         * 입금여부 토글
         */
        async togglePaymentStatus(group, newStatus) {
            if (!group.items || group.items.length === 0) return;

            const statusText = newStatus ? '입금완료' : '미입금';
            const confirmed = confirm(`${group.companyid} 入账状态改为「${statusText === '입금완료' ? '已入账' : '未入账'}」? / ${group.companyid}의 입금 상태를 '${statusText}'로 변경하시겠습니까?`);
            if (!confirmed) return;

            try {
                // 그룹 내 모든 아이템의 입금여부 업데이트
                for (const item of group.items) {
                    item.입금여부 = newStatus;
                    item.입금일시 = newStatus ? new Date().toISOString() : null;
                    // 银行到账核对 으로 켠 건을 손으로 끄면 은행 행 연결도 끊는다(다시 대조할 수 있게)
                    if (!newStatus && item.입금은행내역) item.입금은행내역 = null;
                }
                await this.updatereqlist(group.items);

                group.입금여부 = newStatus;
                this.$bvToast.toast(`入账状态已变更 / 입금 상태가 '${statusText}'로 변경되었습니다.`, {
                    title: '入账状态变更 / 입금 상태 변경',
                    variant: 'success',
                    solid: true
                });
            } catch (error) {
                console.error('입금 상태 변경 오류:', error);
                this.$bvToast.toast('入账状态变更出错 / 입금 상태 변경 중 오류가 발생했습니다.', {
                    title: '错误 / 오류',
                    variant: 'danger',
                    solid: true
                });
            }
        },

        /**
         * 결제 진행 - 1688 결제 페이지 열기
         */
        /**
         * 그룹 테이블에서 미결제 뱃지 클릭 시 결제진행
         * - selectedGroup을 해당 그룹으로 설정한 후 기존 proceedPayment 재사용
         */
        async proceedPaymentFromTable(group) {
            if (!group || !group.주문생성여부 || !group.입금여부) return;
            this.selectedGroup = group;
            await this.proceedPayment();
        },

        async proceedPayment() {
            if (!this.selectedGroup || !this.selectedGroup.items || this.selectedGroup.items.length === 0) {
                this.$bvToast.toast('没有可付款的订单 / 결제할 주문이 없습니다.', { title: '错误 / 오류', variant: 'warning', solid: true });
                return;
            }

            // 1688주문번호별로 items 그룹핑 (여러 공급업체 = 여러 주문번호)
            const orderIdToItems = {};
            for (const it of this.selectedGroup.items) {
                const oid = it.주문정보?.['1688주문번호'];
                if (oid) (orderIdToItems[oid] = orderIdToItems[oid] || []).push(it);
            }
            if (!Object.keys(orderIdToItems).length) {
                this.$bvToast.toast('没有1688订单号 / 1688 주문번호가 없습니다.', { title: '错误 / 오류', variant: 'warning', solid: true });
                return;
            }

            this.processingPayment = true;
            try {
                await this._payOrders(orderIdToItems);
            } finally {
                this.processingPayment = false;
            }
        },

        /**
         * 1688주문번호 → items 맵을 받아 합산결제 URL 을 열고 자동확인 폴링을 건다.
         * 합산이 안 되는 주문은 주문번호별 순차 오픈으로 폴백. (단건 결제·일괄결제 공용)
         */
        async _payOrders(orderIdToItems) {
            const orderIds = Object.keys(orderIdToItems);
            if (!orderIds.length) return;
            // A) 합산결제 시도 — 단건이어도 동일 경로 사용
            let response;
            try {
                response = await axios.post('/api/alibaba/getPaymentUrl', { orderIds });
            } catch (err) {
                console.error('결제 URL 조회 오류:', err);
                response = { data: { 요청결과: '실패', fallback: orderIds.length > 1 } };
            }

            if (response.data?.요청결과 === '성공' && response.data.paymentUrl) {
                window.open(response.data.paymentUrl, '_blank');
                // 공식 문서: success=true 여도 payFailureOrderList 로 부분 실패 가능
                // 성공 URL 열어 나머지는 합산결제로 진행 + 실패 주문만 폴백으로 분기
                const failList = (response.data.payFailureOrderList || []).map(String);
                const paidPending = {};
                const failPending = {};
                for (const [oid, items] of Object.entries(orderIdToItems)) {
                    if (failList.includes(String(oid))) failPending[oid] = items;
                    else paidPending[oid] = items;
                }
                const label = orderIds.length > 1 ? `${orderIds.length - failList.length}건 합산결제` : 'Alipay 결제';
                if (failList.length > 0) {
                    this.$bvToast.toast(
                        `${failList.length}件无法合并付款，将按订单号依次付款 / ${failList.length}건은 합산 불가 → 주문번호별로 순차 결제됩니다.`,
                        { title: '部分合并付款 / 부분 합산결제', variant: 'warning', solid: true }
                    );
                }
                this.$bvToast.toast(
                    `付款页面已打开，付款完成后将自动变为"已购买" / ${label} 페이지가 열렸습니다. 결제 완료 시 자동으로 "구매완료"로 반영됩니다.`,
                    // 정보성 안내라 5초 뒤 자동으로 사라진다(崔凡 10-06 — 매번 손으로 닫기 번거로움)
                    { title: '付款进行中 / 결제 진행 중', variant: 'info', solid: true, autoHideDelay: 5000 }
                );
                if (Object.keys(paidPending).length > 0) {
                    this.startPaymentPolling(paidPending, '1688 Alipay 결제');
                }
                if (Object.keys(failPending).length > 0) {
                    // 합산 실패 주문은 주문번호별로 순차 오픈 + 폴링
                    await this._proceedPaymentFallback(failPending);
                }
                return;
            }

            // B) 폴백 — 주문번호별 순차 오픈 (전체 합산 실패)
            if (orderIds.length > 1) {
                this.$bvToast.toast('无法合并付款，按订单号依次付款 / 합산결제 불가. 주문번호별로 순차 결제를 진행합니다.', {
                    title: '提示 / 알림', variant: 'info', solid: true
                });
            }
            await this._proceedPaymentFallback(orderIdToItems);
        },

        /**
         * 批量付款 / 일괄결제 — 체크한 행들의 1688 주문을 한 번에 결제한다(崔凡 10-06).
         * 연휴 며칠치를 같은 날 샀는데 그룹이 날짜별로 갈리는 경우를 위한 것.
         * 자격은 단건 결제와 같다(주문생성 + 입금확인 + 미결제). 거기에 1688 실제 상태가
         * waitbuyerpay 인 주문만 남긴다 — 이미 결제·닫힌 주문을 다시 결제창에 넣지 않으려고.
         */
        async batchPaySelected() {
            if (this.processingPayment) return;
            const targets = this.viewMode === 'group'
                ? this.tableSelectedItem.flatMap(g => g.items || [])
                : this.tableSelectedItem;
            if (!targets.length) {
                this.$bvToast.toast('请先勾选要付款的行 / 결제할 행을 선택하세요', { title: '批量付款 / 일괄결제', variant: 'warning', solid: true });
                return;
            }

            const excluded = {}; // 사유 → 요청건 수
            const addEx = (reason, n = 1) => { excluded[reason] = (excluded[reason] || 0) + n; };
            const orderIdToItems = {};
            for (const it of targets) {
                if (this.isNon1688(it)) { addEx('非1688(自行采购) / 비1688 직접구매 — 已转账로 처리'); continue; }
                const oid = it.주문정보?.['1688주문번호'];
                if (!oid) { addEx('未下单 / 1688주문 없음'); continue; }
                if (it.최종결제여부) { addEx('已付款 / 이미 결제완료'); continue; }
                if (!it.입금여부) { addEx('未确认入账 / 입금 미확인'); continue; }
                (orderIdToItems[oid] = orderIdToItems[oid] || []).push(it);
            }

            this.processingPayment = true;
            try {
                // 1688 실제 상태로 한 번 더 거른다 — waitbuyerpay(待付款) 만 결제 대상
                const candidateIds = Object.keys(orderIdToItems);
                if (candidateIds.length) {
                    const statuses = await this.verifyPaymentStatus(candidateIds);
                    const byId = {};
                    statuses.forEach(s => { byId[String(s.orderId)] = s; });
                    for (const oid of candidateIds) {
                        const st = byId[String(oid)] || {};
                        if (st.status === 'waitbuyerpay') continue;
                        const n = orderIdToItems[oid].length;
                        if (st.paid === true) addEx('1688已付款 / 1688에서 이미 결제됨', n);
                        else if (st.closed === true) addEx('1688订单已关闭 / 1688 주문 닫힘', n);
                        else if (!st.status) addEx('状态查询失败 / 1688 상태조회 실패', n);
                        else addEx(`非待付款(${st.status}) / 결제대기 아님`, n);
                        delete orderIdToItems[oid];
                    }
                }

                // 같은 1688 주문에 묶인 다른 요청건(선택 안 한 그룹)도 같이 결제되므로 자동확인 대상에 넣는다
                for (const oid of Object.keys(orderIdToItems)) {
                    const ids = new Set(orderIdToItems[oid].map(i => i._id));
                    (this.reqlistsinit || []).forEach(i => {
                        if (i.주문정보?.['1688주문번호'] === oid && !i.최종결제여부 && !ids.has(i._id)) {
                            orderIdToItems[oid].push(i);
                            ids.add(i._id);
                        }
                    });
                }

                const payIds = Object.keys(orderIdToItems);
                const exLines = Object.entries(excluded).map(([r, n]) => `· ${r}: ${n}건`);
                if (!payIds.length) {
                    this.$bvModal.msgBoxOk(
                        this.$createElement('div', { style: { whiteSpace: 'pre-line' } }, `没有可付款的订单 / 결제할 주문이 없습니다\n\n${exLines.join('\n')}`),
                        { title: '批量付款 / 일괄결제' }
                    );
                    return;
                }
                const itemCount = payIds.reduce((s, oid) => s + orderIdToItems[oid].length, 0);
                const msg = [
                    `付款对象 / 결제 대상: 1688订单 ${payIds.length}个 (요청건 ${itemCount}건)`,
                    exLines.length ? `\n已排除 / 제외 ${Object.values(excluded).reduce((a, b) => a + b, 0)}건:\n${exLines.join('\n')}` : '',
                    '\n打开合并付款页面? / 합산결제 페이지를 열까요?'
                ].join('\n');
                const ok = await this.$bvModal.msgBoxConfirm(this.$createElement('div', { style: { whiteSpace: 'pre-line' } }, msg), {
                    title: '批量付款 / 일괄결제', okTitle: '付款 / 결제', cancelTitle: '取消 / 취소', okVariant: 'primary'
                });
                if (!ok) return;

                // alibaba.alipay.url.get 의 orderIdList 는 한 번에 최대 30개 — 넘으면 나눠 연다
                const CHUNK = 30;
                for (let i = 0; i < payIds.length; i += CHUNK) {
                    const chunk = {};
                    payIds.slice(i, i + CHUNK).forEach(oid => { chunk[oid] = orderIdToItems[oid]; });
                    await this._payOrders(chunk);
                }
            } catch (err) {
                console.error('일괄결제 오류:', err);
                this.$bvToast.toast('批量付款失败 / 일괄결제 중 오류가 발생했습니다', { title: '错误 / 오류', variant: 'danger', solid: true });
            } finally {
                this.processingPayment = false;
            }
        },

        /**
         * 결제 폴백 — 1688주문번호별로 결제 페이지를 열고 폴링으로 자동 확인.
         * 사용자 컨펌 없이 폴링 + SSE 웹훅으로 자동 반영.
         */
        async _proceedPaymentFallback(orderIdToItems) {
            const entries = Object.entries(orderIdToItems);
            for (const [oid] of entries) {
                // 주문번호별 단건 URL 재요청
                let url = null;
                try {
                    const r = await axios.post('/api/alibaba/getPaymentUrl', { orderId: oid });
                    if (r.data?.요청결과 === '성공' && r.data.paymentUrl) url = r.data.paymentUrl;
                } catch (err) {
                    console.error(`결제 URL 조회 오류 (${oid}):`, err);
                }
                if (!url) url = `https://trade.1688.com/order/buyer_order_detail.htm?orderId=${oid}`;
                window.open(url, '_blank');
            }
            this.$bvToast.toast(
                `已打开${entries.length}个付款页面，付款完成后将自动反映 / ${entries.length}건 결제 페이지가 열렸습니다. 결제 완료 시 자동으로 반영됩니다.`,
                { title: '付款进行中 / 결제 진행 중', variant: 'info', solid: true, autoHideDelay: 5000 }
            );
            // 폴백으로 온 주문들도 동일 폴링에 합류
            this.startPaymentPolling(orderIdToItems, '1688 Alipay 결제');
        },

        /**
         * 주문번호별 items 맵을 받아 1688 API 로 결제 상태를 검증하고,
         * 결제 확인된 주문만 자동 마킹. 미확인/에러 주문은 사용자에게 재확인/강제완료/취소 선택 제공.
         *
         * @param {Object} orderIdToItems - { [orderId]: item[] }
         * @param {string} memoPrefix - bulk update memo 접두사
         */
        async markOrdersPurchased(orderIdToItems, memoPrefix) {
            const targetIds = Object.keys(orderIdToItems);
            if (!targetIds.length) return;

            // 1) API 로 결제 상태 검증
            const statuses = await this.verifyPaymentStatus(targetIds);
            const paidIds = statuses.filter(s => s.paid === true).map(s => s.orderId);
            // 1688 이 닫은 주문은 재확인·강제완료 대상이 아니다 — 안내만 하고 뺀다
            const closedIds = statuses.filter(s => s.closed === true).map(s => s.orderId);
            if (closedIds.length > 0) this.notifyClosed1688Orders(closedIds);
            const unpaidIds = statuses.filter(s => s.paid === false && s.closed !== true).map(s => s.orderId);
            const errorIds = statuses.filter(s => s.paid === null).map(s => s.orderId);

            // 2) 검증된 주문 먼저 자동 마킹
            if (paidIds.length > 0) {
                const itemIds = paidIds.flatMap(id => orderIdToItems[id].map(i => i._id));
                await this.markItemsPurchased(itemIds, `${memoPrefix} (API 검증됨)`);
                this.$bvToast.toast(`${paidIds.length}件已确认付款 → 已付款 / ${paidIds.length}건 결제 확인 → 구매완료 처리`, {
                    title: '完成 / 완료', variant: 'success', solid: true
                });
            }

            // 3) 미확인/에러 주문이 있으면 사용자 선택
            const pendingIds = [...unpaidIds, ...errorIds];
            if (pendingIds.length === 0) return;

            const action = await this._askRetryOrForce(unpaidIds, errorIds);
            if (action === 'retry') {
                await new Promise(r => setTimeout(r, 5000));
                const pendingMap = {};
                pendingIds.forEach(id => { pendingMap[id] = orderIdToItems[id]; });
                await this.markOrdersPurchased(pendingMap, memoPrefix);
            } else if (action === 'force') {
                const itemIds = pendingIds.flatMap(id => orderIdToItems[id].map(i => i._id));
                await this.markItemsPurchased(itemIds, `${memoPrefix} (수동 강제완료)`);
                this.$bvToast.toast(`${pendingIds.length}件强制完成 / ${pendingIds.length}건 강제완료 처리`, {
                    title: '完成 / 완료', variant: 'warning', solid: true
                });
            }
            // 'cancel' → 마킹하지 않고 종료 (웹훅이 도착하면 자동 처리)
        },

        /**
         * 1688 결제 상태 조회. 실패 시 모든 주문을 error(paid=null) 로 반환.
         */
        async verifyPaymentStatus(orderIds) {
            try {
                const r = await axios.post('/api/alibaba/checkPaymentStatus', { orderIds });
                if (r.data?.요청결과 === '성공' && Array.isArray(r.data.results)) {
                    return r.data.results;
                }
            } catch (err) {
                console.error('결제 상태 조회 오류:', err);
            }
            return orderIds.map(id => ({ orderId: id, status: null, paid: null, error: 'API 호출 실패' }));
        },

        /**
         * 미확인/에러 주문에 대한 사용자 선택 모달 시퀀스.
         * @returns {Promise<'retry'|'force'|'cancel'>}
         */
        async _askRetryOrForce(unpaidIds, errorIds) {
            const lines = [];
            if (unpaidIds.length > 0) lines.push(`🕐 待反映付款 / 결제 반영 대기: ${unpaidIds.join(', ')}`);
            if (errorIds.length > 0) lines.push(`⚠️ 状态查询失败 / 상태 조회 실패: ${errorIds.join(', ')}`);

            const retry = await this.$bvModal.msgBoxConfirm(
                `${lines.join('\n')}\n\n5秒后重新确认? / 5초 대기 후 재확인하시겠습니까?\n(否 = 选择强制完成/取消 / 아니오 = 강제완료/취소 선택)`,
                { title: '需确认付款反映 / 결제 반영 확인 필요', okVariant: 'primary', okTitle: '5秒后重新确认 / 재확인 (5초 대기)', cancelTitle: '下一步 / 다음 단계' }
            );
            if (retry) return 'retry';

            const force = await this.$bvModal.msgBoxConfirm(
                'API未确认到付款，仍要标记为「已付款」吗? / API로 결제가 확인되지 않았습니다. 그래도 "구매완료"로 처리하시겠습니까?\n(若实际未付款，之后需要修改 / 실제 결제되지 않았다면 나중에 수정이 필요합니다)',
                { title: '强制完成处理 / 강제 완료 처리', okVariant: 'warning', okTitle: '强制完成 / 강제 완료', cancelTitle: '取消 / 취소' }
            );
            return force ? 'force' : 'cancel';
        },

        /**
         * 결제 상태 자동 폴링 시작.
         * - verifyPaymentStatus 를 주기적으로 호출하고, paid 로 확인된 주문은 즉시 markItemsPurchased.
         * - 웹훅(SSE payment_completed) 도착 시 즉시 1회 추가 체크해 반영 속도 단축.
         * - 5분 타임아웃 시 남은 주문은 토스트 안내 후 폴링 종료. (웹훅은 계속 유효)
         */
        startPaymentPolling(orderIdToItems, memoPrefix) {
            if (!orderIdToItems || Object.keys(orderIdToItems).length === 0) return;
            // 기존 폴링이 있으면 타겟 merge (부분합산/폴백이 섞여 들어오는 케이스)
            if (this.paymentPollerId) {
                for (const [oid, items] of Object.entries(orderIdToItems)) {
                    if (!this.paymentPollerOrders[oid]) this.paymentPollerOrders[oid] = items;
                }
                return;
            }
            this.paymentPollerOrders = { ...orderIdToItems };
            this.paymentPollerMemo = memoPrefix || '1688 Alipay 결제';
            this.paymentPollerStart = Date.now();
            this.paymentPollerLastSSE = this.$store.state.sseNotifications?.payment_completed || 0;
            // 즉시 1회 + 10초마다 체크
            this._pollPaymentOnce();
            this.paymentPollerId = setInterval(() => this._pollPaymentOnce(), 10000);
        },

        async _pollPaymentOnce() {
            const pendingIds = Object.keys(this.paymentPollerOrders || {});
            if (pendingIds.length === 0) {
                this.stopPaymentPolling('모든 주문 확인 완료');
                return;
            }
            // 5분 타임아웃
            const TIMEOUT_MS = 5 * 60 * 1000;
            if (Date.now() - this.paymentPollerStart > TIMEOUT_MS) {
                this.$bvToast.toast(
                    `${pendingIds.length}个订单尚未检测到付款，收到1688通知后将自动反映 / ${pendingIds.length}건 결제 반영이 아직 감지되지 않았습니다. 1688 웹훅 도착 시 자동 반영됩니다.`,
                    // 경고라 정보성보다 길게(10초) 보여 주고 자동으로 사라진다
                    { title: '自动确认超时 / 자동 확인 타임아웃', variant: 'warning', solid: true, autoHideDelay: 10000 }
                );
                this.stopPaymentPolling('타임아웃');
                return;
            }
            try {
                const statuses = await this.verifyPaymentStatus(pendingIds);
                // 1688 이 미결제로 닫은 주문은 구매완료로 찍지 않고 폴링에서 빼고 안내만 한다(상태 변경은 직원 판단)
                const closedIds = statuses.filter(s => s.closed === true).map(s => String(s.orderId));
                if (closedIds.length > 0) {
                    closedIds.forEach(id => { delete this.paymentPollerOrders[id]; });
                    this.notifyClosed1688Orders(closedIds);
                }
                const paidIds = statuses.filter(s => s.paid === true).map(s => String(s.orderId));
                if (paidIds.length > 0) {
                    const itemIds = paidIds.flatMap(id => (this.paymentPollerOrders[id] || []).map(i => i._id));
                    await this.markItemsPurchased(itemIds, `${this.paymentPollerMemo} (자동확인)`);
                    paidIds.forEach(id => { delete this.paymentPollerOrders[id]; });
                    this.$bvToast.toast(`${paidIds.length}件付款已自动反映 / ${paidIds.length}건 결제 자동 반영 완료`, {
                        title: '付款确认 / 결제 확인', variant: 'success', solid: true
                    });
                }
                if (Object.keys(this.paymentPollerOrders).length === 0) {
                    this.stopPaymentPolling('모든 주문 확인 완료');
                }
            } catch (err) {
                console.error('결제 폴링 오류:', err);
            }
        },

        /**
         * 1688 이 미결제 등으로 닫은 주문 안내. 상태는 바꾸지 않는다 — 직원이 구매전으로 되돌려 다시 주문한다.
         */
        notifyClosed1688Orders(orderIds) {
            this.$bvToast.toast(
                `1688订单已关闭（未付款）/ 1688 주문이 미결제로 닫혔습니다: ${orderIds.join(', ')}\n请改回「구매전」后重新下单 / 구매전으로 되돌려 다시 주문하세요`,
                { title: '1688订单已关闭 / 1688 주문 닫힘', variant: 'danger', solid: true, noAutoHide: true }
            );
        },

        stopPaymentPolling(reason) {
            if (this.paymentPollerId) {
                clearInterval(this.paymentPollerId);
                this.paymentPollerId = null;
            }
            this.paymentPollerOrders = null;
            this.paymentPollerStart = 0;
            if (reason) console.log('[결제폴링] 종료:', reason);
        },

        /**
         * SSE payment_completed 카운터 변화 감지 시 즉시 1회 추가 체크.
         * 카운터는 orderId 를 주지 않으므로 "웹훅 도착 힌트"로만 사용.
         */
        handlePaymentSSEHint() {
            if (!this.paymentPollerId) return;
            this._pollPaymentOnce();
        },

        /**
         * 지정한 itemIds만 "구매완료/최종결제여부:true" 로 일괄 마킹.
         * 서버 bulk update + 로컬 selectedGroup/reqlistsinit 동기화 + 상태 카운트 갱신.
         */
        async markItemsPurchased(itemIds, memo) {
            if (!itemIds || itemIds.length === 0) return;
            await axios.post('/api/reqpurchase/updateProcessStatusBulk', {
                ids: itemIds,
                toStatus: '구매완료',
                memo: memo || '1688 Alipay 결제 완료',
                additionalFields: { 최종결제여부: true }
            });
            const idSet = new Set(itemIds);
            // 폴링/웹훅 도착 시점에 상세모달이 닫혀 selectedGroup 이 비어있을 수 있음
            (this.selectedGroup?.items || []).forEach(item => {
                if (!idSet.has(item._id)) return;
                item.processStatus = '구매완료';
                item.진행현황 = '구매완료';
                item.최종결제여부 = true;
            });
            this.reqlistsinit.forEach(initItem => {
                if (!idSet.has(initItem._id)) return;
                initItem.processStatus = '구매완료';
                initItem.진행현황 = '구매완료';
                initItem.최종결제여부 = true;
            });
            this.updateStatusCounts();
        },

        /**
         * 주문수량/판매자메시지를 다시 입력할 수 있는 상태인지.
         * 주문생성여부는 한 번 true 가 되면 구매전으로 되돌려도 지워지지 않아서,
         * 그걸 게이트로 쓰면 되돌린 뒤에도 입력칸이 안 열린다.
         * 주문생성 버튼과 같은 기준(구매전/구매확인)으로 판정한다.
         */
        canEditOrderQty(item) {
            const st = item.processStatus || item.진행현황;
            return st === '구매전' || st === '구매확인';
        },

        /**
         * 진행현황에 따른 Badge variant 반환
         */
        getStatusVariant(status) {
            const variants = {
                '구매전': 'secondary',
                '협상중': 'info',
                '구매확인': 'info',
                '입금요청': 'warning',
                '입금완료': 'primary',
                '구매완료': 'primary',
                '구매보류': 'warning',
                '구매취소': 'danger',
                '배송중': 'info',
                '배송완료': 'success',
                '입고작업': 'info',
                '출고확인대기': 'warning',
                '재고대기': 'info',
                '출고요청': 'warning',
                '출고대기': 'primary',
                '출고완료': 'success',
                '중국재고': 'dark',
                '입고오류': 'danger',
                '해외입고중': 'info',
                '국내입고중': 'primary',
                '쿠팡센터입고완료': 'success',
                '국내창고입고중': 'info',
                '국내창고입고완료': 'success',
            };
            return variants[status] || 'secondary';
        },

        /**
         * 클립보드에 텍스트 복사
         */
        copyToClipboard(text) {
            navigator.clipboard.writeText(text).then(() => {
                this.$bvToast.toast('已复制到剪贴板 / 클립보드에 복사되었습니다.', {
                    title: '复制完成 / 복사 완료',
                    variant: 'success',
                    solid: true,
                    autoHideDelay: 2000
                });
            }).catch(err => {
                console.error('복사 실패:', err);
            });
        },

        /**
         * 왕왕 채팅 링크 열기
         * @param {Object} item - 상품 아이템 (item.item.sellerOpenId 필요)
         */
        async openWangwangChat(item) {
            try {
                // sellerOpenId 확인
                const sellerOpenId = item.item?.sellerOpenId;
                if (!sellerOpenId) {
                    this.$bvToast.toast('没有卖家信息，请重新查询商品信息 / 판매자 정보가 없습니다. 상품 정보를 다시 조회해주세요.', {
                        title: '提示 / 알림',
                        variant: 'warning',
                        solid: true
                    });
                    return;
                }

                // 로딩 표시
                this.$bvToast.toast('正在获取聊天链接… / 채팅 링크를 가져오는 중...', {
                    title: '提示 / 알림',
                    variant: 'info',
                    solid: true,
                    autoHideDelay: 2000
                });

                // API 호출
                const response = await axios.post('/api/alibaba/getWangwangUrl', {
                    toOpenUid: sellerOpenId
                });

                if (response.data.요청결과 === '성공' && response.data.result) {
                    // 새 탭에서 채팅 링크 열기
                    window.open(response.data.result, '_blank');
                } else {
                    this.$bvToast.toast('聊天链接生成失败 / 채팅 링크 생성에 실패했습니다: ' + (response.data.error || '알 수 없는 오류'), {
                        title: '错误 / 오류',
                        variant: 'danger',
                        solid: true
                    });
                }
            } catch (error) {
                console.error('왕왕 채팅 링크 오류:', error);
                this.$bvToast.toast('获取聊天链接出错 / 채팅 링크를 가져오는 중 오류가 발생했습니다.', {
                    title: '错误 / 오류',
                    variant: 'danger',
                    solid: true
                });
            }
        },

        /**
         * 그룹 상세 모달 열기
         */
        openGroupDetail(group) {
            this.selectedGroup = group;
            this.detailSelectedItems = [];
            this.showDetailModal = true;
            this.$bvModal.show('group-detail-modal');
        },

        /**
         * 그룹 내 모든 상품의 요청사항을 중국어로 번역
         */
        async translateGroupRequests() {
            if (!this.selectedGroup || !this.selectedGroup.items) {
                this.$bvToast.toast('没有要翻译的商品 / 번역할 상품이 없습니다.', { title: '提示 / 알림', variant: 'warning', solid: true });
                return;
            }

            // 번역이 필요한 항목만 수집
            const textsToTranslate = [];
            const itemsToUpdate = [];

            this.selectedGroup.items.forEach((item, idx) => {
                if (!item.요청내역) return;

                // 한글 상품명: 이미 번역된 경우 제외
                if (item.상품명 && !item.요청내역.상품명_cn) {
                    textsToTranslate.push({
                        key: `name_${idx}`,
                        text: item.상품명,
                        itemIndex: idx,
                        field: '상품명_cn'
                    });
                    if (!itemsToUpdate.includes(idx)) itemsToUpdate.push(idx);
                }

                // 구매요청사항: 이미 번역된 경우 제외
                if (item.요청내역.reqcontentPurchase && !item.요청내역.reqcontentPurchase_cn) {
                    textsToTranslate.push({
                        key: `purchase_${idx}`,
                        text: item.요청내역.reqcontentPurchase,
                        itemIndex: idx,
                        field: 'reqcontentPurchase_cn'
                    });
                    if (!itemsToUpdate.includes(idx)) itemsToUpdate.push(idx);
                }

                // 물류요청사항: 이미 번역된 경우 제외
                if (item.요청내역.reqcontent && !item.요청내역.reqcontent_cn) {
                    textsToTranslate.push({
                        key: `logistics_${idx}`,
                        text: item.요청내역.reqcontent,
                        itemIndex: idx,
                        field: 'reqcontent_cn'
                    });
                    if (!itemsToUpdate.includes(idx)) itemsToUpdate.push(idx);
                }
            });

            if (textsToTranslate.length === 0) {
                this.$bvToast.toast('没有需要翻译的新要求，已翻译完成 / 번역할 새로운 요청사항이 없습니다. (이미 번역 완료)', { title: '提示 / 알림', variant: 'info', solid: true });
                return;
            }

            this.isTranslating = true;

            try {
                // 번역 API 호출
                const response = await axios.post('/api/ai/translate-to-chinese', {
                    texts: textsToTranslate.map(t => ({ key: t.key, text: t.text }))
                });

                if (!response.data.success) {
                    throw new Error(response.data.error || '번역 실패');
                }

                // 번역 결과 매핑 및 DB 업데이트
                const results = response.data.results;
                const updatePromises = [];

                for (const result of results) {
                    const textInfo = textsToTranslate.find(t => t.key === result.key);
                    if (!textInfo || !result.translated) continue;

                    const item = this.selectedGroup.items[textInfo.itemIndex];
                    if (!item || !item.요청내역) continue;

                    // Vue 반응성 업데이트
                    this.$set(item.요청내역, textInfo.field, result.translated);

                    // DB 업데이트
                    updatePromises.push(
                        axios.post('/api/reqpurchase/updatereqcontent', {
                            _id: item._id,
                            field: textInfo.field,
                            value: result.translated
                        })
                    );
                }

                // 모든 DB 업데이트 실행
                await Promise.all(updatePromises);

                this.$bvToast.toast(`${results.filter(r => r.translated).length}条要求翻译完成 / ${results.filter(r => r.translated).length}개 요청사항 번역 완료`, {
                    title: '翻译完成 / 번역 완료',
                    variant: 'success',
                    solid: true
                });

            } catch (error) {
                console.error('번역 오류:', error);
                this.$bvToast.toast('翻译出错 / 번역 중 오류가 발생했습니다: ' + (error.message || error), {
                    title: '错误 / 오류',
                    variant: 'danger',
                    solid: true
                });
            } finally {
                this.isTranslating = false;
            }
        },

        /**
         * 메인 테이블에서 미생성 뱃지 클릭 시 1688 주문 생성
         * - selectedGroup을 해당 그룹으로 설정한 후 기존 createOrderFromGroup 재사용
         * - 실패 시 groupOrderErrors에 에러 메시지 저장 (테이블에 표식 표시)
         */
        /**
         * 1688 최소주문수량(起批量)에 걸린 주문을 개별주문(代发)으로 한 번 더 시도할지 묻는다.
         *
         * flow=general 은 도매 주문이라 상품마다 정해진 최소수량을 요구한다.
         * flow=saleproxy 는 그 제약이 없다(실측: 같은 상품 1개 주문이 general 실패 / saleproxy 성공).
         * 다만 **개당 단가와 배송비가 달라진다** — 실측상 1개 15.90元, 10개는 개당 12.90元+배송비.
         * 매입가가 조용히 바뀌면 안 되므로 자동으로 넘어가지 않고 반드시 확인을 받는다.
         *
         * @returns {boolean} 개별주문으로 재시도할지
         */
        askRetryAsSaleproxy(errorMessage) {
            if (!/起批量|混批限制/.test(String(errorMessage || ''))) return false;
            return confirm(
                '此订单未达到1688批发起批量 / 이 주문은 1688 도매 최소주문수량에 미달합니다.\n\n'
                + '改为代发下单? / 개별주문(代发)으로 진행하시겠습니까?\n'
                + '不受起批量限制，但单价和运费可能与批发不同 / 최소수량 제한 없이 주문되지만, 개당 단가와 배송비가 도매와 다를 수 있습니다.'
            );
        },

        async createOrderFromTable(group) {
            if (!group) return;
            if (this.orderCreating || this.bulkOrdering) return; // 다른 주문 생성이 진행중이면 무시(중복 주문 방지)
            this.selectedGroup = group;
            this.orderErrorMessage = '';
            await this.createOrderFromGroup();
            if (this.orderErrorMessage) {
                this.$set(this.groupOrderErrors, group.groupKey, this.orderErrorMessage);
            } else {
                this.$delete(this.groupOrderErrors, group.groupKey);
            }
        },

        /**
         * 에러 표식 아이콘 클릭 시 상세 모달 열기 + 저장된 에러 메시지 복원
         */
        openGroupDetailWithError(group) {
            this.orderErrorMessage = this.groupOrderErrors[group.groupKey] || '';
            this.openGroupDetail(group);
        },

        /**
         * 1688 주문생성 - 그룹의 모든 상품을 1688 주문으로 생성
         */
        // opts.bulk = 批量下单(bulkCreateOrders) 에서 부를 때 — 그룹마다 묻는 확인창·완료/실패 토스트를 생략하고
        // 메모는 bulkOrderNotes 로 넘긴다. 템플릿 @click 은 이벤트 객체가 들어오므로 bulk === true 일 때만 본다
        async createOrderFromGroup(opts) {
            const bulk = !!(opts && opts.bulk === true);
            if (this.orderCreating) return; // 진행중이면 즉시 무시 — 재클릭 중복 주문 방지
            if (!bulk && this.bulkOrdering) return; // 일괄 주문 중엔 단건 주문을 받지 않는다
            if (!this.selectedGroup) return;

            // 非1688(自行采购) 건은 1688 주문 대상이 아니다 — 已转账(송금완료)로 처리한다
            const items = this.selectedGroup.items.filter(it => !this.isNon1688(it));
            const non1688Cnt = this.selectedGroup.items.length - items.length;
            if (non1688Cnt > 0) {
                this.$bvToast.toast(`非1688 ${non1688Cnt}건은 1688 주문에서 제외됩니다 — 已转账(송금완료)로 처리하세요.`, {
                    title: '非1688 / 비1688 제외', variant: 'info', solid: true
                });
            }
            if (items.length === 0) {
                this.$bvToast.toast('没有要下单的商品 / 주문할 상품이 없습니다.', { title: '提示 / 알림', variant: 'warning', solid: true });
                return;
            }

            // 구매전 또는 구매확인 상태만 주문 가능
            const validStatuses = ['구매전', '구매확인'];
            const invalidItems = items.filter(item => !validStatuses.includes(item.processStatus || item.진행현황));
            if (invalidItems.length > 0) {
                this.$bvToast.toast(`${invalidItems.length}个商品为不可下单状态 / ${invalidItems.length}개 상품이 주문 불가 상태입니다.`, {
                    title: '无法下单 / 주문 불가', variant: 'warning', solid: true
                });
                return;
            }

            if (!bulk && !confirm(`在1688下单${items.length}个商品? / ${items.length}개 상품을 1688에 주문하시겠습니까?`)) return;

            this.orderCreating = true;
            this.orderCreatingText = '创建订单中… / 주문 생성 중...';
            this.orderCreatingOverlay = true;
            try {
                const companyId = this.selectedGroup.companyid;
                const allUpdatedItems = [];

                // 판매자별 그룹핑
                const supplierGroups = {};
                const sellerKeyOf = this.makeSellerKeyOf(items);
                const noLinkItems = [];
                items.forEach(item => {
                    const offerId = ((item.구매링크 || '').match(/offer\/(\d+)/) || [])[1] || '';
                    // 구매링크가 없거나 1688 상품 주소가 아니면 주문에 넣지 않는다.
                    if (!offerId) {
                        noLinkItems.push(item.상품명 || item.상품주문번호 || '(이름 없음)');
                        if (bulk) this.bulkAddFail(item, '无1688链接 / 1688 구매링크 없음');
                        return;
                    }
                    // 같은 판매자·같은 배송유형 상품을 한 주문으로 묶는다 (sellerOpenId 없으면 상품 단위).
                    // 배송유형(reqtype)이 주소 접미사 R/Z/G/S 를 정하므로 섞이면 오배송된다.
                    const supplierId = sellerKeyOf(item, offerId) + '|' + (item.reqtype || '');
                    if (!supplierGroups[supplierId]) supplierGroups[supplierId] = [];
                    supplierGroups[supplierId].push(item);
                });
                if (noLinkItems.length && bulk) {
                    this.bulkOrderNotes.push('无1688链接除外 / 구매링크 없음 제외 ' + noLinkItems.length + '件');
                } else if (noLinkItems.length) {
                    alert('以下商品没有1688采购链接，不下单 / 아래 상품은 1688 구매링크가 없어 주문에서 제외됩니다.\n\n'
                        + noLinkItems.slice(0, 10).map(n => '· ' + n).join('\n')
                        + (noLinkItems.length > 10 ? '\n· 另 (외) ' + (noLinkItems.length - 10) + '件' : ''));
                }

                // 옵션이 1688 SKU 와 맞지 않는 상품이 하나라도 있으면 주문을 시작하지 않는다.
                // (예전에는 여기서 "Cannot read properties of undefined (reading 'specId')" 로 멈췄다)
                // 일괄 주문(bulk)은 맞지 않는 상품만 실패 목록에 넣고 나머지는 계속 주문한다.
                const bulkChunkErrors = [];
                if (bulk) {
                    const badOpt = [].concat(...Object.values(supplierGroups)).filter(it => this.findSkuSpecId(it) === undefined);
                    if (badOpt.length) {
                        badOpt.forEach(it => this.bulkAddFail(it, '选项与1688不匹配，请重新匹配选项 / 옵션이 1688 상품과 맞지 않음 — 옵션 매칭 다시 필요'));
                        this.bulkOrderNotes.push('选项不匹配除外 / 옵션 불일치 제외 ' + badOpt.length + '件');
                        const badIds = badOpt.map(it => it._id);
                        Object.keys(supplierGroups).forEach(k => {
                            supplierGroups[k] = supplierGroups[k].filter(i => !badIds.includes(i._id));
                            if (supplierGroups[k].length === 0) delete supplierGroups[k];
                        });
                    }
                } else {
                    const unmatchedMsg = this.unmatchedOptionMessage([].concat(...Object.values(supplierGroups)));
                    if (unmatchedMsg) throw new Error(unmatchedMsg);
                }

                // 주문 직전 1688 실시간 재고 확인 — 모자란 품목은 빼고 주문하거나 취소
                // 가림막은 내리지 않는다(내리면 그 사이 재클릭으로 중복 주문이 나간다). 문구만 바꾼다.
                // 일괄 주문(bulk)은 확인창 없이 부족 품목을 자동으로 빼고 실패 목록에 넣는다.
                this.orderCreatingText = '库存确认中… / 재고 확인 중';
                const stockCheck = await this.checkLiveStock([].concat(...Object.values(supplierGroups)), bulk);
                this.orderCreatingText = '创建订单中… / 주문 생성 중...';
                if (!stockCheck) return;
                if (stockCheck.excludedIds.length) {
                    if (bulk) {
                        this.bulkOrderNotes.push('库存不足除外 / 재고부족 제외 ' + stockCheck.excludedIds.length + '件');
                        [].concat(...Object.values(supplierGroups)).filter(i => stockCheck.excludedIds.includes(i._id))
                            .forEach(i => this.bulkAddFail(i, (stockCheck.reasons && stockCheck.reasons[i._id]) || '库存不足 / 재고 부족'));
                    }
                    Object.keys(supplierGroups).forEach(k => {
                        supplierGroups[k] = supplierGroups[k].filter(i => !stockCheck.excludedIds.includes(i._id));
                        if (supplierGroups[k].length === 0) delete supplierGroups[k];
                    });
                }

                for (const supplierItems of Object.values(supplierGroups)) {
                    // cargoParamList 구성 (동일 specId 병합)
                    const mergedItems = {};
                    supplierItems.forEach(item => {
                        const specId = this.findSkuSpecId(item);
                        const offerId = parseInt(((item.구매링크 || '').match(/offer\/(\d+)/) || [])[1]);
                        const key = `${offerId}_${specId}`;
                        if (!mergedItems[key]) {
                            mergedItems[key] = { offerId: offerId, specId: specId, quantity: 0 };
                        }
                        // 주문수량 오버라이드가 있으면 사용, 없으면 기존 로직
                        const orderQty = item._주문수량_override != null
                            ? parseInt(item._주문수량_override)
                            : parseInt(item.구매요청수량) * parseInt(item.판매구성수량 || 1);
                        mergedItems[key].quantity += orderQty;
                    });

                    const mergedItemsList = Object.values(mergedItems);
                    const chunks = [];
                    for (let i = 0; i < mergedItemsList.length; i += 50) {
                        chunks.push(mergedItemsList.slice(i, i + 50));
                    }

                    for (const chunk of chunks) {
                        let reqtype = 'G ';
                        if (supplierItems[0].reqtype == '로켓배송') reqtype = 'R ';
                        else if (supplierItems[0].reqtype == '제트배송') reqtype = 'Z ';
                        else if (supplierItems[0].reqtype == '샘플검증') reqtype = 'S ';

                        // reqItems 구성
                        const reqItems = [];
                        for (const chunkItem of chunk) {
                            supplierItems.filter(item => {
                                const itemSpecId = this.findSkuSpecId(item);
                                return (itemSpecId || "") === chunkItem.specId
                                    && parseInt(((item.구매링크 || '').match(/offer\/(\d+)/) || [])[1]) === chunkItem.offerId;
                            }).forEach(item => reqItems.push({ _id: item._id }));
                        }

                        // 각 reqItem에 주문수량 정보 추가
                        const reqItemsWithQty = reqItems.map(ri => {
                            const srcItem = supplierItems.find(si => si._id === ri._id);
                            const defaultQty = srcItem ? parseInt(srcItem.구매요청수량) * parseInt(srcItem.판매구성수량 || 1) : 0;
                            const orderQty = srcItem?._주문수량_override != null ? parseInt(srcItem._주문수량_override) : defaultQty;
                            return { ...ri, 주문수량: orderQty, 구매요청수량: srcItem?.구매요청수량 };
                        });

                        // 해당 판매자의 아이템들에서 메시지 수집 (중복 제거)
                        const sellerMessages = [...new Set(supplierItems.map(i => i._판매자메시지).filter(Boolean))].join('; ');

                        const orderRequest = {
                            flow: 'general',
                            message: sellerMessages,
                            addressParam: {
                                // 수취인명은 1688 과거 주문 조회 편의를 위해 업체별로 통일 (항상 '飞运Z ' 접두사)
                                // 배송유형(R/Z/G/S) 구분은 주소 뒤에만 유지
                                fullName: ('飞运Z ' + companyId).slice(0, 24),
                                mobile: '15650102901',
                                provinceText: '山东省',
                                cityText: '威海市',
                                areaText: '环翠区',
                                address: '凤林街道海南路9号飞运' + reqtype + companyId + `(无法自提 不接受到付)`,
                                postCode: '000000'
                            },
                            cargoParamList: chunk,
                            companyId: companyId,
                            reqItems: reqItemsWithQty
                        };
                        console.log('Sending order request:', orderRequest);

                        let res;
                        try {
                            res = await axios.post('/api/reqpurchase/createCrossOrder', orderRequest);
                            console.log('Order creation response:', res.data);
                            if (res.data.요청결과 !== '성공'
                                && this.askRetryAsSaleproxy(res.data.error?.errorMessage || res.data.error?.message)) {
                                res = await axios.post('/api/reqpurchase/createCrossOrder',
                                    Object.assign({}, orderRequest, { flow: 'saleproxy' }));
                                console.log('Order creation response (saleproxy):', res.data);
                            }
                            if (res.data.요청결과 !== '성공') {
                                throw new Error(res.data.error?.errorMessage || res.data.error?.message || '주문 생성 실패');
                            }
                        } catch (chunkErr) {
                            if (!bulk) throw chunkErr;
                            // 일괄 주문: 이 묶음(판매처·50품목 단위)만 실패로 기록하고 다음 묶음으로 계속 간다
                            const chunkMsg = chunkErr.response?.data?.error?.errorMessage || chunkErr.message || '주문 생성 실패';
                            console.error('[批量下单] 묶음 주문 실패 — 건너뛰고 계속', chunkErr);
                            reqItems.forEach(ri => {
                                const failed = supplierItems.find(si => si._id === ri._id);
                                if (failed) this.bulkAddFail(failed, chunkMsg);
                            });
                            bulkChunkErrors.push(chunkMsg);
                            continue;
                        }

                        // 성공 시 UI 업데이트 (서버 응답의 아이템별 가격 사용)
                        const 화주주문번호 = res.data.화주주문번호;
                        const 상품주문번호Map = res.data.상품주문번호Map;
                        const orderResult = res.data.result.orderResult.result;
                        const 아이템별가격 = res.data.아이템별가격 || {};
                        for (const chunkItem of chunk) {
                            supplierItems.filter(item => {
                                const itemSpecId = this.findSkuSpecId(item);
                                return (itemSpecId || "") === chunkItem.specId
                                    && parseInt(((item.구매링크 || '').match(/offer\/(\d+)/) || [])[1]) === chunkItem.offerId;
                            }).forEach(item => {
                                const price = 아이템별가격[item._id] || {};
                                const defaultQty = parseInt(item.구매요청수량) * parseInt(item.판매구성수량 || 1);
                                const actualOrderQty = item._주문수량_override != null ? parseInt(item._주문수량_override) : defaultQty;
                                item.화주주문번호 = 화주주문번호;
                                item.상품주문번호 = 상품주문번호Map[item._id] || '';
                                item.주문정보 = {
                                    '1688주문번호': orderResult.orderId,
                                    협상전_단가: price.협상전_단가 || 0,
                                    협상전_상품금액: price.협상전_상품금액 || 0,
                                    협상전_배송비: price.협상전_배송비 || 0,
                                    협상전_총금액: price.협상전_총금액 || 0,
                                    협상전_수량: price.협상전_수량 || parseInt(item.구매요청수량) || 1,
                                    협상전_주문배송비: price.협상전_주문배송비 || 0,
                                    주문수량: actualOrderQty,
                                    판매자메시지: item._판매자메시지 || sellerMessages || '',
                                    주문시간: new Date().toISOString()
                                };
                                item.주문생성여부 = true;
                                item.주문시간 = new Date().toISOString();
                                item.processStatus = '협상중';
                                item.진행현황 = '협상중';
                                allUpdatedItems.push(item);
                            });
                        }
                    }
                }

                // 로컬 데이터 갱신 (서버는 이미 DB 저장 완료했으므로 updatereqlist 불필요)
                if (allUpdatedItems.length > 0) {
                    for (const updated of allUpdatedItems) {
                        const idx = this.reqlists.findIndex(r => r._id === updated._id);
                        if (idx !== -1) this.$set(this.reqlists, idx, updated);
                        const initIdx = this.reqlistsinit.findIndex(r => r._id === updated._id);
                        if (initIdx !== -1) this.$set(this.reqlistsinit, initIdx, this.deepClone(updated));
                    }
                }

                // selectedGroup을 재계산된 그룹으로 갱신
                const itemIds = allUpdatedItems.map(i => i._id);
                const newGroup = this.groupedReqlists.find(g =>
                    g.items.some(i => itemIds.includes(i._id))
                );
                if (newGroup) {
                    this.selectedGroup = newGroup;
                }

                // 일괄 주문에서 실패한 묶음이 있으면 사유를 남긴다(그룹 표시·진행창 사유 칸)
                this.orderErrorMessage = bulkChunkErrors.length ? [...new Set(bulkChunkErrors)].join('\n') : '';
                if (!bulk) {
                    this.$bvToast.toast('1688订单创建完成 / 1688 주문 생성이 완료되었습니다.'
                        + (stockCheck.excludedIds.length ? ` (库存不足除外 / 재고부족 제외 ${stockCheck.excludedIds.length}건)` : ''), {
                        title: '下单完成 / 주문 완료', variant: 'success', solid: true
                    });
                }
            } catch (e) {
                // 서버 중복 방어(409)는 axios 가 예외로 던진다 — 서버 문구를 그대로 보여준다
                const msg = e.response?.data?.error?.errorMessage || e.message;
                // 에러 메시지를 모달 상단에 고정 표시 (일괄 주문이면 진행창 실패 목록에 들어간다)
                this.orderErrorMessage = msg;
                if (!bulk) {
                    this.$bvToast.toast('订单创建失败 / 주문 생성 실패: ' + msg, {
                        title: '错误 / 오류', variant: 'danger', solid: true
                    });
                }
                console.error('주문 생성 에러:', e);
            } finally {
                this.orderCreatingOverlay = false;
                this.orderCreatingText = '创建订单中… / 주문 생성 중...';
                this.orderCreating = false;
            }
        },

        setOrderShippingOverride(orderId, type, value) {
            if (!this.quotationOrderShippingOverrides[orderId]) {
                this.$set(this.quotationOrderShippingOverrides, orderId, {});
            }
            this.$set(this.quotationOrderShippingOverrides[orderId], type, value);
        },

        /**
         * 판매자 메시지 입력 (아이템별)
         */
        openSellerMessageEdit(item) {
            const current = item._판매자메시지 || '';
            const msg = prompt('卖家留言 (판매자 메시지):\n예: 96개 주문, 실제 100개 발송 요청', current);
            if (msg === null) return; // 취소
            this.$set(item, '_판매자메시지', msg);
        },

        /**
         * 견적서 편집 오버라이드 값 설정
         */
        setQuotationEdit(itemId, field, value) {
            if (!this.quotationEditOverrides[itemId]) {
                this.$set(this.quotationEditOverrides, itemId, {});
            }
            this.$set(this.quotationEditOverrides[itemId], field, value);
        },

        /**
         * 협상전 가격 오버라이드를 DB에 저장
         */
        async savePreNegotiationPrices() {
            const items = this.quotationGroup?.items || [];
            const updates = [];

            // 주문별 총수량 계산
            const orderGroups = {};
            items.forEach(item => {
                const oid = item.주문정보?.['1688주문번호'] || 'unknown';
                if (!orderGroups[oid]) orderGroups[oid] = [];
                orderGroups[oid].push(item);
            });
            const orderTotalQtys = {};
            for (const [oid, orderItems] of Object.entries(orderGroups)) {
                orderTotalQtys[oid] = orderItems.reduce((sum, i) => sum + (parseInt(i.구매요청수량) || 1), 0);
            }

            for (const item of items) {
                const override = this.quotationEditOverrides[item._id] || {};
                const orderId = item.주문정보?.['1688주문번호'] || 'unknown';
                const orderShipOverride = this.quotationOrderShippingOverrides[orderId];
                const has단가Override = override.협상전_단가 != null;
                const has배송비Override = orderShipOverride?.협상전 != null;

                if (!has단가Override && !has배송비Override) continue;

                const qty = parseInt(item.구매요청수량) || 1;
                const origPre배송비 = item.주문정보?.협상전_배송비 || 0;
                const 총금액 = item.주문정보?.협상전_총금액 || 0;

                let 단가, 배송비;
                if (has배송비Override) {
                    const orderTotalQty = orderTotalQtys[orderId] || qty;
                    배송비 = Math.round(parseFloat(orderShipOverride.협상전) / orderTotalQty * qty * 100) / 100;
                } else {
                    배송비 = origPre배송비;
                }
                if (has단가Override) {
                    단가 = parseFloat(override.협상전_단가);
                } else {
                    단가 = qty > 0 ? Math.round((총금액 - origPre배송비) / qty * 100) / 100 : 0;
                }

                updates.push({
                    _id: item._id,
                    '주문정보.협상전_상품금액': Math.round(단가 * qty * 100) / 100,
                    '주문정보.협상전_배송비': Math.round(배송비 * 100) / 100,
                    '주문정보.협상전_총금액': Math.round((단가 * qty + 배송비) * 100) / 100,
                    '주문정보.협상전_주문배송비': has배송비Override ? parseFloat(orderShipOverride.협상전) : (item.주문정보?.협상전_주문배송비 || 0)
                });
            }
            if (updates.length === 0) return;

            try {
                await axios.post('/api/reqpurchase/updatereqpurchase', updates);
                for (const u of updates) {
                    const item = items.find(i => i._id === u._id);
                    if (item && item.주문정보) {
                        this.$set(item.주문정보, '협상전_상품금액', u['주문정보.협상전_상품금액']);
                        this.$set(item.주문정보, '협상전_배송비', u['주문정보.협상전_배송비']);
                        this.$set(item.주문정보, '협상전_총금액', u['주문정보.협상전_총금액']);
                        this.$set(item.주문정보, '협상전_주문배송비', u['주문정보.협상전_주문배송비']);
                    }
                }
                // 오버라이드 초기화
                for (const u of updates) {
                    const o = this.quotationEditOverrides[u._id];
                    if (o) this.$delete(o, '협상전_단가');
                }
                this.quotationOrderShippingOverrides = {};
                this.$bvToast.toast(`协商前价格${updates.length}件已保存 / 협상전 가격 ${updates.length}건 저장 완료`, { title: '保存 / 저장', variant: 'success', solid: true });
            } catch (err) {
                console.error('협상전 가격 저장 오류:', err);
                this.$bvToast.toast('保存失败 / 저장 실패: ' + err.message, { title: '错误 / 오류', variant: 'danger', solid: true });
            }
        },

        /**
         * 구매요청수량 일괄 수정 - 상세 모달에서 선택된 항목 수정
         */
        async openBatchQuantityEdit() {
            const items = this.detailSelectedItems.length > 0 ? this.detailSelectedItems : this.selectedGroup?.items || [];
            if (items.length === 0) {
                this.$bvToast.toast('请选择要修改的商品 / 수정할 상품을 선택해주세요.', { title: '提示 / 알림', variant: 'warning', solid: true });
                return;
            }

            const newQuantity = prompt(`请输入${items.length}个商品的请求数量 / ${items.length}개 상품의 구매요청수량을 입력하세요:`, items[0].구매요청수량);
            if (!newQuantity || isNaN(parseInt(newQuantity))) return;

            try {
                for (const item of items) {
                    item.구매요청수량 = parseInt(newQuantity);
                }
                await this.updatereqlist(items);
                this.$bvToast.toast(`${items.length}个商品的请求数量已修改 / ${items.length}개 상품의 구매요청수량이 수정되었습니다.`, {
                    title: '修改完成 / 수정 완료', variant: 'success', solid: true
                });
            } catch (error) {
                console.error('구매요청수량 수정 오류:', error);
                this.$bvToast.toast('修改出错 / 수정 중 오류가 발생했습니다.', { title: '错误 / 오류', variant: 'danger', solid: true });
            }
        },

        /**
         * 통관방법 일괄 수정 - 상세 모달에서 선택된 항목 수정
         */
        async openBatchCustomsEdit() {
            const items = this.detailSelectedItems.length > 0 ? this.detailSelectedItems : this.selectedGroup?.items || [];
            if (items.length === 0) {
                this.$bvToast.toast('请选择要修改的商品 / 수정할 상품을 선택해주세요.', { title: '提示 / 알림', variant: 'warning', solid: true });
                return;
            }

            // 요청 상세의 통관 버튼(:1653)과 같은 필드(요청내역.customsType)를 바꾸고 같은 라우트(updatereqpurchase)로 저장한다
            const customsMap = { '통합통관': 'integrated', '화주단독통관': 'client', '쿠패스단독통관': 'kupass' };
            const customsMethods = Object.keys(customsMap);
            const currentMethod = items[0].통관방법 || '통합통관';
            const newMethod = prompt(`请输入清关方式(按下列韩文原样输入) / 통관방법을 선택하세요:
${customsMethods.join(', ')}

当前 / 현재: ${currentMethod}`, currentMethod);

            if (!newMethod || !customsMap[newMethod]) {
                if (newMethod) this.$bvToast.toast('请输入正确的清关方式 / 올바른 통관방법을 입력해주세요.', { title: '提示 / 알림', variant: 'warning', solid: true });
                return;
            }

            // 이미 견적서가 있으면 환율·배율·금액이 달라지므로 건너뛴다
            const targets = items.filter(item => !item.견적서_1688구매금액);
            const skipped = items.length - targets.length;
            if (targets.length === 0) {
                this.$bvToast.toast('已生成报价单的请求无法修改清关方式(需重新生成报价单) / 이미 견적서가 만들어진 요청은 통관방식을 바꿀 수 없습니다(견적서 재생성 필요).', { title: '提示 / 알림', variant: 'warning', solid: true });
                return;
            }

            const before = targets.map(item => ({ item, type: item.요청내역.customsType, method: item.통관방법 }));
            try {
                for (const item of targets) {
                    item.요청내역.customsType = customsMap[newMethod];
                    item.통관방법 = newMethod;
                }
                await this.updatereqlist(targets);
                this.$forceUpdate();
                const skipMsg = skipped > 0 ? `, ${skipped}件已有报价单未修改(需重新生成报价单) / ${skipped}건은 이미 견적서가 있어 통관방식을 바꾸지 못했습니다(견적서 재생성 필요)` : '';
                this.$bvToast.toast(`${targets.length}个商品的清关方式已改为「${newMethod}」 / ${targets.length}개 상품의 통관방법이 "${newMethod}"으로 수정되었습니다.${skipMsg}`, {
                    title: '修改完成 / 수정 완료', variant: skipped > 0 ? 'warning' : 'success', solid: true
                });
            } catch (error) {
                before.forEach(b => { b.item.요청내역.customsType = b.type; b.item.통관방법 = b.method; });
                console.error('통관방법 수정 오류:', error);
                this.$bvToast.toast('修改出错 / 수정 중 오류가 발생했습니다.', { title: '错误 / 오류', variant: 'danger', solid: true });
            }
        },

        /**
         * 진행현황 일괄 수정 - 상세 모달에서 선택된 항목 수정 (모달 오픈)
         */
        openBatchStatusEdit() {
            const items = this.detailSelectedItems.length > 0 ? this.detailSelectedItems : this.selectedGroup?.items || [];
            if (items.length === 0) {
                this.$bvToast.toast('请选择要修改的商品 / 수정할 상품을 선택해주세요.', { title: '提示 / 알림', variant: 'warning', solid: true });
                return;
            }

            this.selectedStatusForBatch = '';
            this.showStatusModal = true;
        },

        /**
         * 모달에서 선택한 진행현황으로 일괄 수정
         */
        async confirmBatchStatusEdit() {
            const items = this.detailSelectedItems.length > 0 ? this.detailSelectedItems : this.selectedGroup?.items || [];
            const newStatus = this.selectedStatusForBatch;

            if (!newStatus) {
                this.$bvToast.toast('请选择状态 / 진행현황을 선택해주세요.', { title: '提示 / 알림', variant: 'warning', solid: true });
                return;
            }

            try {
                // processStatus API로 일괄 변경 (processHistory 자동 기록)
                const ids = items.map(item => item._id);
                const response = await axios.post('/api/reqpurchase/updateProcessStatusBulk', {
                    ids: ids,
                    toStatus: newStatus,
                    memo: '쿠패스 현황수정'
                });

                if (response.data.요청결과 === '성공') {
                    // 서버가 역행 방지로 건너뛴 건은 화면에서도 바꾸지 않는다(서버 값 유지).
                    // 예전에는 skipped 를 무시하고 전부 바꿔서, 화면만 바뀌고 DB 는 그대로였다.
                    const skipped = response.data.skipped || [];
                    const skippedMap = {};
                    for (const s of skipped) skippedMap[String(s.id)] = s;
                    const sync = (item, status, extra) => {
                        item.processStatus = status;
                        item.진행현황 = status;
                        Object.assign(item, extra);
                        const initIdx = this.reqlistsinit.findIndex(i => i._id === item._id);
                        if (initIdx !== -1) {
                            this.reqlistsinit[initIdx].processStatus = status;
                            this.reqlistsinit[initIdx].진행현황 = status;
                            Object.assign(this.reqlistsinit[initIdx], extra);
                        }
                    };
                    let changed = 0;
                    for (const item of items) {
                        const s = skippedMap[String(item._id)];
                        if (s) {
                            sync(item, s.fromStatus || item.processStatus || item.진행현황, {});
                        } else {
                            // 구매취소에서 되돌리면 서버가 구매취소 표시도 같이 거둔다.
                            const wasCancel = (item.processStatus || item.진행현황) === '구매취소' && newStatus !== '구매취소';
                            sync(item, newStatus, wasCancel ? { 구매취소: false } : {});
                            changed++;
                        }
                    }
                    this.updateStatusCounts();
                    this.showStatusModal = false;
                    if (skipped.length) {
                        const nameOf = (id) => {
                            const it = items.find(i => String(i._id) === String(id));
                            return it ? (it.구매코드 || it.상품명 || it.SKUID || String(id)).toString().slice(0, 30) : String(id);
                        };
                        alert(`${changed}件已修改，${skipped.length}件未能修改 (${changed}건 변경, ${skipped.length}건 변경 못 함)\n\n` +
                            skipped.slice(0, 10).map(s => `· ${nameOf(s.id)}: ${s.fromStatus} → ${s.toStatus}\n   ${s.reason}`).join('\n') +
                            (skipped.length > 10 ? `\n· 另 (외) ${skipped.length - 10}件` : ''));
                    } else {
                        this.$bvToast.toast(`${items.length}个商品的状态已改为「${this.displayZh(newStatus)}」 / ${items.length}개 상품의 진행현황이 "${newStatus}"으로 수정되었습니다.`, {
                            title: '修改完成 / 수정 완료', variant: 'success', solid: true
                        });
                    }
                } else {
                    throw new Error(response.data.error || '상태 변경 실패');
                }
            } catch (error) {
                console.error('진행현황 수정 오류:', error);
                this.$bvToast.toast('修改出错 / 수정 중 오류가 발생했습니다.', { title: '错误 / 오류', variant: 'danger', solid: true });
            }
        },

        /**
         * 1688 구매코드 생성
         * - 제트배송 + 쿠팡센터: Z (로켓그로스)
         * - 제트배송 + 화주: G (화주)
         * - 로켓배송: R (로켓)
         * - 그 외: G (화주)
         */
        generate1688PurchaseCode(item) {
            let typeCode = 'G'; // 기본값: 화주

            if (item.reqtype === '제트배송') {
                if (item.요청내역?.destination === 'customer') {
                    typeCode = 'G'; // 화주
                } else {
                    typeCode = 'Z'; // 로켓그로스 (쿠팡센터)
                }
            } else if (item.reqtype === '로켓배송') {
                typeCode = 'R'; // 로켓
            } else if (item.reqtype === '일반LCL') {
                typeCode = 'G'; // LCL
            } else if (item.reqtype === '샘플검증') {
                typeCode = 'S'; // 샘플검증
            }

            // 飞运 + 타입코드 + 공백 + companyid (최대 24자)
            return ('飞运' + typeCode + ' ' + item.companyid).slice(0, 24);
        },
        async fetchExchangeRate() {
            try {
                const response = await axios.post('/api/getExchangeRate', {});
                if (response.data.success && response.data.data) {
                    this.exchangeRate = response.data.data;
                    // 통합통관 환율이 있으면 설정
                    if (response.data.data.integratedRate) {
                        this.integratedExchangeRate = response.data.data.integratedRate;
                        this.editIntegratedRate = response.data.data.integratedRate;
                    }
                }
            } catch (error) {
                console.error('환율 정보 조회 오류:', error);
            }
            // 단독통관 견적·목록 환율은 1688 주문일 기준이라 이력도 함께 받아 둔다(실패해도 현재 환율로 동작)
            try {
                const res = await axios.post('/api/getExchangeRateHistory', {});
                if (res.data.success) this.exchangeRateHistory = res.data.data || [];
                else console.error('환율 이력 조회 실패:', res.data.message);
            } catch (error) {
                console.error('환율 이력 조회 오류:', error);
            }
        },
        /**
         * 1688 주문 생성일(KST)에 적용되던 단독통관 환율 — 서버 fxOrderDateOf + pickCnyRateAsOf 와 같은 규칙.
         * 재주문이면 주문시간이 새 주문으로 바뀌므로 재주문일 환율이다. 주문 전·이력 없음이면 null.
         */
        cnyRateForOrder(item) {
            const t = item?.주문정보?.주문시간 || item?.주문시간;
            if (!t || !this.exchangeRateHistory.length) return null;
            const ms = new Date(t).getTime();
            if (isNaN(ms)) return null;
            const 기준일 = new Date(ms + 9 * 3600 * 1000).toISOString().slice(0, 10);
            const h = this.exchangeRateHistory.find(x => x.적용시작 <= 기준일); // 이력은 최근순
            const rate = h ? parseFloat(h.cashBuyValue) : 0;
            return rate > 0 ? { 기준일, rate } : null;
        },
        /** 견적 생성 시 요청별 환율 — 통합통관=통합환율, 단독통관=직접 입력값(환율수동) > 1688 주문일 환율 > 입력칸/현재 환율 */
        quoteRateForItem(item) {
            const form = this.quotation1688Form || {};
            if (form.customsType === 'integrated') return this.integratedExchangeRate || 300;
            if (form.환율수동) return form.환율 || parseFloat(this.exchangeRate?.cashBuyValue) || 190;
            const r = this.cnyRateForOrder(item);
            if (r) return r.rate;
            return parseFloat(this.exchangeRate?.cashBuyValue) || form.환율 || 190; // 주문 전 — 기존처럼 현재 환율
        },
        async openExchangeRateHistory() {
            this.$bvModal.show('exchange-rate-history-modal');
            this.exchangeRateHistoryLoading = true;
            try {
                const response = await axios.post('/api/getExchangeRateHistory', {});
                if (response.data.success) {
                    this.exchangeRateHistory = response.data.data || [];
                } else {
                    console.error('환율 이력 조회 실패:', response.data.message);
                    alert('환율 이력 조회 실패 (汇率历史查询失败)');
                }
            } catch (error) {
                console.error('환율 이력 조회 오류:', error);
                alert('환율 이력 조회 중 오류가 발생했습니다. (汇率历史查询出错)');
            } finally {
                this.exchangeRateHistoryLoading = false;
            }
        },
        todayKst() {
            return new Date(Date.now() + 9 * 3600 * 1000).toISOString().slice(0, 10);
        },
        async fetchIntegratedRateHistory() {
            try {
                const res = await axios.post('/api/getIntegratedExchangeRateHistory', {});
                if (res.data.success) this.integratedRateHistory = res.data.data || [];
                else console.error('통합통관 환율 이력 조회 실패:', res.data.message);
            } catch (error) {
                console.error('통합통관 환율 이력 조회 오류:', error);
            }
        },
        openExchangeRateModal() {
            const password = prompt('비밀번호를 입력하세요 (请输入密码):');
            if (password === '0217') {
                this.editIntegratedRate = this.integratedExchangeRate;
                this.editIntegratedFrom = this.todayKst();
                this.fetchIntegratedRateHistory();
                this.$bvModal.show('exchange-rate-modal');
            } else if (password !== null) {
                alert('비밀번호가 올바르지 않습니다. (密码错误)');
            }
        },
        async saveIntegratedExchangeRate() {
            try {
                const response = await axios.post('/api/saveIntegratedExchangeRate', {
                    integratedRate: parseFloat(this.editIntegratedRate),
                    effectiveFrom: this.editIntegratedFrom || this.todayKst()
                });
                if (response.data.success) {
                    // 예약(미래 시작일)이면 지금 화면 값은 그대로 — 서버의 오늘 기준 값을 다시 받는다
                    await this.fetchExchangeRate();
                    this.fetchIntegratedRateHistory();
                    alert('통합통관 환율이 저장되었습니다. (综合清关汇率已保存) 生效日期/적용 시작일: ' + (response.data.effectiveFrom || ''));
                } else {
                    alert('保存失败 / 저장 실패: ' + response.data.message);
                }
            } catch (error) {
                console.error('환율 저장 오류:', error);
                alert('保存出错 / 저장 중 오류가 발생했습니다.');
            }
        },
        getModalId(item) {
            // item._id가 고유하고 HTML ID로 사용 가능하다고 가정
            return `edit-modal-${item._id}`;
        },

        // 모달이 열리기 직전 호출 (@show 이벤트 핸들러)
        handleModalShow(item) {
            console.log(`모달 열림 준비: ${item._id}`);
            // 취소 시 복원을 위해 원본 데이터 임시 저장 (item 객체에 직접 추가)
            // '_originalData' 같이 충돌 가능성 적은 이름 사용
            this.$set(item, '_originalData', this.deepClone({
                상품명: item.상품명,
                바코드: item.바코드
                // 필요한 다른 필드도 복사
            }));
            console.log("원본 데이터 저장됨:", item._originalData);
        },

        // 모달 '저장(OK)' 버튼 클릭 시 (@ok 이벤트 핸들러)
        async handleModalOk(bvModalEvent, item) {
            console.log(`저장 시도: ${item._id}`);
            // 기본 모달 닫힘 방지
            bvModalEvent.preventDefault();

            // 간단 유효성 검사
            if (!item.상품명 || !item.바코드) {
                alert('请填写商品名和条码 / 상품명과 바코드를 모두 입력해주세요.');
                return; // 저장 중단
            }

            // 원본과 비교하여 변경사항 확인 (선택 사항)
            if (item._originalData &&
                item.상품명 === item._originalData.상품명 &&
                item.바코드 === item._originalData.바코드) {
                console.log("변경 사항 없음, 모달 닫기");
                // 변경 없으면 임시 데이터 제거 후 모달 닫기
                delete item._originalData;
                this.$refs['modalRef-' + item._id]?.hide(); // ref로 특정 모달 닫기
                return;
            }


            try {
                // 서버 업데이트 요청 (item 객체를 배열에 담아 전달)
                await this.updatereqlist([item]); // v-model로 이미 item이 수정된 상태

                // 성공 시: 임시 원본 데이터 제거
                delete item._originalData;
                console.log(`저장 성공 및 임시 데이터 제거: ${item._id}`);
                alert('已保存 / 성공적으로 저장되었습니다.');

                // 명시적으로 모달 닫기 (필수)
                this.$refs['modalRef-' + item._id]?.hide();

                // reqlistsinit 업데이트 (필요 시)
                const initIndex = this.reqlistsinit.findIndex(initItem => initItem._id === item._id);
                if (initIndex !== -1) {
                    this.reqlistsinit.splice(initIndex, 1, this.deepClone(item));
                }


            } catch (error) {
                console.error(`저장 실패: ${item._id}`, error);
                alert(`保存出错 / 저장 중 오류가 발생했습니다: ${error.message || '未知错误 / 알 수 없는 오류'}`);
                // 실패 시 모달을 닫지 않음 (사용자가 수정하거나 취소할 기회 제공)
            }
        },

        // 모달이 완전히 닫힌 후 호출 (@hidden 이벤트 핸들러)
        handleModalHidden(item) {
            console.log(`모달 닫힘: ${item._id}`);
            // 임시 원본 데이터가 남아있다면 => 저장 실패했거나, '취소' 버튼을 누른 경우
            if (item._originalData) {
                console.log("취소 또는 저장 실패로 인한 데이터 복원 시도");
                // 원본 데이터로 item 객체 복원
                Object.assign(item, item._originalData); // item의 속성을 _originalData의 속성으로 덮어씀
                // 복원 후 임시 데이터 제거
                delete item._originalData;
                console.log("데이터 복원 완료 및 임시 데이터 제거");
            } else {
                console.log("정상 저장 완료 후 닫힘 (복원 불필요)");
            }
        },

        // Form 안에서 Enter키로 제출 시 OK 버튼 누른 것과 동일하게 처리 (선택 사항)
        submitViaOk(item) {
            // 해당 아이템의 모달 참조를 찾아 ok() 메소드를 호출
            this.$refs['modalRef-' + item._id]?.ok();
        },
        updateInspectionResults(group, item, list) {
            // 체크된 항목들만 요청내역에 저장
            const checkedItems = group.items
                .filter(i => i.checked)
                .map(i => i.content);

            if (!list.요청내역.checklist) {
                this.$set(list.요청내역, 'checklist', {
                    groups: this.deepClone(this.checklistGroups)
                });
            }

            // 현재 그룹 찾기
            const targetGroup = list.요청내역.checklist.groups.find(g => g.title === group.title);
            if (targetGroup) {
                // 아이템 업데이트
                const targetItem = targetGroup.items.find(i => i.content === item.content);
                if (targetItem) {
                    targetItem.checked = item.checked;
                }

                // 체크된 항목들을 샘플검사요청내역에 저장
                if (!list.요청내역.샘플검사요청내역) {
                    this.$set(list.요청내역, '샘플검사요청내역', {});
                }

                if (checkedItems.length > 0) {
                    this.$set(list.요청내역.샘플검사요청내역, group.title, checkedItems);
                } else {
                    // 체크된 항목이 없으면 해당 그룹 삭제
                    this.$delete(list.요청내역.샘플검사요청내역, group.title);
                }
            }
        },
        validateQuantity(list) {
            const minQuantity = this.getMinOrderQuantity(list);
            const maxQuantity = this.getAvailableStock(list);
            const currentQuantity = parseInt(list.구매요청수량);

            if (currentQuantity < minQuantity) {
                alert(`少于起批量(${minQuantity}) / 최소 주문수량(${minQuantity}개)보다 적습니다.`);
                // list.구매요청수량 = minQuantity;
            } else if (currentQuantity > maxQuantity) {
                alert(`超过可采购的最大数量(${maxQuantity}) / 구매 가능한 최대 수량(${maxQuantity}개)을 초과하였습니다.`);
                // list.구매요청수량 = maxQuantity;
            }
        },
        getMinOrderQuantity(list) {
            if (!list.item) return 2;
            return list.item?.minOrderQuantity || 2;
        },
        // 요청 옵션(옵션1/옵션2_중국어)이 가리키는 1688 specId.
        // 옵션이 없으면 '' (옵션 없는 상품), 맞는 SKU 가 없으면 undefined.
        // 1688 skuAttributes 순서가 옵션1/옵션2 와 반대인 상품이 있다(예: [特大, 03.粉红郁金香] 인데
        // 옵션1=03.粉红郁金香 · 옵션2=特大). 자리 그대로 먼저 찾고, 없으면 순서와 무관하게 값으로 찾는다.
        findSkuSpecId(item) {
            const wanted = [item.옵션1_중국어, item.옵션2_중국어].filter(Boolean);
            if (wanted.length === 0) return '';
            const skus = (item.item && item.item.productSkuInfos) || [];
            const values = sku => (sku.skuAttributes || []).map(a => a.value);
            const sku = skus.find(f => wanted.every((w, i) => values(f)[i] === w))
                || skus.find(f => {
                    const v = values(f);
                    return v.length === wanted.length && wanted.every(w => v.includes(w));
                });
            return sku ? sku.specId : undefined;
        },
        // 옵션이 1688 상품의 어느 SKU 와도 맞지 않는 요청 → 주문을 막을 안내문. 없으면 ''.
        unmatchedOptionMessage(items) {
            const bad = items.filter(item => this.findSkuSpecId(item) === undefined);
            if (bad.length === 0) return '';
            return '以下商品的请求选项与1688商品选项不匹配，无法下单，请重新匹配选项 / 아래 상품은 요청 옵션이 1688 상품의 옵션과 맞지 않아 주문을 만들 수 없습니다. 옵션 매칭을 다시 해주세요.\n\n'
                + bad.slice(0, 10).map(item => '· ' + (item.상품명 || item.상품주문번호 || '(이름 없음)')
                    + ' [' + [item.옵션1_중국어, item.옵션2_중국어].filter(Boolean).join(' / ') + ']').join('\n')
                + (bad.length > 10 ? '\n· 另 (외) ' + (bad.length - 10) + '件' : '');
        },
        /**
         * 1688 주문 직전 실시간 재고 확인.
         * 구매요청에 저장된 상품정보는 등록 시점 재고라 낡는다. 1688 은 한 품목이라도 재고가
         * 모자라면 주문 전체를 거절하므로(库存不足) 주문 전에 지금 재고와 요청수량을 비교한다.
         * 모자란 품목이 있으면 [그 품목 빼고 주문] / [취소] 를 묻는다. 뺀 품목은 상태를 건드리지 않는다.
         *
         * @returns {Promise<{excludedIds: string[], shortLines: string[]}|null>} 취소면 null
         */
        // auto=true(批量下单): 확인창 없이 모자란·옵션 바뀐 품목을 자동으로 빼고 reasons(_id → 사유)를 함께 돌려준다. 취소(null)는 없다.
        async checkLiveStock(items, auto) {
            const need = {}; // offerId_specId → 요청 합계
            items.forEach(item => {
                const offerId = ((item.구매링크 || '').match(/offer\/(\d+)/) || [])[1];
                if (!offerId) return;
                const specId = this.findSkuSpecId(item) || '';
                const key = offerId + '_' + specId;
                const qty = item._주문수량_override != null
                    ? parseInt(item._주문수량_override)
                    : parseInt(item.구매요청수량) * parseInt(item.판매구성수량 || 1);
                if (!need[key]) {
                    need[key] = {
                        offerId, specId, qty: 0, ids: [],
                        name: item.상품명 || offerId,
                        wanted: [item.옵션1_중국어, item.옵션2_중국어].filter(Boolean),
                        label: [item.옵션1_중국어, item.옵션2_중국어].filter(Boolean).join(' ')
                    };
                }
                need[key].qty += qty || 0;
                need[key].ids.push(item._id);
            });
            const offerIds = [...new Set(Object.values(need).map(n => n.offerId))];
            if (offerIds.length === 0) return { excludedIds: [], shortLines: [] };

            let live;
            try {
                const res = await axios.post('/api/reqpurchase/liveSkuStock', { offerIds });
                if (res.data.요청결과 !== '성공') throw new Error(res.data.error || '조회 실패');
                live = res.data.result || {};
            } catch (e) {
                // 확인을 못 하면 예전처럼 그대로 주문한다 — 모자라면 1688 이 오류로 알려준다.
                console.error('1688 실시간 재고 확인 실패:', e);
                return { excludedIds: [], shortLines: [] };
            }

            const short = [];
            // 저장된 옵션(specId)이 1688 실시간 옵션에 없음 = 판매자가 옵션 이름을 바꿈. 재고 0 이 아니다.
            const renamed = [];
            Object.values(need).forEach(n => {
                const r = judgeLiveStock(n, live[n.offerId]); // 조회 실패(skip)한 상품은 막지 않는다
                if (r.kind === 'short') {
                    const label = (r.sku && r.sku.옵션.join(' ')) || n.label || n.name;
                    short.push(Object.assign({}, n, { stock: r.stock, label }));
                } else if (r.kind === 'renamed') {
                    renamed.push(Object.assign({}, n, { candidates: r.candidates }));
                }
            });
            if (short.length === 0 && renamed.length === 0) return { excludedIds: [], shortLines: [] };

            if (auto === true) {
                const reasons = {};
                short.forEach(s => s.ids.forEach(id => { reasons[id] = '库存不足 / 재고 부족 (库存' + s.stock + ' / 需要' + s.qty + ')'; }));
                renamed.forEach(s => s.ids.forEach(id => { reasons[id] = '1688选项已变更 / 1688 옵션이 바뀜 — 옵션 매칭 다시 필요'; }));
                return {
                    excludedIds: [].concat(...short.concat(renamed).map(s => s.ids)),
                    shortLines: [], reasons
                };
            }

            const multiOffer = offerIds.length > 1;
            const prefix = s => '· ' + (multiOffer ? '[' + String(s.name).slice(0, 15) + '] ' : '');
            const shortLines = short.map(s => prefix(s) + s.label + '  库存' + s.stock + ' / 需要' + s.qty);
            const renamedLines = renamed.map(s => prefix(s) + (s.label || s.name)
                + (s.candidates.length
                    ? '\n    → 新选项候选 / 새 옵션 후보: ' + s.candidates.slice(0, 3)
                        .map(c => c.옵션.join(' ') + ' (库存 ' + c.재고 + ')').join(', ')
                    : ''));
            const heads = [];
            if (renamed.length) {
                heads.push('1688 选项已变更（卖家修改了选项名称），请重新匹配选项 / 1688 옵션이 바뀌었습니다(판매자가 옵션 이름 변경) — 옵션을 다시 매칭해 주세요 ('
                    + renamed.length + '개 품목)\n\n' + renamedLines.join('\n'));
            }
            if (short.length) {
                heads.push('1688 库存不足 / 1688 재고 부족 (' + short.length + '개 품목)\n\n' + shortLines.join('\n'));
            }
            const head = heads.join('\n\n');
            const problems = short.concat(renamed);
            const allShort = problems.length === Object.keys(need).length;
            const h = this.$createElement;
            if (allShort) {
                await this.$bvModal.msgBoxOk(
                    h('div', { style: { whiteSpace: 'pre-line' } },
                        head + (renamed.length
                            ? '\n\n所有品项均无法下单 / 모든 품목을 주문할 수 없습니다.'
                            : '\n\n所有品项库存不足，无法下单 / 모든 품목의 재고가 부족해 주문할 수 없습니다.')),
                    { title: '库存确认 / 재고 확인', okTitle: '确认 / 확인' }
                );
                return null;
            }
            const ok = await this.$bvModal.msgBoxConfirm(
                h('div', { style: { whiteSpace: 'pre-line' } },
                    head + '\n\n1688 在任一品项缺货或选项不存在时会拒绝整笔订单。\n한 품목이라도 모자라거나 옵션이 없으면 1688 이 주문 전체를 거절합니다.\n\n'
                    + '以上品项除外，其余下单? / 위 품목은 빼고 나머지만 주문할까요?\n(除外品项状态不变 / 뺀 품목은 상태가 그대로 남습니다)'),
                {
                    title: '库存确认 / 재고 확인',
                    okTitle: '以上品项除外下单 / 위 품목 빼고 주문',
                    cancelTitle: '取消 / 취소',
                    okVariant: 'primary'
                }
            );
            if (!ok) return null;
            return { excludedIds: [].concat(...problems.map(s => s.ids)), shortLines: shortLines.concat(renamedLines) };
        },
        getAvailableStock(list) {
            // console.log(list)
            if (!list.item || !list.item.productSaleInfo) return 0;

            let stock = 0;
            if (!list.옵션1_중국어 && !list.옵션2_중국어) {
                stock = parseInt(list.item.productSaleInfo.amountOnSale);
            } else if (list.옵션1_중국어 && !list.옵션2_중국어) {
                stock = parseInt(list.item.productSkuInfos.find(f =>
                    f.skuAttributes[0].value == list.옵션1_중국어
                )?.amountOnSale || 0);
            } else {
                stock = parseInt(list.item.productSkuInfos.find(f =>
                    f.skuAttributes[0].value == list.옵션1_중국어 &&
                    f.skuAttributes[1].value == list.옵션2_중국어
                )?.amountOnSale || 0);
            }
            return stock;
        },
        async createOrder() {
            if (this.orderCreating || this.bulkOrdering) return; // 진행중이면 즉시 무시 — 재클릭 중복 주문 방지
            // 1. 선택된 아이템 검증
            let arr = [];
            const validStatuses = ['구매전', '구매확인'];
            if (this.tableSelectedItem.length == 0) {
                if (this.reqlists.some(e => !validStatuses.includes(e.processStatus || e.진행현황))) {
                    alert('请只选择待采购或采购确认状态的商品 / 구매전 또는 구매확인 상태인 제품들만 선택해주세요.')
                    return
                }
                arr = this.reqlists
            } else {
                if (this.tableSelectedItem.some(e => !validStatuses.includes(e.processStatus || e.진행현황))) {
                    alert('请只选择待采购或采购确认状态的商品 / 구매전 또는 구매확인 상태인 제품들만 선택해주세요.')
                    return
                }
                arr = this.tableSelectedItem
            }

            // 非1688(自行采购) 은 1688 주문을 만들지 않는다 — 已转账(송금완료) 로 처리한다
            const isNonRow = e => this.isNon1688(e) || e.비1688 === true;
            const non1688Cnt = arr.filter(isNonRow).length;
            if (non1688Cnt > 0) {
                arr = arr.filter(e => !isNonRow(e));
                alert(`非1688(自行采购) ${non1688Cnt}건은 1688 주문생성에서 제외됩니다. 已转账(송금완료)로 처리하세요.\n已排除非1688商品，请用「已转账」登记。`);
                if (arr.length === 0) return;
            }

            // 최소 주문수량은 여기서 막지 않는다 — 1688 이 起批量으로 거절하면
            // 아래 createCrossOrder 응답에서 개별주문(代发) 재시도를 묻는다(askRetryAsSaleproxy).
            const unmatchedMsg = this.unmatchedOptionMessage(arr.filter(item => item.구매링크));
            if (unmatchedMsg) {
                alert(unmatchedMsg);
                return;
            }
            // 재고는 저장된 상품정보(등록 시점 값)가 아니라 주문 직전 1688 실시간 재고로 확인한다.
            // 재고 확인(2~5초) 전에 진행중 플래그를 켠다 — 그 사이 재클릭으로 중복 주문이 나갔다(2026-10-07).
            this.orderCreating = true;
            try {
            const stockCheck = await this.checkLiveStock(arr.filter(item => item.구매링크));
            if (!stockCheck) return;
            if (stockCheck.excludedIds.length) {
                arr = arr.filter(item => !stockCheck.excludedIds.includes(item._id));
            }
            this.showspinner = true;

            try {
                console.log("처리할 전체 items:", arr);
                const allUpdatedItems = []; // 모든 업데이트될 아이템을 담을 배열

                const companyGroups = {};
                arr.forEach(item => {
                    if (!companyGroups[item.companyid]) {
                        companyGroups[item.companyid] = [];
                    }
                    companyGroups[item.companyid].push(item);
                });
                console.log("Company Groups:", companyGroups);

                for (const [companyId, items] of Object.entries(companyGroups)) {
                    console.log(`Processing Company ${companyId} with items:`, items);

                    const supplierGroups = {};
                const sellerKeyOf = this.makeSellerKeyOf(items);
                    const noLinkItems = [];
                    items.forEach(item => {
                        const offerId = ((item.구매링크 || '').match(/offer\/(\d+)/) || [])[1] || '';
                        // 구매링크가 없거나 1688 상품 주소가 아니면 주문에 넣지 않는다.
                        // 예전에는 여기서 화면이 멈춰(undefined 에 .slice) 무엇이 문제인지 알 수 없었다.
                        if (!offerId) {
                            noLinkItems.push(item.상품명 || item.상품주문번호 || '(이름 없음)');
                            return;
                        }
                        // 같은 판매자·같은 배송유형 상품을 한 주문으로 묶는다 (sellerOpenId 없으면 상품 단위).
                        // 배송유형(reqtype)이 주소 접미사 R/Z/G/S 를 정하므로 섞이면 오배송된다.
                        const supplierId = sellerKeyOf(item, offerId) + '|' + (item.reqtype || '');
                        if (!supplierGroups[supplierId]) {
                            supplierGroups[supplierId] = [];
                        }
                        supplierGroups[supplierId].push(item);
                    });
                    if (noLinkItems.length) {
                        alert('以下商品没有1688采购链接，不下单 / 아래 상품은 1688 구매링크가 없어 주문에서 제외됩니다.\n\n'
                            + noLinkItems.slice(0, 10).map(n => '· ' + n).join('\n')
                            + (noLinkItems.length > 10 ? '\n· 另 (외) ' + (noLinkItems.length - 10) + '件' : ''));
                    }
                    console.log(`Supplier Groups for ${companyId}:`, supplierGroups);

                    for (const [supplierId, supplierItems] of Object.entries(supplierGroups)) {
                        console.log(`Processing Supplier ${supplierId} with items:`, supplierItems);

                        const mergedItems = {};
                        supplierItems.forEach(item => {
                            console.log(`Processing item for merging:`, item);
                            const specId = this.findSkuSpecId(item);

                            console.log(`Found specId:`, specId);

                            // if (!specId) {
                            //     console.log(`No specId found for item:`, item);
                            //     return;
                            // }

                            const offerId = parseInt(((item.구매링크 || '').match(/offer\/(\d+)/) || [])[1]);
                            const key = `${offerId}_${specId}`;
                            if (!mergedItems[key]) {
                                mergedItems[key] = {
                                    offerId: offerId,
                                    specId: specId,
                                    quantity: 0
                                };
                            }
                            mergedItems[key].quantity += parseInt(item.구매요청수량) * parseInt(item.판매구성수량 || 1);
                        });
                        console.log(`Merged items:`, mergedItems);

                        const mergedItemsList = Object.values(mergedItems);
                        console.log(`Merged items list:`, mergedItemsList);

                        const chunks = [];
                        for (let i = 0; i < mergedItemsList.length; i += 50) {
                            chunks.push(mergedItemsList.slice(i, i + 50));
                        }
                        console.log(`Created chunks:`, chunks);

                        for (const chunk of chunks) {
                            console.log(`Processing chunk:`, chunk);
                            let reqtype = 'G ';
                            if (supplierItems[0].reqtype == '로켓배송') {
                                reqtype = 'R ';
                            } else if (supplierItems[0].reqtype == '제트배송') {
                                reqtype = 'Z ';
                            } else if (supplierItems[0].reqtype == '샘플검증') {
                                reqtype = 'S ';
                            }

                            // 이 chunk에 해당하는 상품들의 _id 목록 생성
                            const reqItems = [];
                            for (const chunkItem of chunk) {
                                const items = supplierItems.filter(item => {
                                    const itemSpecId = this.findSkuSpecId(item);
                                    return itemSpecId === chunkItem.specId
                                        && parseInt(((item.구매링크 || '').match(/offer\/(\d+)/) || [])[1]) === chunkItem.offerId;
                                });
                                items.forEach(item => {
                                    reqItems.push({ _id: item._id });
                                });
                            }

                            const orderRequest = {
                                flow: 'general',
                                message: '',
                                addressParam: {
                                    // 수취인명은 1688 과거 주문 조회 편의를 위해 업체별로 통일 (항상 '飞运Z ' 접두사)
                                    // 배송유형(R/Z/G/S) 구분은 주소 뒤에만 유지
                                    fullName: ('飞运Z ' + companyId).slice(0, 24),
                                    mobile: '15650102901',
                                    provinceText: '山东省',
                                    cityText: '威海市',
                                    areaText: '环翠区',
                                    address: '凤林街道海南路9号飞运' + reqtype + companyId +
                                        `(无法自提 不接受到付)`,
                                    postCode: '000000'
                                },
                                cargoParamList: chunk,
                                companyId: companyId,
                                reqItems: reqItems
                            };
                            console.log(`Sending order request:`, orderRequest);

                            let res = await axios.post('/api/reqpurchase/createCrossOrder', orderRequest);
                            console.log(`Order creation response:`, res.data);
                            if (res.data.요청결과 !== '성공'
                                && this.askRetryAsSaleproxy(res.data.error?.errorMessage || res.data.error?.message)) {
                                res = await axios.post('/api/reqpurchase/createCrossOrder',
                                    Object.assign({}, orderRequest, { flow: 'saleproxy' }));
                                console.log(`Order creation response (saleproxy):`, res.data);
                            }
                            if (res.data.요청결과 !== '성공') {
                                const errorMessage = res.data.error?.errorMessage ||
                                    res.data.error?.message ||
                                    res.data.error ||
                                    '주문 생성 실패';
                                throw new Error(errorMessage);
                            }
                            if (res.data.요청결과 === '성공') {
                                const 화주주문번호 = res.data.화주주문번호;
                                const 상품주문번호Map = res.data.상품주문번호Map;

                                // chunk에 사용된 specId들을 이용해 해당하는 supplierItems 찾기
                                for (const chunkItem of chunk) {
                                    const items = supplierItems.filter(item => {
                                        const itemSpecId = this.findSkuSpecId(item);
                                        return itemSpecId === chunkItem.specId
                                            && parseInt(((item.구매링크 || '').match(/offer\/(\d+)/) || [])[1]) === chunkItem.offerId;
                                    });

                                    // 찾은 items에 주문 정보 업데이트 (서버 응답의 아이템별 가격 사용)
                                    const 아이템별가격 = res.data.아이템별가격 || {};
                                    items.forEach(item => {
                                        const price = 아이템별가격[item._id] || {};
                                        item.화주주문번호 = 화주주문번호;
                                        item.상품주문번호 = 상품주문번호Map[item._id] || '';
                                        item.주문정보 = {
                                            '1688주문번호': res.data.result.orderResult.result.orderId,
                                            협상전_단가: price.협상전_단가 || 0,
                                            협상전_상품금액: price.협상전_상품금액 || 0,
                                            협상전_배송비: price.협상전_배송비 || 0,
                                            협상전_총금액: price.협상전_총금액 || 0,
                                            협상전_수량: price.협상전_수량 || parseInt(item.구매요청수량) || 1,
                                            협상전_주문배송비: price.협상전_주문배송비 || 0,
                                            주문시간: new Date().toISOString()
                                        };
                                        item.주문생성여부 = true;
                                        item.주문시간 = new Date().toISOString();
                                        item.processStatus = '협상중';
                                        item.진행현황 = '협상중';
                                        allUpdatedItems.push(item);
                                    });
                                }
                            }
                        }
                    }
                }

                // 로컬 데이터 갱신 (서버는 이미 DB 저장 완료했으므로 updatereqlist 불필요)
                if (allUpdatedItems.length > 0) {
                    for (const updated of allUpdatedItems) {
                        const idx = this.reqlists.findIndex(r => r._id === updated._id);
                        if (idx !== -1) this.$set(this.reqlists, idx, updated);
                        const initIdx = this.reqlistsinit.findIndex(r => r._id === updated._id);
                        if (initIdx !== -1) this.$set(this.reqlistsinit, initIdx, this.deepClone(updated));
                    }
                }

                alert('全部订单创建完成 / 모든 주문 생성 완료');
                this.showspinner = false;
            } catch (e) {
                // 서버 중복 방어(409)는 axios 가 예외로 던진다 — 서버 문구를 그대로 보여준다
                alert('订单创建失败 / 주문 생성 실패: ' + (e.response?.data?.error?.errorMessage || e.message));
                console.error('주문 생성 에러:', e);
                this.showspinner = false;
                return;
            }
            } finally {
                this.orderCreating = false;
            }
        },
        changePackage(list) {
            if (this.packageMethod == 'opp') {
                list.요청내역.opp = true;
                list.요청내역.LDPE = false;
                list.요청내역.auto = false;
                return
            }
            if (this.packageMethod == 'LDPE') {
                list.요청내역.opp = true;
                list.요청내역.LDPE = false;
                list.요청내역.auto = false;
                return
            }
            if (this.packageMethod == 'noPackage') {
                list.요청내역.opp = false;
                list.요청내역.LDPE = false;
                list.요청내역.auto = false;
                return
            }
            if (this.packageMethod == 'auto') {
                list.요청내역.opp = false;
                list.요청내역.LDPE = false;
                list.요청내역.auto = true;
                return
            }
        },
        confirmBarcode(list) {
            if (list.바코드.includes('no') || list.바코드.includes('NO') || list.바코드.includes('No') || list.바코드.includes('노')) {
                if (list.묶음구성여부) {
                    alert('没有条码信息时无法合包，请先生成条码 / 바코드 정보가 없는 경우 묶음구성 진행이 어렵습니다. 바코드를 먼저 생성해 주세요')
                    return
                }
            }
        },
        async changeoptiondone() {
            if (this.change && !this.changeoption) {
                if (confirm('保存修改? / 변경사항을 저장하시겠습니까?')) {
                    this.reqlists.forEach((e, i) => {
                        if (this.changeindexlist.includes(i)) {
                            e.checked = true;
                        } else {
                            e.checked = false;
                        }
                    })
                    var arr = this.reqlists.filter(e => e.checked);
                    // 구매취소 대상은 「구매불가로 표시된 행」만 — 재매칭으로 옵션만 바꾼 행은 절대 포함하지 않는다
                    const unbuyable = pickUnbuyableRows(arr);
                    if (unbuyable.length > 0 && confirm('以下不可采购商品将被采购取消 (' + unbuyable.length + '件) / 아래 구매불가 건을 구매취소처리하시겠습니까? (' + unbuyable.length + '건)\n\n' + describeRows(unbuyable))
                        && confirm('再次确认: 采购取消 ' + unbuyable.length + '件? / 최종 확인: ' + unbuyable.length + '건을 구매취소합니다. 진행할까요?')) {
                        const cancelIds = unbuyable.map(e => e._id);
                        await axios.post('/api/reqpurchase/updateProcessStatusBulk', {
                            ids: cancelIds,
                            toStatus: '구매취소',
                            memo: '구매옵션재매칭 - 구매불가 취소처리',
                            additionalFields: { 구매취소: true }
                        });
                        // 취소하지 않는 나머지 행(옵션만 바꾼 행)은 재매칭 결과를 저장한다
                        const rest = arr.filter(e => !unbuyable.includes(e));
                        if (rest.length) await this.updatereqlist(rest);
                    } else {
                        await this.updatereqlist(arr);
                    }
                    this.search();
                } else {
                    this.search();
                }
            }
        },
        async allcancelpo() {
            if (this.tableSelectedItem.length == 0) {
                alert('请选择要变更的记录 / 변경할 내역을 선택해 주세요')
                return
            }
            if (this.일괄변경 == '구매취소' && this.tableSelectedItem.filter(e => (e.processStatus || e.진행현황) !== '구매전' && (e.processStatus || e.진행현황) !== '구매취소').length > 0) {
                if (!confirm('已有已采购的商品，仍要采购取消? / 이미 구매한 제품이 있습니다. 그래도 구매취소처리하시겠습니까?')) {
                    return
                }
            }
            const ids = this.tableSelectedItem.map(e => e._id);
            const additionalFields = this.일괄변경 == '구매취소'
                ? { 구매취소: true, 구매취소내용: this.tableSelectedItem[0]?.일괄구매취소내용 || '' }
                : { 구매취소: false, 구매취소내용: '' };

            const res = await axios.post('/api/reqpurchase/updateProcessStatusBulk', {
                ids: ids,
                toStatus: this.일괄변경,
                memo: '일괄변경 - ' + this.일괄변경,
                additionalFields: additionalFields
            });
            // 서버가 역행이라고 건너뛴 건은 조용히 넘기지 않는다. 안 알려주면
            // 사용자는 바뀐 줄 알고 다음 작업(주문생성 등)을 시도하게 된다.
            const skipped = res.data?.skipped || [];
            if (skipped.length) {
                alert(`${skipped.length}件未能变更 / ${skipped.length}건은 변경하지 못했습니다.\n\n` +
                    skipped.slice(0, 5).map(s => `· ${s.reason}`).join('\n') +
                    (skipped.length > 5 ? `\n· 另 (외) ${skipped.length - 5}件` : ''));
            }
            this.search();
        },
        async cancelpo(list) {
            const toStatus = list.구매취소 ? '구매취소' : '구매전';
            const memo = list.구매취소 ? '구매취소 처리' : '구매취소 해제';
            try {
                const response = await axios.post('/api/reqpurchase/updateProcessStatus', {
                    _id: list._id,
                    toStatus: toStatus,
                    memo: memo
                });
                if (response.data.요청결과 === '성공') {
                    list.processStatus = toStatus;
                    list.진행현황 = toStatus;
                    // reqlistsinit 동기화
                    const initIdx = this.reqlistsinit.findIndex(i => i._id === list._id);
                    if (initIdx !== -1) {
                        this.reqlistsinit[initIdx].processStatus = toStatus;
                        this.reqlistsinit[initIdx].진행현황 = toStatus;
                        this.reqlistsinit[initIdx].구매취소 = list.구매취소;
                    }
                    this.updateStatusCounts();
                } else {
                    // 실패 시 체크박스 원복
                    list.구매취소 = !list.구매취소;
                    alert(response.data.error || '状态变更失败 / 상태 변경 실패');
                }
            } catch (error) {
                console.error('구매취소 처리 오류:', error);
                list.구매취소 = !list.구매취소;
                alert('采购取消处理出错 / 구매취소 처리 중 오류가 발생했습니다.');
            }
        },
        async cancelOrder1688() {
            if (!this.selectedGroup) return;

            const targetItems = this.cancelOrder1688Items;
            if (targetItems.length === 0) {
                alert('请选择有1688订单号的商品 / 1688 주문번호가 있는 상품을 선택하세요.');
                return;
            }

            // 선택된 항목에서 고유 주문번호 추출
            const tradeIDs = [...new Set(targetItems.map(i => i.주문정보['1688주문번호']))];

            const reasonOptions = '请选择取消原因 / 취소 사유를 선택하세요:\n1. 买家取消 / 구매자 취소 (buyerCancel)\n2. 卖家无货 / 판매자 재고 없음 (sellerGoodsLack)\n3. 其他 / 기타 (other)';
            const choice = prompt(reasonOptions, '1');
            if (!choice) return;

            const reasonMap = { '1': 'buyerCancel', '2': 'sellerGoodsLack', '3': 'other' };
            const cancelReason = reasonMap[choice] || 'buyerCancel';

            const remark = prompt('取消备注 选填 / 취소 비고 (선택):', '') || '';

            if (!confirm(`取消1688订单 ${tradeIDs.join(', ')}? / 1688 주문 ${tradeIDs.join(', ')}을(를) 취소하시겠습니까?\n对象 / 대상: ${targetItems.length}件\n原因 / 사유: ${cancelReason}\n\n※ 仅限未付款订单 / 미결제 주문만 취소 가능합니다.`)) return;

            this.cancellingOrder = true;
            try {
                const results = [];
                for (const tradeID of tradeIDs) {
                    const response = await axios.post('/api/reqpurchase/cancelOrder1688', {
                        tradeID: tradeID,
                        cancelReason: cancelReason,
                        remark: remark
                    });
                    results.push({ tradeID, result: response.data });
                }

                const successes = results.filter(r => r.result.요청결과 === '성공');
                const failures = results.filter(r => r.result.요청결과 !== '성공');

                // 성공한 주문번호에 해당하는 아이템만 상태 업데이트
                const successTradeIDs = new Set(successes.map(r => r.tradeID));
                this.selectedGroup.items.forEach(item => {
                    const itemTradeID = item.주문정보?.['1688주문번호'];
                    if (itemTradeID && successTradeIDs.has(itemTradeID)) {
                        item.processStatus = '구매취소';
                        item.진행현황 = '구매취소';
                        item.구매취소 = true;
                        item.구매취소내용 = remark || '1688 주문취소';
                        const initIdx = this.reqlistsinit.findIndex(i => i._id === item._id);
                        if (initIdx !== -1) {
                            this.reqlistsinit[initIdx].processStatus = '구매취소';
                            this.reqlistsinit[initIdx].진행현황 = '구매취소';
                            this.reqlistsinit[initIdx].구매취소 = true;
                        }
                    }
                });
                this.updateStatusCounts();

                let msg = '';
                if (successes.length > 0) msg += `取消成功 / 취소 성공: ${successes.map(r => r.tradeID).join(', ')}\n`;
                if (failures.length > 0) msg += `取消失败 / 취소 실패: ${failures.map(r => r.tradeID + ' (' + r.result.error + ')').join(', ')}`;
                alert(msg.trim());
            } catch (error) {
                console.error('1688 주문 취소 오류:', error);
                alert('取消订单出错 / 주문 취소 중 오류가 발생했습니다.');
            } finally {
                this.cancellingOrder = false;
            }
        },
        productNameWith(list) {
            // if(confirm('변경된 한글표시사항 제품명에 따라 상품명도 변경하시겠습니까?')){
            list.상품명 = list.한글표시사항.제품명;
            // }
        },
        importcompanyinfo() {
            if (this.업체명) {
                if (this.$store.state.purchase.length > 0 && this.업체명.toUpperCase() == this.$store.state.purchase[0].companyid.toUpperCase()) {
                    this.showimportspinner = false;
                    this.importtext = 'Connected'
                    return
                }
                this.showimportspinner = true;
                axios.post('/api/logisaddimport/importcompanyinfo', {
                    companyid: this.업체명
                })
                    .then(result => {
                        if (result.data.요청결과 == 'success') {
                            this.importreqlists()
                            this.$store.commit('dbupdate', result.data.dbs)
                            this.importstock = this.$store.state.stock.length > 0 ? this.$store.state.stock.filter(e => e.site == 'cn') : [];
                            this.showimportspinner = false;
                            this.importtext = 'Connected'
                        } else {
                            alert('货主数据导入失败 / 업체 Data Import 실패')
                        }
                    }).catch((e) => {
                        console.log(e);
                    })
            } else {
                alert('请输入货主ID / 업체ID를 기입해 주세요')
            }
        },
        // polists(후보) 중 실제로 고른 발주(selectpo) 하나. 미선택·목록에 없으면 null
        selectedPo(item) {
            if (!item || !item.selectpo || !Array.isArray(item.polists)) return null;
            return item.polists.find(p => p && p.발주번호 === item.selectpo) || null;
        },
        polistchange(b, list) {
            list.발주수량 = b.sku수량;
            list.구매요청수량 = b.sku수량;
            list.selectpo = b.발주번호;
        },
        labelling(요청내역) {
            if (요청내역.barcode) {
                요청내역.한글표시사항 = true
            } else {
                요청내역.한글표시사항 = false
            }
        },
        qadefault(요청내역) {
            if (!요청내역.default) {
                if (요청내역.barcode || 요청내역.sticker || 요청내역.stamp || 요청내역.tag) {
                    alert('单独做原产地作业时，基本验货为必选项 / 개별 원산지 작업을 하는 경우 기본검수는 필수항목 입니다.')
                    요청내역.default = true;
                }
            }
        },

        showModal(item) {
            this.formData = item
            // console.log('formData', this.formData)
        },
        async saverequest(item) {
            const selectedIndex = this.reqlists.findIndex(i => i._id === item._id);
            if ((item.processStatus || item.진행현황) === '입고완료') {
                if (!confirm('已入库的商品不能修改，仍要继续? / 입고가 완료된 상품은 수정이 불가능 합니다. 그래도 진행하시겠습니까?')) {
                    return
                }
            }
            if ((item.processStatus || item.진행현황) === '구매전') {
                this.reqlistsinit[selectedIndex] = this.deepClone(item)
                await this.updatereqlist([item])
                this.$forceUpdate();
            } else {
                if (item['구매요청수량'] !== this.reqlistsinit[selectedIndex]['구매요청수량']) {
                    if (!confirm('已采购的商品不能修改请求数量，仍要继续? / 이미 구매 진행된 상품은 구매요청수량을 변경할 수 없습니다. 그래도 진행하시겠습니까?')) {
                        return
                    }
                } else {
                    this.reqlistsinit[selectedIndex] = this.deepClone(item)
                    await this.updatereqlist([item])
                    this.$forceUpdate();
                }
            }
        },
        async updatereqlist(arr) { /* 기존 로직 (에러 throw 필수) */
            if (arr && arr.length > 0) {
                console.log("서버 업데이트 요청:", arr);
                return axios.post('/api/reqpurchase/updatereqpurchase', arr)
                    .then((res) => {
                        if (res.data.요청결과 == '변경완료') {
                            console.log('서버 업데이트 성공');
                        } else {
                            console.error('서버 업데이트 실패:', res.data);
                            throw new Error(res.data.요청결과 || '서버 저장 실패');
                        }
                        return res;
                    })
                    .catch(error => {
                        console.error('updatereqlist Axios 오류:', error);
                        throw error; // 에러를 상위로 전파
                    });
            } else {
                return Promise.resolve();
            }
        },
        showtotal() {
            this.showreqlist = false;
            setTimeout(() => {
                this.reqlists = this.reqlistsinit;
                this.showreqlist = true;
            }, 10);
        },
        showa() {
            this.showreqlist = false;
            setTimeout(() => {
                this.reqlists = this.reqlistsinit.filter(e => (e.processStatus || e.진행현황) == '구매전');
                this.showreqlist = true;
            }, 10);
        },
        showb() {
            this.showreqlist = false;
            setTimeout(() => {
                this.reqlists = this.reqlistsinit.filter(e => (e.processStatus || e.진행현황) == '배송전');
                this.showreqlist = true;
            }, 10);
        },
        showc() {
            this.showreqlist = false;
            setTimeout(() => {
                const s = e => e.processStatus || e.진행현황;
                this.reqlists = this.reqlistsinit.filter(e => s(e) != '구매전' && s(e) != '배송전' && s(e) != '발송지연' && s(e) != '입고완료' && s(e) != '배송지연');
                this.showreqlist = true;
            }, 10);
        },
        showd() {
            this.showreqlist = false;
            setTimeout(() => {
                this.reqlists = this.reqlistsinit.filter(e => (e.processStatus || e.진행현황) == '입고완료');
                this.showreqlist = true;
            }, 10);
        },
        showe() {
            this.showreqlist = false;
            setTimeout(() => {
                this.reqlists = this.reqlistsinit.filter(e => e.reqtype == '제트배송');
                this.showreqlist = true;
            }, 10);
        },
        // 샘플검증 판정 — 화면 뱃지·필터 버튼 개수·필터링이 **모두 이걸 쓴다.**
        //
        // 예전엔 세 곳이 각자 `reqtype === '샘플검증'` 을 봤는데, applyReqlistResults 가
        // 목록을 읽으면서 그 값을 '일반LCL' + sampleCheck.enabled 로 먼저 바꿔놓기 때문에
        // 세 곳 다 도달 불가능한 죽은 조건이었다 — 뱃지가 안 뜨고, 개수는 0, 필터는 빈 목록.
        // (2026-09-14 YZY 제보. nomadclub 오늘 4건이 DB 엔 '샘플검증' 인데 화면엔 「일반」 뿐이었다)
        // ⚠ 두 모양을 다 받는다. 목록(applyReqlistResults)은 정규화를 거쳐 옵션으로 오는데,
        //   단건 조회(loadSingleRequest)는 정규화를 안 타서 **DB 원본 그대로** reqtype='샘플검증'
        //   이고 sampleCheck 가 아예 없다. 옵션만 보면 단건 화면에서 샘플 표시가 사라진다.
        hasSampleCheck(e) {
            if (!e) return false;
            if (e.reqtype === '샘플검증') return true;
            return !!(e.요청내역 && e.요청내역.sampleCheck && e.요청내역.sampleCheck.enabled);
        },
        showk() {
            this.showreqlist = false;
            setTimeout(() => {
                // ⚠ reqtype 으로 거르면 **영원히 0건**이다. applyReqlistResults 가 목록을 읽을 때
                //   reqtype '샘플검증' 을 '일반LCL' + sampleCheck.enabled 로 이미 바꿔놨다.
                //   판정 기준은 옵션 하나로 통일한다(뱃지·카운트·필터 셋 다).
                this.reqlists = this.reqlistsinit.filter(e => this.hasSampleCheck(e));
                this.showreqlist = true;
            }, 10);
        },
        showl() {
            this.showreqlist = false;
            setTimeout(() => {
                this.reqlists = this.reqlistsinit.filter(e => e.요청변경);
                this.showreqlist = true;
            }, 10);
        },
        showC1() {
            this.showreqlist = false;
            setTimeout(() => {
                this.reqlists = this.reqlistsinit.filter(e => e.통관방법 == '통합통관');
                this.showreqlist = true;
            }, 10);
        },
        showC2() {
            this.showreqlist = false;
            setTimeout(() => {
                this.reqlists = this.reqlistsinit.filter(e => e.통관방법 == '화주단독통관');
                this.showreqlist = true;
            }, 10);
        },
        showC3() {
            this.showreqlist = false;
            setTimeout(() => {
                this.reqlists = this.reqlistsinit.filter(e => e.통관방법 == '쿠패스단독통관');
                this.showreqlist = true;
            }, 10);
        },
        showf() {
            this.showreqlist = false;
            setTimeout(() => {
                this.reqlists = this.reqlistsinit.filter(e => e.구매취소);
                this.showreqlist = true;
            }, 10);
        },
        showg() {
            this.showreqlist = false;
            setTimeout(() => {
                this.reqlists = this.reqlistsinit.filter(e => (e.processStatus || e.진행현황) == '발송지연');
                this.showreqlist = true;
            }, 10);
        },
        showh() {
            this.showreqlist = false;
            setTimeout(() => {
                this.reqlists = this.reqlistsinit.filter(e => (e.processStatus || e.진행현황) == '배송지연');
                this.showreqlist = true;
            }, 10);
        },
        showi() {
            this.showreqlist = false;
            setTimeout(() => {
                this.reqlists = this.reqlistsinit.filter(e => e.reqtype !== '제트배송' && e.reqtype !== '로켓배송');
                this.showreqlist = true;
            }, 10);
        },
        // 快递资料件(로켓배송) — 저장값 reqtype '로켓배송' 그대로 거른다
        showRocket() {
            this.showreqlist = false;
            setTimeout(() => {
                this.reqlists = this.reqlistsinit.filter(e => e.reqtype === '로켓배송');
                this.showreqlist = true;
            }, 10);
        },
        showj() {
            this.showreqlist = false;
            setTimeout(() => {
                this.reqlists = this.reqlistsinit.filter(e => (e.processStatus || e.진행현황) == '구매확인');
                this.showreqlist = true;
            }, 10);
        },
        async poconfirm(arr) {
            const targetItems = arr.filter(e => (e.processStatus || e.진행현황) === '구매전');
            if (targetItems.length > 0) {
                const ids = targetItems.map(e => e._id);
                await axios.post('/api/reqpurchase/updateProcessStatusBulk', {
                    ids: ids,
                    toStatus: '구매확인',
                    memo: '다운로드 시 구매확인 처리'
                });
            }
            this.search();
        },
        getTimeDate(timestamp) {
            let date = new Date(timestamp);
            let year = date.getFullYear();
            let month = ("0" + (1 + date.getMonth())).slice(-2);
            let day = ("0" + date.getDate()).slice(-2);
            let hours = ("0" + date.getHours()).slice(-2);
            let minutes = ("0" + date.getMinutes()).slice(-2);
            let seconds = ("0" + date.getSeconds()).slice(-2);

            return year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
        },

        async onClickLocket(list) {
            if ((list.processStatus || list.진행현황) !== '구매전') {
                alert('只能修改待采购的商品 / 구매전인 상품만 변경 가능합니다.');
            } else {
                if (confirm('改为快递资料件? / 로켓배송으로 변경 하시겠습니까 ?')) {
                    try {
                        const response = await axios.post('/api/reqpurchase/changeLocket', { list })
                        console.log(response)
                        alert(response.data.요청결과)
                    } catch (error) {
                        alert('未知错误 / 알 수 없는 error')
                        console.error(error);
                    }
                } else {
                    return false
                }
            }
        },
        /**
         * 단건 주문 조회 (화주주문번호/1688주문번호/운송장번호 중 선택).
         * 결과를 reqlists에 주입하여 기존 그룹뷰/주문상세 모달을 그대로 재사용.
         * 기간/업체ID 필터 무관 — 전역 검색.
         */
        // 개별상품뷰 검색창용 — 1688주문번호는 주문정보 안쪽에 있어서 표 검색이 못 본다
        reqSearchText(item) {
            return [item?.주문정보?.['1688주문번호'] || '', this.batchNo(item)].join(' ');
        },
        /**
         * 묶음번호 — 한 번에 같이 제출된 구매요청을 묶어 부르는 **표시 전용** 번호. DB 에 저장하지 않는다.
         * 셀러 화면(growth/reqpurchaseV0.vue)이 한 번 제출할 때 모든 건에 같은 요청일(ms)을 넣으므로
         * 「요청일」만으로 묶음이 갈린다. 화주주문번호는 1688 주문 단위(createCrossOrder 가 부여)라 별개다.
         * 형식: YYMMDD-HHmmss (한국시간 고정 — 보는 사람 PC 시간대와 무관하게 같은 번호)
         *   예) 2026-09-17 14:30:25 KST 에 제출 → 260917-143025
         * 업체ID 는 같은 줄에 이미 보이므로 번호에 넣지 않는다(짧게 읽고 부르기 위함).
         */
        batchNo(item) {
            let v = item?.요청일;
            if (v === undefined || v === null || v === '') return '';
            if (typeof v === 'string' && /^\d+$/.test(v)) v = Number(v);
            const d = new Date(v);
            if (isNaN(d.getTime())) return '';
            const k = new Date(d.getTime() + 9 * 60 * 60 * 1000);
            const p = n => String(n).padStart(2, '0');
            return `${p(k.getUTCFullYear() % 100)}${p(k.getUTCMonth() + 1)}${p(k.getUTCDate())}-${p(k.getUTCHours())}${p(k.getUTCMinutes())}${p(k.getUTCSeconds())}`;
        },
        openBatchSearch() {
            this.batchSearchText = this.batchSearchMode === 'owner'
                ? this.ownerFilterNames.join('\n')
                : this.batchSearchNos.join('\n');
            this.showBatchSearchModal = true;
        },
        applyBatchSearch(bvEvt) {
            const nos = this.batchSearchParsed;
            if (!nos.length || nos.length > 100) {
                if (bvEvt) bvEvt.preventDefault();
                return;
            }
            if (this.batchSearchMode === 'owner') {
                // 화주명 모드는 날짜 검색 위에 거는 거름이다 — 번호 검색·단일 화주 칸은 비운다
                this.batchSearchNos = [];
                this.batchSearchNotFound = [];
                this.업체명 = '';
                this.ownerFilterNames = nos;
                this.ownerFilterNotFound = [];
                this.search();
                return;
            }
            this.ownerFilterNames = [];
            this.ownerFilterNotFound = [];
            this.batchSearchNos = nos;
            this.batchSearchNotFound = [];
            this.search();
        },
        // 화주 비교 키 — 대소문자·공백 무시
        ownerKey(v) {
            return String(v == null ? '' : v).toLowerCase().replace(/\s+/g, '');
        },
        // 검색 결과에서 화주 필터에 걸린 건만 남기고, 하나도 안 걸린 화주명을 ownerFilterNotFound 에 둔다
        applyOwnerFilter(list) {
            const keys = new Map(this.ownerFilterNames.map(n => [this.ownerKey(n), n]));
            const hit = new Set();
            const out = (list || []).filter(r => {
                if (this.ownerFilterOnlyBefore && (r.processStatus || r.진행현황 || '구매전') !== '구매전') return false;
                const info = this.companyInfos.find(c => c.companyid === r.companyid);
                const k = [this.ownerKey(r.companyid), info ? this.ownerKey(info.name) : ''].find(x => x && keys.has(x));
                if (!k) return false;
                hit.add(keys.get(k));
                return true;
            });
            this.ownerFilterNotFound = this.ownerFilterNames.filter(n => !hit.has(n));
            return out;
        },
        removeOwnerFilterName(name) {
            this.ownerFilterNames = this.ownerFilterNames.filter(n => n !== name);
            if (!this.ownerFilterNames.length) this.ownerFilterNotFound = [];
            this.search();
        },
        clearOwnerFilter(rerun = true) {
            if (!this.ownerFilterNames.length) return;
            this.ownerFilterNames = [];
            this.ownerFilterNotFound = [];
            if (rerun) this.search();
        },
        bulkOrderCount(status) {
            return this.bulkOrderResults.filter(r => r.status === status).length;
        },
        // 批量下单 실패 목록 — 상품 하나씩 «고객명---货主号---실패사유». 고객명 = 화주명(companyName), 货主号 = 목록 행 눈 아이콘 옆 파란 배지의 화주주문번호(없으면 그룹 대표)
        bulkAddFail(item, reason) {
            if (!item || this.bulkFailItems.some(f => f._id === item._id)) return;
            const g = this.selectedGroup || {};
            const opt = [item.옵션1_중국어, item.옵션2_중국어].filter(Boolean).join(' / ');
            const why = String(reason || '').replace(/\s*\n\s*/g, ' ').trim();
            const name = (item.상품명 || item.상품주문번호 || '') + (opt ? ' [' + opt + ']' : '');
            this.bulkFailItems.push({
                _id: item._id,
                customer: g.companyName || item.companyid || '',
                owner: item.화주주문번호 || g.화주주문번호 || (g.화주주문번호목록 || [])[0] || '',
                product: name,
                reason: why
            });
        },
        bulkFailText() {
            return this.bulkFailItems.map(f => `${f.customer}---${f.owner}---${f.product ? f.product + ' : ' : ''}${f.reason}`).join('\n');
        },
        copyBulkFail() {
            const text = this.bulkFailText();
            const done = () => this.$bvToast.toast('已复制 / 복사했습니다', { title: '提示 / 알림', variant: 'success', solid: true });
            const fallback = () => {
                const ta = this.$refs.bulkFailTextarea;
                if (ta) { ta.select(); try { document.execCommand('copy'); done(); } catch (e) { console.error('실패 목록 복사 실패:', e); } }
            };
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(text).then(done).catch(e => { console.error('실패 목록 복사 실패:', e); fallback(); });
            } else {
                fallback();
            }
        },
        downloadBulkFail() {
            if (!this.bulkFailItems.length) return;
            const rows = this.bulkFailItems.map(f => ({
                '客户名 (고객명)': f.customer,
                '货主号 (订单号·화주주문번호)': f.owner,
                '商品 (상품)': f.product,
                '失败原因 (실패사유)': f.reason
            }));
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(rows), '실패목록');
            XLSX.writeFile(wb, '일괄주문_실패목록_' + this.getToday() + '.xlsx');
        },
        /**
         * 批量下单 / 일괄 1688주문 (崔凡 10-07) — 새 주문 로직이 아니다.
         * 선택 건을 그룹(groupedReqlists: 요청일·유형·화주·상태·통관)으로 나눠 기존 createOrderFromGroup 을 **하나씩 차례로** 부른다.
         * 그 안에서 판매처(sellerOpenId)·50품목 단위로 다시 나뉘고, 재고확인(#1117)·서버 중복잠금(#1185)·代发 재시도 확인도 그대로 탄다.
         * 동시 호출은 항상 1개. 중단은 다음 그룹부터 멈춘다(진행중인 1688 호출은 끝까지 기다린다).
         */
        async bulkCreateOrders() {
            if (this.orderCreating || this.bulkOrdering) return;
            const selected = this.viewMode === 'group'
                ? this.tableSelectedItem.flatMap(g => g.items || [])
                : this.tableSelectedItem;
            const ids = new Set(selected.map(i => i._id));
            if (!ids.size) {
                alert('请先选择商品 / 먼저 상품을 선택하세요');
                return;
            }
            const validStatuses = ['구매전', '구매확인'];
            const targets = [];
            const skipped = [];
            this.groupedReqlists.forEach(g => {
                const items = g.items.filter(i => ids.has(i._id));
                if (!items.length) return;
                const label = `${g.companyid} · ${this.getdate(g.요청일)} · ${this.displayZh(g.reqtype)} · ${this.displayZh(g.processStatus)}`;
                if (g.비1688) {
                    skipped.push({ label, count: items.length, status: 'skip', reason: '非1688 → 已转账 / 비1688 — 송금완료로 처리' });
                } else if (!validStatuses.includes(g.processStatus)) {
                    skipped.push({ label, count: items.length, status: 'skip', reason: '状态不可下单 / 주문 불가 상태' });
                } else {
                    targets.push({ group: Object.assign({}, g, { items }), label, count: items.length });
                }
            });
            if (!targets.length) {
                alert('没有可下单的分组 / 주문할 수 있는 그룹이 없습니다 (구매전·구매확인만)');
                return;
            }
            const owners = new Set(targets.map(t => t.group.companyid)).size;
            const itemCnt = targets.reduce((s, t) => s + t.count, 0);
            if (!confirm(`批量下单 / 일괄 1688주문\n货主 ${owners}个 · 分组 ${targets.length}个 · 商品 ${itemCnt}件\n화주 ${owners}곳 · 그룹 ${targets.length}개 · 상품 ${itemCnt}건`
                + (skipped.length ? `\n\n跳过 / 건너뜀 ${skipped.length}组 (非1688·状态)` : '')
                + '\n\n依次下单，可中途停止 / 차례로 주문하며 중간에 멈출 수 있습니다')) return;

            const prevGroup = this.selectedGroup;
            this.bulkOrderResults = skipped.slice();
            this.bulkOrderedItems = [];
            this.bulkFailItems = [];
            this.bulkOrderTotal = targets.length;
            this.bulkOrderDone = 0;
            this.bulkOrderStopReq = false;
            this.bulkOrdering = true;
            this.bulkOrderModal = true;
            try {
                for (const t of targets) {
                    if (this.bulkOrderStopReq) {
                        this.bulkOrderResults.push({ label: t.label, count: t.count, status: 'skip', reason: '已中止 / 중단됨 (주문 안 함)' });
                        this.bulkOrderDone++;
                        continue;
                    }
                    this.bulkOrderCurrent = t.label;
                    this.selectedGroup = t.group;
                    this.orderErrorMessage = '';
                    this.bulkOrderNotes = [];
                    try {
                        await this.createOrderFromGroup({ bulk: true });
                    } catch (e) {
                        console.error('[批量下单] 그룹 주문 예외', t.label, e);
                        this.orderErrorMessage = this.orderErrorMessage || (e && e.message) || String(e);
                    }
                    const ordered = t.group.items.filter(i => i.주문생성여부 && (i.processStatus === '협상중' || i.진행현황 === '협상중'));
                    const err = this.orderErrorMessage;
                    // 주문도 안 되고 실패 목록에도 없는 상품(예상 밖 예외·중단 등)은 여기서 실패로 모은다
                    t.group.items.filter(i => !ordered.includes(i)).forEach(i => this.bulkAddFail(i, err || this.bulkOrderNotes.join(' / ') || '未下单 / 주문되지 않음'));
                    if (err) this.$set(this.groupOrderErrors, t.group.groupKey, err);
                    else this.$delete(this.groupOrderErrors, t.group.groupKey);
                    const reason = [err].concat(this.bulkOrderNotes).filter(Boolean).join('\n');
                    const status = ordered.length === t.count ? 'ok' : ordered.length > 0 ? 'partial' : 'fail';
                    this.bulkOrderResults.push({
                        label: t.label, count: t.count, ordered: ordered.length, status,
                        reason: reason || (status === 'fail' ? '已取消 / 취소됨 (재고 확인 등)' : '')
                    });
                    this.bulkOrderedItems = this.bulkOrderedItems.concat(ordered);
                    this.bulkOrderDone++;
                }
            } finally {
                this.bulkOrdering = false;
                this.bulkOrderCurrent = '';
                this.bulkOrderNotes = [];
                this.orderErrorMessage = '';
                this.selectedGroup = prevGroup;
            }
        },
        // rerun=true(칩 ✕) 면 해제 뒤 원래 조건(날짜·업체)으로 다시 검색한다
        clearBatchSearch(rerun = true) {
            if (!this.batchSearchNos.length) return;
            this.batchSearchNos = [];
            this.batchSearchNotFound = [];
            if (rerun) this.search();
        },
        searchByOrder() {
            this.clearBatchSearch(false);
            this.clearOwnerFilter(false);
            const keyword = (this.orderLookupKeyword || '').trim();
            if (!keyword) {
                alert('请输入搜索词 / 검색어를 입력해주세요');
                return;
            }
            // 묶음번호는 YYMMDD-HHmmss (하이픈 생략 허용) — batchNo() 가 만드는 형식
            if (this.orderLookupType === 'batch' && !/^\d{6}-?\d{6}$/.test(keyword)) {
                alert('묶음번호 형식이 아닙니다 批次号格式错误 (예: 260917-143025)');
                return;
            }
            this.orderLookupLoading = true;
            this.showreqlist = false;
            this.tableSelectedItem = [];
            this.activeFilter = 'total';

            axios.post('/api/reqpurchase/import/search', {
                검색타입: this.orderLookupType,
                검색어: keyword
            })
                .then(res => {
                    this.orderLookupLoading = false;
                    if (res.data?.요청결과 !== '성공') {
                        alert(res.data?.error?.errorMessage || '查询失败 / 조회 실패');
                        return;
                    }
                    const results = res.data.results || [];
                    if (results.length === 0) {
                        alert('没有搜索结果 / 검색 결과가 없습니다');
                        return;
                    }
                    this.$store.commit('reqpurchaseupdate', results);
                    this.applyReqlistResults(results);
                })
                .catch(err => {
                    this.orderLookupLoading = false;
                    console.error('searchByOrder error:', err);
                    alert('查询出错 / 조회 중 오류가 발생했습니다');
                });
        },
        // 银行到账核对 반영·취소 뒤 — 목록이 열려 있으면 다시 불러온다
        onBankReconcileApplied() {
            if (this.reqlistsinit && this.reqlistsinit.length) this.search();
        },
        // ?stage=진행현황&start=&end=&companyid= (订单列表 진행 단계 카드) → 그 기간·업체 전체(待采购 끔)로 검색하고 그 진행현황만 보인다.
        // 적용한 뒤 주소에서 지워 같은 카드를 다시 눌러도 다시 걸린다
        applyStageQuery() {
            const q = this.$route.query;
            const stage = String(q.stage || '');
            if (!STAGE_FILTERS.includes(stage)) return;
            this.clearBatchSearch(false);
            this.clearOwnerFilter(false);
            if (q.start) this.startdate = String(q.start);
            if (q.end) this.enddate = String(q.end);
            this.업체명 = q.companyid ? String(q.companyid) : '';
            this.tobepurchase = false;
            this.pageView = 'requests';
            const rest = { ...q };
            ['stage', 'start', 'end', 'companyid', 'view'].forEach(k => delete rest[k]);
            this.$router.replace({ query: rest }).catch(e => { if (e && e.name !== 'NavigationDuplicated') console.error('[商品求购] 단계 주소 정리 실패', e); });
            // 그 단계 건만 받는다(기간 전체는 5000건 상한에 걸린다) — 서버 판정은 카드 숫자(stageCounts)와 같다
            this.search(stage).then(data => {
                if (!data || !Array.isArray(data.reqpurchase)) {
                    const msg = data && data.error ? (data.error.errorMessage || data.error) : '';
                    alert('查询失败，请缩小日期或选择货主 / 조회 실패 — 기간을 좁히거나 업체를 고르세요' + (msg ? '\n' + msg : ''));
                    return;
                }
                this.showStatus(stage);
                this.activeFilter = stage;
            });
        },
        // stage = 订单列表 카드에서 온 진행현황(applyStageQuery 만 넘긴다. 버튼 @click 은 이벤트가 들어오므로 문자열일 때만 쓴다)
        search(stage) {
            // console.log(this.업체명)
            this.showreqlist = false;
            this.reqlistsinit = [];
            this.reqlists = [];
            this.tableSelectedItem = [];
            this.activeFilter = 'total'; // 필터 상태 초기화
            var start = this.gettimestamp(this.startdate) - (1000 * 60 * 60 * 9)
            var end = this.gettimestamp(this.getdate(this.gettimestamp(this.enddate) + (1000 * 60 * 60 * 24))) - (1000 * 60 * 60 * 9) - 1
            console.log(start, end)
            // 응답을 돌려줘 applyStageQuery 가 검색 뒤 필터를 걸 수 있게 한다
            const body = { start: start, end: end, companyid: this.업체명, tobepurchase: this.tobepurchase };
            if (typeof stage === 'string' && stage) body.stage = stage;
            // 批量搜索 중이면 그 번호들만(1688·화주·판매처 주문번호). 결제 뒤 다시 불러도 거름이 유지된다
            const batchNos = this.batchSearchNos.slice();
            if (batchNos.length) body.orderNos = batchNos;
            return axios.post('/api/reqpurchase/getliststotal', body)
                .then((res) => {
                    if (batchNos.length) {
                        if (!Array.isArray(res.data.reqpurchase)) {
                            const msg = res.data && res.data.error ? (res.data.error.errorMessage || res.data.error) : '';
                            alert('批量搜索失败 / 일괄 검색 실패' + (msg ? '\n' + msg : ''));
                        }
                        const found = new Set();
                        (res.data.reqpurchase || []).forEach(r => {
                            const o = r.주문정보 || {};
                            [r.화주주문번호, o['1688주문번호'], o.판매처주문번호].forEach(v => { if (v !== undefined && v !== null && v !== '') found.add(String(v).trim()); });
                        });
                        this.batchSearchNotFound = batchNos.filter(no => !found.has(no));
                    }
                    // 화주명 일괄 필터 — 받은 기간 결과에서 그 화주들 건만 남긴다(번호 검색 중엔 걸지 않는다)
                    let list = res.data.reqpurchase || [];
                    if (!batchNos.length && this.ownerFilterNames.length) list = this.applyOwnerFilter(list);
                    this.$store.commit('reqpurchaseupdate', list);
                    console.log(res.data.reqpurchase)
                    console.log(res.data.요청결과)
                    this.applyReqlistResults(list);
                    console.log(this.reqlists)
                    return res.data;
                })
                .catch(e => { console.error('err821', e); return null; })
        },
        /**
         * 검색 결과를 reqlists에 주입 + 카운트/필터 재계산.
         * search() / searchByOrder() 양쪽에서 동일한 후처리를 공유.
         */
        // 기타요청사항 원문 앞부분(화주주소·통관정보가 비었을 때 참고용)
        reqcontentSnippet(item) {
            const t = ((item && item.요청내역 && item.요청내역.reqcontent) || '').trim();
            return t.length > 120 ? t.slice(0, 120) + '…' : t;
        },
        applyReqlistResults(rawList) {
            var arr = [];
            var cnt = {
                구매전: 0, 발송전: 0, 발송완료: 0, 입고완료: 0, 구매확인: 0,
                노마드클럽: 0, 샘플검증: 0, 일반배송: 0, 로켓배송: 0,
                구매취소: 0, 요청변경: 0,
                통합통관: 0, 단독통관: 0, 쿠패스단독통관: 0
            };
            (rawList || []).forEach(e => {
                // 레거시 데이터 표시용 정규화
                // 주의: 이 객체는 상세모달 저장(updatereqlist)으로 그대로 DB 에 반영된다.
                // reqtype 만 바꾸고 sampleCheck.enabled 를 안 켜면 샘플검증요청내역에서 영구히 사라진다.
                if (e.reqtype === '샘플검증') {
                    e.reqtype = '일반LCL';
                    if (e.요청내역) {
                        if (!e.요청내역.sampleCheck || typeof e.요청내역.sampleCheck !== 'object') {
                            e.요청내역.sampleCheck = {
                                enabled: true,
                                quantity: e.구매요청수량 || 0,
                                checklist: { groups: [] },
                                disposition: e.요청내역.destination === 'distroy' ? 'destroy' : 'send'
                            };
                        } else {
                            e.요청내역.sampleCheck.enabled = true;
                        }
                    }
                }
                if (e.reqtype === '일반') e.reqtype = '일반LCL';
                if (e.요청내역) {
                    if (e.요청내역.destination === 'distroy') e.요청내역.destination = 'customer';
                    if (e.요청내역.destination === 'coupang_shipment') e.요청내역.destination = 'coupang';
                    if (!e.요청내역.customsType) e.요청내역.customsType = 'integrated';
                    if (!e.요청내역.destination) {
                        e.요청내역.destination = e.reqtype === '일반LCL' ? 'customer' : 'coupang';
                    }
                    if (!e.요청내역.exportType) e.요청내역.exportType = 'box';
                    if (!e.요청내역.화주주소 || typeof e.요청내역.화주주소 !== 'object') {
                        e.요청내역.화주주소 = { 업체명: '', 주소: '', 연락처: '' };
                    }
                    if (!e.요청내역.sampleCheck || typeof e.요청내역.sampleCheck !== 'object') {
                        e.요청내역.sampleCheck = { enabled: false, quantity: 0, checklist: { groups: [] }, disposition: 'send' };
                    }
                }
                var customsType = e.요청내역?.customsType == 'integrated' ? '통합통관'
                    : e.요청내역?.customsType == 'client' ? '화주단독통관'
                        : e.요청내역?.customsType == 'kupass' ? '쿠패스단독통관' : '';
                e.통관방법 = customsType;
                // 물류방법 파생 (roket+coupang=쉽먼트, jet+coupang=밀크런, 그 외 일반)
                var _쿠팡 = e.요청내역?.destination === 'coupang';
                var _팔레트 = e.요청내역?.exportType === 'pallet';
                e.물류방법 = (e.reqtype === '로켓배송' && _쿠팡) ? '쉽먼트택배'
                    : (e.reqtype === '제트배송' && _쿠팡) ? (_팔레트 ? '밀크런트럭' : '밀크런택배')
                    : (_팔레트 ? '일반트럭' : '일반택배');
                e.요청내역 = e.요청내역 || {};
                e.요청내역.reqcontentPurchase = e.요청내역.reqcontentPurchase || "";
                e.요청변경 = this.hasUnconfirmedChange(e);
                e.진행현황 = e.진행현황 ? e.진행현황 : "구매전";
                e.processStatus = e.processStatus || e.진행현황;
                e.구매취소 = e.구매취소 ? e.구매취소 : false;
                e.구매취소내용 = e.구매취소내용 ? e.구매취소내용 : '';
                e.판매구성수량 = e.판매구성수량 == '단품' ? 1 : e.판매구성수량;
                e.statusHistory = e.statusHistory || [];
                if (e.진행현황 == '발송전') {
                    e.processStatus = '구매완료';
                    e.진행현황 = '구매완료';
                }
                e.checked = false;

                // Vue 2 reactivity 우회: 수정되지 않는 중첩 이력/견적서 객체는 freeze
                if (e.changeHistory) Object.freeze(e.changeHistory);
                if (e.statusHistory) Object.freeze(e.statusHistory);
                if (e.견적서_1688구매금액) Object.freeze(e.견적서_1688구매금액);

                // 단일 패스 카운트 집계
                var st = e.processStatus || e.진행현황;
                if (st == '구매전') cnt.구매전++;
                else if (st == '발송전') cnt.발송전++;
                else if (st == '발송완료') cnt.발송완료++;
                else if (st == '입고완료') cnt.입고완료++;
                else if (st == '구매확인') cnt.구매확인++;
                if (e.reqtype == '제트배송') cnt.노마드클럽++;
                else if (e.reqtype == '로켓배송') cnt.로켓배송++;
                else cnt.일반배송++;
                if (this.hasSampleCheck(e)) cnt.샘플검증++;
                if (e.구매취소) cnt.구매취소++;
                if (e.요청변경) cnt.요청변경++;
                if (customsType == '통합통관') cnt.통합통관++;
                else if (customsType == '화주단독통관') cnt.단독통관++;
                else if (customsType == '쿠패스단독통관') cnt.쿠패스단독통관++;

                arr.push(e);
            });
            // push 기반 Vue reactivity notify 폭탄 방지: 한 번에 할당
            this.reqlistsinit = arr;
            this.reqlists = arr.slice();
            this.allreqlists = arr;
            // 선적이 달린 건의 진행현황 수량 분포(정본 §5 Phase 2-17). 목록 단위로 한 번만 부른다.
            // 선적이 없으면 응답이 비고, 화면은 지금까지 쓰던 뱃지를 그대로 그린다.
            this.loadShipmentDist(arr);
            this.구매전 = cnt.구매전;
            this.발송전 = cnt.발송전;
            this.발송완료 = cnt.발송완료;
            this.입고완료 = cnt.입고완료;
            this.노마드클럽 = cnt.노마드클럽;
            this.샘플검증 = cnt.샘플검증;
            this.일반배송 = cnt.일반배송;
            this.로켓배송 = cnt.로켓배송;
            this.구매확인 = cnt.구매확인;
            this.구매취소 = cnt.구매취소;
            this.요청변경 = cnt.요청변경;
            this.통합통관 = cnt.통합통관;
            this.단독통관 = cnt.단독통관;
            this.쿠패스단독통관 = cnt.쿠패스단독통관;
            this.total = arr.length;
            this.updateStatusCounts();
            this.showreqlist = true;
        },
        getdate(timestamp) {
            var date = new Date(timestamp);
            var year = date.getFullYear();
            var month = ("0" + (1 + date.getMonth())).slice(-2);
            var day = ("0" + date.getDate()).slice(-2);

            return year + "-" + month + "-" + day;
        },
        changedate() {
            var now
            var target
            if (this.selectdate == 'today') {
                this.startdate = this.getTodaywith();
                this.enddate = this.getTodaywith();
            } else {
                if (this.selectdate == 'week') {
                    now = new Date(this.getTodaywith());
                    target = now - 1000 * 60 * 60 * 24 * 7

                    this.startdate = this.getdate(target);
                    this.enddate = this.getTodaywith();
                } else {
                    if (this.selectdate == 'month') {
                        now = new Date(this.getTodaywith());
                        target = now - 1000 * 60 * 60 * 24 * 30
                        this.startdate = this.getdate(target);
                        this.enddate = this.getTodaywith();
                    }
                }
            }
        },
        allcheck() {
            if (this.allcheckreqlists) {
                this.reqlists.forEach(e => {
                    e.checked = true;
                })
            } else {
                this.reqlists.forEach(e => {
                    e.checked = false;
                })
            }
        },
        confirmlists() {
            var arr = [];
            if (this.lists.filter(e => e.checked).length == 0) {
                arr = this.lists
            } else {
                arr = this.lists.filter(e => e.checked)
            }
            if (arr.filter(e => e.구매링크 === undefined).length > 0) {
                alert('请填写全部采购链接 / 구매링크를 모두 입력해 주세요')
                return
            }
            if (arr.filter(e => e.옵션1_중국어 === undefined || e.옵션2_중국어 === undefined).length > 0) {
                alert('请点放大镜匹配全部选项 / 돋보기를 눌러 옵션을 모두 매칭해 주세요.')
                return []
            }
            return arr
        },
        async requestpurchase() {
            var list = await this.confirmlists()
            if (list.length == 0) {
                alert('没有要请求的列表 / 요청할 목록이 없습니다.')
                return
            }
            var cnt = list.length;
            var arr = [];
            var obj = {};
            var now = Date.now();
            list.forEach(e => {
                obj = {
                    companyid: this.$store.state.user.companyid,
                    요청일: now,
                    SKUID: parseInt(e.SKUID),
                    바코드: e.바코드,
                    상품명: e.상품명,
                    구매링크: e.구매링크,
                    옵션1_중국어: e.옵션1_중국어,
                    옵션2_중국어: e.옵션2_중국어,
                    구매요청수량: e.구매요청수량,
                    등록이미지: e.등록이미지,
                }
                arr.push(obj);
            })
            if (confirm("共" + cnt + "件，请求代购? / 총 " + cnt + "건을 구매대행 요청하시겠습니까?")) {
                axios.post('/api/reqpurchase/requestpurchase', arr)
                    .then((res) => {
                        this.$store.commit('reqpurchaseupdate', res.data.reqpurchase);
                        alert(res.data.요청결과)
                    })
                    .catch(console.log)
            }
        },
        async saveproductdb() {
            var list = await this.confirmlists()
            if (list.length == 0) {
                alert('没有要更新的列表 / 업데이트할 목록이 없습니다.')
                return
            }
            console.log(list)
            axios.post('/api/reqpurchase/updateproductdb', list)
                .then((res) => {
                    this.$store.commit('productdbupdate', res.data.productdb);
                    alert(res.data.요청결과)
                })
                .catch(console.log)
        },
        deleteindexfromarray(array, index) {
            return array.slice(0, index).concat(array.slice(index + 1))
        },
        deleteitem(index) {
            if (confirm('删除后不能恢复，确定删除? / 삭제된 제품은 복구가 불가능합니다. 삭제하시겠습니까?')) {
                this.showlist = false;
                setTimeout(() => {
                    this.lists = this.deleteindexfromarray(this.lists, index);
                    this.showlist = true;
                }, 1);
            }
        },
        confirmexcelDownFunc() {
            if (this.reqtype == '로켓배송') {
                this.excelDownFunc()
                return
            }
            if (this.reqtype == '제트배송') {
                this.excelDownFunc()
                return
            }
            if (this.reqtype == '일반LCL') {
                if (confirm('一般货主件的SKUID可随意填写10000000以下的数字 / 일반LCL에서 SKUID는 10000000 이하의 숫자로 임의로 기입하시면 됩니다.')) {
                    this.excelDownFunc()
                    return
                }
            }
        },
        reset(list) {
            list.옵션1_중국어 = undefined;
            list.옵션2_중국어 = undefined;
            list.상품매칭.옵션1_중국어 = [];
            list.상품매칭.옵션2_중국어 = [];
            list.구매링크 = undefined;
        },
        async rematching(list) {
            this.change = true;
            const selectedIndex = this.reqlists.findIndex(i => i._id === list._id);
            this.changeindexlist.push(selectedIndex);
            if (!list.구매링크) {
                alert('请填写采购链接 / 구매링크를 입력해 주세요')
                return
            }
            // 1688 조회가 실패하면 원래 옵션으로 되돌린다 — 비운 채로 두면 저장 시 옵션이 지워진다
            const prev = {
                옵션1_중국어: list.옵션1_중국어,
                옵션2_중국어: list.옵션2_중국어,
                매칭상태: list.매칭상태,
                구매재고: list.구매재고,
                상품매칭1: list.상품매칭.옵션1_중국어,
                상품매칭2: list.상품매칭.옵션2_중국어,
            };
            list.옵션1_중국어 = undefined;
            list.옵션2_중국어 = undefined;
            list.상품매칭.옵션1_중국어 = [];
            list.상품매칭.옵션2_중국어 = [];
            const ok = await this.matchoption1(selectedIndex, list.구매링크);
            if (!ok) {
                list.옵션1_중국어 = prev.옵션1_중국어;
                list.옵션2_중국어 = prev.옵션2_중국어;
                list.매칭상태 = prev.매칭상태;
                list.구매재고 = prev.구매재고;
                list.상품매칭.옵션1_중국어 = prev.상품매칭1;
                list.상품매칭.옵션2_중국어 = prev.상품매칭2;
                list.showspinner = false;
                alert('1688商品信息读取失败，已恢复原选项 / 1688 상품정보를 불러오지 못해 원래 옵션으로 되돌렸습니다.');
            }
        },
        pickOption(level, name, list) {
            const arr = (list.상품매칭 && list.상품매칭['옵션' + level + '_중국어']) || [];
            const a = arr.find(o => o.name === name);
            if (!a) return;
            if (level === 1) this.option1matching(a, list);
            else this.option2matching(a, list);
        },
        fileupload() {
            this.$refs.pdbupload.value = '';
            this.$refs.pdbupload.click();
        },
        option1matching(a, list) {
            this.change = true;
            // this.showlist = false;
            if (a.imageUrl) {
                if (!list.등록이미지) {
                    list.등록이미지 = a.imageUrl;
                }
                list.옵션이미지 = a.imageUrl;
            }
            list.옵션1_중국어 = a.name;


            // if(this.checkstock){
            if (list.옵션2_중국어 == '') {
                var properties1 = list.상품매칭.옵션1_중국어.find(e => e.name == list.옵션1_중국어).properties;
                list.구매재고 = parseInt(list.item.skus.sku.find(e => e.properties == properties1).quantity);
                if (list.구매재고 == 0) {
                    alert('没有可采购的库存，请向卖家确认 / 구매 가능한 재고수량이 없습니다. 판매자에게 확인해 주세요.')
                } else {
                    alert('可采购库存 / 구매 가능한 재고수량 : ' + list.구매재고)
                }
                list.매칭상태 = '매칭완료';
            } else {
                if (list.옵션2_중국어 !== undefined) {
                    properties1 = list.상품매칭.옵션1_중국어.find(e => e.name == list.옵션1_중국어).properties;
                    var properties2 = list.상품매칭.옵션2_중국어.find(e => e.name == list.옵션2_중국어).properties;
                    list.구매재고 = parseInt(list.item.skus.sku.find(e => e.properties == properties1 + ";" + properties2).quantity);
                    if (list.구매재고 == 0) {
                        alert('没有可采购的库存，请向卖家确认 / 구매 가능한 재고수량이 없습니다. 판매자에게 확인해 주세요.')
                    } else {
                        alert('可采购库存 / 구매 가능한 재고수량 : ' + list.구매재고)
                    }
                    list.매칭상태 = '매칭완료';
                }
            }
            if (list.등록이미지 == '' && list.옵션이미지 == '') {
                list.등록이미지 = list.item.pic_url;
                list.옵션이미지 = list.item.pic_url;
            }
            // this.showlist = true;
            // }
            this.pricechange(list)
        },
        option2matching(a, list) {
            this.change = true;
            // this.showlist = false;
            if (a.imageUrl) {
                list.등록이미지 = a.imageUrl;
            }
            list.옵션2_중국어 = a.name;

            // if(this.checkstock){

            if (list.상품매칭.옵션1_중국어 && list.상품매칭.옵션1_중국어.find(e => e.name == list.옵션1_중국어)) {
                var properties1 = list.상품매칭.옵션1_중국어.find(e => e.name == list.옵션1_중국어).properties;
                var properties2 = list.상품매칭.옵션2_중국어.find(e => e.name == list.옵션2_중국어).properties;
                list.구매재고 = parseInt(list.item.skus.sku.find(e => e.properties == properties1 + ";" + properties2).quantity);
                if (list.구매재고 == 0) {
                    alert('没有可采购的库存，请向卖家确认 / 구매 가능한 재고수량이 없습니다. 판매자에게 확인해 주세요.')
                } else {
                    alert('可采购库存 / 구매 가능한 재고수량 : ' + list.구매재고)
                }
                list.매칭상태 = '매칭완료'
            }

            // }
            if (list.등록이미지 == '' && list.옵션이미지 == '') {
                list.등록이미지 = list.item.pic_url;
                list.옵션이미지 = list.item.pic_url;
            }
            // this.showlist = true;
            this.pricechange(list)
        },
        sendmessage(url) {
            window.postMessage({ greeting: "importproductinfo", url: url }, "*",)
        },
        async matchoption1(index, 구매링크) {
            this.reqlists[index].showspinner = true;
            this.reqlists[index].구매링크 = 구매링크;
            this.currentindex = index;
            console.log(구매링크)
            // setTimeout(() => {this.sendmessage(구매링크);},1)
            var newObj = await this.confirmreq(this.reqlists[index]);
            if (!newObj) return false;
            // console.log(newObj)
            // this.showlist = false
            this.$set(this.reqlists, index, newObj);
            console.log(this.reqlists[this.currentindex])
            return true;
            // this.showlist = true


            // axios.post('/api/reqpurchase/geturlinfo',{
            //     url : 구매링크
            // })
            // .then((res) => {
            //     if(res.data.요청결과 == 'success'){
            //         console.log(res.data.result)
            //         var obj = {}
            //         res.data.result.option1array.forEach(e => {
            //             obj = {
            //                 image : e.imageUrl,
            //                 optionname : e.name,
            //             }
            //             list.상품매칭.옵션1_중국어.push(obj)
            //         })
            //         res.data.result.option2array.forEach(e => {
            //             obj = {
            //                 image : e.imageUrl,
            //                 optionname : e.name,
            //             }
            //             list.상품매칭.옵션1_중국어.push(obj)
            //         })

            //     } else {
            //         alert('error777 :' + res.data.요청결과)
            //     }
            // })
            // .catch(console.log)
        },
        nopo(구매링크) {
            this.reqlists.forEach((obj, i) => {
                if (obj.구매링크 == 구매링크) {
                    obj.상품매칭.옵션1_중국어 = [];
                    obj.상품매칭.옵션2_중국어 = [];
                    obj.옵션1_중국어 = '';
                    obj.옵션2_중국어 = '';
                    obj.구매재고 = '구매불가';
                    obj.등록이미지 = obj.등록이미지 ? obj.등록이미지 : '';
                    obj.옵션이미지 = obj.옵션이미지 ? obj.옵션이미지 : '';
                    obj.매칭상태 = '매칭필요';
                    obj.showspinner = false;
                    this.changeindexlist.push(i)
                }
            })
        },
        async confirmreq(obj) {
            if (!obj.구매링크 || obj.구매링크 == '사입') {
                obj.showspinner = false;
                return obj
            }
            obj.구매링크init = obj.구매링크;
            obj.매칭상태 = '매칭필요'
            var item = await this.getProductInfo(obj.구매링크);
            console.log(item)
            // 조회 실패(서버 오류·외부 API 거절)면 item 이 비어 온다 — 여기서 멈춰야 아래 item.* 에서 조용히 죽지 않는다
            if (!item) {
                console.error('confirmreq: 1688 상품정보 없음', obj.구매링크);
                obj.showspinner = false;
                return null;
            }
            this.$set(obj, 'item', item);

            if (item.format_check == 'fail') {
                obj.상품매칭.옵션1_중국어 = [];
                obj.상품매칭.옵션2_중국어 = [];
                obj.옵션1_중국어 = '';
                obj.옵션2_중국어 = '';
                obj.구매재고 = '구매불가';
                obj.등록이미지 = obj.등록이미지 ? obj.등록이미지 : item.pic_url;
                obj.옵션이미지 = obj.옵션이미지 ? obj.옵션이미지 : item.pic_url;
                obj.매칭상태 = '매칭필요';
                obj.showspinner = false;
                if (confirm('该商品不可采购，同一链接全部设为不可采购? / 해당제품은 구매불가입니다. 같은 링크를 모두 구매불가 처리하시겠습니까?')) {
                    this.nopo(obj.구매링크);
                }
                return obj
            }

            var option1array = [];
            var option2array = [];
            if (item.props_list && Object.keys(item.props_list).length > 0) {
                item.skus.sku.forEach(e => {
                    if (e.properties.includes(";")) {
                        var properties1 = e.properties.split(';')[0];
                        var properties2 = e.properties.split(';')[1];
                        if (!option1array.find(ele => ele.properties == properties1)) {
                            option1array.push({
                                properties: properties1,
                                name: e.properties_name.split(";" + properties2 + ':')[0].replace(properties1 + ":", ""),
                                imageUrl: item.props_img[properties1] ? item.props_img[properties1] : '',
                            })
                        }
                        if (!option2array.find(ele => ele.properties == properties2)) {
                            option2array.push({
                                properties: properties2,
                                name: e.properties_name.split(";" + properties2 + ':')[1],
                                imageUrl: item.props_img[properties2] ? item.props_img[properties2] : '',
                            })
                        }
                    } else {
                        option1array.push({
                            properties: e.properties,
                            name: e.properties_name.replace(e.properties + ":", ""),
                            imageUrl: item.props_img[e.properties] ? item.props_img[e.properties] : '',
                        })
                    }
                })



                // Object.keys(item.props_list).forEach(e => {
                //     if(e[0] == '0'){
                //         option1array.push({
                //             properties : e,
                //             name : item.props_list[e].split(":")[1],
                //             imageUrl : item.props_img[e] ? item.props_img[e] : '',
                //         })
                //     }
                //     if(e[0] == '1'){
                //         option2array.push({
                //             properties : e,
                //             name : item.props_list[e].split(":")[1],
                //             imageUrl : item.props_img[e] ? item.props_img[e] : '',
                //         })
                //     }
                // })
            }

            if (option1array.length == 0) {
                obj.상품매칭.옵션1_중국어 = [];
                obj.상품매칭.옵션2_중국어 = [];
                obj.옵션1_중국어 = '';
                obj.옵션2_중국어 = '';
                obj.구매재고 = parseInt(item.num);
                obj.등록이미지 = obj.등록이미지 ? obj.등록이미지 : item.pic_url;
                obj.옵션이미지 = obj.옵션이미지 ? obj.옵션이미지 : item.pic_url;
                obj.매칭상태 = '매칭완료'
            } else {
                if (option2array.length == 0) {
                    var imgUrl = '';
                    if (!option1array.find(e => e.name == obj.옵션1_중국어)) {
                        obj.옵션1_중국어 = undefined;
                        obj.옵션이미지 = undefined;
                        obj.구매재고 = 0;
                    } else {
                        var option1properties = option1array.find(e => e.name == obj.옵션1_중국어).properties;
                        obj.구매재고 = parseInt(item.skus.sku.find(e => e.properties == option1properties).quantity);
                        if (item.prop_imgs.prop_img.length > 0) {
                            imgUrl = item.prop_imgs.prop_img.find(e => e.properties == option1properties).url;
                        }
                        obj.옵션이미지 = imgUrl;
                        obj.매칭상태 = '매칭완료'
                    }
                    obj.상품매칭.옵션1_중국어 = option1array;
                    obj.상품매칭.옵션2_중국어 = [];
                    obj.옵션2_중국어 = '';
                    obj.등록이미지 = obj.등록이미지 ? obj.등록이미지 : imgUrl;
                } else {
                    imgUrl = '';
                    if (!option1array.find(e => e.name == obj.옵션1_중국어)) {
                        obj.옵션1_중국어 = undefined;
                        obj.옵션이미지 = undefined;
                        obj.구매재고 = 0;
                    } else {
                        option1properties = option1array.find(e => e.name == obj.옵션1_중국어).properties;
                        if (item.prop_imgs.prop_img && item.prop_imgs.prop_img.find(e => e.properties == option1properties)) {
                            imgUrl = item.prop_imgs.prop_img.find(e => e.properties == option1properties).url;
                        }
                        obj.옵션이미지 = imgUrl;
                        if (!option2array.find(e => e.name == obj.옵션2_중국어)) {
                            obj.옵션2_중국어 = undefined;
                            obj.구매재고 = 0;
                        } else {
                            var option2properties = option2array.find(e => e.name == obj.옵션2_중국어).properties;
                            obj.구매재고 = parseInt(item.skus.sku.find(e => e.properties == (option1properties + ';' + option2properties)).quantity);
                            if (item.prop_imgs.prop_img && item.prop_imgs.prop_img.find(e => e.properties == option2properties)) {
                                imgUrl = item.prop_imgs.prop_img.find(e => e.properties == option2properties).url;
                            }
                            obj.옵션이미지 = imgUrl;
                            obj.매칭상태 = '매칭완료'
                        }
                    }
                    obj.상품매칭.옵션1_중국어 = option1array;
                    obj.상품매칭.옵션2_중국어 = option2array;
                    obj.등록이미지 = obj.등록이미지 ? obj.등록이미지 : imgUrl;
                }
            }
            if (!obj.등록이미지 && !option1array.find(e => e.imageUrl) && !option1array.find(e => e.imageUrl)) {
                obj.등록이미지 = item.pic_url;
            }
            this.pricechange(obj);
            obj.showspinner = false;
            return obj
        },
        async getProductInfo(구매링크) {
            var productNo = 구매링크.slice(구매링크.search('offer/') + 6, 구매링크.search('.html'));
            console.log(productNo)
            try {
                var res = await axios.post('/api/reqpurchase/getProductInfo', [productNo])
                return res.data.result[0].item
            } catch (e) {
                console.log('err821' + e);
                return false
            }
        },
        pricechange(obj) {
            this.change = true;
            if (obj.매칭상태 == '매칭필요') {
                obj.구매가격 = '';
                return
            }
            if (obj.item && obj.구매요청수량) {
                var option1array = [];
                var option2array = [];
                var item = obj.item;
                if (item.props_list && Object.keys(item.props_list).length > 0) {
                    Object.keys(item.props_list).forEach(e => {
                        if (e[0] == '0') {
                            option1array.push({
                                properties: e,
                                name: item.props_list[e].split(":")[1],
                                imageUrl: item.props_img[e] ? item.props_img[e] : '',
                            })
                        }
                        if (e[0] == '1') {
                            option2array.push({
                                properties: e,
                                name: item.props_list[e].split(":")[1],
                                imageUrl: item.props_img[e] ? item.props_img[e] : '',
                            })
                        }
                    })
                }

                if (option1array.length == 0) {
                    if (item.priceRange) {
                        for (var i = 0; i < item.priceRange.length; i++) {
                            obj.구매가격 = parseFloat(item.priceRange[i][1]);
                            if (parseInt(item.priceRange[i][0]) > obj.구매요청수량) {
                                break
                            }
                        }
                    } else {
                        obj.구매가격 = parseInt(item.price);
                    }
                } else {
                    if (option2array.length == 0) {
                        if (item.priceRange) {
                            for (i = 0; i < item.priceRange.length; i++) {
                                obj.구매가격 = parseFloat(item.priceRange[i][1]);
                                if (parseInt(item.priceRange[i][0]) > obj.구매요청수량) {
                                    break
                                }
                            }
                        } else {
                            obj.구매가격 = parseInt(item.price);
                        }
                    } else {
                        if (!option1array.find(e => e.name == obj.옵션1_중국어)) {
                            obj.구매가격 = '';
                        } else {
                            if (!option2array.find(e => e.name == obj.옵션2_중국어)) {
                                obj.구매가격 = '';
                            } else {
                                var option1properties = option1array.find(e => e.name == obj.옵션1_중국어).properties;
                                var option2properties = option2array.find(e => e.name == obj.옵션2_중국어).properties;
                                obj.구매가격 = parseInt(item.skus.sku.find(e => e.properties == (option1properties + ';' + option2properties)).price);
                            }
                        }
                    }
                }
            }
        },
        matchclass(a) {
            if (a == '매칭완료') {
                return 'badge badge-success';
            } else {
                return 'badge badge-warning';
            }
        },
        excelDownFunc() {
            var arr = [];
            var myHeader = ["SKUID", "구매요청수량"];

            var dataWS = XLSX.utils.json_to_sheet(arr, { header: myHeader });

            const range = XLSX.utils.decode_range(dataWS['!ref']);
            range.e['c'] = myHeader.length - 1;
            dataWS['!ref'] = XLSX.utils.encode_range(range);

            var wb = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(wb, dataWS, '구매대행요청양식');
            // 엑셀 파일을 내보낸다.
            XLSX.writeFile(wb, '구매대행요청양식.xlsx');
        },
        // uploadfile(event) {
        //     var obj = {};
        //     var ob = {};
        //     var op1 = '';
        //     var op2 = '';
        //     this.showlist = false;
        //     this.lists = [];
        //     // var 주문번호,판매처,배송단가,할인단가,운송장번호,주문날짜,주문상태;
        //     setTimeout(() => {
        //         const file = event.target.files[0];
        //         let reader = new FileReader();
        //         reader.onload = (e) => {
        //             // let data = reader.result;
        //             let data = e.target.result;
        //             let workbook = XLSX.read(data, {type: 'binary'});
        //             workbook.SheetNames.forEach(sheetName => {
        //                 const roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
        //                 console.log(roa)
        //                 if(this.reqtype == '일반LCL'){
        //                     roa.forEach(e => {
        //                         if(this.$store.state.productdb.find(ele => parseInt(ele['SKU ID']) == parseInt(e.SKUID))){
        //                             ob = this.$store.state.productdb.find(ele => parseInt(ele['SKU ID']) == parseInt(e.SKUID))
        //                             // console.log(e)
        //                             // console.log(ob)
        //                             if(ob.옵션1_중국어 || ob.옵션1_중국어 == ''){
        //                                 op1 = ob.옵션1_중국어
        //                             } else {
        //                                 op1 = undefined
        //                             }
        //                             if(ob.옵션2_중국어 || ob.옵션2_중국어 == ''){
        //                                 op2 = ob.옵션2_중국어
        //                             } else {
        //                                 op2 = undefined
        //                             }
        //                             obj = {
        //                                 checked : false,
        //                                 showspinner : false,
        //                                 SKUID : e.SKUID,
        //                                 바코드 : ob.바코드 ? ob.바코드 : '',
        //                                 상품명 : ob.상품명,
        //                                 구매링크 : ob.구매링크 ? ob.구매링크 : undefined,
        //                                 옵션1_중국어 : op1,
        //                                 옵션2_중국어 : op2,
        //                                 매칭상태 : ob.구매링크 !== undefined || op1 !== undefined || op2 !== undefined ? '매칭완료' : '매칭필요',
        //                                 상품매칭 : {
        //                                     옵션1_중국어 : [],
        //                                     옵션2_중국어 : [],
        //                                 },
        //                                 구매요청수량 : e.구매요청수량,
        //                                 등록이미지 : ob.등록이미지
        //                             }
        //                             this.lists.push(obj)
        //                         } else {
        //                             if(e.옵션1_중국어 || e.옵션1_중국어 == ''){
        //                                 op1 = e.옵션1_중국어
        //                             } else {
        //                                 op1 = undefined
        //                             }
        //                             if(e.옵션2_중국어 || e.옵션2_중국어 == ''){
        //                                 op2 = e.옵션2_중국어
        //                             } else {
        //                                 op2 = undefined
        //                             }
        //                             obj = {
        //                                 checked : false,
        //                                 showspinner : false,
        //                                 SKUID : e.SKUID,
        //                                 바코드 : e.바코드 ? e.바코드 : '',
        //                                 상품명 : e.상품명,
        //                                 구매링크 : e.구매링크 ? e.구매링크 : undefined,
        //                                 옵션1_중국어 : op1,
        //                                 옵션2_중국어 : op2,
        //                                 매칭상태 : e.구매링크 !== undefined || op1 !== undefined || op2 !== undefined ? '매칭완료' : '매칭필요',
        //                                 상품매칭 : {
        //                                     옵션1_중국어 : [],
        //                                     옵션2_중국어 : [],
        //                                 },
        //                                 구매요청수량 : e.구매요청수량,
        //                                 등록이미지 : e.등록이미지
        //                             }
        //                             this.lists.push(obj)
        //                         }
        //                     })
        //                 } else {
        //                     roa.forEach(e => {
        //                         if(this.$store.state.productdb.find(ele => parseInt(ele['SKU ID']) == parseInt(e.SKUID))){
        //                             ob = this.$store.state.productdb.find(ele => parseInt(ele['SKU ID']) == parseInt(e.SKUID))
        //                             // console.log(e)
        //                             // console.log(ob)
        //                             if(ob.옵션1_중국어 || ob.옵션1_중국어 == ''){
        //                                 op1 = ob.옵션1_중국어
        //                             } else {
        //                                 op1 = undefined
        //                             }
        //                             if(ob.옵션2_중국어 || ob.옵션2_중국어 == ''){
        //                                 op2 = ob.옵션2_중국어
        //                             } else {
        //                                 op2 = undefined
        //                             }
        //                             obj = {
        //                                 checked : false,
        //                                 showspinner : false,
        //                                 SKUID : e.SKUID,
        //                                 바코드 : ob.바코드,
        //                                 상품명 : ob.상품명,
        //                                 구매링크 : ob.구매링크 ? ob.구매링크 : undefined,
        //                                 옵션1_중국어 : op1,
        //                                 옵션2_중국어 : op2,
        //                                 매칭상태 : ob.구매링크 !== undefined || op1 !== undefined || op2 !== undefined ? '매칭완료' : '매칭필요',
        //                                 상품매칭 : {
        //                                     옵션1_중국어 : [],
        //                                     옵션2_중국어 : [],
        //                                 },
        //                                 구매요청수량 : e.구매요청수량,
        //                                 등록이미지 : ob.등록이미지
        //                             }
        //                             // console.log(obj)
        //                             this.lists.push(obj)
        //                         } else {
        //                             alert('로켓/제트 상품은 상품DB를 먼저 등록해주세요')
        //                             return
        //                         }
        //                     })
        //                 }
        //                 this.showlist = true;
        //             });
        //         };
        //         reader.readAsBinaryString(file);
        //     }, 10);
        // },
        /**
         * Action 모달 열기 — 모달은 한 건만 렌더되므로 대상 요청건을 먼저 바꾸고 연다.
         * 개별 상품 뷰와 그룹 상세 모달이 같이 쓴다. item 은 반드시 reqlists 원본 요청건.
         */
        openItemActionModal(prefix, item) {
            if (!item) return;
            this.actionModalItem = item;
            this.$nextTick(() => this.$bvModal.show(prefix + item._id));
        },
        modalID(index) {
            // console.log(index);
            return 'modal' + index
        },

        deepClone(obj) {
            if (obj === null || typeof obj !== "object") {
                return obj
            }

            const result = Array.isArray(obj) ? [] : {}

            for (let key of Object.keys(obj)) {
                result[key] = this.deepClone(obj[key])
            }

            return result
        },
        deletelist(index) {
            var newarr = [];
            var delarr = [];
            this.reqlists.forEach((e, i) => {
                if (i != index) {
                    newarr.push(this.deepClone(e))
                } else {
                    delarr.push(this.deepClone(e))
                }
            })
            this.reqlists = newarr;
            if (confirm('删除后不能恢复，仍要删除? / 삭제 후에는 복구가 불가능합니다. 그래도 삭제하시겠습니까?')) {
                this.deletereqlists(delarr);
            }
        },
        async deletereqlists(delarr) {
            axios.post('/api/reqpurchase/deletereqpurchase', delarr)
                .then((res) => {
                    if (res.data.요청결과 == '삭제완료') {
                        alert(res.data.요청결과)
                    } else {
                        alert(res.data.요청결과)
                        console.log(res.data)
                    }
                })
                .catch(console.log)
        },
        deletedetail(발주번호, SKUID) {
            var newarr = [];
            var newobj = {};
            this.lists.forEach(e => {
                if (e.발주번호 != 발주번호) {
                    newarr.push(e);
                } else {
                    newobj = this.deepClone(e);
                    newobj.발주세부내역 = [];
                    e.발주세부내역.forEach(ele => {
                        if (ele.SKUID != SKUID) {
                            newobj.발주세부내역.push(ele);
                        }
                    });
                    newarr.push(newobj);
                }
            })
            this.lists = newarr;
        },
        allchecklist(allchecked) {
            if (allchecked == true) {
                this.lists.forEach(e => {
                    e.checked = true;
                })
            } else {
                this.lists.forEach(e => {
                    e.checked = false;
                })
            }
        },
        allcheckdetaillist(allcheckdetail) {
            if (allcheckdetail == true) {
                this.detaillists.forEach(e => {
                    e.checked = true;
                })
            } else {
                this.detaillists.forEach(e => {
                    e.checked = false;
                })
            }
        },
        getTodaywith() {
            var date = new Date();
            var year = date.getFullYear();
            var month = ("0" + (1 + date.getMonth())).slice(-2);
            var day = ("0" + date.getDate()).slice(-2);

            return year + "-" + month + "-" + day;
        },
        getToday() {
            var date = new Date();
            var year = date.getFullYear();
            var month = ("0" + (1 + date.getMonth())).slice(-2);
            var day = ("0" + date.getDate()).slice(-2);

            return year + month + day;
        },
        timestamp(date) {
            //inputdate = "yyyy-mm-dd"
            return new Date(date).getTime() / 1000
        },
        gettimestamp(date) {
            return new Date(date).getTime()
        },
        // list = 批量下单 진행창의 「이번 주문내역」(성공 건). 버튼 @click 은 이벤트가 들어오므로 배열일 때만 쓴다
        downloadlist(list) {
            // 체크한 건만 내보낸다. 아무것도 안 고르면 지금까지처럼 화면에 보이는 전체를 받는다.
            //
            // ⚠ 선택 원소의 모양이 뷰 모드마다 다르다. 그룹 뷰의 선택은 groupedReqlists 가 만든
            //    **그룹 행**이라 원본 요청건이 .items 안에 들어 있고, 개인 뷰의 선택은 reqlists
            //    원소 그대로다. 이걸 구분하지 않고 그대로 내보내면 그룹 뷰에서 엑셀이 빈 채로 나간다.
            var targets = this.reqlists;
            if (Array.isArray(list)) {
                targets = list;
            } else if (this.tableSelectedItem.length > 0) {
                targets = this.viewMode === 'group'
                    ? this.tableSelectedItem.flatMap(g => g.items || [])
                    : this.tableSelectedItem;
            }

            var arr = [];
            targets.forEach(e => {
                var customsType = e.요청내역.customsType == 'integrated' ? '통합통관' : e.요청내역.customsType == 'client' ? '화주단독통관' : e.요청내역.customsType == 'kupass' ? '쿠패스단독통관' : ''

                // 협상전 가격 재계산 (견적서 뷰 quotationGroupItemsProcessed 와 동일한 derivation)
                // 저장된 협상전_단가가 아이템 수 균등분할로 기록된 경우 부정확하므로
                // 협상전_총금액/배송비/수량 기반으로 단위당 값을 재계산한다.
                const __qty = parseInt(e.구매요청수량) || 1;
                const __preTotal = parseFloat(e.주문정보?.협상전_총금액) || 0;
                const __preShipping = parseFloat(e.주문정보?.협상전_배송비) || 0;
                const __preProductAmount = __preTotal - __preShipping;
                const __preUnitPrice = __qty > 0 ? Math.round(__preProductAmount / __qty * 100) / 100 : 0;
                const __preShippingPerUnit = __qty > 0 ? Math.round(__preShipping / __qty * 100) / 100 : 0;

                // 요청타입은 화면 뱃지(reqtype 슬롯)와 같은 표기로 내보낸다.
                // 샘플검증이 먼저인 것도 화면과 같다 — 여기만 빠지면 화면과 엑셀이 어긋난다.
                const __reqtypeText = this.hasSampleCheck(e) ? '샘플검증'
                    : e.reqtype === '제트배송' ? '로켓그로스'
                        : (e.reqtype === '일반LCL' || e.reqtype === '일반') ? '일반'
                            : (e.reqtype || '');
                // 발주번호/발주센터/입고예정일은 로켓배송만 있다. polists 는 후보 목록이고
                // 실제로 고른 발주는 selectpo 하나라 그것만 내보낸다(미선택이면 빈칸).
                const __po = this.selectedPo(e);
                // 판매구성수량은 '단품' 문자열로 저장된 건이 있어 parseInt 하면 NaN 이 된다.
                const __판매구성수량 = (e.판매구성수량 === '단품' || !e.판매구성수량) ? 1 : (parseInt(e.판매구성수량) || 1);

                arr.push({
                    업체명: e.companyid,
                    요청일: this.getdate(e.요청일),
                    요청타입: __reqtypeText,
                    상품명: e.상품명,
                    SKUID: e.SKUID,
                    바코드: e.바코드,
                    구매요청수량: parseInt(e.구매요청수량),
                    판매구성수량: __판매구성수량,
                    묶음구성여부: e.묶음구성여부 ? "O" : "",
                    묶음구성수량: e.묶음구성여부 ? (parseInt(e.묶음구성수량) || "") : "",
                    구매링크: e.구매링크,
                    옵션1_중국어: e.옵션1_중국어,
                    옵션2_중국어: e.옵션2_중국어,
                    배치발주번호: __po ? __po.발주번호 : '',
                    발주번호: __po ? (__po.발주번호 || '') : '',
                    발주센터: __po ? (__po.발주센터 || '') : '',
                    입고예정일: __po ? (__po.입고예정일 || '') : '',
                    출고방법: e.요청내역.exportType,
                    목적지: e.요청내역.destination ? e.요청내역.destination : "coupang",
                    신고영문명: e.신고영문명,
                    신고가격: e.신고가격,
                    HSCODE: e.HSCODE,

                    "기본검수/분류/포장": e.요청내역.default,
                    바코드라벨: e.요청내역.barcode,

                    포장방법위임: e.요청내역.auto ? "O" : "",
                    LDPE: e.요청내역.LDPE ? "O" : "",
                    OPP: e.요청내역.OPP ? "O" : "",
                    재포장생략: (e.요청내역.auto == false && !e.요청내역.LDPE && !e.요청내역.OPP) ? "O" : "",

                    원산지스티커: e.요청내역.sticker ? "O" : "",
                    라벨봉제: e.요청내역.sewing ? "O" : "",
                    도장: e.요청내역.stamp ? "O" : "",
                    택총: e.요청내역.tag ? "O" : "",
                    에어캡포장: e.요청내역.airpacking ? "O" : "",
                    중국어마스킹: e.요청내역.masking ? "O" : "",

                    화주주문번호: e.화주주문번호 || "",
                    묶음번호: this.batchNo(e),
                    "1688주문번호": e.주문정보?.['1688주문번호'] || "",
                    협상전가격: __preUnitPrice,
                    협상전운임: __preShippingPerUnit,
                    협상전총가격: __preTotal,

                    협의단가: e.협의단가,
                    총금액: e.요청내역.총금액,
                    협의ID: e.협의ID,

                    "기타요청사항(물류)": e.요청내역.reqcontent,
                    "기타요청사항(구매)": e.요청내역?.reqcontentPurchase || "",
                    이미지링크: e.등록이미지,
                    통관방법: customsType,
                    // 쿠팡 발주 확정수량 — 선택한 발주(selectpo)의 수량
                    발주수량: __po ? (__po.sku수량 ?? '') : ''
                })
            })
            const workBook = XLSX.utils.book_new()
            const workSheet = XLSX.utils.json_to_sheet(arr)
            XLSX.utils.book_append_sheet(workBook, workSheet, '주문내역')
            XLSX.writeFile(workBook, '주문내역' + '_' + this.getToday() + '.xlsx')
        },

        savesetting() {
            var payload = {
                companyid: this.$store.state.user.companyid,
                CreatePo_수취인: this.CreatePo_수취인,
                CreatePo_연락처: this.CreatePo_연락처,
                CreatePo_주소_성: this.CreatePo_주소_성,
                CreatePo_주소_시: this.CreatePo_주소_시,
                CreatePo_주소_구: this.CreatePo_주소_구,
                CreatePo_상세주소: this.CreatePo_상세주소,
                CreatePo_주문번호: this.CreatePo_주문번호,
                CreatePo_발주기준일: this.CreatePo_발주기준일
            };

            this.$store.commit('settingsupdate', payload)
            axios.post('/api/addpurchase/addsettings', payload)
                .then((res) => { alert(res.data.요청결과) })
        },
        importcompanyids() {
            axios.post('/api/getcompanyids', {})
                .then(result => {
                    if (result.data.요청결과 == 'success') {
                        result.data.result.forEach(e => {
                            if (e.auth?.showimport) {
                                if (!this.companyids.includes(e.companyid)) {
                                    this.companyids.push(e.companyid);
                                    this.companyInfos.push({companyid: e.companyid, name: e.name })
                                }
                            }
                        })
                        console.log(this.companyids)
                    } else {
                        alert(result.data.사유)
                    }
                }).catch((e) => {
                    alert('获取companyid失败 / companyid 가져오기 실패 (1413)')
                    console.log(e);
                    return true
                })
        },
        /**
         * 요청사항 툴팁 생성 (한국어 + 중국어)
         */
        getReqContentTooltip(korText, cnText) {
            if (!korText) return '';

            let tooltip = `<div style="max-width: 300px; text-align: left;">`;
            tooltip += `<div style="margin-bottom: 4px;"><strong>🇰🇷 한국어:</strong><br>${korText}</div>`;

            if (cnText) {
                tooltip += `<hr style="margin: 6px 0; border-color: rgba(255,255,255,0.3);">`;
                tooltip += `<div><strong>🇨🇳 中文:</strong><br>${cnText}</div>`;
            }

            tooltip += `</div>`;
            return tooltip;
        },

        // 행 강조 클래스 (메인 테이블에서 한눈에 보이도록)
        getRowHighlightClass(item) {
            if (!item) return '';
            const hasUnconfirmed = this.hasUnconfirmedChange(item);
            const status = item.processStatus || item.진행현황;
            if (hasUnconfirmed && status !== '구매전') return 'row-change-urgent';
            if (hasUnconfirmed) return 'row-change-pending';
            if (item.주문정보 && item.주문정보.별도결제) return 'row-side-payment';
            return '';
        },
        // 미확인 변경 존재 여부
        hasUnconfirmedChange(item) {
            if (!item || !Array.isArray(item.changeHistory)) return false;
            return item.changeHistory.some(c => c && c.confirmed === false);
        },
        unconfirmedChangeCount(item) {
            if (!item || !Array.isArray(item.changeHistory)) return 0;
            return item.changeHistory.filter(c => c && c.confirmed === false).length;
        },
        // 변경이력 처리 모달 오픈
        openChangeReviewModal(item) {
            if (!item || !Array.isArray(item.changeHistory) || item.changeHistory.length === 0) return;
            this.changeReviewItem = item;
            this.changeReviewSelected = item.changeHistory
                .filter(c => c && c.confirmed === false)
                .map(c => c.changeId);
            this.changeReviewNote = '';
            this.showChangeReviewModal = true;
        },
        async confirmChangeHistory(mode) {
            if (!this.changeReviewItem) return;
            const item = this.changeReviewItem;
            const payload = { requestId: item._id, confirmNote: this.changeReviewNote || null };
            if (mode === 'all') {
                payload.all = true;
            } else {
                if (!this.changeReviewSelected || this.changeReviewSelected.length === 0) {
                    alert('请选择要处理的项目 / 처리할 항목을 선택하세요.');
                    return;
                }
                payload.changeIds = this.changeReviewSelected;
            }
            try {
                this.changeReviewProcessing = true;
                const res = await axios.post('/api/logis/confirmchange', payload);
                if (!res.data.success) {
                    alert(res.data.message || '处理失败 / 처리 실패');
                    return;
                }
                const targetIds = mode === 'all'
                    ? item.changeHistory.filter(c => c.confirmed === false).map(c => c.changeId)
                    : this.changeReviewSelected;
                const apply = (target) => {
                    if (!target || !Array.isArray(target.changeHistory)) return;
                    target.changeHistory.forEach(c => {
                        if (targetIds.includes(c.changeId) && c.confirmed === false) {
                            c.confirmed = true;
                            c.confirmedBy = res.data.confirmedBy;
                            c.confirmedDate = res.data.confirmedDate;
                            c.confirmNote = this.changeReviewNote || null;
                        }
                    });
                    target.요청변경 = this.hasUnconfirmedChange(target);
                };
                apply(item);
                const initIdx = this.reqlistsinit.findIndex(r => r._id === item._id);
                if (initIdx !== -1) apply(this.reqlistsinit[initIdx]);
                this.요청변경 = this.reqlists.filter(e => this.hasUnconfirmedChange(e)).length;
                this.showChangeReviewModal = false;
                this.$forceUpdate();
                alert('已处理 / 처리되었습니다.');
            } catch (error) {
                console.error('confirmchange error:', error);
                alert('处理出错 / 처리 중 오류가 발생했습니다.');
            } finally {
                this.changeReviewProcessing = false;
            }
        },
        /**
         * 주문수량 기본값 = 구매요청수량 × 판매구성수량.
         * 판매구성수량이 '단품' 문자열로 저장된 건이 있어 parseInt 하면 NaN 이 된다.
         */
        defaultOrderQty(item) {
            const compose = (item.판매구성수량 === '단품' || !item.판매구성수량)
                ? 1 : (parseInt(item.판매구성수량) || 1);
            return (parseInt(item.구매요청수량) || 0) * compose;
        },

        // 별도링크 결제 모달 오픈
        openSidePaymentModal(item) {
            if (!item) return;
            this.sidePaymentItem = item;
            this.sidePaymentItems = [item];
            const prev = item.별도결제 || {};
            this.sidePaymentForm = {
                링크: prev.링크 || '',
                총금액: prev.총금액 || (item.견적서_1688구매금액?.최종금액합계_KRW || 0),
                총금액_CNY: prev.총금액_CNY || '',
                주문번호: prev.주문번호 ||(item.주문정보?.주문번호 || item.주문정보?.['1688주문번호'] || ''),
                // 다시 주문한 건은 수량도 달라져 있기 마련이다. 요청수량 기준으로 채워두고
                // 실제 주문 수량이 다르면 고쳐 넣게 한다. 비워두면 옛 수량이 그대로 남는다.
                주문수량: prev.주문수량 || this.defaultOrderQty(item),
                운송장번호: prev.운송장번호 || (item.주문정보?.운송장번호 || ''),
                메모: prev.메모 || '',
                판매처주문번호: item.주문정보?.판매처주문번호 || ''
            };
            this.showSidePaymentModal = true;
        },
        // 주문상세에서 체크한 여러 요청을 1688 주문 하나에 한꺼번에 연결
        openSidePaymentModalBatch() {
            const items = this.detailSelectedItems || [];
            if (items.length === 0) {
                alert('연결할 상품을 체크해주세요. / 请勾选要关联的商品。');
                return;
            }
            if (items.length === 1) {
                this.openSidePaymentModal(items[0]);
                return;
            }
            this.sidePaymentItem = items[0];
            this.sidePaymentItems = items.slice();
            // 체크한 요청들이 이미 같은 수동 주문에 묶여 있으면 그 값을 채워둔다.
            const prev = items[0].별도결제 || {};
            const same = !!prev.주문번호 && items.every(it => it.별도결제?.주문번호 === prev.주문번호);
            this.sidePaymentForm = {
                링크: same ? (prev.링크 || '') : '',
                총금액: same ? (prev.총금액 || 0) : 0,
                총금액_CNY: same ? (prev.총금액_CNY || '') : '',
                주문번호: same ? prev.주문번호 : '',
                주문수량: 0, // 다건은 요청별 수량을 그대로 둔다
                운송장번호: same ? (prev.운송장번호 || '') : '',
                메모: same ? (prev.메모 || '') : '',
                판매처주문번호: ''
            };
            this.showSidePaymentModal = true;
        },
        async saveSidePayment() {
            if (!this.sidePaymentItem) return;
            const targets = this.sidePaymentItems.length ? this.sidePaymentItems : [this.sidePaymentItem];
            const multi = targets.length > 1;
            const f = this.sidePaymentForm;
            const non1688 = this.sidePaymentNon1688;
            if (!non1688 && targets.some(it => this.isNon1688(it))) {
                alert('非1688 상품과 1688 상품을 한 번에 연결할 수 없습니다. / 非1688与1688商品不能一起关联。');
                return;
            }
            if (non1688) {
                // 非1688 은 1688 주문번호가 없다. 송금액이 견적서 금액이 되므로 비우면 안 된다
                if (!(parseFloat(f.총금액_CNY) > 0)) {
                    alert('请填写转账金额 / 송금액(CNY)을 입력해주세요.');
                    return;
                }
                if (targets.some(it => !this.canManualTransfer(it) && !it.별도결제)) {
                    const blocked = targets.filter(it => !this.canManualTransfer(it) && !it.별도결제);
                    if (blocked.some(it => it.최종결제여부)) {
                        alert('이미 결제된 상품이 있습니다. / 有已付款的商品。');
                    } else if (blocked.some(it => !it.입금여부)) {
                        alert('화주 입금이 확인되지 않은 상품이 있습니다. 입금 확인 후 송금 등록할 수 있습니다. / 有商品尚未确认入账，请先确认入账后再登记转账。');
                    } else {
                        alert('현재 진행 상태에서는 송금 등록을 할 수 없는 상품이 있습니다. / 有商品当前状态无法登记转账。');
                    }
                    return;
                }
            } else if (!f.주문번호 || !String(f.주문번호).trim()) {
                alert('1688 주문번호를 입력해주세요. / 请填写1688订单号。');
                return;
            }
            if (!multi && (!f.주문수량 || parseInt(f.주문수량) < 1)) {
                alert('주문수량을 입력해주세요. / 请填写下单数量。');
                return;
            }
            if (targets.some(it => it.주문정보?.별도결제) &&
                !confirm('이미 별도결제가 처리된 건이 있습니다. 덮어쓸까요? / 已有处理过的订单，确定覆盖吗？')) {
                return;
            }
            try {
                this.sidePaymentProcessing = true;
                // 총금액_CNY 가 있으면 서버가 견적서 환율로 원화 환산한다. 비워두면 기존 원화(총금액)를 그대로 보낸다.
                const payload = { 별도결제: { ...f, 주문번호: non1688 ? '' : String(f.주문번호).trim(), 총금액_CNY: parseFloat(f.총금액_CNY) || 0 } };
                // 단건은 예전 형식 그대로 보낸다.
                if (multi) payload.requestIds = targets.map(it => it._id);
                else payload.requestId = targets[0]._id;
                const res = await axios.post('/api/logis/savesidepayment', payload);
                if (!res.data.success) {
                    alert(res.data.message || '저장 실패 / 保存失败');
                    return;
                }
                const results = Array.isArray(res.data.results) && res.data.results.length
                    ? res.data.results
                    : [{ requestId: targets[0]._id, ...res.data }];
                const apply = (target, r) => {
                    if (!target || !r) return;
                    target.별도결제 = r.별도결제;
                    target.주문정보 = r.주문정보;
                    if (r.견적서_1688구매금액) {
                        target.견적서_1688구매금액 = r.견적서_1688구매금액;
                    }
                    if (r.진행현황) {
                        target.진행현황 = r.진행현황;
                        target.processStatus = r.진행현황;
                    }
                    // 결제 여부는 서버가 1688 주문 상태로 판정한 값을 따른다('결제진행' 뱃지 즉시 갱신).
                    if (typeof r.최종결제여부 === 'boolean') target.최종결제여부 = r.최종결제여부;
                };
                for (const r of results) {
                    apply(targets.find(it => String(it._id) === String(r.requestId)), r);
                    const initIdx = this.reqlistsinit.findIndex(x => String(x._id) === String(r.requestId));
                    if (initIdx !== -1) apply(this.reqlistsinit[initIdx], r);
                }
                // 非1688 은 1688 물류 웹훅이 없다 — 운송장을 订单列表 운송장 직접입력(paidlist/update)으로 넘겨야
                // 입고처리 운송장 검색이 찾는다(1688 건은 웹훅이 채우므로 기존대로 둔다)
                const waybill = String(f.운송장번호 || '').trim();
                const waybillFailed = [];
                if (non1688 && waybill) {
                    for (const it of targets) {
                        try {
                            const wr = await axios.post('/api/reqpurchase/paidlist/update', {
                                _id: it._id, 운송장: { 물류코드: '', 운송장번호: waybill }, 같은주문적용: false
                            });
                            if (wr.data.요청결과 === '성공') this.$set(it, '물류정보', wr.data.물류정보 || it.물류정보 || {});
                            else waybillFailed.push(`${it.상품명 || it._id}: ${wr.data.error?.errorMessage || '실패'}`);
                        } catch (err) {
                            console.error('非1688 운송장 저장 오류:', err);
                            waybillFailed.push(`${it.상품명 || it._id}: ${err.message}`);
                        }
                    }
                }
                this.showSidePaymentModal = false;
                this.$forceUpdate();
                if (waybillFailed.length) {
                    alert('저장했지만 운송장 저장 실패(订单列表 에서 다시 입력) / 运单号保存失败:\n' + waybillFailed.join('\n'));
                } else if (res.data.주문상태조회 === 'failed') {
                    alert('연결은 저장했지만 1688 주문 상태를 가져오지 못했습니다. 결제 상태는 나중에 자동으로 반영됩니다.\n'
                        + '已保存关联，但未能获取1688订单状态，付款状态稍后会自动更新。');
                } else {
                    alert('별도결제가 저장되었습니다. / 已保存。');
                }
            } catch (error) {
                console.error('별도결제 저장 오류:', error);
                alert('별도결제 저장 중 오류가 발생했습니다. / 保存时出错。');
            } finally {
                this.sidePaymentProcessing = false;
            }
        },
        /** 그룹 안 요청들의 판매처 주문번호(非1688 기록용, 중복 제거) */
        sellerOrderNos(group) {
            return [...new Set((group?.items || []).map(it => it.주문정보?.판매처주문번호).filter(Boolean))];
        },
        /** 非1688(自行采购) 요청인가 — 화주 화면이 저장하는 구매유형:'non1688' (없으면 기존 1688 건) */
        isNon1688(item) {
            return !!item && item.구매유형 === 'non1688';
        },
        /** 已转账 처리 가능 상태 — 결제 전 단계만. 상태 역행 판정은 서버 checkStatusRollback 이 한 번 더 한다 */
        canManualTransfer(x) {
            if (!x || x.최종결제여부) return false;
            if (!x.입금여부) return false;   // 화주 입금 확인 뒤에만 — 서버(savesidepayment)도 같은 규칙으로 막는다
            const st = x.processStatus || x.진행현황 || '구매전';
            return ['구매전', '협상중', '구매확인', '입금요청', '입금완료'].includes(st);
        },
        /**
         * 非1688 已转账 — 기존 별도링크 결제(별도결제) 모달을 그대로 쓴다(YZY 10-07 점검).
         * 1688 주문번호 대신 상점/메모를 받고, 송금액(CNY)은 견적서 환율로 환산돼 견적서에 반영된다(#1125 와 같은 경로).
         * 서버(/api/logis/savesidepayment)가 非1688 문서면 구매완료·결제완료로 올린다.
         */
        openNon1688Transfer(items) {
            const list = (items || []).filter(it => this.isNon1688(it));
            if (!list.length) {
                alert('非1688 商品이 없습니다. / 没有非1688商品。');
                return;
            }
            const prev = list[0].별도결제 || {};
            this.sidePaymentItem = list[0];
            this.sidePaymentItems = list.slice();
            this.sidePaymentForm = {
                링크: prev.링크 || list[0].구매링크 || '',
                총금액: prev.총금액 || 0,
                총금액_CNY: prev.총금액_CNY || '',
                주문번호: '',
                주문수량: list.length > 1 ? 0 : (prev.주문수량 || this.defaultOrderQty(list[0])),
                운송장번호: prev.운송장번호 || '',
                메모: prev.메모 || '',
                // 송금 후 다시 열어 고칠 때 저장된 값을 채워둔다(여러 건이면 모두 같을 때만)
                판매처주문번호: list.every(it => (it.주문정보?.판매처주문번호 || '') === (list[0].주문정보?.판매처주문번호 || ''))
                    ? (list[0].주문정보?.판매처주문번호 || '') : ''
            };
            this.showSidePaymentModal = true;
        },
        getChangeHistoryTooltip(item) {
            if (!item.changeHistory || item.changeHistory.length === 0) return '';

            // "구매전"이 아닌 상태에서 변경된 경우 경고 메시지 추가
            let warningMessage = '';
            if ((item.processStatus || item.진행현황) !== '구매전') {
                warningMessage = `
                    <div class="p-2" style="background-color: #fff3cd; border: 1px solid #ffc107; border-radius: 4px; margin-bottom: 8px;">
                        <strong style="color: #856404;">⚠️ 주의: 구매확인 이후 변경된 요청사항입니다!</strong><br>
                        <span style="color: #856404; font-size: 0.9em;">현재 상태: ${item.processStatus || item.진행현황}</span>
                    </div>
                `;
            }

            const historyContent = item.changeHistory.map(change => {
                const date = new Date(change.changeDate).toLocaleDateString();
                const changesList = Object.entries(change.changes)
                    .map(([key, value]) => {
                        return `${key}: ${value.변경전} → ${value.변경후}`;
                    })
                    .join('<br>');

                return `
                    <div class="p-1">
                        <strong>${date}</strong> (${change.changedBy})<br>
                        ${changesList}
                    </div>
                `;
            }).join('<hr class="my-1">');

            return warningMessage + historyContent;
        },
        importtextchange(event) {
            this.importtext = 'Connect';
            if (event.keyCode === 13 && this.업체명 != '') {
                this.importcompanyinfo()
            }
        },
        // 단일 요청 로드 메서드 추가
        async loadSingleRequest(requestId) {
            try {
                console.log('loadSingleRequest 시작 - requestId:', requestId);
                this.showspinner = true
                this.showreqlist = false

                // 서버에 단일 요청 조회 API 호출
                console.log('API 호출 전 - /api/reqpurchase/getrequest');
                const response = await axios.post('/api/reqpurchase/getrequest', { requestId })
                console.log('API 응답 받음:', response.data);

                if (response.data.success && response.data.request) {
                    console.log('요청 데이터 찾음');
                    const request = response.data.request

                    // 데이터 가공
                    request.요청내역 = request.요청내역 || {}
                    const customsType = request.요청내역.customsType == 'integrated' ? '통합통관' :
                                       request.요청내역.customsType == 'client' ? '화주단독통관' :
                                       request.요청내역.customsType == 'kupass' ? '쿠패스단독통관' : ''

                    request.통관방법 = customsType
                    request.요청내역.reqcontentPurchase = request.요청내역?.reqcontentPurchase || ""
                    request.요청변경 = this.hasUnconfirmedChange(request)
                    request.진행현황 = request.진행현황 ? request.진행현황 : "구매전"
                    request.processStatus = request.processStatus || request.진행현황
                    request.구매취소 = request.구매취소 ? request.구매취소 : false
                    request.구매취소내용 = request.구매취소내용 ? request.구매취소내용 : ''
                    request.판매구성수량 = request.판매구성수량 == '단품' ? 1 : request.판매구성수량

                    // statusHistory 초기화 (없으면 빈 배열로 설정)
                    request.statusHistory = request.statusHistory || [];

                    if (request.진행현황 == '발송전') {
                        request.processStatus = '구매완료'
                        request.진행현황 = '구매완료'
                    }

                    request.checked = false

                    // 리스트에 추가
                    this.reqlistsinit = [this.deepClone(request)]
                    this.reqlists = [this.deepClone(request)]

                    // 통계 업데이트
                    const status = request.processStatus || request.진행현황
                    this.total = 1
                    this.구매전 = status == '구매전' ? 1 : 0
                    this.발송전 = status == '발송전' ? 1 : 0
                    this.발송완료 = status == '발송완료' ? 1 : 0
                    this.입고완료 = status == '입고완료' ? 1 : 0
                    this.노마드클럽 = request.reqtype == '제트배송' ? 1 : 0
                    this.샘플검증 = this.hasSampleCheck(request) ? 1 : 0
                    this.로켓배송 = request.reqtype === '로켓배송' ? 1 : 0
                    this.일반배송 = request.reqtype !== '제트배송' && request.reqtype !== '로켓배송' ? 1 : 0
                    this.구매확인 = status == '구매확인' ? 1 : 0
                    this.구매취소 = request.구매취소 ? 1 : 0
                    this.요청변경 = this.hasUnconfirmedChange(request) ? 1 : 0
                    this.통합통관 = request.통관방법 == '통합통관' ? 1 : 0
                    this.단독통관 = request.통관방법 == '화주단독통관' ? 1 : 0
                    this.쿠패스단독통관 = request.통관방법 == '쿠패스단독통관' ? 1 : 0

                    this.showreqlist = true
                } else {
                    alert('找不到请求 / 요청을 찾을 수 없습니다.')
                    // 요청을 찾을 수 없으면 일반 검색 실행
                    this.search()
                }
            } catch (error) {
                console.error('단일 요청 로드 오류:', error)
                alert('加载请求出错 / 요청을 로드하는 중 오류가 발생했습니다.')
                this.search()
            } finally {
                this.showspinner = false
            }
        },

        // 일괄처리 관련 메서드들
        async updateBatchStatus() {
            if (!this.batchStatus || this.tableSelectedItem.length === 0) {
                alert('请选择状态和项目 / 진행현황을 선택하고 항목을 선택해주세요.');
                return;
            }

            // 입고오류는 개별 처리만 가능 (오류 상세 입력 필요)
            if (this.batchStatus === '입고오류') {
                alert('入库错误请在单个商品上用「错误」按钮处理 / 입고오류는 개별 상품에서 "오류" 버튼을 통해 처리해주세요.\n(需填写错误类型和详细内容 / 오류유형과 상세내용 입력이 필요합니다)');
                return;
            }

            if (!confirm(`将所选${this.tableSelectedItem.length}项的状态改为「${this.displayZh(this.batchStatus)}」? / 선택된 ${this.tableSelectedItem.length}개 항목의 진행현황을 '${this.batchStatus}'로 변경하시겠습니까?`)) {
                return;
            }

            this.batchProcessing = true;

            try {
                // processStatus API로 일괄 변경 (processHistory 자동 기록)
                const ids = this.tableSelectedItem.map(item => item._id);
                const response = await axios.post('/api/reqpurchase/updateProcessStatusBulk', {
                    ids: ids,
                    toStatus: this.batchStatus,
                    memo: '쿠패스 일괄변경'
                });

                if (response.data.요청결과 === '성공') {
                    // 서버가 역행이라고 판단해 건너뛴 건이 있을 수 있다. 그걸 확인하지 않고
                    // 화면만 바꾸면 "바뀐 것처럼 보이는데 DB 는 그대로"가 된다.
                    const skipped = response.data.skipped || [];
                    const skippedIds = new Set(skipped.map(s => String(s.id)));

                    if (skippedIds.size >= this.tableSelectedItem.length) {
                        // 하나도 못 바꿨다 — 로컬 상태를 건드리지 않는다
                        alert('未能变更状态 / 진행현황을 변경하지 못했습니다.\n\n' +
                            skipped.slice(0, 5).map(s => `· ${s.reason}`).join('\n') +
                            (skipped.length > 5 ? `\n· 另 (외) ${skipped.length - 5}件` : ''));
                        return;
                    }

                    // 로컬 데이터 업데이트 (실제로 바뀐 것만)
                    this.tableSelectedItem.forEach(selectedItem => {
                        if (skippedIds.has(String(selectedItem._id))) return;
                        // 구매취소에서 되돌리면 서버가 구매취소 표시도 같이 거둔다.
                        const wasCancel = (selectedItem.processStatus || selectedItem.진행현황) === '구매취소' && this.batchStatus !== '구매취소';
                        const index = this.reqlists.findIndex(item => item._id === selectedItem._id);
                        if (index !== -1) {
                            this.reqlists[index].processStatus = this.batchStatus;
                            this.reqlists[index].진행현황 = this.batchStatus;
                            if (wasCancel) this.reqlists[index].구매취소 = false;
                        }
                        const initIdx = this.reqlistsinit.findIndex(item => item._id === selectedItem._id);
                        if (initIdx !== -1) {
                            this.reqlistsinit[initIdx].processStatus = this.batchStatus;
                            this.reqlistsinit[initIdx].진행현황 = this.batchStatus;
                            if (wasCancel) this.reqlistsinit[initIdx].구매취소 = false;
                        }
                    });

                    const changed = this.tableSelectedItem.length - skippedIds.size;
                    // 선택 해제 및 상태 초기화
                    this.tableSelectedItem = [];
                    this.batchStatus = '';
                    this.showBatchChange = false;

                    alert(`${changed}项状态已变更 / ${changed}개 항목의 진행현황이 변경되었습니다.` +
                        (skipped.length
                            ? `\n\n未能变更 / 변경하지 못한 ${skipped.length}건:\n` +
                              skipped.slice(0, 5).map(s => `· ${s.reason}`).join('\n') +
                              (skipped.length > 5 ? `\n· 另 (외) ${skipped.length - 5}件` : '')
                            : ''));
                    this.updateStatusCounts();
                } else {
                    throw new Error(response.data.error || '일괄 상태 변경 실패');
                }
            } catch (error) {
                console.error('일괄 상태 변경 오류:', error);
                alert('批量变更状态出错 / 일괄 상태 변경 중 오류가 발생했습니다.');
            } finally {
                this.batchProcessing = false;
            }
        },

        getStatusHistoryTooltip(item) {
            if (!item.statusHistory || item.statusHistory.length === 0) return '';

            return item.statusHistory.map(history => {
                const date = new Date(history.changeDate).toLocaleString('ko-KR', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit'
                });

                return `
                    <div class="p-1">
                        <strong>변경일:</strong> ${date}<br>
                        <strong>변경자:</strong> ${history.changedBy}<br>
                        <strong>변경상태:</strong> ${history.previousStatus} → ${history.newStatus}
                    </div>
                `;
            }).join('<hr style="margin: 5px 0;">');
        },

        updateStatusCounts() {
            // 현재 표시된 데이터를 기반으로 상태별 카운트 업데이트
            const counts = {
                구매전: 0,
                협상중: 0,
                구매확인: 0,
                구매보류: 0,
                구매취소: 0,
                입금요청: 0,
                입금완료: 0,
                구매완료: 0,
                배송중: 0,
                배송완료: 0,
                입고작업: 0,
                출고확인대기: 0,
                재고대기: 0,
                출고요청: 0,
                출고대기: 0,
                출고완료: 0,
                중국재고: 0,
                입고오류: 0,
                해외입고중: 0,
                국내입고중: 0,
                국내창고입고중: 0,
                국내창고입고완료: 0,
                쿠팡센터입고완료: 0
            };

            this.reqlistsinit.forEach(item => {
                const status = item.processStatus || item.진행현황 || '구매전';
                if (status in counts) {
                    counts[status]++;
                }
            });

            // statusCounts 객체 업데이트
            this.statusCounts = { ...counts };

            // 전체 카운트 업데이트
            this.total = this.reqlistsinit.length;
        },

        // 결제진행 = 표 「결제진행」 칸의 「미결제(눌러서 결제)」와 같은 판정: 1688 주문 있음 · 입금확인 · 최종결제 전
        isPaymentPending(item) {
            return !!((item.주문생성여부 || item.주문정보) && item.입금여부 && !item.최종결제여부);
        },
        showPaymentPending() {
            this.showreqlist = false;
            setTimeout(() => {
                this.reqlists = this.reqlistsinit.filter(item => this.isPaymentPending(item));
                this.showreqlist = true;
            }, 10);
        },

        // 상태별 필터링 메서드
        showStatus(status) {
            this.showreqlist = false;
            setTimeout(() => {
                this.reqlists = this.reqlistsinit.filter(item => {
                    return (item.processStatus || item.진행현황 || '구매전') === status;
                });
                this.showreqlist = true;
            }, 10);
        },

        // ==================== 견적서 관련 메서드 ====================

        // 견적서 상태에 따른 Badge 색상 반환
        getQuotationBadgeVariant(status) {
            const variants = {
                '미생성': 'secondary',
                '생성완료': 'info',
                '발송완료': 'primary',
                '입금확인': 'warning',
                '결제완료': 'success'
            };
            return variants[status] || 'secondary';
        },

        // 그룹에서 견적서 모달 열기 (상세 모달의 견적서생성 버튼)
        createQuotationFromGroup() {
            if (!this.selectedGroup || !this.selectedGroup.items) return;
            this.openQuotationModal(this.selectedGroup);
        },

        // 개별 아이템에서 견적서 모달 열기 (같은 화주주문번호 그룹을 찾아서 열기)
        createQuotation(item) {
            // 같은 화주주문번호를 가진 아이템들로 가상 그룹 구성
            const 화주주문번호 = item.화주주문번호;
            let groupItems = [item];
            if (화주주문번호) {
                groupItems = this.reqlistsinit.filter(i => i.화주주문번호 === 화주주문번호);
            }
            const customsType = item.요청내역?.customsType || item.통관방법 || 'integrated';
            const group = {
                companyid: item.companyid,
                companyName: item.companyid,
                요청일: item.요청일,
                화주주문번호: 화주주문번호 || '',
                적용환율: customsType === '통합통관' || customsType === 'integrated' ? 300 : (parseFloat(this.exchangeRate?.cashBuyValue) || 190),
                items: groupItems
            };
            this.openQuotationModal(group);
        },

        // 견적서 일괄 생성 (quotation-modal 내부에서 호출)
        async submitQuotationBatch() {
            const unquotedItems = this.quotationGroupUnquotedItems;
            if (!unquotedItems.length) return;

            this.quotationCreating = true;
            const form = this.quotation1688Form;
            let successCount = 0;
            let failCount = 0;
            let emptyCount = 0; // 非1688 금액 없이 만든 견적(견적 미입력)

            // 견적서 생성 전 1688 API로 최신 가격 자동 조회 (주문번호별로 분리 조회)
            const orderIdGroups = {};
            unquotedItems.forEach(item => {
                const oid = item.주문정보?.['1688주문번호'];
                if (oid) {
                    if (!orderIdGroups[oid]) orderIdGroups[oid] = [];
                    orderIdGroups[oid].push(item);
                }
            });
            for (const [orderId, groupItems] of Object.entries(orderIdGroups)) {
                try {
                    const priceRes = await axios.post('/api/reqpurchase/checkPriceModification', {
                        orderId: orderId,
                        reqItems: groupItems.map(item => ({
                            _id: item._id,
                            상품ID: item.상품ID || item.productId,
                            SKU: item.SKU || item.specId
                        }))
                    });
                    if (priceRes.data.요청결과 === '성공') {
                        const modifications = priceRes.data.priceModifications || [];
                        // 서버가 요청건별로 나눠 저장한 값을 그대로 쓴다(품목을 여기서 다시 맞추면 같은 상품 다른 옵션이 섞인다)
                        const perDoc = priceRes.data.perDoc || {};
                        const 주문배송비 = priceRes.data.orderSummary?.주문배송비 || 0;
                        groupItems.forEach(item => {
                            if (!item.주문정보) item.주문정보 = {};
                            const saved = perDoc[item._id];
                            if (saved) Object.assign(item.주문정보, saved);
                            item.주문정보.협상후_주문배송비 = 주문배송비;
                        });
                        console.log(`[견적서생성] 1688주문 ${orderId} 최신 가격 조회 완료:`, modifications.length, '건');
                    }
                } catch (e) {
                    console.warn(`[견적서생성] 1688주문 ${orderId} 최신 가격 조회 실패, 기존 데이터로 진행:`, e.message);
                }
            }

            // 주문별 총수량 계산 (총배송비 분배용)
            const allGroupItems = this.quotationGroup?.items || [];
            const orderTotalQtysForQuote = {};
            allGroupItems.forEach(gi => {
                const oid = gi.주문정보?.['1688주문번호'] || 'unknown';
                if (!orderTotalQtysForQuote[oid]) orderTotalQtysForQuote[oid] = 0;
                orderTotalQtysForQuote[oid] += parseInt(gi.구매요청수량) || 1;
            });

            let 결제원값합 = 0;
            for (const item of unquotedItems) {
                try {
                    const override = this.quotationEditOverrides[item._id] || {};
                    const orderId = item.주문정보?.['1688주문번호'] || 'unknown';
                    const orderShipOverride = this.quotationOrderShippingOverrides[orderId];
                    const orderTotalQty = orderTotalQtysForQuote[orderId] || 1;

                    const 구매수량 = override.구매수량 != null ? parseInt(override.구매수량) : (parseInt(item.구매요청수량) || 1);
                    let 협상후_구매단가 = override.구매단가 != null ? parseFloat(override.구매단가)
                        : negoUnitCny(item.주문정보, parseInt(item.구매요청수량) || 1);

                    // 협상후 배송비: 주문 총배송비 override → 수량비례 분배
                    let 협상후_배송비;
                    if (orderShipOverride?.협상후 != null) {
                        협상후_배송비 = Math.round(parseFloat(orderShipOverride.협상후) / orderTotalQty * 구매수량 * 100) / 100;
                    } else {
                        const post배송비 = item.주문정보?.협상후_배송비;
                        협상후_배송비 = (post배송비 != null && post배송비 !== '') ? (parseFloat(post배송비) || 0) : (parseFloat(item.주문정보?.협상전_배송비) || 0);
                    }

                    // 협상전 오버라이드 계산
                    const qty_for_pre = parseInt(item.구매요청수량) || 1;
                    const pre총금액 = item.주문정보?.협상전_총금액 || 0;
                    let 협상전_구매단가, 협상전_배송비_total;
                    if (override.협상전_단가 != null) {
                        협상전_구매단가 = parseFloat(override.협상전_단가);
                        협상전_배송비_total = Math.round((pre총금액 - 협상전_구매단가 * qty_for_pre) * 100) / 100;
                    } else if (orderShipOverride?.협상전 != null) {
                        협상전_배송비_total = Math.round(parseFloat(orderShipOverride.협상전) / orderTotalQty * qty_for_pre * 100) / 100;
                        협상전_구매단가 = qty_for_pre > 0 ? Math.round((pre총금액 - 협상전_배송비_total) / qty_for_pre * 100) / 100 : 0;
                    } else {
                        협상전_구매단가 = null;
                        협상전_배송비_total = null;
                    }

                    const response = await axios.post('/api/quotation/create1688', {
                        reqpurchaseId: item._id,
                        customsType: form.customsType,
                        협상후_구매단가: 협상후_구매단가,
                        협상후_배송비: 협상후_배송비,
                        ...(협상전_구매단가 != null && { 협상전_구매단가 }),
                        ...(협상전_배송비_total != null && { 협상전_배송비: 협상전_배송비_total }),
                        구매수량: 구매수량,
                        // 단독통관은 서버가 1688 주문일 환율로 정한다 — 직원이 칸을 직접 고쳤을 때만 그 값을 쓰게 알린다
                        환율: this.quoteRateForItem(item),
                        환율수동: form.customsType !== 'integrated' && !!form.환율수동,
                        // 묶음 합계를 낸 뒤 한 번만 반올림 — 앞 행들의 원화 원값 합을 서버에 돌려보낸다
                        앞행_결제원값합: 결제원값합,
                        메모: form.메모
                    });

                    if (response.data.요청결과 === '성공') {
                        // 非1688 빈 견적(견적 미입력)은 서버가 입금요청으로 넘기지 않는다 — 서버가 준 상태를 따른다
                        if (response.data.결제원값누계 != null) 결제원값합 = response.data.결제원값누계;
                        const nextStatus = response.data.processStatus || '입금요청';
                        if (response.data.견적미입력) emptyCount++;
                        // 로컬 데이터 업데이트 (quotationGroup.items 내 해당 아이템)
                        item.견적서상태 = '생성완료';
                        item.견적서_1688구매금액 = response.data.견적서_1688구매금액;
                        item.processStatus = nextStatus;
                        item.진행현황 = nextStatus;

                        // reqlistsinit도 동기화
                        const initItem = this.reqlistsinit.find(i => i._id === item._id);
                        if (initItem) {
                            initItem.견적서상태 = '생성완료';
                            initItem.견적서_1688구매금액 = response.data.견적서_1688구매금액;
                            initItem.processStatus = nextStatus;
                            initItem.진행현황 = nextStatus;
                        }
                        successCount++;
                    } else {
                        failCount++;
                    }
                } catch (error) {
                    console.error('견적서 생성 오류:', item.상품명, error);
                    failCount++;
                }
            }

            this.quotationCreating = false;

            // 상태 카운트 갱신
            this.updateStatusCounts();

            // reqlistsinit 배열 재할당으로 Vue 2 computed 반응성 트리거 보장
            this.reqlistsinit = [...this.reqlistsinit];

            // quotationGroup 갱신 (견적서 미생성 아이템 재계산을 위해)
            if (this.quotationGroup) {
                this.quotationGroup = { ...this.quotationGroup };
            }

            this.$forceUpdate();

            if (emptyCount > 0) {
                this.$bvToast.toast(`非1688 ${emptyCount}건은 금액이 비어 「견적 미입력」 으로 저장됐습니다. 입금요청으로 넘어가지 않습니다 — 재생성으로 금액을 채워주세요.`, { title: '未生成账单 / 견적 미입력', variant: 'danger', solid: true, noAutoHide: true });
            }
            if (failCount === 0) {
                this.$bvToast.toast(`${successCount}件报价单已生成 / ${successCount}건 견적서 생성 완료`, { title: '完成 / 완료', variant: 'success', solid: true });
            } else {
                this.$bvToast.toast(`成功 / 성공 ${successCount}, 失败 / 실패 ${failCount}`, { title: '结果 / 결과', variant: 'warning', solid: true });
            }
        },

        // 견적서 재생성을 위해 기존 견적서 데이터 초기화 (입금완료 전만 가능)
        resetQuotationForRegenerate(item) {
            if (item.processStatus === '입금완료') {
                this.$bvToast.toast('已入账的项目不能重新生成 / 입금완료된 항목은 재생성할 수 없습니다.', { title: '提示 / 알림', variant: 'warning', solid: true });
                return;
            }
            if (!confirm(`重新生成「${item.상품명}」的报价单? / "${item.상품명}" 견적서를 재생성하시겠습니까?`)) return;

            // 로컬 데이터에서 견적서 정보 초기화 → quotationGroupUnquotedItems에 포함됨
            item.견적서_1688구매금액 = null;
            item.견적서상태 = '미생성';
            // reqlistsinit도 동기화
            const initItem = this.reqlistsinit.find(i => i._id === item._id);
            if (initItem) {
                initItem.견적서_1688구매금액 = null;
                initItem.견적서상태 = '미생성';
            }
            // quotationGroup 갱신
            this.quotationGroup = { ...this.quotationGroup };
            this.$forceUpdate();
        },

        // 중국물류비 견적서 생성 모달 열기 (동적 items + 자동 pre-populate)
        openChinaLogisticsModal(item) {
            this.chinaLogisticsItem = item;
            const customsType = item.요청내역?.customsType || 'integrated';
            const qty = parseInt(item.입고수량) || parseInt(item.구매요청수량) || 0;

            this.chinaLogisticsForm = { customsType, 메모: '' };

            // 기존 견적서가 있으면 해당 items 로드 (재생성/수정)
            if (item.견적서_중국물류비?.items?.length) {
                this.chinaLogisticsItems = item.견적서_중국물류비.items.map(i => ({ ...i }));
                this.chinaLogisticsForm.메모 = item.견적서_중국물류비.메모 || '';
            } else {
                // 요청내역 기반 자동 pre-populate
                const items = [];
                if (item.요청내역?.default) {
                    items.push({ name: '검수포장비', unitPrice: 200, quantity: qty, amount: 200 * qty });
                }
                if (item.요청내역?.barcode) {
                    items.push({ name: '바코드비', unitPrice: 100, quantity: qty, amount: 100 * qty });
                }
                if (customsType !== 'integrated') {
                    items.push({ name: '해상운송비_LCL', unitPrice: 0, quantity: 0, amount: 0 });
                    items.push({ name: '서류비', unitPrice: 0, quantity: 0, amount: 0 });
                    items.push({ name: '작업비', unitPrice: 0, quantity: 0, amount: 0 });
                    items.push({ name: '부자재비', unitPrice: 0, quantity: 0, amount: 0 });
                }
                // 항목이 하나도 없으면 빈 행 1개
                if (items.length === 0) {
                    items.push({ name: '', unitPrice: 0, quantity: qty, amount: 0 });
                }
                this.chinaLogisticsItems = items;
            }

            this.showChinaLogisticsModal = true;
        },

        // 동적 items 금액 자동 계산
        calcChinaItemAmount(idx) {
            const row = this.chinaLogisticsItems[idx];
            row.amount = (row.unitPrice || 0) * (row.quantity || 0);
        },

        // 중국물류비 견적서 생성/수정 제출 (동적 items)
        async submitChinaLogistics(bvModalEvt) {
            bvModalEvt.preventDefault();

            if (!this.chinaLogisticsItem) {
                alert('没有要生成报价单的对象 / 견적서 생성 대상이 없습니다.');
                return;
            }

            const validItems = this.chinaLogisticsItems.filter(i => i.name && i.name.trim());
            if (validItems.length === 0) {
                alert('请至少填写1个费用项目 / 비용 항목을 1개 이상 입력해주세요.');
                return;
            }

            try {
                this.showspinner = true;

                const response = await axios.post('/api/quotation/createChinaLogistics', {
                    reqpurchaseId: this.chinaLogisticsItem._id,
                    customsType: this.chinaLogisticsForm.customsType,
                    items: validItems,
                    메모: this.chinaLogisticsForm.메모
                });

                if (response.data.요청결과 === '성공') {
                    const isEdit = !!this.chinaLogisticsItem.견적서_중국물류비;
                    this.$bvToast.toast(`中国物流费报价单已${isEdit ? '修改' : '生成'} / 중국물류비 견적서가 ${isEdit ? '수정' : '생성'}되었습니다.`, {
                        title: `报价单${isEdit ? '修改' : '生成'}完成 / 견적서 ${isEdit ? '수정' : '생성'} 완료`,
                        variant: 'success',
                        solid: true
                    });

                    // 로컬 데이터 업데이트 (items 포함)
                    const updatedData = {
                        quotationId: response.data.quotation._id,
                        customsType: response.data.quotation.customsType,
                        items: response.data.quotation.items,
                        합계: response.data.quotation.합계,
                        총금액: response.data.quotation.총금액,
                        paymentStatus: response.data.quotation.paymentStatus,
                        생성일: response.data.quotation.생성일
                    };
                    this.chinaLogisticsItem.견적서_중국물류비 = updatedData;

                    const initIndex = this.reqlistsinit.findIndex(i => i._id === this.chinaLogisticsItem._id);
                    if (initIndex !== -1) {
                        this.reqlistsinit[initIndex].견적서_중국물류비 = updatedData;
                    }

                    this.$forceUpdate();
                    this.showChinaLogisticsModal = false;
                    this.chinaLogisticsItem = null;
                } else {
                    alert('报价单生成失败 / 견적서 생성 실패: ' + (response.data.error?.errorMessage || '未知错误 / 알 수 없는 오류'));
                }
            } catch (error) {
                console.error('중국물류비 견적서 생성 오류:', error);
                alert('报价单生成出错 / 견적서 생성 중 오류가 발생했습니다: ' + (error.response?.data?.error?.errorMessage || error.message));
            } finally {
                this.showspinner = false;
            }
        },

        // 진행현황 변경 이력 조회 모달 열기
        async openProcessHistoryModal(item) {
            // 그룹 뷰에서는 items 배열의 첫 번째 아이템 사용
            const targetItem = item.items ? item.items[0] : item;
            if (!targetItem || !targetItem._id) {
                alert('该项目无法查询记录 / 이력을 조회할 수 없는 항목입니다.');
                return;
            }

            this.showProcessHistoryModal = true;
            this.processHistoryLoading = true;
            this.processHistoryList = [];
            this.processHistoryCurrentStatus = targetItem.processStatus || targetItem.진행현황 || '구매전';
            this.statusLogRows = [];
            this.statusLogNow = null;
            this.statusLogOpen = false;

            try {
                const [response, logRes] = await Promise.all([
                    axios.post('/api/reqpurchase/getProcessHistory', { _id: targetItem._id }),
                    // 기록 조회가 실패해도 기존 이력은 보여준다
                    axios.post('/api/reqpurchase/getStatusLog', { _id: targetItem._id })
                        .catch(err => { console.error('상태 기록 조회 오류:', err); return null; })
                ]);

                if (response.data.요청결과 === '성공') {
                    this.processHistoryList = response.data.processHistory || [];
                    this.processHistoryCurrentStatus = response.data.processStatus;
                }
                if (logRes && logRes.data && logRes.data.요청결과 === '성공') {
                    this.statusLogNow = logRes.data.지금 && logRes.data.지금.진행현황;
                    this.statusLogRows = this.toStatusLogRows(logRes.data.기록 || []);
                }
            } catch (error) {
                console.error('이력 조회 오류:', error);
                alert('查询记录出错 / 이력 조회 중 오류가 발생했습니다.');
            } finally {
                this.processHistoryLoading = false;
            }
        },

        // 상태 기록 줄 → 화면 줄(최신이 위). 두 칸이 같은 값으로 함께 바뀐 줄은 하나로 보인다
        toStatusLogRows(rows) {
            const 출처 = { 수동: '手动 (직접)', 웹훅: '1688自动 (1688 자동)', 자동: '系统 (시스템)' };
            return rows.map(r => {
                const a = r.진행현황, b = r.processStatus;
                const one = a || b;
                let 구분 = '';
                if (a && b && a.값 !== b.값) 구분 = '流程 (처리단계) ' + this.displayZh(b.값);
                else if (a && !b) 구분 = '配送状态 (배송상태)';
                else if (!a && b) 구분 = '流程 (처리단계)';
                return {
                    시각: r.시각, 값: one.값, 이전값: one.이전값, 구분: r.생성 ? '创建 (생성)' : 구분,
                    출처: 출처[r.출처] || '', 누가: r.누가 || ''
                };
            }).reverse();
        },
        fmtStatusLogTime(t) {
            return t ? new Date(t).toLocaleString('ko-KR', { year: '2-digit', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }) : '-';
        },
        statusLogDays(ms, ko) {
            const d = Math.floor((ms || 0) / 86400000);
            if (d < 1) { const h = Math.floor((ms || 0) / 3600000); return ko ? h + '시간' : h + '小时'; }
            return ko ? d + '일' : d + '天';
        },

        // 입고오류 처리 모달 열기
        openInboundErrorModal(item) {
            this.errorTargetItem = item;
            this.errorForm = { 오류유형: '', 오류내용: '', 기타상세: '' };
            this.showErrorModal = true;
        },

        // 입고오류 처리 제출
        async submitInboundError(bvModalEvt) {
            bvModalEvt.preventDefault();
            if (!this.errorForm.오류유형) {
                this.$bvToast.toast('请选择错误类型 / 오류유형을 선택해주세요.', { title: '提示 / 알림', variant: 'warning', solid: true });
                return;
            }

            const 오류유형 = this.errorForm.오류유형 === '기타' && this.errorForm.기타상세
                ? this.errorForm.기타상세
                : this.errorForm.오류유형;

            try {
                const response = await axios.post('/api/reqpurchase/updateProcessStatus', {
                    _id: this.errorTargetItem._id,
                    toStatus: '입고오류',
                    오류유형: 오류유형,
                    오류내용: this.errorForm.오류내용,
                    memo: `입고오류: ${오류유형}`
                });

                if (response.data.요청결과 === '성공') {
                    // 로컬 데이터 업데이트
                    this.errorTargetItem.processStatus = '입고오류';
                    this.errorTargetItem.진행현황 = '입고오류';
                    const initIdx = this.reqlistsinit.findIndex(i => i._id === this.errorTargetItem._id);
                    if (initIdx !== -1) {
                        this.reqlistsinit[initIdx].processStatus = '입고오류';
                        this.reqlistsinit[initIdx].진행현황 = '입고오류';
                    }
                    this.$forceUpdate();
                    this.showErrorModal = false;
                    this.$bvToast.toast('入库错误已登记 / 입고오류가 등록되었습니다.', { title: '入库错误 / 입고오류', variant: 'warning', solid: true });
                } else {
                    alert('错误登记失败 / 오류 등록 실패: ' + (response.data.error || '未知错误 / 알 수 없는 오류'));
                }
            } catch (error) {
                console.error('입고오류 등록 오류:', error);
                alert('入库错误登记出错 / 입고오류 등록 중 오류가 발생했습니다.');
            }
        },

        // 한국물류비 견적서 생성 모달 열기 (동적 items + pre-populate)
        openKoreaLogisticsModal(item) {
            this.koreaLogisticsItem = item;
            const customsType = item.요청내역?.customsType || 'integrated';

            this.koreaLogisticsForm = { customsType, 메모: '' };

            // 기존 견적서가 있으면 해당 items 로드 (재생성/수정)
            if (item.견적서_한국물류비?.items?.length) {
                this.koreaLogisticsItems = item.견적서_한국물류비.items.map(i => ({ ...i }));
                this.koreaLogisticsForm.메모 = item.견적서_한국물류비.메모 || '';
            } else {
                // 기본 항목 pre-populate (빈값 - 쿠패스가 금액 입력)
                this.koreaLogisticsItems = [
                    { name: '관부가세', unitPrice: 0, quantity: 1, amount: 0 },
                    { name: '국내물류비', unitPrice: 0, quantity: 1, amount: 0 },
                    { name: '관세사비', unitPrice: 0, quantity: 1, amount: 0 }
                ];
            }

            this.showKoreaLogisticsModal = true;
        },

        // 동적 items 금액 자동 계산 (한국물류비)
        calcKoreaItemAmount(idx) {
            const row = this.koreaLogisticsItems[idx];
            row.amount = (row.unitPrice || 0) * (row.quantity || 0);
        },

        // 한국물류비 견적서 생성/수정 제출 (동적 items)
        async submitKoreaLogistics(bvModalEvt) {
            bvModalEvt.preventDefault();

            if (!this.koreaLogisticsItem) {
                alert('没有要生成报价单的对象 / 견적서 생성 대상이 없습니다.');
                return;
            }

            const validItems = this.koreaLogisticsItems.filter(i => i.name && i.name.trim());
            if (validItems.length === 0) {
                alert('请至少填写1个费用项目 / 비용 항목을 1개 이상 입력해주세요.');
                return;
            }

            try {
                this.showspinner = true;

                const response = await axios.post('/api/quotation/createKoreaLogistics', {
                    reqpurchaseId: this.koreaLogisticsItem._id,
                    customsType: this.koreaLogisticsForm.customsType,
                    items: validItems,
                    메모: this.koreaLogisticsForm.메모
                });

                if (response.data.요청결과 === '성공') {
                    const isEdit = !!this.koreaLogisticsItem.견적서_한국물류비;
                    this.$bvToast.toast(`韩国物流费报价单已${isEdit ? '修改' : '生成'} / 한국물류비 견적서가 ${isEdit ? '수정' : '생성'}되었습니다.`, {
                        title: `报价单${isEdit ? '修改' : '生成'}完成 / 견적서 ${isEdit ? '수정' : '생성'} 완료`,
                        variant: 'success',
                        solid: true
                    });

                    // 로컬 데이터 업데이트 (items 포함)
                    const updatedData = {
                        quotationId: response.data.quotation._id,
                        customsType: response.data.quotation.customsType,
                        items: response.data.quotation.items,
                        합계: response.data.quotation.합계,
                        총금액: response.data.quotation.총금액,
                        paymentStatus: response.data.quotation.paymentStatus,
                        생성일: response.data.quotation.생성일
                    };
                    this.koreaLogisticsItem.견적서_한국물류비 = updatedData;

                    const initIndex = this.reqlistsinit.findIndex(i => i._id === this.koreaLogisticsItem._id);
                    if (initIndex !== -1) {
                        this.reqlistsinit[initIndex].견적서_한국물류비 = updatedData;
                    }

                    this.$forceUpdate();
                    this.showKoreaLogisticsModal = false;
                    this.koreaLogisticsItem = null;
                } else {
                    alert('报价单生成失败 / 견적서 생성 실패: ' + (response.data.error?.errorMessage || '未知错误 / 알 수 없는 오류'));
                }
            } catch (error) {
                console.error('한국물류비 견적서 생성 오류:', error);
                alert('报价单生成出错 / 견적서 생성 중 오류가 발생했습니다: ' + (error.response?.data?.error?.errorMessage || error.message));
            } finally {
                this.showspinner = false;
            }
        },


        // 부피값 편집 시작
        startVolumeEdit(item) {
            this.volumeEditingId = item._id;
            this.volumeEditForm = {
                sizeX: item.sizeX || 0,
                sizeY: item.sizeY || 0,
                sizeZ: item.sizeZ || 0
            };
        },
        // 부피값 저장
        async saveVolume(item) {
            try {
                const res = await axios.post('/api/reqpurchase/updateVolume', {
                    reqpurchaseId: item._id,
                    ...this.volumeEditForm
                });
                if (res.data.요청결과 === '성공') {
                    item.sizeX = this.volumeEditForm.sizeX;
                    item.sizeY = this.volumeEditForm.sizeY;
                    item.sizeZ = this.volumeEditForm.sizeZ;
                    // reqlistsinit도 동기화
                    const initItem = this.reqlistsinit.find(i => i._id === item._id);
                    if (initItem) {
                        initItem.sizeX = this.volumeEditForm.sizeX;
                        initItem.sizeY = this.volumeEditForm.sizeY;
                        initItem.sizeZ = this.volumeEditForm.sizeZ;
                    }
                    this.volumeEditingId = null;
                    this.$bvToast.toast('体积已保存 / 부피값이 저장되었습니다.', { title: '保存完成 / 저장 완료', variant: 'success', solid: true });
                } else {
                    alert('体积保存失败 / 부피값 저장 실패: ' + (res.data.error?.errorMessage || ''));
                }
            } catch (error) {
                console.error('부피값 저장 오류:', error);
                alert('体积保存出错 / 부피값 저장 중 오류 발생');
            }
        },

        // 공통물류비 모달 열기
        async openCommonLogisticsModal(group) {
            this.commonLogisticsTarget = group;
            this.commonLogisticsExisting = false;
            this.commonLogisticsItems = [{ name: '', amount: 0 }];
            this.commonLogisticsMemo = '';

            // 기존 공통물류비가 있는지 조회
            try {
                const 화주주문번호 = group.화주주문번호;
                const companyid = group.companyid;
                if (화주주문번호 && companyid) {
                    const res = await axios.get(`/api/quotation/getCommonLogistics/${encodeURIComponent(화주주문번호)}/${encodeURIComponent(companyid)}`);
                    if (res.data.요청결과 === '성공' && res.data.data) {
                        this.commonLogisticsExisting = true;
                        this.commonLogisticsItems = res.data.data.items || [{ name: '', amount: 0 }];
                        this.commonLogisticsMemo = res.data.data.메모 || '';
                    }
                }
            } catch (e) {
                console.error('공통물류비 조회 오류:', e);
            }

            this.showCommonLogisticsModal = true;
        },
        // 공통물류비 저장/수정
        async submitCommonLogistics(bvModalEvent) {
            bvModalEvent.preventDefault();

            const validItems = this.commonLogisticsItems.filter(i => i.name && (Number(i.amount) || 0) > 0);
            if (validItems.length === 0) {
                alert('请至少填写1个有效费用项目 / 유효한 비용 항목을 1개 이상 입력해주세요.');
                return;
            }

            try {
                this.showspinner = true;
                const res = await axios.post('/api/quotation/createCommonLogistics', {
                    화주주문번호: this.commonLogisticsTarget.화주주문번호,
                    companyid: this.commonLogisticsTarget.companyid,
                    items: validItems,
                    메모: this.commonLogisticsMemo
                });

                if (res.data.요청결과 === '성공') {
                    this.$bvToast.toast(`公共物流费${this.commonLogisticsExisting ? '修改' : '保存'}完成 / 공통물류비 ${this.commonLogisticsExisting ? '수정' : '저장'} 완료 (₩${res.data.총금액?.toLocaleString()})`, {
                        title: '公共物流费 / 공통물류비', variant: 'success', solid: true
                    });

                    // 로컬 데이터 업데이트: 그룹 아이템 + reqlistsinit
                    const ref = { quotationId: res.data.quotationId, 총금액: res.data.총금액, paymentStatus: '미요청' };
                    if (this.commonLogisticsTarget?.items) {
                        this.commonLogisticsTarget.items.forEach(item => {
                            item.견적서_공통물류비 = { ...ref };
                            const initItem = this.reqlistsinit.find(i => i._id === item._id);
                            if (initItem) initItem.견적서_공통물류비 = { ...ref };
                        });
                    }

                    this.showCommonLogisticsModal = false;
                    this.$forceUpdate();
                } else {
                    alert('公共物流费保存失败 / 공통물류비 저장 실패: ' + (res.data.error?.errorMessage || ''));
                }
            } catch (error) {
                console.error('공통물류비 저장 오류:', error);
                alert('公共物流费保存出错 / 공통물류비 저장 중 오류: ' + (error.response?.data?.error?.errorMessage || error.message));
            } finally {
                this.showspinner = false;
            }
        },

        // 💳 예치금 관리 모달 열기
        async openDepositManageModal() {
            try {
                const res = await axios.get('/api/deposit/getAllBalances');
                if (res.data.요청결과 === '성공') {
                    this.depositAllBalances = res.data.data || [];
                }
            } catch (e) { console.error('예치금 목록 조회 오류:', e); }
            this.depositSelectedCompany = '';
            this.depositDetailBalance = 0;
            this.depositDetailHistory = [];
            this.depositAction = '';
            this.showDepositManageModal = true;
        },
        // 💳 특정 화주 예치금 상세 조회
        async fetchDepositDetail() {
            if (!this.depositSelectedCompany) return;
            try {
                const res = await axios.get('/api/deposit/getHistory/' + encodeURIComponent(this.depositSelectedCompany));
                if (res.data.요청결과 === '성공') {
                    this.depositDetailBalance = res.data.data?.잔액 || 0;
                    this.depositDetailHistory = res.data.data?.내역 || [];
                }
            } catch (e) { console.error('예치금 상세 조회 오류:', e); }
            this.depositAction = '';
        },
        // 💳 예치금 충전/차감/환불 실행
        async submitDepositAction() {
            if (!this.depositSelectedCompany || !this.depositAmount || this.depositAmount <= 0) return;
            if (!confirm(`${this.depositSelectedCompany} ₩${Number(this.depositAmount).toLocaleString()} ${this.displayZh(this.depositAction)}? / ${this.depositSelectedCompany}에 ₩${Number(this.depositAmount).toLocaleString()} ${this.depositAction} 하시겠습니까?`)) return;

            const apiMap = { '충전': '/api/deposit/charge', '차감': '/api/deposit/deduct', '환불': '/api/deposit/refund' };
            try {
                const res = await axios.post(apiMap[this.depositAction], {
                    companyid: this.depositSelectedCompany,
                    금액: this.depositAmount,
                    사유: this.depositReason || `${this.depositAction} (쿠패스)`
                });
                if (res.data.요청결과 === '성공') {
                    this.$bvToast.toast(`${this.displayZh(this.depositAction)} 完成 / 완료 (余额 / 잔액: ₩${(res.data.잔액 || 0).toLocaleString()})`, { title: '预存款处理 / 예치금 처리', variant: 'success', solid: true });
                    this.depositAction = '';
                    this.depositAmount = '';
                    this.depositReason = '';
                    await this.fetchDepositDetail();
                    // 목록도 갱신
                    const balRes = await axios.get('/api/deposit/getAllBalances');
                    if (balRes.data.요청결과 === '성공') this.depositAllBalances = balRes.data.data || [];
                } else {
                    alert(this.displayZh(this.depositAction) + ' 失败 / 실패: ' + (res.data.error?.errorMessage || ''));
                }
            } catch (e) {
                console.error('예치금 처리 오류:', e);
                alert('预存款处理出错 / 예치금 처리 오류: ' + (e.response?.data?.error?.errorMessage || e.message));
            }
        },

        // 물류비 입금요청 (쿠패스 → 화주)
        openPurchaseNote(item) {
            this.purchaseNoteTarget = item;
            this.purchaseNoteForm = { 메모: item.구매메모 || '', 사진: Array.isArray(item.구매메모사진) ? item.구매메모사진.slice() : [] };
            this.showPurchaseNote = true;
        },
        removePurchaseNotePhoto(url) {
            this.purchaseNoteForm.사진 = this.purchaseNoteForm.사진.filter(u => u !== url);
        },
        onPurchaseNoteFiles(e) {
            const files = Array.from((e.target && e.target.files) || []);
            const input = e.target;
            if (!files.length) return;
            if (this.purchaseNoteForm.사진.length + files.length > 10) { alert('最多10张 (사진은 최대 10장)'); input.value = ''; return; }
            this.purchaseNoteUploading = true;
            AWS.config.update({ region: this.purchaseNoteRegion, credentials: new AWS.CognitoIdentityCredentials({ IdentityPoolId: this.purchaseNotePool }) });
            const s3 = new AWS.S3({ apiVersion: '2006-03-01', params: { Bucket: this.purchaseNoteBucket } });
            Promise.all(files.map(file => s3.upload({ Key: `purchase-note/${Date.now()}_${file.name}`, Body: file, ACL: 'public-read' }).promise()))
                .then(results => { results.forEach(r => this.purchaseNoteForm.사진.push(r.Location)); input.value = ''; })
                .catch(err => { console.error('采购备注 사진 업로드 오류:', err); alert('上传失败(업로드 실패): ' + err.message); })
                .finally(() => { this.purchaseNoteUploading = false; });
        },
        async savePurchaseNote() {
            const t = this.purchaseNoteTarget;
            if (!t) return;
            this.purchaseNoteSaving = true;
            try {
                const { data } = await axios.post('/api/reqpurchase/purchaseNote', { _id: t._id, 메모: this.purchaseNoteForm.메모, 사진목록: this.purchaseNoteForm.사진 });
                if (data.요청결과 !== '성공') { alert('保存失败(저장 실패): ' + ((data.error && data.error.errorMessage) || '')); return; }
                this.$set(t, '구매메모', data.구매메모 !== undefined ? data.구매메모 : this.purchaseNoteForm.메모.trim());
                this.$set(t, '구매메모사진', this.purchaseNoteForm.사진.slice());
                const init = (this.reqlistsinit || []).find(i => i._id === t._id);
                if (init && init !== t) { this.$set(init, '구매메모', t.구매메모); this.$set(init, '구매메모사진', t.구매메모사진); }
                this.showPurchaseNote = false;
                this.$bvToast.toast('已保存 (저장됨)', { title: '采购备注', variant: 'success', solid: true, autoHideDelay: 2000 });
            } catch (e) {
                console.error('采购备注 저장 오류:', e);
                alert('保存失败(저장 실패): ' + e.message);
            } finally {
                this.purchaseNoteSaving = false;
            }
        },
        async requestLogisticsPayment(item, type) {
            const typeName = type === '중국물류비' ? '중국물류비' : '한국물류비';
            if (!confirm(`发送「${item.상품명}」${typeName} 付款请求? / "${item.상품명}" ${typeName} 입금요청을 보내시겠습니까?`)) return;

            try {
                this.showspinner = true;
                const response = await axios.post('/api/quotation/requestLogisticsPayment', {
                    reqpurchaseIds: [item._id],
                    type
                });

                if (response.data.요청결과 === '성공') {
                    this.$bvToast.toast(`${typeName} 付款请求已发送 / ${typeName} 입금요청이 전송되었습니다.`, {
                        title: '请求付款完成 / 입금요청 완료', variant: 'success', solid: true
                    });

                    // 로컬 데이터 업데이트
                    const fieldName = type === '중국물류비' ? '견적서_중국물류비' : '견적서_한국물류비';
                    if (item[fieldName]) item[fieldName].paymentStatus = '입금요청';
                    const initItem = this.reqlistsinit.find(i => i._id === item._id);
                    if (initItem?.[fieldName]) initItem[fieldName].paymentStatus = '입금요청';
                    this.$forceUpdate();
                } else {
                    alert('付款请求失败 / 입금요청 실패: ' + (response.data.error?.errorMessage || '未知错误 / 알 수 없는 오류'));
                }
            } catch (error) {
                console.error('물류비 입금요청 오류:', error);
                alert('付款请求出错 / 입금요청 중 오류: ' + (error.response?.data?.error?.errorMessage || error.message));
            } finally {
                this.showspinner = false;
            }
        },

        // 견적서 보기
        async viewQuotation(item) {
            if (!item.견적서_id) {
                alert('没有报价单ID / 견적서 ID가 없습니다.');
                return;
            }

            try {
                this.showspinner = true;

                // 견적서 조회 API 호출
                const response = await axios.get(`/api/quotation/get/${item.견적서_id}`);

                if (response.data.요청결과 === '성공') {
                    // 견적서 모달 표시 (다음 단계에서 구현)
                    this.showQuotationModal(response.data.quotation);
                } else {
                    alert('报价单查询失败 / 견적서 조회 실패: ' + (response.data.error?.errorMessage || '未知错误 / 알 수 없는 오류'));
                }
            } catch (error) {
                console.error('견적서 조회 오류:', error);
                alert('报价单查询出错 / 견적서 조회 중 오류가 발생했습니다: ' + (error.response?.data?.error?.errorMessage || error.message));
            } finally {
                this.showspinner = false;
            }
        },

        // 개별 견적서 모달 표시
        showQuotationModal(quotation) {
            this.currentQuotation = quotation;
            this.$bvModal.show('quotation-item-modal');
        },
        // 페이지 진입 시 알림 카운트 초기화
        clearSSENotifications() {
            this.$store.commit('sseClearNotification', 'price_modified');
            this.$store.commit('sseClearNotification', 'payment_completed');
        },
    },
    mounted() {
        this.importcompanyids()
        this.fetchExchangeRate() // 환율 정보 조회
        this.clearSSENotifications() // 페이지 진입 시 알림 초기화

        // URL 쿼리 파라미터에서 requestId가 있는지 확인
        const requestId = this.$route.query.requestId
        console.log('logisreqpurchase mounted - requestId:', requestId);
        if (requestId) {
            // requestId가 있으면 해당 요청만 로드
            this.loadSingleRequest(requestId)
        } else if (this.$route.query.stage) {
            this.applyStageQuery()
        }
    },
    // 상단 탭으로 다시 돌아오면 사이드바 알림점을 본 것으로 친다(처음 열 때는 mounted 가 한다)
    activated() {
        this.clearSSENotifications()
    },
    beforeDestroy() {
        // 결제 폴링 타이머 정리 (이탈 시 누수 방지)
        this.stopPaymentPolling('컴포넌트 언마운트');
    },
}
</script>
<style>
.quotation-modal-90 {
    max-width: 90vw !important;
    width: 90vw !important;
    margin: 5vh auto !important;
}
.quotation-modal-90 .modal-content {
    max-height: 90vh;
    overflow-y: auto;
}
.my-class .dropdown-menu {
    transform: translate3d(0px, -30px, 0px) !important;
    max-height: 100px;
    width: 300px;
    z-index: 10000;
    overflow-y: auto;
}

#quill-container {
    height: 50px;
}

#quill-container .ql-editor {
    min-height: unset;
}

.modal-dialog {
    max-width: 90%;
    position: absolute;

    margin: auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}

.checklist-group {
    margin-bottom: 25px;
    width: 100%
}

.group-title {
    color: #34495e;
    font-weight: 600;
    margin-bottom: 15px;
    font-size: 1.1rem;
}

.checklist-items {
    width: 100%;
    /* 최대 너비 사용 */
}

.checklist-items .form-control {
    width: calc(100% - 120px);
    /* 버튼 공간 확보 */
    max-width: none;
    /* auto 너비 제한 해제 */
}

.inspection-checklist ul {
    list-style-type: none;
    padding-left: 20px;
    margin-bottom: 15px;
}

.inspection-checklist li {
    position: relative;
    padding-left: 20px;
    margin-bottom: 8px;
    color: #596068;
}

.inspection-checklist li:before {
    content: "•";
    color: #3498db;
    position: absolute;
    left: 0;
    font-weight: bold;
}

.inspection-checklist textarea {
    border: 1px solid #e9ecef;
    resize: vertical;
    width: 100%;
}

.inspection-checklist textarea:focus {
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, .25);
}

::v-deep .my-dropdown-class {
    transform: translate3d(0px, -30px, 0px) !important;
    max-height: 150px;
    width: 400px;
    z-index: 10000;
    overflow-y: auto;
}

#quill-container {
    height: 50px;
}

#quill-container .ql-editor {
    min-height: unset;
}


.action-button {
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.warning2 {
    font-size: 16px;
    color: #e83e8c;
    font-weight: bold;
}

.status {
    width: 100%;
    border: 3px solid #cccccc;
    display: flex;
    justify-content: space-between;
}

.status-area {
    width: 30%;
    padding: 20px;
}

.status-header {
    border-bottom: 1px solid #ccced2;
    text-align: center;
    margin-bottom: 12px;
}

.status-tit {
    margin-bottom: 20px;
}

.status-txt {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

.status-txt a {
    cursor: pointer;
}

.status-txt span {
    font-weight: bold;
}

.purchase-request-form {
    padding: 1rem;
}

.form-section {
    background: #f8f9fa;
    border-radius: 8px;
    padding: 1.5rem;
    margin-bottom: 1.5rem;
    width: 100%;
}

.section-title {
    font-size: 1rem;
    font-weight: 600;
    color: #495057;
    margin-bottom: 1rem;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid #dee2e6;
}

.input-wrapper {
    margin-bottom: 1rem;
}

.stock-info {
    font-size: 0.9rem;
    color: #6c757d;
}

.info-label {
    color: #495057;
}

.info-value {
    font-weight: 500;
    color: #212529;
}

.separator {
    margin: 0 0.5rem;
    color: #adb5bd;
}

.custom-radio-card {
    padding: 1rem;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.custom-radio-card:hover {
    background: #e9ecef;
}

.custom-radio-card.active {
    background: #e9ecef;
    border-color: #0d6efd;
}

.card-title {
    font-weight: 600;
    margin-bottom: 0.5rem;
}

.card-desc {
    font-size: 0.85rem;
    color: #6c757d;
}

.warning-box {
    background: #fff3cd;
    border: 1px solid #ffeeba;
    border-radius: 6px;
    padding: 1rem;
}

.warning-text {
    color: #dc3545;
    font-size: 0.85rem;
    margin-top: 0.25rem;
}



.option-group {
    border-bottom: 1px solid #dee2e6;
    padding-bottom: 1rem;
    margin-bottom: 1rem;
}

.option-title {
    font-weight: 500;
    color: #495057;
    font-size: 0.9rem;
}

textarea.form-control {
    min-height: 100px;
}

.text-muted {
    font-size: 0.85rem;
}

.inspection-request {
    background-color: #fff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.section-header {
    border-bottom: 2px solid #f0f0f0;
    padding-bottom: 15px;
}

.section-title {
    color: #2c3e50;
    font-weight: 600;
    margin-bottom: 5px;
}

.checklist-group {
    margin-bottom: 25px;
    width: 100%
}

.group-title {
    color: #34495e;
    font-weight: 600;
    margin-bottom: 15px;
    font-size: 1.1rem;
}

.sub-group {
    margin-left: 20px;
    margin-bottom: 15px;
}

.sub-title {
    color: #7f8c8d;
    font-weight: 500;
    margin-bottom: 10px;
    font-size: 1rem;
}

.inspection-checklist ul {
    list-style-type: none;
    padding-left: 20px;
    margin-bottom: 15px;
}

.inspection-checklist li {
    position: relative;
    padding-left: 20px;
    margin-bottom: 8px;
    color: #596068;
}

.inspection-checklist li:before {
    content: "•";
    color: #3498db;
    position: absolute;
    left: 0;
    font-weight: bold;
}

.request-input {
    background-color: #f8f9fa;
    padding: 20px;
    border-radius: 6px;
    margin-top: 20px;
}

.request-input label {
    font-weight: 500;
    color: #2c3e50;
    margin-bottom: 10px;
    display: block;
}

.inspection-checklist textarea {
    border: 1px solid #e9ecef;
    resize: vertical;
    width: 100%;
}

.inspection-checklist textarea:focus {
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, .25);
}

@media (max-width: 768px) {
    .inspection-request {
        padding: 15px;
    }

    .sub-group {
        margin-left: 10px;
    }
}

.checklist-items {
    width: 100%;
    /* 최대 너비 사용 */
}

/* 체크리스트 항목 내 입력 필드 너비 조정 */
.checklist-items .form-control {
    width: calc(100% - 120px);
    /* 버튼 공간 확보 */
    max-width: none;
    /* auto 너비 제한 해제 */
}


.purchase-notice {
    padding: 20px;
    font-size: 14px;
    line-height: 1.6;
}

.notice-title {
    color: #1a73e8;
    font-weight: 600;
    text-align: center;
}

.notice-item {
    display: flex;
    margin-bottom: 15px;
}

.notice-number {
    flex: 0 0 30px;
    font-weight: 600;
    color: #1a73e8;
}

.notice-content {
    flex: 1;
}

.warning-text {
    color: #dc3545;
    font-size: 13px;
    margin-top: 5px;
    padding-left: 30px;
}

/* 중요 사항 강조 */
.notice-content strong {
    color: #dc3545;
    font-weight: 600;
}

::v-deep .my-dropdown-class {
    transform: translate3d(0px, -30px, 0px) !important;
    max-height: 150px;
    width: 400px;
    z-index: 9999;
    overflow-y: auto;
}

::v-deep #modal-scrollable .modal-dialog {
    max-width: 90%;
    position: absolute;

    margin: auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}

#quill-container {
    height: 50px;
}

#quill-container .ql-editor {
    min-height: unset;
}


.reqpo-action-button {
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.reqpo-status {
    width: 100%;
    border: 3px solid #cccccc;
    display: flex;
    justify-content: space-between;
}

.reqpo-status-area {
    width: 30%;
    padding: 20px;
}

.reqpo-status-header {
    border-bottom: 1px solid #ccced2;
    text-align: center;
    margin-bottom: 12px;
}

.reqpo-status-tit {
    margin-bottom: 20px;
}

.reqpo-status-txt {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

.reqpo-status-txt a {
    cursor: pointer;
}

.reqpo-status-txt span {
    font-weight: bold;
}

.reqpo-purchase-request-form {
    padding: 1rem;
}

.reqpo-form-section {
    background: #f8f9fa;
    border-radius: 8px;
    padding: 1.5rem;
    margin-bottom: 1.5rem;
}

.reqpo-section-title {
    font-size: 1rem;
    font-weight: 600;
    color: #495057;
    margin-bottom: 1rem;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid #dee2e6;
}

.reqpo-input-wrapper {
    margin-bottom: 1rem;
}

.reqpo-stock-info {
    font-size: 0.9rem;
    color: #6c757d;
}

.reqpo-info-label {
    color: #495057;
}

.reqpo-info-value {
    font-weight: 500;
    color: #212529;
}

.reqpo-separator {
    margin: 0 0.5rem;
    color: #adb5bd;
}

.reqpo-custom-radio-card {
    padding: 1rem;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.reqpo-custom-radio-card:hover {
    background: #e9ecef;
}

.reqpo-custom-radio-card.active {
    background: #e9ecef;
    border-color: #0d6efd;
}

.reqpo-card-title {
    font-weight: 600;
    margin-bottom: 0.5rem;
}

.reqpo-card-desc {
    font-size: 0.85rem;
    color: #6c757d;
}

.reqpo-warning-box {
    background: #fff3cd;
    border: 1px solid #ffeeba;
    border-radius: 6px;
    padding: 1rem;
}

.reqpo-warning-text {
    color: #dc3545;
    font-size: 0.85rem;
    margin-top: 0.25rem;
}

.reqpo-option-group {
    border-bottom: 1px solid #dee2e6;
    padding-bottom: 1rem;
    margin-bottom: 1rem;
}

.reqpo-option-title {
    font-weight: 500;
    color: #495057;
    font-size: 0.9rem;
}

.reqpo-text-muted {
    font-size: 0.85rem;
}

/* ========== 검색 영역 스타일 ========== */
.search-card {
    padding: 0.5rem !important;
}

.search-card .card-body {
    padding: 0.5rem !important;
}

.search-row {
    display: flex;
    align-items: center;
    gap: 1rem;
    flex-wrap: wrap;
}

.search-group {
    display: flex;
    align-items: center;
    gap: 0.3rem;
}

.search-group--period {
    flex-shrink: 0;
}

.search-group--date {
    flex-shrink: 0;
}

/* 좁은 화면에서 날짜 칸이 화면 밖으로 나가지 않게(판 #871) */
@media (max-width: 768px) {
    .search-group--date {
        flex-wrap: wrap;
        max-width: 100%;
    }
}

.search-group--date .custom-select {
    width: auto;
    min-width: 120px;
}

.search-group--date .b-form-datepicker {
    width: 150px;
}

.date-separator {
    padding: 0 0.3rem;
    color: #6c757d;
}

.search-group--company {
    flex: 0 0 120px;
}

.search-group--company .form-control {
    width: 100%;
}

.search-group--switch {
    flex-shrink: 0;
}

.batch-search-chip {
    cursor: pointer;
    font-size: 0.8rem;
}

.search-btn {
    flex-shrink: 0;
    padding: 0.375rem 1rem;
}

.search-row--lookup {
    border-top: 1px dashed #dee2e6;
    padding-top: 0.5rem;
}

.search-group--lookup-input {
    flex: 1 1 260px;
    min-width: 200px;
}

.search-group--lookup-input .form-control {
    width: 100%;
}

/* ========== 필터 그룹 스타일 (컴팩트) ========== */
.filter-container {
    padding: 0.5rem;
    background: #f8f9fa;
    border-radius: 6px;
    border: 1px solid #c4c4c4;
}

.filter-group {
    background: #fff;
    border-radius: 6px;
    padding: 0.4rem 0.6rem;
    margin-bottom: 0.4rem;
    border: 1px solid #e9ecef;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.4rem;
}

.filter-group__title {
    font-weight: 600;
    font-size: 0.85rem;
    color: #495057;
    white-space: nowrap;
    margin-right: 0.5rem;
    line-height: 1.3;
}

.filter-group__title small {
    font-weight: 400;
    font-size: 0.7rem;
}

.filter-group__buttons {
    display: flex;
    flex-wrap: wrap;
    gap: 0.3rem;
    align-items: stretch;
}

.filter-btn {
    font-size: 0.85rem !important;
    padding: 0.25rem 0.5rem !important;
    border-radius: 8px !important;
    transition: all 0.15s ease;
}

.filter-btn .badge {
    font-size: 0.75rem;
    padding: 0.15em 0.4em;
    margin-left: 0.2rem;
}

/* 중국어+한글 2줄 버튼 */
.filter-btn--bilingual {
    display: inline-flex;
    align-items: center;
    text-align: left;
    line-height: 1.2;
}

.filter-btn--bilingual span {
    display: inline-block;
}

.filter-btn--bilingual small {
    font-size: 0.65rem;
    opacity: 0.7;
}

/* 숫자 0인 필터 흐리게 */
.filter-btn--dim {
    opacity: 0.4;
}

.filter-btn--dim:hover {
    opacity: 0.7;
}

/* gap 유틸리티 */
.gap-2 {
    gap: 0.4rem;
}

/* outline-light 버튼 테두리 보이게 */
.btn-outline-light {
    border-color: #dee2e6;
    color: #adb5bd;
}

.btn-outline-light:hover {
    background-color: #f8f9fa;
    border-color: #ced4da;
    color: #6c757d;
}

/* 상세 모달 요약 바 - 뱃지 형태 */
.detail-summary-bar {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    padding: 12px;
    background: #f8f9fa;
    border-radius: 8px;
}

/* 좌측: 요약 뱃지들 */
.summary-badges-left {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

/* 우측: 액션 버튼들 */
.summary-actions-right {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

/* 이중언어 버튼 스타일 */
.action-btn-bilingual {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 12px;
    white-space: nowrap;
}

.action-btn-bilingual .btn-icon {
    font-size: 14px;
}

.action-btn-bilingual .btn-text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    line-height: 1.2;
}

.action-btn-bilingual .text-cn {
    font-size: 18px;
    font-weight: 500;
}

.action-btn-bilingual .text-kr {
    font-size: 13px;
    opacity: 0.7;
}

.summary-badge {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 8px 14px;
    background: #fff;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    min-width: 70px;
    box-shadow: 0 1px 2px rgba(0,0,0,0.04);
}

.summary-badge-wide {
    min-width: 140px;
}

.badge-label {
    display: flex;
    /* flex-direction: column; */
    align-items: center;
    margin-bottom: 4px;
    line-height: 1.2;
}

.badge-label .label-cn {
    font-size: 15px;
    color: #666;
    font-weight: 500;
}

.badge-label .label-kr {
    font-size: 12px;
    color: #999;
}

.badge-value {
    font-size: 13px;
    color: #333;
    font-weight: 600;
    text-align: center;
}

.badge-value code {
    font-size: 11px;
    background: #f5f5f5;
    padding: 2px 6px;
    border-radius: 4px;
    color: #555;
}

/* 변경이력 처리 — 한눈에 보이도록 강조 */
.change-review-cell {
    display: inline-flex;
    align-items: center;
    padding: 4px 8px;
    border-radius: 4px;
    transition: transform 0.15s;
}
.change-review-cell:hover {
    transform: scale(1.08);
}
.change-review-urgent {
    color: #dc3545;
    background: #fff2f2;
    border: 1px solid #dc3545;
    box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.25);
}
.change-review-pending {
    color: #0d6efd;
}
.change-review-done {
    color: #6c757d;
    opacity: 0.6;
}
.change-review-pulse {
    animation: change-review-pulse 1.4s ease-in-out infinite;
}
@keyframes change-review-pulse {
    0%, 100% { opacity: 1; transform: scale(1); }
    50% { opacity: 0.55; transform: scale(1.12); }
}

/* 모달 — 경고 배너 */
.change-review-warning {
    background: #fff3cd;
    border: 2px solid #ffc107;
    border-radius: 6px;
    padding: 12px 14px;
    color: #856404;
}
.change-review-list {
    max-height: 60vh;
    overflow-y: auto;
}
.change-review-item {
    padding: 12px;
    margin-bottom: 8px;
    border-radius: 6px;
    border: 1px solid #dee2e6;
}
.change-item-unconfirmed {
    border-left: 4px solid #dc3545;
    background: #fff5f5;
}
.change-item-confirmed {
    background: #f8f9fa;
    opacity: 0.78;
}
.change-fields {
    background: #fff;
    border-radius: 4px;
    padding: 6px 10px;
    margin-top: 4px;
    font-size: 0.9rem;
}
.change-field-row {
    padding: 2px 0;
}
.change-field-row + .change-field-row {
    border-top: 1px dashed #e9ecef;
}

/* 별도링크 결제처리 */
.side-payment-notice {
    background: #e7f3ff;
    border: 1px solid #b6d4fe;
    border-radius: 6px;
    padding: 10px 14px;
    color: #0c5391;
}
.side-payment-existing {
    background: #fff3cd;
    border: 2px solid #ffc107;
    border-radius: 6px;
    padding: 10px 14px;
    color: #856404;
}
.side-payment-btn {
    transition: transform 0.15s;
}
.side-payment-btn:hover {
    transform: scale(1.12);
}

/* 메인 테이블 행 강조 — v-data-table은 ::v-deep 필요 */
::v-deep tr.row-change-urgent > td {
    background: #fff2f2 !important;
}
::v-deep tr.row-change-urgent > td:first-child {
    border-left: 5px solid #dc3545 !important;
    box-shadow: inset 4px 0 0 #dc3545;
}
::v-deep tr.row-change-urgent {
    animation: row-urgent-pulse 2s ease-in-out infinite;
}
@keyframes row-urgent-pulse {
    0%, 100% { background-color: transparent; }
    50% { background-color: rgba(220, 53, 69, 0.06); }
}
::v-deep tr.row-change-pending > td {
    background: #f0f8ff !important;
}
::v-deep tr.row-change-pending > td:first-child {
    border-left: 4px solid #0d6efd !important;
}
::v-deep tr.row-side-payment > td {
    background: #fffbe6 !important;
}
::v-deep tr.row-side-payment > td:first-child {
    border-left: 4px solid #ffc107 !important;
}
/* 개별 상품 뷰 — 1920 화면에서 가로 스크롤 없이(2026-10-07 YZY). 칸 안쪽 여백만 줄인다 */
.reqlist-individual .v-data-table th,
.reqlist-individual .v-data-table td {
    padding-left: 6px !important;
    padding-right: 6px !important;
}
/* 그룹 뷰도 1920 화면에서 가로 스크롤 없이(2026-10-07 YZY) — 칸 폭은 groupHeaders, 여기선 안쪽 여백만 */
.reqlist-group .v-data-table th,
.reqlist-group .v-data-table td {
    padding-left: 4px !important;
    padding-right: 4px !important;
}
.reqlist-individual .v-data-table td .badge {
    max-width: 110px;
}
/* 배지 2줄 표시(위 中文, 아래 작게 한국어) — 「中文 (한국어)」 한 줄보다 가로폭이 좁다(2026-10-07 YZY) */
.badge small.d-block {
    font-size: 0.72em;
    font-weight: normal;
    opacity: 0.85;
    margin-top: 1px;
}
</style>
